function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function(t2) {
    return p.apply(e, t2);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)); )
    ;
  return t;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r))
    return r;
}
function _classPrivateMethodInitSpec(e, a) {
  _checkPrivateRedeclaration(e, a), a.add(e);
}
function _classPrivateFieldInitSpec(e, t, a) {
  _checkPrivateRedeclaration(e, t), t.set(e, a);
}
function _checkPrivateRedeclaration(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classPrivateFieldSet(s, a, r) {
  return s.set(_assertClassBrand(s, a), r), r;
}
function _classPrivateFieldGet(s, a) {
  return s.get(_assertClassBrand(s, a));
}
function _assertClassBrand(e, t, n) {
  if ("function" == typeof e ? e === t : e.has(t))
    return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r))
    return _arrayLikeToArray(r);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper2(t2) {
    if (null === t2 || !_isNativeFunction(t2))
      return t2;
    if ("function" != typeof t2)
      throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t2))
        return r.get(t2);
      r.set(t2, Wrapper);
    }
    function Wrapper() {
      return _construct(t2, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }), _setPrototypeOf(Wrapper, t2);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct())
    return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime2() {
    return e;
  };
  var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t2, e2, r2) {
    t2[e2] = r2.value;
  }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function define2(t2, e2, r2) {
    return Object.defineProperty(t2, e2, { value: r2, enumerable: true, configurable: true, writable: true }), t2[e2];
  }
  try {
    define2({}, "");
  } catch (t2) {
    define2 = function define3(t3, e2, r2) {
      return t3[e2] = r2;
    };
  }
  function wrap(t2, e2, r2, n2) {
    var i2 = e2 && e2.prototype instanceof Generator ? e2 : Generator, a2 = Object.create(i2.prototype), c2 = new Context(n2 || []);
    return o(a2, "_invoke", { value: makeInvokeMethod(t2, r2, c2) }), a2;
  }
  function tryCatch(t2, e2, r2) {
    try {
      return { type: "normal", arg: t2.call(e2, r2) };
    } catch (t3) {
      return { type: "throw", arg: t3 };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  var p = {};
  define2(p, a, function() {
    return this;
  });
  var d = Object.getPrototypeOf, v2 = d && d(d(values([])));
  v2 && v2 !== r && n.call(v2, a) && (p = v2);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t2) {
    ["next", "throw", "return"].forEach(function(e2) {
      define2(t2, e2, function(t3) {
        return this._invoke(e2, t3);
      });
    });
  }
  function AsyncIterator(t2, e2) {
    function invoke(r3, o2, i2, a2) {
      var c2 = tryCatch(t2[r3], t2, o2);
      if ("throw" !== c2.type) {
        var u2 = c2.arg, h2 = u2.value;
        return h2 && "object" == _typeof(h2) && n.call(h2, "__await") ? e2.resolve(h2.__await).then(function(t3) {
          invoke("next", t3, i2, a2);
        }, function(t3) {
          invoke("throw", t3, i2, a2);
        }) : e2.resolve(h2).then(function(t3) {
          u2.value = t3, i2(u2);
        }, function(t3) {
          return invoke("throw", t3, i2, a2);
        });
      }
      a2(c2.arg);
    }
    var r2;
    o(this, "_invoke", { value: function value(t3, n2) {
      function callInvokeWithMethodAndArg() {
        return new e2(function(e3, r3) {
          invoke(t3, n2, e3, r3);
        });
      }
      return r2 = r2 ? r2.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    } });
  }
  function makeInvokeMethod(e2, r2, n2) {
    var o2 = h;
    return function(i2, a2) {
      if (o2 === f)
        throw Error("Generator is already running");
      if (o2 === s) {
        if ("throw" === i2)
          throw a2;
        return { value: t, done: true };
      }
      for (n2.method = i2, n2.arg = a2; ; ) {
        var c2 = n2.delegate;
        if (c2) {
          var u2 = maybeInvokeDelegate(c2, n2);
          if (u2) {
            if (u2 === y)
              continue;
            return u2;
          }
        }
        if ("next" === n2.method)
          n2.sent = n2._sent = n2.arg;
        else if ("throw" === n2.method) {
          if (o2 === h)
            throw o2 = s, n2.arg;
          n2.dispatchException(n2.arg);
        } else
          "return" === n2.method && n2.abrupt("return", n2.arg);
        o2 = f;
        var p2 = tryCatch(e2, r2, n2);
        if ("normal" === p2.type) {
          if (o2 = n2.done ? s : l, p2.arg === y)
            continue;
          return { value: p2.arg, done: n2.done };
        }
        "throw" === p2.type && (o2 = s, n2.method = "throw", n2.arg = p2.arg);
      }
    };
  }
  function maybeInvokeDelegate(e2, r2) {
    var n2 = r2.method, o2 = e2.iterator[n2];
    if (o2 === t)
      return r2.delegate = null, "throw" === n2 && e2.iterator.return && (r2.method = "return", r2.arg = t, maybeInvokeDelegate(e2, r2), "throw" === r2.method) || "return" !== n2 && (r2.method = "throw", r2.arg = new TypeError("The iterator does not provide a '" + n2 + "' method")), y;
    var i2 = tryCatch(o2, e2.iterator, r2.arg);
    if ("throw" === i2.type)
      return r2.method = "throw", r2.arg = i2.arg, r2.delegate = null, y;
    var a2 = i2.arg;
    return a2 ? a2.done ? (r2[e2.resultName] = a2.value, r2.next = e2.nextLoc, "return" !== r2.method && (r2.method = "next", r2.arg = t), r2.delegate = null, y) : a2 : (r2.method = "throw", r2.arg = new TypeError("iterator result is not an object"), r2.delegate = null, y);
  }
  function pushTryEntry(t2) {
    var e2 = { tryLoc: t2[0] };
    1 in t2 && (e2.catchLoc = t2[1]), 2 in t2 && (e2.finallyLoc = t2[2], e2.afterLoc = t2[3]), this.tryEntries.push(e2);
  }
  function resetTryEntry(t2) {
    var e2 = t2.completion || {};
    e2.type = "normal", delete e2.arg, t2.completion = e2;
  }
  function Context(t2) {
    this.tryEntries = [{ tryLoc: "root" }], t2.forEach(pushTryEntry, this), this.reset(true);
  }
  function values(e2) {
    if (e2 || "" === e2) {
      var r2 = e2[a];
      if (r2)
        return r2.call(e2);
      if ("function" == typeof e2.next)
        return e2;
      if (!isNaN(e2.length)) {
        var o2 = -1, i2 = function next() {
          for (; ++o2 < e2.length; )
            if (n.call(e2, o2))
              return next.value = e2[o2], next.done = false, next;
          return next.value = t, next.done = true, next;
        };
        return i2.next = i2;
      }
    }
    throw new TypeError(_typeof(e2) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: true }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: true }), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t2) {
    var e2 = "function" == typeof t2 && t2.constructor;
    return !!e2 && (e2 === GeneratorFunction || "GeneratorFunction" === (e2.displayName || e2.name));
  }, e.mark = function(t2) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t2, GeneratorFunctionPrototype) : (t2.__proto__ = GeneratorFunctionPrototype, define2(t2, u, "GeneratorFunction")), t2.prototype = Object.create(g), t2;
  }, e.awrap = function(t2) {
    return { __await: t2 };
  }, defineIteratorMethods(AsyncIterator.prototype), define2(AsyncIterator.prototype, c, function() {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function(t2, r2, n2, o2, i2) {
    void 0 === i2 && (i2 = Promise);
    var a2 = new AsyncIterator(wrap(t2, r2, n2, o2), i2);
    return e.isGeneratorFunction(r2) ? a2 : a2.next().then(function(t3) {
      return t3.done ? t3.value : a2.next();
    });
  }, defineIteratorMethods(g), define2(g, u, "Generator"), define2(g, a, function() {
    return this;
  }), define2(g, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(t2) {
    var e2 = Object(t2), r2 = [];
    for (var n2 in e2)
      r2.push(n2);
    return r2.reverse(), function next() {
      for (; r2.length; ) {
        var t3 = r2.pop();
        if (t3 in e2)
          return next.value = t3, next.done = false, next;
      }
      return next.done = true, next;
    };
  }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e2) {
    if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = false, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e2)
      for (var r2 in this)
        "t" === r2.charAt(0) && n.call(this, r2) && !isNaN(+r2.slice(1)) && (this[r2] = t);
  }, stop: function stop() {
    this.done = true;
    var t2 = this.tryEntries[0].completion;
    if ("throw" === t2.type)
      throw t2.arg;
    return this.rval;
  }, dispatchException: function dispatchException(e2) {
    if (this.done)
      throw e2;
    var r2 = this;
    function handle(n2, o3) {
      return a2.type = "throw", a2.arg = e2, r2.next = n2, o3 && (r2.method = "next", r2.arg = t), !!o3;
    }
    for (var o2 = this.tryEntries.length - 1; o2 >= 0; --o2) {
      var i2 = this.tryEntries[o2], a2 = i2.completion;
      if ("root" === i2.tryLoc)
        return handle("end");
      if (i2.tryLoc <= this.prev) {
        var c2 = n.call(i2, "catchLoc"), u2 = n.call(i2, "finallyLoc");
        if (c2 && u2) {
          if (this.prev < i2.catchLoc)
            return handle(i2.catchLoc, true);
          if (this.prev < i2.finallyLoc)
            return handle(i2.finallyLoc);
        } else if (c2) {
          if (this.prev < i2.catchLoc)
            return handle(i2.catchLoc, true);
        } else {
          if (!u2)
            throw Error("try statement without catch or finally");
          if (this.prev < i2.finallyLoc)
            return handle(i2.finallyLoc);
        }
      }
    }
  }, abrupt: function abrupt(t2, e2) {
    for (var r2 = this.tryEntries.length - 1; r2 >= 0; --r2) {
      var o2 = this.tryEntries[r2];
      if (o2.tryLoc <= this.prev && n.call(o2, "finallyLoc") && this.prev < o2.finallyLoc) {
        var i2 = o2;
        break;
      }
    }
    i2 && ("break" === t2 || "continue" === t2) && i2.tryLoc <= e2 && e2 <= i2.finallyLoc && (i2 = null);
    var a2 = i2 ? i2.completion : {};
    return a2.type = t2, a2.arg = e2, i2 ? (this.method = "next", this.next = i2.finallyLoc, y) : this.complete(a2);
  }, complete: function complete(t2, e2) {
    if ("throw" === t2.type)
      throw t2.arg;
    return "break" === t2.type || "continue" === t2.type ? this.next = t2.arg : "return" === t2.type ? (this.rval = this.arg = t2.arg, this.method = "return", this.next = "end") : "normal" === t2.type && e2 && (this.next = e2), y;
  }, finish: function finish(t2) {
    for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
      var r2 = this.tryEntries[e2];
      if (r2.finallyLoc === t2)
        return this.complete(r2.completion, r2.afterLoc), resetTryEntry(r2), y;
    }
  }, catch: function _catch(t2) {
    for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
      var r2 = this.tryEntries[e2];
      if (r2.tryLoc === t2) {
        var n2 = r2.completion;
        if ("throw" === n2.type) {
          var o2 = n2.arg;
          resetTryEntry(r2);
        }
        return o2;
      }
    }
    throw Error("illegal catch attempt");
  }, delegateYield: function delegateYield(e2, r2, n2) {
    return this.delegate = { iterator: values(e2), resultName: r2, nextLoc: n2 }, "next" === this.method && (this.arg = t), y;
  } }, e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c), u = i.value;
  } catch (n2) {
    return void e(n2);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function() {
    var t = this, e = arguments;
    return new Promise(function(r, o) {
      var a = n.apply(t, e);
      function _next(n2) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n2);
      }
      function _throw(n2) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n2);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e))
    return e;
  if (void 0 !== e)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0, F = function F2() {
      };
      return { s: F, n: function(_n51) {
        function n2() {
          return _n51.apply(this, arguments);
        }
        n2.toString = function() {
          return _n51.toString();
        };
        return n2;
      }(function() {
        return n >= r.length ? { done: true } : { done: false, value: r[n++] };
      }), e: function e2(r2) {
        throw r2;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o, a = true, u = false;
  return { s: function s() {
    t = t.call(r);
  }, n: function n2() {
    var r2 = t.next();
    return a = r2.done, r2;
  }, e: function e2(r2) {
    u = true, o = r2;
  }, f: function f() {
    try {
      a || null == t.return || t.return();
    } finally {
      if (u)
        throw o;
    }
  } };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r)
      return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function _asyncGeneratorDelegate(t) {
  var e = {}, n = false;
  function pump(e2, r) {
    return n = true, r = new Promise(function(n2) {
      n2(t[e2](r));
    }), { done: false, value: new _OverloadYield(r, 1) };
  }
  return e["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function() {
    return this;
  }, e.next = function(t2) {
    return n ? (n = false, t2) : pump("next", t2);
  }, "function" == typeof t.throw && (e.throw = function(t2) {
    if (n)
      throw n = false, t2;
    return pump("throw", t2);
  }), "function" == typeof t.return && (e.return = function(t2) {
    return n ? (n = false, t2) : pump("return", t2);
  }), e;
}
function _asyncIterator(r) {
  var n, t, o, e = 2;
  for ("undefined" != typeof Symbol && (t = Symbol.asyncIterator, o = Symbol.iterator); e--; ) {
    if (t && null != (n = r[t]))
      return n.call(r);
    if (o && null != (n = r[o]))
      return new AsyncFromSyncIterator(n.call(r));
    t = "@@asyncIterator", o = "@@iterator";
  }
  throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(r) {
  function AsyncFromSyncIteratorContinuation(r2) {
    if (Object(r2) !== r2)
      return Promise.reject(new TypeError(r2 + " is not an object."));
    var n = r2.done;
    return Promise.resolve(r2.value).then(function(r3) {
      return { value: r3, done: n };
    });
  }
  return AsyncFromSyncIterator = function AsyncFromSyncIterator2(r2) {
    this.s = r2, this.n = r2.next;
  }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() {
    return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
  }, return: function _return(r2) {
    var n = this.s.return;
    return void 0 === n ? Promise.resolve({ value: r2, done: true }) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
  }, throw: function _throw(r2) {
    var n = this.s.return;
    return void 0 === n ? Promise.reject(r2) : AsyncFromSyncIteratorContinuation(n.apply(this.s, arguments));
  } }, new AsyncFromSyncIterator(r);
}
function _awaitAsyncGenerator(e) {
  return new _OverloadYield(e, 0);
}
function _wrapAsyncGenerator(e) {
  return function() {
    return new AsyncGenerator(e.apply(this, arguments));
  };
}
function AsyncGenerator(e) {
  var r, t;
  function resume(r2, t2) {
    try {
      var n = e[r2](t2), o = n.value, u = o instanceof _OverloadYield;
      Promise.resolve(u ? o.v : o).then(function(t3) {
        if (u) {
          var i = "return" === r2 ? "return" : "next";
          if (!o.k || t3.done)
            return resume(i, t3);
          t3 = e[i](t3).value;
        }
        settle(n.done ? "return" : "normal", t3);
      }, function(e2) {
        resume("throw", e2);
      });
    } catch (e2) {
      settle("throw", e2);
    }
  }
  function settle(e2, n) {
    switch (e2) {
      case "return":
        r.resolve({ value: n, done: true });
        break;
      case "throw":
        r.reject(n);
        break;
      default:
        r.resolve({ value: n, done: false });
    }
    (r = r.next) ? resume(r.key, r.arg) : t = null;
  }
  this._invoke = function(e2, n) {
    return new Promise(function(o, u) {
      var i = { key: e2, arg: n, resolve: o, reject: u, next: null };
      t ? t = t.next = i : (r = t = i, resume(e2, n));
    });
  }, "function" != typeof e.return && (this.return = void 0);
}
AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
  return this;
}, AsyncGenerator.prototype.next = function(e) {
  return this._invoke("next", e);
}, AsyncGenerator.prototype.throw = function(e) {
  return this._invoke("throw", e);
}, AsyncGenerator.prototype.return = function(e) {
  return this._invoke("return", e);
};
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
var ys = Object.defineProperty;
var Kg = Object.getOwnPropertyDescriptor;
var Gg = Object.getOwnPropertyNames;
var Qg = Object.prototype.hasOwnProperty;
var _e = function _e2(t, e) {
  return function() {
    return t && (e = t(t = 0)), e;
  };
};
var M = function M2(t, e) {
  return function() {
    return e || t((e = { exports: {} }).exports, e), e.exports;
  };
}, Jt = function Jt2(t, e) {
  for (var r in e)
    ys(t, r, { get: e[r], enumerable: true });
}, Yg = function Yg2(t, e, r, i) {
  if (e && _typeof(e) == "object" || typeof e == "function") {
    var _iterator13 = _createForOfIteratorHelper(Gg(e)), _step13;
    try {
      var _loop = function _loop2() {
        var n = _step13.value;
        !Qg.call(t, n) && n !== r && ys(t, n, { get: function get2() {
          return e[n];
        }, enumerable: !(i = Kg(e, n)) || i.enumerable });
      };
      for (_iterator13.s(); !(_step13 = _iterator13.n()).done; ) {
        _loop();
      }
    } catch (err) {
      _iterator13.e(err);
    } finally {
      _iterator13.f();
    }
  }
  return t;
};
var X = function X2(t) {
  return Yg(ys({}, "__esModule", { value: true }), t);
};
var _ = _e(function() {
});
var B = {};
Jt(B, { _debugEnd: function _debugEnd() {
  return yu;
}, _debugProcess: function _debugProcess() {
  return gu;
}, _events: function _events() {
  return Ou;
}, _eventsCount: function _eventsCount() {
  return xu;
}, _exiting: function _exiting() {
  return Yl;
}, _fatalExceptions: function _fatalExceptions() {
  return cu;
}, _getActiveHandles: function _getActiveHandles() {
  return eu;
}, _getActiveRequests: function _getActiveRequests() {
  return Zl;
}, _kill: function _kill() {
  return ru;
}, _linkedBinding: function _linkedBinding() {
  return Gl;
}, _maxListeners: function _maxListeners() {
  return ku;
}, _preload_modules: function _preload_modules() {
  return Cu;
}, _rawDebug: function _rawDebug() {
  return zl;
}, _startProfilerIdleNotifier: function _startProfilerIdleNotifier() {
  return bu;
}, _stopProfilerIdleNotifier: function _stopProfilerIdleNotifier() {
  return wu;
}, _tickCallback: function _tickCallback() {
  return pu;
}, abort: function abort() {
  return Eu;
}, addListener: function addListener() {
  return Mu;
}, allowedNodeEnvironmentFlags: function allowedNodeEnvironmentFlags() {
  return lu;
}, arch: function arch() {
  return xl;
}, argv: function argv() {
  return Ul;
}, argv0: function argv0() {
  return Ru;
}, assert: function assert() {
  return uu;
}, binding: function binding() {
  return Fl;
}, chdir: function chdir() {
  return Hl;
}, config: function config() {
  return Jl;
}, cpuUsage: function cpuUsage() {
  return $i;
}, cwd: function cwd() {
  return $l;
}, debugPort: function debugPort() {
  return Tu;
}, default: function _default() {
  return $u;
}, dlopen: function dlopen() {
  return Xl;
}, domain: function domain() {
  return Ql;
}, emit: function emit() {
  return Du;
}, emitWarning: function emitWarning() {
  return jl;
}, env: function env() {
  return Ll;
}, execArgv: function execArgv() {
  return Nl;
}, execPath: function execPath() {
  return Iu;
}, exit: function exit() {
  return ou;
}, features: function features() {
  return fu;
}, hasUncaughtExceptionCaptureCallback: function hasUncaughtExceptionCaptureCallback() {
  return du;
}, hrtime: function hrtime() {
  return Wi;
}, kill: function kill() {
  return su;
}, listeners: function listeners() {
  return Wu;
}, memoryUsage: function memoryUsage() {
  return nu;
}, moduleLoadList: function moduleLoadList() {
  return Kl;
}, nextTick: function nextTick() {
  return Pl;
}, off: function off() {
  return Uu;
}, on: function on() {
  return wt;
}, once: function once() {
  return Lu;
}, openStdin: function openStdin() {
  return au;
}, pid: function pid() {
  return Su;
}, platform: function platform() {
  return Ml;
}, ppid: function ppid() {
  return Au;
}, prependListener: function prependListener() {
  return ju;
}, prependOnceListener: function prependOnceListener() {
  return Fu;
}, reallyExit: function reallyExit() {
  return tu;
}, release: function release() {
  return Vl;
}, removeAllListeners: function removeAllListeners() {
  return qu;
}, removeListener: function removeListener() {
  return Nu;
}, resourceUsage: function resourceUsage() {
  return iu;
}, setSourceMapsEnabled: function setSourceMapsEnabled() {
  return Bu;
}, setUncaughtExceptionCaptureCallback: function setUncaughtExceptionCaptureCallback() {
  return hu;
}, stderr: function stderr() {
  return mu;
}, stdin: function stdin() {
  return vu;
}, stdout: function stdout() {
  return _u;
}, title: function title() {
  return Ol;
}, umask: function umask() {
  return Wl;
}, uptime: function uptime() {
  return Pu;
}, version: function version() {
  return ql;
}, versions: function versions() {
  return Dl;
} });
function _s(t) {
  throw new Error("Node.js process " + t + " is not supported by JSPM core outside of Node.js");
}
function Jg() {
  !Lr || !Xt || (Lr = false, Xt.length ? bt = Xt.concat(bt) : Fi = -1, bt.length && Bl());
}
function Bl() {
  if (!Lr) {
    var t = setTimeout(Jg, 0);
    Lr = true;
    for (var e = bt.length; e; ) {
      for (Xt = bt, bt = []; ++Fi < e; )
        Xt && Xt[Fi].run();
      Fi = -1, e = bt.length;
    }
    Xt = null, Lr = false, clearTimeout(t);
  }
}
function Pl(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var r = 1; r < arguments.length; r++)
      e[r - 1] = arguments[r];
  bt.push(new kl(t, e)), bt.length === 1 && !Lr && setTimeout(Bl, 0);
}
function kl(t, e) {
  this.fun = t, this.array = e;
}
function Ee() {
}
function Gl(t) {
  _s("_linkedBinding");
}
function Xl(t) {
  _s("dlopen");
}
function Zl() {
  return [];
}
function eu() {
  return [];
}
function uu(t, e) {
  if (!t)
    throw new Error(e || "assertion error");
}
function du() {
  return false;
}
function Pu() {
  return Lt.now() / 1e3;
}
function Wi(t) {
  var e = Math.floor((Date.now() - Lt.now()) * 1e-3), r = Lt.now() * 1e-3, i = Math.floor(r) + e, n = Math.floor(r % 1 * 1e9);
  return t && (i = i - t[0], n = n - t[1], n < 0 && (i--, n += ws)), [i, n];
}
function wt() {
  return $u;
}
function Wu(t) {
  return [];
}
var bt, Lr, Xt, Fi, Ol, xl, Ml, Ll, Ul, Nl, ql, Dl, jl, Fl, Wl, $l, Hl, Vl, zl, Kl, Ql, Yl, Jl, tu, ru, $i, iu, nu, su, ou, au, lu, fu, cu, hu, pu, gu, yu, bu, wu, _u, mu, vu, Eu, Su, Au, Iu, Tu, Ru, Cu, Bu, Lt, bs, ws, ku, Ou, xu, Mu, Lu, Uu, Nu, qu, Du, ju, Fu, $u, Hu = _e(function() {
  _();
  v();
  m();
  bt = [], Lr = false, Fi = -1;
  kl.prototype.run = function() {
    this.fun.apply(null, this.array);
  };
  Ol = "browser", xl = "x64", Ml = "browser", Ll = { PATH: "/usr/bin", LANG: navigator.language + ".UTF-8", PWD: "/", HOME: "/home", TMP: "/tmp" }, Ul = ["/usr/bin/node"], Nl = [], ql = "v16.8.0", Dl = {}, jl = function jl2(t, e) {
    console.warn((e ? e + ": " : "") + t);
  }, Fl = function Fl2(t) {
    _s("binding");
  }, Wl = function Wl2(t) {
    return 0;
  }, $l = function $l2() {
    return "/";
  }, Hl = function Hl2(t) {
  }, Vl = { name: "node", sourceUrl: "", headersUrl: "", libUrl: "" };
  zl = Ee, Kl = [];
  Ql = {}, Yl = false, Jl = {};
  tu = Ee, ru = Ee, $i = function $i2() {
    return {};
  }, iu = $i, nu = $i, su = Ee, ou = Ee, au = Ee, lu = {};
  fu = { inspector: false, debug: false, uv: false, ipv6: false, tls_alpn: false, tls_sni: false, tls_ocsp: false, tls: false, cached_builtins: true }, cu = Ee, hu = Ee;
  pu = Ee, gu = Ee, yu = Ee, bu = Ee, wu = Ee, _u = void 0, mu = void 0, vu = void 0, Eu = Ee, Su = 2, Au = 1, Iu = "/bin/usr/node", Tu = 9229, Ru = "node", Cu = [], Bu = Ee, Lt = { now: (typeof performance === "undefined" ? "undefined" : _typeof(performance)) < "u" ? performance.now.bind(performance) : void 0, timing: (typeof performance === "undefined" ? "undefined" : _typeof(performance)) < "u" ? performance.timing : void 0 };
  Lt.now === void 0 && (bs = Date.now(), Lt.timing && Lt.timing.navigationStart && (bs = Lt.timing.navigationStart), Lt.now = function() {
    return Date.now() - bs;
  });
  ws = 1e9;
  Wi.bigint = function(t) {
    var e = Wi(t);
    return (typeof BigInt === "undefined" ? "undefined" : _typeof(BigInt)) > "u" ? e[0] * ws + e[1] : BigInt(e[0] * ws) + BigInt(e[1]);
  };
  ku = 10, Ou = {}, xu = 0;
  Mu = wt, Lu = wt, Uu = wt, Nu = wt, qu = wt, Du = Ee, ju = wt, Fu = wt;
  $u = { version: ql, versions: Dl, arch: xl, platform: Ml, release: Vl, _rawDebug: zl, moduleLoadList: Kl, binding: Fl, _linkedBinding: Gl, _events: Ou, _eventsCount: xu, _maxListeners: ku, on: wt, addListener: Mu, once: Lu, off: Uu, removeListener: Nu, removeAllListeners: qu, emit: Du, prependListener: ju, prependOnceListener: Fu, listeners: Wu, domain: Ql, _exiting: Yl, config: Jl, dlopen: Xl, uptime: Pu, _getActiveRequests: Zl, _getActiveHandles: eu, reallyExit: tu, _kill: ru, cpuUsage: $i, resourceUsage: iu, memoryUsage: nu, kill: su, exit: ou, openStdin: au, allowedNodeEnvironmentFlags: lu, assert: uu, features: fu, _fatalExceptions: cu, setUncaughtExceptionCaptureCallback: hu, hasUncaughtExceptionCaptureCallback: du, emitWarning: jl, nextTick: Pl, _tickCallback: pu, _debugProcess: gu, _debugEnd: yu, _startProfilerIdleNotifier: bu, _stopProfilerIdleNotifier: wu, stdout: _u, stdin: vu, stderr: mu, abort: Eu, umask: Wl, chdir: Hl, cwd: $l, env: Ll, title: Ol, argv: Ul, execArgv: Nl, pid: Su, ppid: Au, execPath: Iu, debugPort: Tu, hrtime: Wi, argv0: Ru, _preload_modules: Cu, setSourceMapsEnabled: Bu };
});
var m = _e(function() {
  Hu();
});
var me = {};
Jt(me, { Buffer: function Buffer() {
  return x;
}, INSPECT_MAX_BYTES: function INSPECT_MAX_BYTES() {
  return ty;
}, default: function _default2() {
  return Ut;
}, kMaxLength: function kMaxLength() {
  return ry;
} });
function Xg() {
  if (Vu)
    return ci;
  Vu = true, ci.byteLength = a, ci.toByteArray = c, ci.fromByteArray = g;
  for (var t = [], e = [], r = (typeof Uint8Array === "undefined" ? "undefined" : _typeof(Uint8Array)) < "u" ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, o = i.length; n < o; ++n)
    t[n] = i[n], e[i.charCodeAt(n)] = n;
  e["-".charCodeAt(0)] = 62, e["_".charCodeAt(0)] = 63;
  function s(y) {
    var w = y.length;
    if (w % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var S = y.indexOf("=");
    S === -1 && (S = w);
    var E = S === w ? 0 : 4 - S % 4;
    return [S, E];
  }
  function a(y) {
    var w = s(y), S = w[0], E = w[1];
    return (S + E) * 3 / 4 - E;
  }
  function l(y, w, S) {
    return (w + S) * 3 / 4 - S;
  }
  function c(y) {
    var w, S = s(y), E = S[0], I = S[1], C = new r(l(y, E, I)), R = 0, U = I > 0 ? E - 4 : E, N;
    for (N = 0; N < U; N += 4)
      w = e[y.charCodeAt(N)] << 18 | e[y.charCodeAt(N + 1)] << 12 | e[y.charCodeAt(N + 2)] << 6 | e[y.charCodeAt(N + 3)], C[R++] = w >> 16 & 255, C[R++] = w >> 8 & 255, C[R++] = w & 255;
    return I === 2 && (w = e[y.charCodeAt(N)] << 2 | e[y.charCodeAt(N + 1)] >> 4, C[R++] = w & 255), I === 1 && (w = e[y.charCodeAt(N)] << 10 | e[y.charCodeAt(N + 1)] << 4 | e[y.charCodeAt(N + 2)] >> 2, C[R++] = w >> 8 & 255, C[R++] = w & 255), C;
  }
  function h(y) {
    return t[y >> 18 & 63] + t[y >> 12 & 63] + t[y >> 6 & 63] + t[y & 63];
  }
  function d(y, w, S) {
    for (var E, I = [], C = w; C < S; C += 3)
      E = (y[C] << 16 & 16711680) + (y[C + 1] << 8 & 65280) + (y[C + 2] & 255), I.push(h(E));
    return I.join("");
  }
  function g(y) {
    for (var w, S = y.length, E = S % 3, I = [], C = 16383, R = 0, U = S - E; R < U; R += C)
      I.push(d(y, R, R + C > U ? U : R + C));
    return E === 1 ? (w = y[S - 1], I.push(t[w >> 2] + t[w << 4 & 63] + "==")) : E === 2 && (w = (y[S - 2] << 8) + y[S - 1], I.push(t[w >> 10] + t[w >> 4 & 63] + t[w << 2 & 63] + "=")), I.join("");
  }
  return ci;
}
function Zg() {
  if (zu)
    return Hi;
  zu = true;
  return Hi.read = function(t, e, r, i, n) {
    var o, s, a = n * 8 - i - 1, l = (1 << a) - 1, c = l >> 1, h = -7, d = r ? n - 1 : 0, g = r ? -1 : 1, y = t[e + d];
    for (d += g, o = y & (1 << -h) - 1, y >>= -h, h += a; h > 0; o = o * 256 + t[e + d], d += g, h -= 8)
      ;
    for (s = o & (1 << -h) - 1, o >>= -h, h += i; h > 0; s = s * 256 + t[e + d], d += g, h -= 8)
      ;
    if (o === 0)
      o = 1 - c;
    else {
      if (o === l)
        return s ? NaN : (y ? -1 : 1) * (1 / 0);
      s = s + Math.pow(2, i), o = o - c;
    }
    return (y ? -1 : 1) * s * Math.pow(2, o - i);
  }, Hi.write = function(t, e, r, i, n, o) {
    var s, a, l, c = o * 8 - n - 1, h = (1 << c) - 1, d = h >> 1, g = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = i ? 0 : o - 1, w = i ? 1 : -1, S = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
    for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = h) : (s = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), s + d >= 1 ? e += g / l : e += g * Math.pow(2, 1 - d), e * l >= 2 && (s++, l /= 2), s + d >= h ? (a = 0, s = h) : s + d >= 1 ? (a = (e * l - 1) * Math.pow(2, n), s = s + d) : (a = e * Math.pow(2, d - 1) * Math.pow(2, n), s = 0)); n >= 8; t[r + y] = a & 255, y += w, a /= 256, n -= 8)
      ;
    for (s = s << n | a, c += n; c > 0; t[r + y] = s & 255, y += w, s /= 256, c -= 8)
      ;
    t[r + y - w] |= S * 128;
  }, Hi;
}
function ey() {
  if (Ku)
    return Zt;
  Ku = true;
  var t = Xg(), e = Zg(), r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  Zt.Buffer = s, Zt.SlowBuffer = I, Zt.INSPECT_MAX_BYTES = 50;
  var i = 2147483647;
  Zt.kMaxLength = i, s.TYPED_ARRAY_SUPPORT = n(), !s.TYPED_ARRAY_SUPPORT && (typeof console === "undefined" ? "undefined" : _typeof(console)) < "u" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
  function n() {
    try {
      var p = new Uint8Array(1), u = { foo: function foo() {
        return 42;
      } };
      return Object.setPrototypeOf(u, Uint8Array.prototype), Object.setPrototypeOf(p, u), p.foo() === 42;
    } catch (_unused) {
      return false;
    }
  }
  Object.defineProperty(s.prototype, "parent", { enumerable: true, get: function get2() {
    if (s.isBuffer(this))
      return this.buffer;
  } }), Object.defineProperty(s.prototype, "offset", { enumerable: true, get: function get2() {
    if (s.isBuffer(this))
      return this.byteOffset;
  } });
  function o(p) {
    if (p > i)
      throw new RangeError('The value "' + p + '" is invalid for option "size"');
    var u = new Uint8Array(p);
    return Object.setPrototypeOf(u, s.prototype), u;
  }
  function s(p, u, f) {
    if (typeof p == "number") {
      if (typeof u == "string")
        throw new TypeError('The "string" argument must be of type string. Received type number');
      return h(p);
    }
    return a(p, u, f);
  }
  s.poolSize = 8192;
  function a(p, u, f) {
    if (typeof p == "string")
      return d(p, u);
    if (ArrayBuffer.isView(p))
      return y(p);
    if (p == null)
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(p));
    if (Ye(p, ArrayBuffer) || p && Ye(p.buffer, ArrayBuffer) || (typeof SharedArrayBuffer === "undefined" ? "undefined" : _typeof(SharedArrayBuffer)) < "u" && (Ye(p, SharedArrayBuffer) || p && Ye(p.buffer, SharedArrayBuffer)))
      return w(p, u, f);
    if (typeof p == "number")
      throw new TypeError('The "value" argument must not be of type number. Received type number');
    var b = p.valueOf && p.valueOf();
    if (b != null && b !== p)
      return s.from(b, u, f);
    var A = S(p);
    if (A)
      return A;
    if ((typeof Symbol === "undefined" ? "undefined" : _typeof(Symbol)) < "u" && Symbol.toPrimitive != null && typeof p[Symbol.toPrimitive] == "function")
      return s.from(p[Symbol.toPrimitive]("string"), u, f);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(p));
  }
  s.from = function(p, u, f) {
    return a(p, u, f);
  }, Object.setPrototypeOf(s.prototype, Uint8Array.prototype), Object.setPrototypeOf(s, Uint8Array);
  function l(p) {
    if (typeof p != "number")
      throw new TypeError('"size" argument must be of type number');
    if (p < 0)
      throw new RangeError('The value "' + p + '" is invalid for option "size"');
  }
  function c(p, u, f) {
    return l(p), p <= 0 ? o(p) : u !== void 0 ? typeof f == "string" ? o(p).fill(u, f) : o(p).fill(u) : o(p);
  }
  s.alloc = function(p, u, f) {
    return c(p, u, f);
  };
  function h(p) {
    return l(p), o(p < 0 ? 0 : E(p) | 0);
  }
  s.allocUnsafe = function(p) {
    return h(p);
  }, s.allocUnsafeSlow = function(p) {
    return h(p);
  };
  function d(p, u) {
    if ((typeof u != "string" || u === "") && (u = "utf8"), !s.isEncoding(u))
      throw new TypeError("Unknown encoding: " + u);
    var f = C(p, u) | 0, b = o(f), A = b.write(p, u);
    return A !== f && (b = b.slice(0, A)), b;
  }
  function g(p) {
    var u = p.length < 0 ? 0 : E(p.length) | 0, f = o(u);
    for (var b = 0; b < u; b += 1)
      f[b] = p[b] & 255;
    return f;
  }
  function y(p) {
    if (Ye(p, Uint8Array)) {
      var u = new Uint8Array(p);
      return w(u.buffer, u.byteOffset, u.byteLength);
    }
    return g(p);
  }
  function w(p, u, f) {
    if (u < 0 || p.byteLength < u)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (p.byteLength < u + (f || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    var b;
    return u === void 0 && f === void 0 ? b = new Uint8Array(p) : f === void 0 ? b = new Uint8Array(p, u) : b = new Uint8Array(p, u, f), Object.setPrototypeOf(b, s.prototype), b;
  }
  function S(p) {
    if (s.isBuffer(p)) {
      var u = E(p.length) | 0, f = o(u);
      return f.length === 0 || p.copy(f, 0, 0, u), f;
    }
    if (p.length !== void 0)
      return typeof p.length != "number" || gs(p.length) ? o(0) : g(p);
    if (p.type === "Buffer" && Array.isArray(p.data))
      return g(p.data);
  }
  function E(p) {
    if (p >= i)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + i.toString(16) + " bytes");
    return p | 0;
  }
  function I(p) {
    return +p != p && (p = 0), s.alloc(+p);
  }
  s.isBuffer = function(u) {
    return u != null && u._isBuffer === true && u !== s.prototype;
  }, s.compare = function(u, f) {
    if (Ye(u, Uint8Array) && (u = s.from(u, u.offset, u.byteLength)), Ye(f, Uint8Array) && (f = s.from(f, f.offset, f.byteLength)), !s.isBuffer(u) || !s.isBuffer(f))
      throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (u === f)
      return 0;
    var b = u.length, A = f.length;
    for (var T = 0, P = Math.min(b, A); T < P; ++T)
      if (u[T] !== f[T]) {
        b = u[T], A = f[T];
        break;
      }
    return b < A ? -1 : A < b ? 1 : 0;
  }, s.isEncoding = function(u) {
    switch (String(u).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return true;
      default:
        return false;
    }
  }, s.concat = function(u, f) {
    if (!Array.isArray(u))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (u.length === 0)
      return s.alloc(0);
    var b;
    if (f === void 0)
      for (f = 0, b = 0; b < u.length; ++b)
        f += u[b].length;
    var A = s.allocUnsafe(f), T = 0;
    for (b = 0; b < u.length; ++b) {
      var P = u[b];
      if (Ye(P, Uint8Array))
        T + P.length > A.length ? (s.isBuffer(P) || (P = s.from(P)), P.copy(A, T)) : Uint8Array.prototype.set.call(A, P, T);
      else if (s.isBuffer(P))
        P.copy(A, T);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      T += P.length;
    }
    return A;
  };
  function C(p, u) {
    if (s.isBuffer(p))
      return p.length;
    if (ArrayBuffer.isView(p) || Ye(p, ArrayBuffer))
      return p.byteLength;
    if (typeof p != "string")
      throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + _typeof(p));
    var f = p.length, b = arguments.length > 2 && arguments[2] === true;
    if (!b && f === 0)
      return 0;
    var A = false;
    for (; ; )
      switch (u) {
        case "ascii":
        case "latin1":
        case "binary":
          return f;
        case "utf8":
        case "utf-8":
          return ps(p).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return f * 2;
        case "hex":
          return f >>> 1;
        case "base64":
          return Cl(p).length;
        default:
          if (A)
            return b ? -1 : ps(p).length;
          u = ("" + u).toLowerCase(), A = true;
      }
  }
  s.byteLength = C;
  function R(p, u, f) {
    var b = false;
    if ((u === void 0 || u < 0) && (u = 0), u > this.length || ((f === void 0 || f > this.length) && (f = this.length), f <= 0) || (f >>>= 0, u >>>= 0, f <= u))
      return "";
    for (p || (p = "utf8"); ; )
      switch (p) {
        case "hex":
          return qg(this, u, f);
        case "utf8":
        case "utf-8":
          return Pr(this, u, f);
        case "ascii":
          return hs(this, u, f);
        case "latin1":
        case "binary":
          return Ng(this, u, f);
        case "base64":
          return ge(this, u, f);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Dg(this, u, f);
        default:
          if (b)
            throw new TypeError("Unknown encoding: " + p);
          p = (p + "").toLowerCase(), b = true;
      }
  }
  s.prototype._isBuffer = true;
  function U(p, u, f) {
    var b = p[u];
    p[u] = p[f], p[f] = b;
  }
  s.prototype.swap16 = function() {
    var u = this.length;
    if (u % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var f = 0; f < u; f += 2)
      U(this, f, f + 1);
    return this;
  }, s.prototype.swap32 = function() {
    var u = this.length;
    if (u % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var f = 0; f < u; f += 4)
      U(this, f, f + 3), U(this, f + 1, f + 2);
    return this;
  }, s.prototype.swap64 = function() {
    var u = this.length;
    if (u % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var f = 0; f < u; f += 8)
      U(this, f, f + 7), U(this, f + 1, f + 6), U(this, f + 2, f + 5), U(this, f + 3, f + 4);
    return this;
  }, s.prototype.toString = function() {
    var u = this.length;
    return u === 0 ? "" : arguments.length === 0 ? Pr(this, 0, u) : R.apply(this, arguments);
  }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(u) {
    if (!s.isBuffer(u))
      throw new TypeError("Argument must be a Buffer");
    return this === u ? true : s.compare(this, u) === 0;
  }, s.prototype.inspect = function() {
    var u = "", f = Zt.INSPECT_MAX_BYTES;
    return u = this.toString("hex", 0, f).replace(/(.{2})/g, "$1 ").trim(), this.length > f && (u += " ... "), "<Buffer " + u + ">";
  }, r && (s.prototype[r] = s.prototype.inspect), s.prototype.compare = function(u, f, b, A, T) {
    if (Ye(u, Uint8Array) && (u = s.from(u, u.offset, u.byteLength)), !s.isBuffer(u))
      throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + _typeof(u));
    if (f === void 0 && (f = 0), b === void 0 && (b = u ? u.length : 0), A === void 0 && (A = 0), T === void 0 && (T = this.length), f < 0 || b > u.length || A < 0 || T > this.length)
      throw new RangeError("out of range index");
    if (A >= T && f >= b)
      return 0;
    if (A >= T)
      return -1;
    if (f >= b)
      return 1;
    if (f >>>= 0, b >>>= 0, A >>>= 0, T >>>= 0, this === u)
      return 0;
    var P = T - A, $ = b - f, se = Math.min(P, $), te = this.slice(A, T), oe = u.slice(f, b);
    for (var J = 0; J < se; ++J)
      if (te[J] !== oe[J]) {
        P = te[J], $ = oe[J];
        break;
      }
    return P < $ ? -1 : $ < P ? 1 : 0;
  };
  function N(p, u, f, b, A) {
    if (p.length === 0)
      return -1;
    if (typeof f == "string" ? (b = f, f = 0) : f > 2147483647 ? f = 2147483647 : f < -2147483648 && (f = -2147483648), f = +f, gs(f) && (f = A ? 0 : p.length - 1), f < 0 && (f = p.length + f), f >= p.length) {
      if (A)
        return -1;
      f = p.length - 1;
    } else if (f < 0)
      if (A)
        f = 0;
      else
        return -1;
    if (typeof u == "string" && (u = s.from(u, b)), s.isBuffer(u))
      return u.length === 0 ? -1 : W(p, u, f, b, A);
    if (typeof u == "number")
      return u = u & 255, typeof Uint8Array.prototype.indexOf == "function" ? A ? Uint8Array.prototype.indexOf.call(p, u, f) : Uint8Array.prototype.lastIndexOf.call(p, u, f) : W(p, [u], f, b, A);
    throw new TypeError("val must be string, number or Buffer");
  }
  function W(p, u, f, b, A) {
    var T = 1, P = p.length, $ = u.length;
    if (b !== void 0 && (b = String(b).toLowerCase(), b === "ucs2" || b === "ucs-2" || b === "utf16le" || b === "utf-16le")) {
      if (p.length < 2 || u.length < 2)
        return -1;
      T = 2, P /= 2, $ /= 2, f /= 2;
    }
    function se(oe2, J2) {
      return T === 1 ? oe2[J2] : oe2.readUInt16BE(J2 * T);
    }
    var te;
    if (A) {
      var oe = -1;
      for (te = f; te < P; te++)
        if (se(p, te) === se(u, oe === -1 ? 0 : te - oe)) {
          if (oe === -1 && (oe = te), te - oe + 1 === $)
            return oe * T;
        } else
          oe !== -1 && (te -= te - oe), oe = -1;
    } else
      for (f + $ > P && (f = P - $), te = f; te >= 0; te--) {
        var _oe = true;
        for (var J = 0; J < $; J++)
          if (se(p, te + J) !== se(u, J)) {
            _oe = false;
            break;
          }
        if (_oe)
          return te;
      }
    return -1;
  }
  s.prototype.includes = function(u, f, b) {
    return this.indexOf(u, f, b) !== -1;
  }, s.prototype.indexOf = function(u, f, b) {
    return N(this, u, f, b, true);
  }, s.prototype.lastIndexOf = function(u, f, b) {
    return N(this, u, f, b, false);
  };
  function K(p, u, f, b) {
    f = Number(f) || 0;
    var A = p.length - f;
    b ? (b = Number(b), b > A && (b = A)) : b = A;
    var T = u.length;
    b > T / 2 && (b = T / 2);
    var P;
    for (P = 0; P < b; ++P) {
      var $ = parseInt(u.substr(P * 2, 2), 16);
      if (gs($))
        return P;
      p[f + P] = $;
    }
    return P;
  }
  function z(p, u, f, b) {
    return ji(ps(u, p.length - f), p, f, b);
  }
  function Q(p, u, f, b) {
    return ji($g(u), p, f, b);
  }
  function pe(p, u, f, b) {
    return ji(Cl(u), p, f, b);
  }
  function Yt(p, u, f, b) {
    return ji(Hg(u, p.length - f), p, f, b);
  }
  s.prototype.write = function(u, f, b, A) {
    if (f === void 0)
      A = "utf8", b = this.length, f = 0;
    else if (b === void 0 && typeof f == "string")
      A = f, b = this.length, f = 0;
    else if (isFinite(f))
      f = f >>> 0, isFinite(b) ? (b = b >>> 0, A === void 0 && (A = "utf8")) : (A = b, b = void 0);
    else
      throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var T = this.length - f;
    if ((b === void 0 || b > T) && (b = T), u.length > 0 && (b < 0 || f < 0) || f > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    A || (A = "utf8");
    var P = false;
    for (; ; )
      switch (A) {
        case "hex":
          return K(this, u, f, b);
        case "utf8":
        case "utf-8":
          return z(this, u, f, b);
        case "ascii":
        case "latin1":
        case "binary":
          return Q(this, u, f, b);
        case "base64":
          return pe(this, u, f, b);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Yt(this, u, f, b);
        default:
          if (P)
            throw new TypeError("Unknown encoding: " + A);
          A = ("" + A).toLowerCase(), P = true;
      }
  }, s.prototype.toJSON = function() {
    return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
  };
  function ge(p, u, f) {
    return u === 0 && f === p.length ? t.fromByteArray(p) : t.fromByteArray(p.slice(u, f));
  }
  function Pr(p, u, f) {
    f = Math.min(p.length, f);
    var b = [], A = u;
    for (; A < f; ) {
      var T = p[A], P = null, $ = T > 239 ? 4 : T > 223 ? 3 : T > 191 ? 2 : 1;
      if (A + $ <= f) {
        var se = void 0, te = void 0, oe = void 0, J = void 0;
        switch ($) {
          case 1:
            T < 128 && (P = T);
            break;
          case 2:
            se = p[A + 1], (se & 192) === 128 && (J = (T & 31) << 6 | se & 63, J > 127 && (P = J));
            break;
          case 3:
            se = p[A + 1], te = p[A + 2], (se & 192) === 128 && (te & 192) === 128 && (J = (T & 15) << 12 | (se & 63) << 6 | te & 63, J > 2047 && (J < 55296 || J > 57343) && (P = J));
            break;
          case 4:
            se = p[A + 1], te = p[A + 2], oe = p[A + 3], (se & 192) === 128 && (te & 192) === 128 && (oe & 192) === 128 && (J = (T & 15) << 18 | (se & 63) << 12 | (te & 63) << 6 | oe & 63, J > 65535 && J < 1114112 && (P = J));
        }
      }
      P === null ? (P = 65533, $ = 1) : P > 65535 && (P -= 65536, b.push(P >>> 10 & 1023 | 55296), P = 56320 | P & 1023), b.push(P), A += $;
    }
    return Or(b);
  }
  var kr = 4096;
  function Or(p) {
    var u = p.length;
    if (u <= kr)
      return String.fromCharCode.apply(String, p);
    var f = "", b = 0;
    for (; b < u; )
      f += String.fromCharCode.apply(String, p.slice(b, b += kr));
    return f;
  }
  function hs(p, u, f) {
    var b = "";
    f = Math.min(p.length, f);
    for (var A = u; A < f; ++A)
      b += String.fromCharCode(p[A] & 127);
    return b;
  }
  function Ng(p, u, f) {
    var b = "";
    f = Math.min(p.length, f);
    for (var A = u; A < f; ++A)
      b += String.fromCharCode(p[A]);
    return b;
  }
  function qg(p, u, f) {
    var b = p.length;
    (!u || u < 0) && (u = 0), (!f || f < 0 || f > b) && (f = b);
    var A = "";
    for (var T = u; T < f; ++T)
      A += Vg[p[T]];
    return A;
  }
  function Dg(p, u, f) {
    var b = p.slice(u, f), A = "";
    for (var T = 0; T < b.length - 1; T += 2)
      A += String.fromCharCode(b[T] + b[T + 1] * 256);
    return A;
  }
  s.prototype.slice = function(u, f) {
    var b = this.length;
    u = ~~u, f = f === void 0 ? b : ~~f, u < 0 ? (u += b, u < 0 && (u = 0)) : u > b && (u = b), f < 0 ? (f += b, f < 0 && (f = 0)) : f > b && (f = b), f < u && (f = u);
    var A = this.subarray(u, f);
    return Object.setPrototypeOf(A, s.prototype), A;
  };
  function ye(p, u, f) {
    if (p % 1 !== 0 || p < 0)
      throw new RangeError("offset is not uint");
    if (p + u > f)
      throw new RangeError("Trying to access beyond buffer length");
  }
  s.prototype.readUintLE = s.prototype.readUIntLE = function(u, f, b) {
    u = u >>> 0, f = f >>> 0, b || ye(u, f, this.length);
    var A = this[u], T = 1, P = 0;
    for (; ++P < f && (T *= 256); )
      A += this[u + P] * T;
    return A;
  }, s.prototype.readUintBE = s.prototype.readUIntBE = function(u, f, b) {
    u = u >>> 0, f = f >>> 0, b || ye(u, f, this.length);
    var A = this[u + --f], T = 1;
    for (; f > 0 && (T *= 256); )
      A += this[u + --f] * T;
    return A;
  }, s.prototype.readUint8 = s.prototype.readUInt8 = function(u, f) {
    return u = u >>> 0, f || ye(u, 1, this.length), this[u];
  }, s.prototype.readUint16LE = s.prototype.readUInt16LE = function(u, f) {
    return u = u >>> 0, f || ye(u, 2, this.length), this[u] | this[u + 1] << 8;
  }, s.prototype.readUint16BE = s.prototype.readUInt16BE = function(u, f) {
    return u = u >>> 0, f || ye(u, 2, this.length), this[u] << 8 | this[u + 1];
  }, s.prototype.readUint32LE = s.prototype.readUInt32LE = function(u, f) {
    return u = u >>> 0, f || ye(u, 4, this.length), (this[u] | this[u + 1] << 8 | this[u + 2] << 16) + this[u + 3] * 16777216;
  }, s.prototype.readUint32BE = s.prototype.readUInt32BE = function(u, f) {
    return u = u >>> 0, f || ye(u, 4, this.length), this[u] * 16777216 + (this[u + 1] << 16 | this[u + 2] << 8 | this[u + 3]);
  }, s.prototype.readBigUInt64LE = Mt(function(u) {
    u = u >>> 0, Mr(u, "offset");
    var f = this[u], b = this[u + 7];
    (f === void 0 || b === void 0) && fi(u, this.length - 8);
    var A = f + this[++u] * Math.pow(2, 8) + this[++u] * Math.pow(2, 16) + this[++u] * Math.pow(2, 24), T = this[++u] + this[++u] * Math.pow(2, 8) + this[++u] * Math.pow(2, 16) + b * Math.pow(2, 24);
    return BigInt(A) + (BigInt(T) << BigInt(32));
  }), s.prototype.readBigUInt64BE = Mt(function(u) {
    u = u >>> 0, Mr(u, "offset");
    var f = this[u], b = this[u + 7];
    (f === void 0 || b === void 0) && fi(u, this.length - 8);
    var A = f * Math.pow(2, 24) + this[++u] * Math.pow(2, 16) + this[++u] * Math.pow(2, 8) + this[++u], T = this[++u] * Math.pow(2, 24) + this[++u] * Math.pow(2, 16) + this[++u] * Math.pow(2, 8) + b;
    return (BigInt(A) << BigInt(32)) + BigInt(T);
  }), s.prototype.readIntLE = function(u, f, b) {
    u = u >>> 0, f = f >>> 0, b || ye(u, f, this.length);
    var A = this[u], T = 1, P = 0;
    for (; ++P < f && (T *= 256); )
      A += this[u + P] * T;
    return T *= 128, A >= T && (A -= Math.pow(2, 8 * f)), A;
  }, s.prototype.readIntBE = function(u, f, b) {
    u = u >>> 0, f = f >>> 0, b || ye(u, f, this.length);
    var A = f, T = 1, P = this[u + --A];
    for (; A > 0 && (T *= 256); )
      P += this[u + --A] * T;
    return T *= 128, P >= T && (P -= Math.pow(2, 8 * f)), P;
  }, s.prototype.readInt8 = function(u, f) {
    return u = u >>> 0, f || ye(u, 1, this.length), this[u] & 128 ? (255 - this[u] + 1) * -1 : this[u];
  }, s.prototype.readInt16LE = function(u, f) {
    u = u >>> 0, f || ye(u, 2, this.length);
    var b = this[u] | this[u + 1] << 8;
    return b & 32768 ? b | 4294901760 : b;
  }, s.prototype.readInt16BE = function(u, f) {
    u = u >>> 0, f || ye(u, 2, this.length);
    var b = this[u + 1] | this[u] << 8;
    return b & 32768 ? b | 4294901760 : b;
  }, s.prototype.readInt32LE = function(u, f) {
    return u = u >>> 0, f || ye(u, 4, this.length), this[u] | this[u + 1] << 8 | this[u + 2] << 16 | this[u + 3] << 24;
  }, s.prototype.readInt32BE = function(u, f) {
    return u = u >>> 0, f || ye(u, 4, this.length), this[u] << 24 | this[u + 1] << 16 | this[u + 2] << 8 | this[u + 3];
  }, s.prototype.readBigInt64LE = Mt(function(u) {
    u = u >>> 0, Mr(u, "offset");
    var f = this[u], b = this[u + 7];
    (f === void 0 || b === void 0) && fi(u, this.length - 8);
    var A = this[u + 4] + this[u + 5] * Math.pow(2, 8) + this[u + 6] * Math.pow(2, 16) + (b << 24);
    return (BigInt(A) << BigInt(32)) + BigInt(f + this[++u] * Math.pow(2, 8) + this[++u] * Math.pow(2, 16) + this[++u] * Math.pow(2, 24));
  }), s.prototype.readBigInt64BE = Mt(function(u) {
    u = u >>> 0, Mr(u, "offset");
    var f = this[u], b = this[u + 7];
    (f === void 0 || b === void 0) && fi(u, this.length - 8);
    var A = (f << 24) + this[++u] * Math.pow(2, 16) + this[++u] * Math.pow(2, 8) + this[++u];
    return (BigInt(A) << BigInt(32)) + BigInt(this[++u] * Math.pow(2, 24) + this[++u] * Math.pow(2, 16) + this[++u] * Math.pow(2, 8) + b);
  }), s.prototype.readFloatLE = function(u, f) {
    return u = u >>> 0, f || ye(u, 4, this.length), e.read(this, u, true, 23, 4);
  }, s.prototype.readFloatBE = function(u, f) {
    return u = u >>> 0, f || ye(u, 4, this.length), e.read(this, u, false, 23, 4);
  }, s.prototype.readDoubleLE = function(u, f) {
    return u = u >>> 0, f || ye(u, 8, this.length), e.read(this, u, true, 52, 8);
  }, s.prototype.readDoubleBE = function(u, f) {
    return u = u >>> 0, f || ye(u, 8, this.length), e.read(this, u, false, 52, 8);
  };
  function Ce(p, u, f, b, A, T) {
    if (!s.isBuffer(p))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (u > A || u < T)
      throw new RangeError('"value" argument is out of bounds');
    if (f + b > p.length)
      throw new RangeError("Index out of range");
  }
  s.prototype.writeUintLE = s.prototype.writeUIntLE = function(u, f, b, A) {
    if (u = +u, f = f >>> 0, b = b >>> 0, !A) {
      var $ = Math.pow(2, 8 * b) - 1;
      Ce(this, u, f, b, $, 0);
    }
    var T = 1, P = 0;
    for (this[f] = u & 255; ++P < b && (T *= 256); )
      this[f + P] = u / T & 255;
    return f + b;
  }, s.prototype.writeUintBE = s.prototype.writeUIntBE = function(u, f, b, A) {
    if (u = +u, f = f >>> 0, b = b >>> 0, !A) {
      var $ = Math.pow(2, 8 * b) - 1;
      Ce(this, u, f, b, $, 0);
    }
    var T = b - 1, P = 1;
    for (this[f + T] = u & 255; --T >= 0 && (P *= 256); )
      this[f + T] = u / P & 255;
    return f + b;
  }, s.prototype.writeUint8 = s.prototype.writeUInt8 = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 1, 255, 0), this[f] = u & 255, f + 1;
  }, s.prototype.writeUint16LE = s.prototype.writeUInt16LE = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 2, 65535, 0), this[f] = u & 255, this[f + 1] = u >>> 8, f + 2;
  }, s.prototype.writeUint16BE = s.prototype.writeUInt16BE = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 2, 65535, 0), this[f] = u >>> 8, this[f + 1] = u & 255, f + 2;
  }, s.prototype.writeUint32LE = s.prototype.writeUInt32LE = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 4, 4294967295, 0), this[f + 3] = u >>> 24, this[f + 2] = u >>> 16, this[f + 1] = u >>> 8, this[f] = u & 255, f + 4;
  }, s.prototype.writeUint32BE = s.prototype.writeUInt32BE = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 4, 4294967295, 0), this[f] = u >>> 24, this[f + 1] = u >>> 16, this[f + 2] = u >>> 8, this[f + 3] = u & 255, f + 4;
  };
  function vl(p, u, f, b, A) {
    Rl(u, b, A, p, f, 7);
    var T = Number(u & BigInt(4294967295));
    p[f++] = T, T = T >> 8, p[f++] = T, T = T >> 8, p[f++] = T, T = T >> 8, p[f++] = T;
    var P = Number(u >> BigInt(32) & BigInt(4294967295));
    return p[f++] = P, P = P >> 8, p[f++] = P, P = P >> 8, p[f++] = P, P = P >> 8, p[f++] = P, f;
  }
  function El(p, u, f, b, A) {
    Rl(u, b, A, p, f, 7);
    var T = Number(u & BigInt(4294967295));
    p[f + 7] = T, T = T >> 8, p[f + 6] = T, T = T >> 8, p[f + 5] = T, T = T >> 8, p[f + 4] = T;
    var P = Number(u >> BigInt(32) & BigInt(4294967295));
    return p[f + 3] = P, P = P >> 8, p[f + 2] = P, P = P >> 8, p[f + 1] = P, P = P >> 8, p[f] = P, f + 8;
  }
  s.prototype.writeBigUInt64LE = Mt(function(u) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return vl(this, u, f, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeBigUInt64BE = Mt(function(u) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return El(this, u, f, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeIntLE = function(u, f, b, A) {
    if (u = +u, f = f >>> 0, !A) {
      var se = Math.pow(2, 8 * b - 1);
      Ce(this, u, f, b, se - 1, -se);
    }
    var T = 0, P = 1, $ = 0;
    for (this[f] = u & 255; ++T < b && (P *= 256); )
      u < 0 && $ === 0 && this[f + T - 1] !== 0 && ($ = 1), this[f + T] = (u / P >> 0) - $ & 255;
    return f + b;
  }, s.prototype.writeIntBE = function(u, f, b, A) {
    if (u = +u, f = f >>> 0, !A) {
      var se = Math.pow(2, 8 * b - 1);
      Ce(this, u, f, b, se - 1, -se);
    }
    var T = b - 1, P = 1, $ = 0;
    for (this[f + T] = u & 255; --T >= 0 && (P *= 256); )
      u < 0 && $ === 0 && this[f + T + 1] !== 0 && ($ = 1), this[f + T] = (u / P >> 0) - $ & 255;
    return f + b;
  }, s.prototype.writeInt8 = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 1, 127, -128), u < 0 && (u = 255 + u + 1), this[f] = u & 255, f + 1;
  }, s.prototype.writeInt16LE = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 2, 32767, -32768), this[f] = u & 255, this[f + 1] = u >>> 8, f + 2;
  }, s.prototype.writeInt16BE = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 2, 32767, -32768), this[f] = u >>> 8, this[f + 1] = u & 255, f + 2;
  }, s.prototype.writeInt32LE = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 4, 2147483647, -2147483648), this[f] = u & 255, this[f + 1] = u >>> 8, this[f + 2] = u >>> 16, this[f + 3] = u >>> 24, f + 4;
  }, s.prototype.writeInt32BE = function(u, f, b) {
    return u = +u, f = f >>> 0, b || Ce(this, u, f, 4, 2147483647, -2147483648), u < 0 && (u = 4294967295 + u + 1), this[f] = u >>> 24, this[f + 1] = u >>> 16, this[f + 2] = u >>> 8, this[f + 3] = u & 255, f + 4;
  }, s.prototype.writeBigInt64LE = Mt(function(u) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return vl(this, u, f, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), s.prototype.writeBigInt64BE = Mt(function(u) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return El(this, u, f, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function Sl(p, u, f, b, A, T) {
    if (f + b > p.length)
      throw new RangeError("Index out of range");
    if (f < 0)
      throw new RangeError("Index out of range");
  }
  function Al(p, u, f, b, A) {
    return u = +u, f = f >>> 0, A || Sl(p, u, f, 4), e.write(p, u, f, b, 23, 4), f + 4;
  }
  s.prototype.writeFloatLE = function(u, f, b) {
    return Al(this, u, f, true, b);
  }, s.prototype.writeFloatBE = function(u, f, b) {
    return Al(this, u, f, false, b);
  };
  function Il(p, u, f, b, A) {
    return u = +u, f = f >>> 0, A || Sl(p, u, f, 8), e.write(p, u, f, b, 52, 8), f + 8;
  }
  s.prototype.writeDoubleLE = function(u, f, b) {
    return Il(this, u, f, true, b);
  }, s.prototype.writeDoubleBE = function(u, f, b) {
    return Il(this, u, f, false, b);
  }, s.prototype.copy = function(u, f, b, A) {
    if (!s.isBuffer(u))
      throw new TypeError("argument should be a Buffer");
    if (b || (b = 0), !A && A !== 0 && (A = this.length), f >= u.length && (f = u.length), f || (f = 0), A > 0 && A < b && (A = b), A === b || u.length === 0 || this.length === 0)
      return 0;
    if (f < 0)
      throw new RangeError("targetStart out of bounds");
    if (b < 0 || b >= this.length)
      throw new RangeError("Index out of range");
    if (A < 0)
      throw new RangeError("sourceEnd out of bounds");
    A > this.length && (A = this.length), u.length - f < A - b && (A = u.length - f + b);
    var T = A - b;
    return this === u && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(f, b, A) : Uint8Array.prototype.set.call(u, this.subarray(b, A), f), T;
  }, s.prototype.fill = function(u, f, b, A) {
    if (typeof u == "string") {
      if (typeof f == "string" ? (A = f, f = 0, b = this.length) : typeof b == "string" && (A = b, b = this.length), A !== void 0 && typeof A != "string")
        throw new TypeError("encoding must be a string");
      if (typeof A == "string" && !s.isEncoding(A))
        throw new TypeError("Unknown encoding: " + A);
      if (u.length === 1) {
        var P = u.charCodeAt(0);
        (A === "utf8" && P < 128 || A === "latin1") && (u = P);
      }
    } else
      typeof u == "number" ? u = u & 255 : typeof u == "boolean" && (u = Number(u));
    if (f < 0 || this.length < f || this.length < b)
      throw new RangeError("Out of range index");
    if (b <= f)
      return this;
    f = f >>> 0, b = b === void 0 ? this.length : b >>> 0, u || (u = 0);
    var T;
    if (typeof u == "number")
      for (T = f; T < b; ++T)
        this[T] = u;
    else {
      var _P = s.isBuffer(u) ? u : s.from(u, A), $ = _P.length;
      if ($ === 0)
        throw new TypeError('The value "' + u + '" is invalid for argument "value"');
      for (T = 0; T < b - f; ++T)
        this[T + f] = _P[T % $];
    }
    return this;
  };
  var xr = {};
  function ds(p, u, f) {
    xr[p] = /* @__PURE__ */ function(_f2) {
      function _class() {
        var _this;
        _classCallCheck(this, _class);
        _this = _callSuper(this, _class), Object.defineProperty(_assertThisInitialized(_this), "message", { value: u.apply(_assertThisInitialized(_this), arguments), writable: true, configurable: true }), _this.name = "".concat(_this.name, " [").concat(p, "]"), _this.stack, delete _this.name;
        return _this;
      }
      _inherits(_class, _f2);
      return _createClass(_class, [{ key: "code", get: function get2() {
        return p;
      }, set: function set(A) {
        Object.defineProperty(this, "code", { configurable: true, enumerable: true, value: A, writable: true });
      } }, { key: "toString", value: function toString() {
        return "".concat(this.name, " [").concat(p, "]: ").concat(this.message);
      } }]);
    }(f);
  }
  ds("ERR_BUFFER_OUT_OF_BOUNDS", function(p) {
    return p ? "".concat(p, " is outside of buffer bounds") : "Attempt to access memory outside buffer bounds";
  }, RangeError), ds("ERR_INVALID_ARG_TYPE", function(p, u) {
    return 'The "'.concat(p, '" argument must be of type number. Received type ').concat(_typeof(u));
  }, TypeError), ds("ERR_OUT_OF_RANGE", function(p, u, f) {
    var b = 'The value of "'.concat(p, '" is out of range.'), A = f;
    return Number.isInteger(f) && Math.abs(f) > Math.pow(2, 32) ? A = Tl(String(f)) : typeof f == "bigint" && (A = String(f), (f > Math.pow(BigInt(2), BigInt(32)) || f < -Math.pow(BigInt(2), BigInt(32))) && (A = Tl(A)), A += "n"), b += " It must be ".concat(u, ". Received ").concat(A), b;
  }, RangeError);
  function Tl(p) {
    var u = "", f = p.length, b = p[0] === "-" ? 1 : 0;
    for (; f >= b + 4; f -= 3)
      u = "_".concat(p.slice(f - 3, f)).concat(u);
    return "".concat(p.slice(0, f)).concat(u);
  }
  function jg(p, u, f) {
    Mr(u, "offset"), (p[u] === void 0 || p[u + f] === void 0) && fi(u, p.length - (f + 1));
  }
  function Rl(p, u, f, b, A, T) {
    if (p > f || p < u) {
      var P = typeof u == "bigint" ? "n" : "", $;
      throw T > 3 ? u === 0 || u === BigInt(0) ? $ = ">= 0".concat(P, " and < 2").concat(P, " ** ").concat((T + 1) * 8).concat(P) : $ = ">= -(2".concat(P, " ** ").concat((T + 1) * 8 - 1).concat(P, ") and < 2 ** ").concat((T + 1) * 8 - 1).concat(P) : $ = ">= ".concat(u).concat(P, " and <= ").concat(f).concat(P), new xr.ERR_OUT_OF_RANGE("value", $, p);
    }
    jg(b, A, T);
  }
  function Mr(p, u) {
    if (typeof p != "number")
      throw new xr.ERR_INVALID_ARG_TYPE(u, "number", p);
  }
  function fi(p, u, f) {
    throw Math.floor(p) !== p ? (Mr(p, f), new xr.ERR_OUT_OF_RANGE(f || "offset", "an integer", p)) : u < 0 ? new xr.ERR_BUFFER_OUT_OF_BOUNDS() : new xr.ERR_OUT_OF_RANGE(f || "offset", ">= ".concat(f ? 1 : 0, " and <= ").concat(u), p);
  }
  var Fg = /[^+/0-9A-Za-z-_]/g;
  function Wg(p) {
    if (p = p.split("=")[0], p = p.trim().replace(Fg, ""), p.length < 2)
      return "";
    for (; p.length % 4 !== 0; )
      p = p + "=";
    return p;
  }
  function ps(p, u) {
    u = u || 1 / 0;
    var f, b = p.length, A = null, T = [];
    for (var P = 0; P < b; ++P) {
      if (f = p.charCodeAt(P), f > 55295 && f < 57344) {
        if (!A) {
          if (f > 56319) {
            (u -= 3) > -1 && T.push(239, 191, 189);
            continue;
          } else if (P + 1 === b) {
            (u -= 3) > -1 && T.push(239, 191, 189);
            continue;
          }
          A = f;
          continue;
        }
        if (f < 56320) {
          (u -= 3) > -1 && T.push(239, 191, 189), A = f;
          continue;
        }
        f = (A - 55296 << 10 | f - 56320) + 65536;
      } else
        A && (u -= 3) > -1 && T.push(239, 191, 189);
      if (A = null, f < 128) {
        if ((u -= 1) < 0)
          break;
        T.push(f);
      } else if (f < 2048) {
        if ((u -= 2) < 0)
          break;
        T.push(f >> 6 | 192, f & 63 | 128);
      } else if (f < 65536) {
        if ((u -= 3) < 0)
          break;
        T.push(f >> 12 | 224, f >> 6 & 63 | 128, f & 63 | 128);
      } else if (f < 1114112) {
        if ((u -= 4) < 0)
          break;
        T.push(f >> 18 | 240, f >> 12 & 63 | 128, f >> 6 & 63 | 128, f & 63 | 128);
      } else
        throw new Error("Invalid code point");
    }
    return T;
  }
  function $g(p) {
    var u = [];
    for (var f = 0; f < p.length; ++f)
      u.push(p.charCodeAt(f) & 255);
    return u;
  }
  function Hg(p, u) {
    var f, b, A, T = [];
    for (var P = 0; P < p.length && !((u -= 2) < 0); ++P)
      f = p.charCodeAt(P), b = f >> 8, A = f % 256, T.push(A), T.push(b);
    return T;
  }
  function Cl(p) {
    return t.toByteArray(Wg(p));
  }
  function ji(p, u, f, b) {
    var A;
    for (A = 0; A < b && !(A + f >= u.length || A >= p.length); ++A)
      u[A + f] = p[A];
    return A;
  }
  function Ye(p, u) {
    return p instanceof u || p != null && p.constructor != null && p.constructor.name != null && p.constructor.name === u.name;
  }
  function gs(p) {
    return p !== p;
  }
  var Vg = function() {
    var p = "0123456789abcdef", u = new Array(256);
    for (var f = 0; f < 16; ++f) {
      var b = f * 16;
      for (var A = 0; A < 16; ++A)
        u[b + A] = p[f] + p[A];
    }
    return u;
  }();
  function Mt(p) {
    return (typeof BigInt === "undefined" ? "undefined" : _typeof(BigInt)) > "u" ? zg : p;
  }
  function zg() {
    throw new Error("BigInt not supported");
  }
  return Zt;
}
var ci, Vu, Hi, zu, Zt, Ku, Ut, x, ty, ry, be = _e(function() {
  _();
  v();
  m();
  ci = {}, Vu = false;
  Hi = {}, zu = false;
  Zt = {}, Ku = false;
  Ut = ey();
  Ut.Buffer;
  Ut.SlowBuffer;
  Ut.INSPECT_MAX_BYTES;
  Ut.kMaxLength;
  x = Ut.Buffer, ty = Ut.INSPECT_MAX_BYTES, ry = Ut.kMaxLength;
});
var v = _e(function() {
  be();
});
var Gu = M(function(vs) {
  _();
  v();
  m();
  Object.defineProperty(vs, "__esModule", { value: true });
  var ms = /* @__PURE__ */ function() {
    function ms2(e) {
      _classCallCheck(this, ms2);
      this.aliasToTopic = {}, this.max = e;
    }
    return _createClass(ms2, [{ key: "put", value: function put2(e, r) {
      return r === 0 || r > this.max ? false : (this.aliasToTopic[r] = e, this.length = Object.keys(this.aliasToTopic).length, true);
    } }, { key: "getTopicByAlias", value: function getTopicByAlias(e) {
      return this.aliasToTopic[e];
    } }, { key: "clear", value: function clear() {
      this.aliasToTopic = {};
    } }]);
  }();
  vs.default = ms;
});
var ce = M(function(xA, Qu) {
  _();
  v();
  m();
  Qu.exports = { ArrayIsArray: function ArrayIsArray(t) {
    return Array.isArray(t);
  }, ArrayPrototypeIncludes: function ArrayPrototypeIncludes(t, e) {
    return t.includes(e);
  }, ArrayPrototypeIndexOf: function ArrayPrototypeIndexOf(t, e) {
    return t.indexOf(e);
  }, ArrayPrototypeJoin: function ArrayPrototypeJoin(t, e) {
    return t.join(e);
  }, ArrayPrototypeMap: function ArrayPrototypeMap(t, e) {
    return t.map(e);
  }, ArrayPrototypePop: function ArrayPrototypePop(t, e) {
    return t.pop(e);
  }, ArrayPrototypePush: function ArrayPrototypePush(t, e) {
    return t.push(e);
  }, ArrayPrototypeSlice: function ArrayPrototypeSlice(t, e, r) {
    return t.slice(e, r);
  }, Error, FunctionPrototypeCall: function FunctionPrototypeCall(t, e) {
    for (var _len = arguments.length, r = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      r[_key - 2] = arguments[_key];
    }
    return t.call.apply(t, [e].concat(r));
  }, FunctionPrototypeSymbolHasInstance: function FunctionPrototypeSymbolHasInstance(t, e) {
    return Function.prototype[Symbol.hasInstance].call(t, e);
  }, MathFloor: Math.floor, Number, NumberIsInteger: Number.isInteger, NumberIsNaN: Number.isNaN, NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER, NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER, NumberParseInt: Number.parseInt, ObjectDefineProperties: function ObjectDefineProperties(t, e) {
    return Object.defineProperties(t, e);
  }, ObjectDefineProperty: function ObjectDefineProperty(t, e, r) {
    return Object.defineProperty(t, e, r);
  }, ObjectGetOwnPropertyDescriptor: function ObjectGetOwnPropertyDescriptor(t, e) {
    return Object.getOwnPropertyDescriptor(t, e);
  }, ObjectKeys: function ObjectKeys(t) {
    return Object.keys(t);
  }, ObjectSetPrototypeOf: function ObjectSetPrototypeOf(t, e) {
    return Object.setPrototypeOf(t, e);
  }, Promise, PromisePrototypeCatch: function PromisePrototypeCatch(t, e) {
    return t.catch(e);
  }, PromisePrototypeThen: function PromisePrototypeThen(t, e, r) {
    return t.then(e, r);
  }, PromiseReject: function PromiseReject(t) {
    return Promise.reject(t);
  }, ReflectApply: Reflect.apply, RegExpPrototypeTest: function RegExpPrototypeTest(t, e) {
    return t.test(e);
  }, SafeSet: Set, String, StringPrototypeSlice: function StringPrototypeSlice(t, e, r) {
    return t.slice(e, r);
  }, StringPrototypeToLowerCase: function StringPrototypeToLowerCase(t) {
    return t.toLowerCase();
  }, StringPrototypeToUpperCase: function StringPrototypeToUpperCase(t) {
    return t.toUpperCase();
  }, StringPrototypeTrim: function StringPrototypeTrim(t) {
    return t.trim();
  }, Symbol, SymbolFor: Symbol.for, SymbolAsyncIterator: Symbol.asyncIterator, SymbolHasInstance: Symbol.hasInstance, SymbolIterator: Symbol.iterator, TypedArrayPrototypeSet: function TypedArrayPrototypeSet(t, e, r) {
    return t.set(e, r);
  }, Uint8Array };
});
var Je = M(function($A, Ss) {
  _();
  v();
  m();
  var iy = (be(), X(me)), ny = Object.getPrototypeOf(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1)
        switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
    }, _callee);
  }))).constructor, Yu = globalThis.Blob || iy.Blob, sy = _typeof(Yu) < "u" ? function(e) {
    return e instanceof Yu;
  } : function(e) {
    return false;
  }, Es = /* @__PURE__ */ function(_Error) {
    function Es2(e) {
      var _this2;
      _classCallCheck(this, Es2);
      if (!Array.isArray(e))
        throw new TypeError("Expected input to be an Array, got ".concat(_typeof(e)));
      var r = "";
      for (var _i2 = 0; _i2 < e.length; _i2++)
        r += "    ".concat(e[_i2].stack, "\n");
      _this2 = _callSuper(this, Es2, [r]), _this2.name = "AggregateError", _this2.errors = e;
      return _this2;
    }
    _inherits(Es2, _Error);
    return _createClass(Es2);
  }(/* @__PURE__ */ _wrapNativeSuper(Error));
  Ss.exports = { AggregateError: Es, kEmptyObject: Object.freeze({}), once: function once3(t) {
    var e = false;
    return function() {
      for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        r[_key2] = arguments[_key2];
      }
      e || (e = true, t.apply(this, r));
    };
  }, createDeferredPromise: function createDeferredPromise() {
    var t, e;
    return { promise: new Promise(function(i, n) {
      t = i, e = n;
    }), resolve: t, reject: e };
  }, promisify: function promisify(t) {
    return new Promise(function(e, r) {
      t(function(i) {
        for (var _len3 = arguments.length, n = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          n[_key3 - 1] = arguments[_key3];
        }
        return i ? r(i) : e.apply(void 0, n);
      });
    });
  }, debuglog: function debuglog() {
    return function() {
    };
  }, format: function format2(t) {
    for (var _len4 = arguments.length, e = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      e[_key4 - 1] = arguments[_key4];
    }
    return t.replace(/%([sdifj])/g, function() {
      for (var _len5 = arguments.length, _ref8 = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        _ref8[_key5] = arguments[_key5];
      }
      var r = _ref8[0], i = _ref8[1];
      var n = e.shift();
      return i === "f" ? n.toFixed(6) : i === "j" ? JSON.stringify(n) : i === "s" && _typeof(n) == "object" ? "".concat(n.constructor !== Object ? n.constructor.name : "", " {}").trim() : n.toString();
    });
  }, inspect: function inspect(t) {
    switch (_typeof(t)) {
      case "string":
        if (t.includes("'"))
          if (t.includes('"')) {
            if (!t.includes("`") && !t.includes("${"))
              return "`".concat(t, "`");
          } else
            return '"'.concat(t, '"');
        return "'".concat(t, "'");
      case "number":
        return isNaN(t) ? "NaN" : Object.is(t, -0) ? String(t) : t;
      case "bigint":
        return "".concat(String(t), "n");
      case "boolean":
      case "undefined":
        return String(t);
      case "object":
        return "{}";
    }
  }, types: { isAsyncFunction: function isAsyncFunction(t) {
    return t instanceof ny;
  }, isArrayBufferView: function isArrayBufferView(t) {
    return ArrayBuffer.isView(t);
  } }, isBlob: sy };
  Ss.exports.promisify.custom = Symbol.for("nodejs.util.promisify.custom");
});
var zi = M(function(ZA, Vi) {
  _();
  v();
  m();
  var _ref9 = (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" ? self : (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? window : void 0, Ju = _ref9.AbortController, oy = _ref9.AbortSignal;
  Vi.exports = Ju;
  Vi.exports.AbortSignal = oy;
  Vi.exports.default = Ju;
});
var Ae = M(function(uI, ef) {
  _();
  v();
  m();
  var _Je = Je(), ay = _Je.format, Ki = _Je.inspect, ly = _Je.AggregateError, uy = globalThis.AggregateError || ly, fy = Symbol("kIsNodeError"), cy = ["string", "function", "number", "object", "Function", "Object", "boolean", "bigint", "symbol"], hy = /^([A-Z][a-z0-9]*)+$/, dy = "__node_internal_", Gi = {};
  function er(t, e) {
    if (!t)
      throw new Gi.ERR_INTERNAL_ASSERTION(e);
  }
  function Xu(t) {
    var e = "", r = t.length, i = t[0] === "-" ? 1 : 0;
    for (; r >= i + 4; r -= 3)
      e = "_".concat(t.slice(r - 3, r)).concat(e);
    return "".concat(t.slice(0, r)).concat(e);
  }
  function py(t, e, r) {
    if (typeof e == "function")
      return er(e.length <= r.length, "Code: ".concat(t, "; The provided arguments length (").concat(r.length, ") does not match the required ones (").concat(e.length, ").")), e.apply(void 0, _toConsumableArray(r));
    var i = (e.match(/%[dfijoOs]/g) || []).length;
    return er(i === r.length, "Code: ".concat(t, "; The provided arguments length (").concat(r.length, ") does not match the required ones (").concat(i, ").")), r.length === 0 ? e : ay.apply(void 0, [e].concat(_toConsumableArray(r)));
  }
  function ve(t, e, r) {
    r || (r = Error);
    var i = /* @__PURE__ */ function(_r2) {
      function i2() {
        _classCallCheck(this, i2);
        for (var _len6 = arguments.length, o = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          o[_key6] = arguments[_key6];
        }
        return _callSuper(this, i2, [py(t, e, o)]);
      }
      _inherits(i2, _r2);
      return _createClass(i2, [{ key: "toString", value: function toString() {
        return "".concat(this.name, " [").concat(t, "]: ").concat(this.message);
      } }]);
    }(r);
    Object.defineProperties(i.prototype, { name: { value: r.name, writable: true, enumerable: false, configurable: true }, toString: { value: function value() {
      return "".concat(this.name, " [").concat(t, "]: ").concat(this.message);
    }, writable: true, enumerable: false, configurable: true } }), i.prototype.code = t, i.prototype[fy] = true, Gi[t] = i;
  }
  function Zu(t) {
    var e = dy + t.name;
    return Object.defineProperty(t, "name", { value: e }), t;
  }
  function gy(t, e) {
    if (t && e && t !== e) {
      if (Array.isArray(e.errors))
        return e.errors.push(t), e;
      var r = new uy([e, t], e.message);
      return r.code = e.code, r;
    }
    return t || e;
  }
  var As = /* @__PURE__ */ function(_Error2) {
    function As2() {
      var _this3;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "The operation was aborted";
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
      _classCallCheck(this, As2);
      if (r !== void 0 && _typeof(r) != "object")
        throw new Gi.ERR_INVALID_ARG_TYPE("options", "Object", r);
      _this3 = _callSuper(this, As2, [e, r]), _this3.code = "ABORT_ERR", _this3.name = "AbortError";
      return _this3;
    }
    _inherits(As2, _Error2);
    return _createClass(As2);
  }(/* @__PURE__ */ _wrapNativeSuper(Error));
  ve("ERR_ASSERTION", "%s", Error);
  ve("ERR_INVALID_ARG_TYPE", function(t, e, r) {
    er(typeof t == "string", "'name' must be a string"), Array.isArray(e) || (e = [e]);
    var i = "The ";
    t.endsWith(" argument") ? i += "".concat(t, " ") : i += '"'.concat(t, '" ').concat(t.includes(".") ? "property" : "argument", " "), i += "must be ";
    var n = [], o = [], s = [];
    var _iterator14 = _createForOfIteratorHelper(e), _step14;
    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done; ) {
        var _l7 = _step14.value;
        er(typeof _l7 == "string", "All expected entries have to be of type string"), cy.includes(_l7) ? n.push(_l7.toLowerCase()) : hy.test(_l7) ? o.push(_l7) : (er(_l7 !== "object", 'The value "object" should be written as "Object"'), s.push(_l7));
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }
    if (o.length > 0) {
      var l = n.indexOf("object");
      l !== -1 && (n.splice(n, l, 1), o.push("Object"));
    }
    if (n.length > 0) {
      switch (n.length) {
        case 1:
          i += "of type ".concat(n[0]);
          break;
        case 2:
          i += "one of type ".concat(n[0], " or ").concat(n[1]);
          break;
        default: {
          var _l2 = n.pop();
          i += "one of type ".concat(n.join(", "), ", or ").concat(_l2);
        }
      }
      (o.length > 0 || s.length > 0) && (i += " or ");
    }
    if (o.length > 0) {
      switch (o.length) {
        case 1:
          i += "an instance of ".concat(o[0]);
          break;
        case 2:
          i += "an instance of ".concat(o[0], " or ").concat(o[1]);
          break;
        default: {
          var _l3 = o.pop();
          i += "an instance of ".concat(o.join(", "), ", or ").concat(_l3);
        }
      }
      s.length > 0 && (i += " or ");
    }
    switch (s.length) {
      case 0:
        break;
      case 1:
        s[0].toLowerCase() !== s[0] && (i += "an "), i += "".concat(s[0]);
        break;
      case 2:
        i += "one of ".concat(s[0], " or ").concat(s[1]);
        break;
      default: {
        var _l4 = s.pop();
        i += "one of ".concat(s.join(", "), ", or ").concat(_l4);
      }
    }
    if (r == null)
      i += ". Received ".concat(r);
    else if (typeof r == "function" && r.name)
      i += ". Received function ".concat(r.name);
    else if (_typeof(r) == "object") {
      var a;
      if ((a = r.constructor) !== null && a !== void 0 && a.name)
        i += ". Received an instance of ".concat(r.constructor.name);
      else {
        var _l5 = Ki(r, { depth: -1 });
        i += ". Received ".concat(_l5);
      }
    } else {
      var _l6 = Ki(r, { colors: false });
      _l6.length > 25 && (_l6 = "".concat(_l6.slice(0, 25), "...")), i += ". Received type ".concat(_typeof(r), " (").concat(_l6, ")");
    }
    return i;
  }, TypeError);
  ve("ERR_INVALID_ARG_VALUE", function(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
    var i = Ki(e);
    return i.length > 128 && (i = i.slice(0, 128) + "..."), "The ".concat(t.includes(".") ? "property" : "argument", " '").concat(t, "' ").concat(r, ". Received ").concat(i);
  }, TypeError);
  ve("ERR_INVALID_RETURN_VALUE", function(t, e, r) {
    var i;
    var n = r != null && (i = r.constructor) !== null && i !== void 0 && i.name ? "instance of ".concat(r.constructor.name) : "type ".concat(_typeof(r));
    return "Expected ".concat(t, ' to be returned from the "').concat(e, '" function but got ').concat(n, ".");
  }, TypeError);
  ve("ERR_MISSING_ARGS", function() {
    for (var _len7 = arguments.length, t = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      t[_key7] = arguments[_key7];
    }
    er(t.length > 0, "At least one arg needs to be specified");
    var e, r = t.length;
    switch (t = (Array.isArray(t) ? t : [t]).map(function(i) {
      return '"'.concat(i, '"');
    }).join(" or "), r) {
      case 1:
        e += "The ".concat(t[0], " argument");
        break;
      case 2:
        e += "The ".concat(t[0], " and ").concat(t[1], " arguments");
        break;
      default:
        {
          var _i3 = t.pop();
          e += "The ".concat(t.join(", "), ", and ").concat(_i3, " arguments");
        }
        break;
    }
    return "".concat(e, " must be specified");
  }, TypeError);
  ve("ERR_OUT_OF_RANGE", function(t, e, r) {
    er(e, 'Missing "range" argument');
    var i;
    return Number.isInteger(r) && Math.abs(r) > Math.pow(2, 32) ? i = Xu(String(r)) : typeof r == "bigint" ? (i = String(r), (r > Math.pow(2n, 32n) || r < -Math.pow(2n, 32n)) && (i = Xu(i)), i += "n") : i = Ki(r), 'The value of "'.concat(t, '" is out of range. It must be ').concat(e, ". Received ").concat(i);
  }, RangeError);
  ve("ERR_MULTIPLE_CALLBACK", "Callback called multiple times", Error);
  ve("ERR_METHOD_NOT_IMPLEMENTED", "The %s method is not implemented", Error);
  ve("ERR_STREAM_ALREADY_FINISHED", "Cannot call %s after a stream was finished", Error);
  ve("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable", Error);
  ve("ERR_STREAM_DESTROYED", "Cannot call %s after a stream was destroyed", Error);
  ve("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
  ve("ERR_STREAM_PREMATURE_CLOSE", "Premature close", Error);
  ve("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF", Error);
  ve("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event", Error);
  ve("ERR_STREAM_WRITE_AFTER_END", "write after end", Error);
  ve("ERR_UNKNOWN_ENCODING", "Unknown encoding: %s", TypeError);
  ef.exports = { AbortError: As, aggregateTwoErrors: Zu(gy), hideStackFrames: Zu, codes: Gi };
});
var hi = M(function(_I, ff) {
  _();
  v();
  m();
  var _ce = ce(), Ts = _ce.ArrayIsArray, sf = _ce.ArrayPrototypeIncludes, of = _ce.ArrayPrototypeJoin, yy = _ce.ArrayPrototypeMap, Rs = _ce.NumberIsInteger, by = _ce.NumberIsNaN, wy = _ce.NumberMAX_SAFE_INTEGER, _y = _ce.NumberMIN_SAFE_INTEGER, my = _ce.NumberParseInt, vy = _ce.ObjectPrototypeHasOwnProperty, af = _ce.RegExpPrototypeExec, Ey = _ce.String, Sy = _ce.StringPrototypeToUpperCase, Ay = _ce.StringPrototypeTrim, _Ae = Ae(), Ue = _Ae.hideStackFrames, _Ae$codes = _Ae.codes, Iy = _Ae$codes.ERR_SOCKET_BAD_PORT, Ie = _Ae$codes.ERR_INVALID_ARG_TYPE, Ur = _Ae$codes.ERR_INVALID_ARG_VALUE, tr = _Ae$codes.ERR_OUT_OF_RANGE, tf = _Ae$codes.ERR_UNKNOWN_SIGNAL, _Je2 = Je(), Ty = _Je2.normalizeEncoding, _Je$types = Je().types, Ry = _Je$types.isAsyncFunction, Cy = _Je$types.isArrayBufferView, rf = {};
  function By(t) {
    return t === (t | 0);
  }
  function Py(t) {
    return t === t >>> 0;
  }
  var ky = /^[0-7]+$/, Oy = "must be a 32-bit unsigned integer or an octal string";
  function xy(t, e, r) {
    if (_typeof(t) > "u" && (t = r), typeof t == "string") {
      if (af(ky, t) === null)
        throw new Ur(e, t, Oy);
      t = my(t, 8);
    }
    return lf(t, e), t;
  }
  var My = Ue(function(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _y;
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : wy;
    if (typeof t != "number")
      throw new Ie(e, "number", t);
    if (!Rs(t))
      throw new tr(e, "an integer", t);
    if (t < r || t > i)
      throw new tr(e, ">= ".concat(r, " && <= ").concat(i), t);
  }), Ly = Ue(function(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -2147483648;
    var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2147483647;
    if (typeof t != "number")
      throw new Ie(e, "number", t);
    if (!Rs(t))
      throw new tr(e, "an integer", t);
    if (t < r || t > i)
      throw new tr(e, ">= ".concat(r, " && <= ").concat(i), t);
  }), lf = Ue(function(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (typeof t != "number")
      throw new Ie(e, "number", t);
    if (!Rs(t))
      throw new tr(e, "an integer", t);
    var i = r ? 1 : 0, n = 4294967295;
    if (t < i || t > n)
      throw new tr(e, ">= ".concat(i, " && <= ").concat(n), t);
  });
  function Cs(t, e) {
    if (typeof t != "string")
      throw new Ie(e, "string", t);
  }
  function Uy(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
    var i = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof t != "number")
      throw new Ie(e, "number", t);
    if (r != null && t < r || i != null && t > i || (r != null || i != null) && by(t))
      throw new tr(e, "".concat(r != null ? ">= ".concat(r) : "").concat(r != null && i != null ? " && " : "").concat(i != null ? "<= ".concat(i) : ""), t);
  }
  var Ny = Ue(function(t, e, r) {
    if (!sf(r, t)) {
      var n = "must be one of: " + of(yy(r, function(o) {
        return typeof o == "string" ? "'".concat(o, "'") : Ey(o);
      }), ", ");
      throw new Ur(e, t, n);
    }
  });
  function uf(t, e) {
    if (typeof t != "boolean")
      throw new Ie(e, "boolean", t);
  }
  function Is(t, e, r) {
    return t == null || !vy(t, e) ? r : t[e];
  }
  var qy = Ue(function(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var i = Is(r, "allowArray", false), n = Is(r, "allowFunction", false);
    if (!Is(r, "nullable", false) && t === null || !i && Ts(t) || _typeof(t) != "object" && (!n || typeof t != "function"))
      throw new Ie(e, "Object", t);
  }), Dy = Ue(function(t, e) {
    if (t != null && _typeof(t) != "object" && typeof t != "function")
      throw new Ie(e, "a dictionary", t);
  }), Bs = Ue(function(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!Ts(t))
      throw new Ie(e, "Array", t);
    if (t.length < r) {
      var _i4 = "must be longer than ".concat(r);
      throw new Ur(e, t, _i4);
    }
  });
  function jy(t, e) {
    Bs(t, e);
    for (var r = 0; r < t.length; r++)
      Cs(t[r], "".concat(e, "[").concat(r, "]"));
  }
  function Fy(t, e) {
    Bs(t, e);
    for (var r = 0; r < t.length; r++)
      uf(t[r], "".concat(e, "[").concat(r, "]"));
  }
  function Wy(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "signal";
    if (Cs(t, e), rf[t] === void 0)
      throw rf[Sy(t)] !== void 0 ? new tf(t + " (signals must use all capital letters)") : new tf(t);
  }
  var $y = Ue(function(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "buffer";
    if (!Cy(t))
      throw new Ie(e, ["Buffer", "TypedArray", "DataView"], t);
  });
  function Hy(t, e) {
    var r = Ty(e), i = t.length;
    if (r === "hex" && i % 2 !== 0)
      throw new Ur("encoding", e, "is invalid for data of length ".concat(i));
  }
  function Vy(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Port";
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (typeof t != "number" && typeof t != "string" || typeof t == "string" && Ay(t).length === 0 || +t !== +t >>> 0 || t > 65535 || t === 0 && !r)
      throw new Iy(e, t, r);
    return t | 0;
  }
  var zy = Ue(function(t, e) {
    if (t !== void 0 && (t === null || _typeof(t) != "object" || !("aborted" in t)))
      throw new Ie(e, "AbortSignal", t);
  }), Ky = Ue(function(t, e) {
    if (typeof t != "function")
      throw new Ie(e, "Function", t);
  }), Gy = Ue(function(t, e) {
    if (typeof t != "function" || Ry(t))
      throw new Ie(e, "Function", t);
  }), Qy = Ue(function(t, e) {
    if (t !== void 0)
      throw new Ie(e, "undefined", t);
  });
  function Yy(t, e, r) {
    if (!sf(r, t))
      throw new Ie(e, "('".concat(of(r, "|"), "')"), t);
  }
  var Jy = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
  function nf(t, e) {
    if (_typeof(t) > "u" || !af(Jy, t))
      throw new Ur(e, t, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
  }
  function Xy(t) {
    if (typeof t == "string")
      return nf(t, "hints"), t;
    if (Ts(t)) {
      var e = t.length, r = "";
      if (e === 0)
        return r;
      for (var _i5 = 0; _i5 < e; _i5++) {
        var n = t[_i5];
        nf(n, "hints"), r += n, _i5 !== e - 1 && (r += ", ");
      }
      return r;
    }
    throw new Ur("hints", t, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
  }
  ff.exports = { isInt32: By, isUint32: Py, parseFileMode: xy, validateArray: Bs, validateStringArray: jy, validateBooleanArray: Fy, validateBoolean: uf, validateBuffer: $y, validateDictionary: Dy, validateEncoding: Hy, validateFunction: Ky, validateInt32: Ly, validateInteger: My, validateNumber: Uy, validateObject: qy, validateOneOf: Ny, validatePlainFunction: Gy, validatePort: Vy, validateSignalName: Wy, validateString: Cs, validateUint32: lf, validateUndefined: Qy, validateUnion: Yy, validateAbortSignal: zy, validateLinkHeaderValue: Xy };
});
var Nt = M(function(BI, pf) {
  _();
  v();
  m();
  var ae = pf.exports = {}, Xe, Ze;
  function Ps() {
    throw new Error("setTimeout has not been defined");
  }
  function ks() {
    throw new Error("clearTimeout has not been defined");
  }
  (function() {
    try {
      typeof setTimeout == "function" ? Xe = setTimeout : Xe = Ps;
    } catch (_unused2) {
      Xe = Ps;
    }
    try {
      typeof clearTimeout == "function" ? Ze = clearTimeout : Ze = ks;
    } catch (_unused3) {
      Ze = ks;
    }
  })();
  function cf(t) {
    if (Xe === setTimeout)
      return setTimeout(t, 0);
    if ((Xe === Ps || !Xe) && setTimeout)
      return Xe = setTimeout, setTimeout(t, 0);
    try {
      return Xe(t, 0);
    } catch (_unused4) {
      try {
        return Xe.call(null, t, 0);
      } catch (_unused5) {
        return Xe.call(this, t, 0);
      }
    }
  }
  function Zy(t) {
    if (Ze === clearTimeout)
      return clearTimeout(t);
    if ((Ze === ks || !Ze) && clearTimeout)
      return Ze = clearTimeout, clearTimeout(t);
    try {
      return Ze(t);
    } catch (_unused6) {
      try {
        return Ze.call(null, t);
      } catch (_unused7) {
        return Ze.call(this, t);
      }
    }
  }
  var _t = [], Nr = false, rr, Qi = -1;
  function eb() {
    !Nr || !rr || (Nr = false, rr.length ? _t = rr.concat(_t) : Qi = -1, _t.length && hf());
  }
  function hf() {
    if (!Nr) {
      var t = cf(eb);
      Nr = true;
      for (var e = _t.length; e; ) {
        for (rr = _t, _t = []; ++Qi < e; )
          rr && rr[Qi].run();
        Qi = -1, e = _t.length;
      }
      rr = null, Nr = false, Zy(t);
    }
  }
  ae.nextTick = function(t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1)
      for (var r = 1; r < arguments.length; r++)
        e[r - 1] = arguments[r];
    _t.push(new df(t, e)), _t.length === 1 && !Nr && cf(hf);
  };
  function df(t, e) {
    this.fun = t, this.array = e;
  }
  df.prototype.run = function() {
    this.fun.apply(null, this.array);
  };
  ae.title = "browser";
  ae.browser = true;
  ae.env = {};
  ae.argv = [];
  ae.version = "";
  ae.versions = {};
  function mt() {
  }
  ae.on = mt;
  ae.addListener = mt;
  ae.once = mt;
  ae.off = mt;
  ae.removeListener = mt;
  ae.removeAllListeners = mt;
  ae.emit = mt;
  ae.prependListener = mt;
  ae.prependOnceListener = mt;
  ae.listeners = function(t) {
    return [];
  };
  ae.binding = function(t) {
    throw new Error("process.binding is not supported");
  };
  ae.cwd = function() {
    return "/";
  };
  ae.chdir = function(t) {
    throw new Error("process.chdir is not supported");
  };
  ae.umask = function() {
    return 0;
  };
});
var tt = M(function(DI, Pf) {
  _();
  v();
  m();
  var _ce2 = ce(), Yi = _ce2.Symbol, gf = _ce2.SymbolAsyncIterator, yf = _ce2.SymbolIterator, bf = _ce2.SymbolFor, wf = Yi("kDestroyed"), _f = Yi("kIsErrored"), Os = Yi("kIsReadable"), mf = Yi("kIsDisturbed"), tb = bf("nodejs.webstream.isClosedPromise"), rb = bf("nodejs.webstream.controllerErrorFunction");
  function Ji(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var r;
    return !!(t && typeof t.pipe == "function" && typeof t.on == "function" && (!e || typeof t.pause == "function" && typeof t.resume == "function") && (!t._writableState || ((r = t._readableState) === null || r === void 0 ? void 0 : r.readable) !== false) && (!t._writableState || t._readableState));
  }
  function Xi(t) {
    var e;
    return !!(t && typeof t.write == "function" && typeof t.on == "function" && (!t._readableState || ((e = t._writableState) === null || e === void 0 ? void 0 : e.writable) !== false));
  }
  function ib(t) {
    return !!(t && typeof t.pipe == "function" && t._readableState && typeof t.on == "function" && typeof t.write == "function");
  }
  function et(t) {
    return t && (t._readableState || t._writableState || typeof t.write == "function" && typeof t.on == "function" || typeof t.pipe == "function" && typeof t.on == "function");
  }
  function vf(t) {
    return !!(t && !et(t) && typeof t.pipeThrough == "function" && typeof t.getReader == "function" && typeof t.cancel == "function");
  }
  function Ef(t) {
    return !!(t && !et(t) && typeof t.getWriter == "function" && typeof t.abort == "function");
  }
  function Sf(t) {
    return !!(t && !et(t) && _typeof(t.readable) == "object" && _typeof(t.writable) == "object");
  }
  function nb(t) {
    return vf(t) || Ef(t) || Sf(t);
  }
  function sb(t, e) {
    return t == null ? false : e === true ? typeof t[gf] == "function" : e === false ? typeof t[yf] == "function" : typeof t[gf] == "function" || typeof t[yf] == "function";
  }
  function Zi(t) {
    if (!et(t))
      return null;
    var e = t._writableState, r = t._readableState, i = e || r;
    return !!(t.destroyed || t[wf] || i != null && i.destroyed);
  }
  function Af(t) {
    if (!Xi(t))
      return null;
    if (t.writableEnded === true)
      return true;
    var e = t._writableState;
    return e != null && e.errored ? false : typeof (e === null || e === void 0 ? void 0 : e.ended) != "boolean" ? null : e.ended;
  }
  function ob(t, e) {
    if (!Xi(t))
      return null;
    if (t.writableFinished === true)
      return true;
    var r = t._writableState;
    return r != null && r.errored ? false : typeof (r === null || r === void 0 ? void 0 : r.finished) != "boolean" ? null : !!(r.finished || e === false && r.ended === true && r.length === 0);
  }
  function ab(t) {
    if (!Ji(t))
      return null;
    if (t.readableEnded === true)
      return true;
    var e = t._readableState;
    return !e || e.errored ? false : typeof (e === null || e === void 0 ? void 0 : e.ended) != "boolean" ? null : e.ended;
  }
  function If(t, e) {
    if (!Ji(t))
      return null;
    var r = t._readableState;
    return r != null && r.errored ? false : typeof (r === null || r === void 0 ? void 0 : r.endEmitted) != "boolean" ? null : !!(r.endEmitted || e === false && r.ended === true && r.length === 0);
  }
  function Tf(t) {
    return t && t[Os] != null ? t[Os] : typeof (t === null || t === void 0 ? void 0 : t.readable) != "boolean" ? null : Zi(t) ? false : Ji(t) && t.readable && !If(t);
  }
  function Rf(t) {
    return typeof (t === null || t === void 0 ? void 0 : t.writable) != "boolean" ? null : Zi(t) ? false : Xi(t) && t.writable && !Af(t);
  }
  function lb(t, e) {
    return et(t) ? Zi(t) ? true : !((e === null || e === void 0 ? void 0 : e.readable) !== false && Tf(t) || (e === null || e === void 0 ? void 0 : e.writable) !== false && Rf(t)) : null;
  }
  function ub(t) {
    var e, r;
    return et(t) ? t.writableErrored ? t.writableErrored : (e = (r = t._writableState) === null || r === void 0 ? void 0 : r.errored) !== null && e !== void 0 ? e : null : null;
  }
  function fb(t) {
    var e, r;
    return et(t) ? t.readableErrored ? t.readableErrored : (e = (r = t._readableState) === null || r === void 0 ? void 0 : r.errored) !== null && e !== void 0 ? e : null : null;
  }
  function cb(t) {
    if (!et(t))
      return null;
    if (typeof t.closed == "boolean")
      return t.closed;
    var e = t._writableState, r = t._readableState;
    return typeof (e === null || e === void 0 ? void 0 : e.closed) == "boolean" || typeof (r === null || r === void 0 ? void 0 : r.closed) == "boolean" ? (e === null || e === void 0 ? void 0 : e.closed) || (r === null || r === void 0 ? void 0 : r.closed) : typeof t._closed == "boolean" && Cf(t) ? t._closed : null;
  }
  function Cf(t) {
    return typeof t._closed == "boolean" && typeof t._defaultKeepAlive == "boolean" && typeof t._removedConnection == "boolean" && typeof t._removedContLen == "boolean";
  }
  function Bf(t) {
    return typeof t._sent100 == "boolean" && Cf(t);
  }
  function hb(t) {
    var e;
    return typeof t._consuming == "boolean" && typeof t._dumped == "boolean" && ((e = t.req) === null || e === void 0 ? void 0 : e.upgradeOrConnect) === void 0;
  }
  function db(t) {
    if (!et(t))
      return null;
    var e = t._writableState, r = t._readableState, i = e || r;
    return !i && Bf(t) || !!(i && i.autoDestroy && i.emitClose && i.closed === false);
  }
  function pb(t) {
    var e;
    return !!(t && ((e = t[mf]) !== null && e !== void 0 ? e : t.readableDidRead || t.readableAborted));
  }
  function gb(t) {
    var e, r, i, n, o, s, a, l, c, h;
    return !!(t && ((e = (r = (i = (n = (o = (s = t[_f]) !== null && s !== void 0 ? s : t.readableErrored) !== null && o !== void 0 ? o : t.writableErrored) !== null && n !== void 0 ? n : (a = t._readableState) === null || a === void 0 ? void 0 : a.errorEmitted) !== null && i !== void 0 ? i : (l = t._writableState) === null || l === void 0 ? void 0 : l.errorEmitted) !== null && r !== void 0 ? r : (c = t._readableState) === null || c === void 0 ? void 0 : c.errored) !== null && e !== void 0 ? e : !((h = t._writableState) === null || h === void 0) && h.errored));
  }
  Pf.exports = { kDestroyed: wf, isDisturbed: pb, kIsDisturbed: mf, isErrored: gb, kIsErrored: _f, isReadable: Tf, kIsReadable: Os, kIsClosedPromise: tb, kControllerErrorFunction: rb, isClosed: cb, isDestroyed: Zi, isDuplexNodeStream: ib, isFinished: lb, isIterable: sb, isReadableNodeStream: Ji, isReadableStream: vf, isReadableEnded: ab, isReadableFinished: If, isReadableErrored: fb, isNodeStream: et, isWebStream: nb, isWritable: Rf, isWritableNodeStream: Xi, isWritableStream: Ef, isWritableEnded: Af, isWritableFinished: ob, isWritableErrored: ub, isServerRequest: hb, isServerResponse: Bf, willEmitClose: db, isTransformStream: Sf };
});
var vt = M(function(QI, Ns) {
  _();
  v();
  m();
  var qt = Nt(), _Ae2 = Ae(), Df = _Ae2.AbortError, yb = _Ae2.codes, bb = yb.ERR_INVALID_ARG_TYPE, kf = yb.ERR_STREAM_PREMATURE_CLOSE, _Je3 = Je(), Ms = _Je3.kEmptyObject, Ls = _Je3.once, _hi = hi(), wb = _hi.validateAbortSignal, _b = _hi.validateFunction, mb = _hi.validateObject, vb = _hi.validateBoolean, _ce3 = ce(), Eb = _ce3.Promise, Sb = _ce3.PromisePrototypeThen, _tt = tt(), Ab = _tt.isClosed, Of = _tt.isReadable, xs = _tt.isReadableNodeStream, Ib = _tt.isReadableStream, xf = _tt.isReadableFinished, Mf = _tt.isReadableErrored, Lf = _tt.isWritable, Uf = _tt.isWritableNodeStream, Tb = _tt.isWritableStream, Nf = _tt.isWritableFinished, qf = _tt.isWritableErrored, Rb = _tt.isNodeStream, Cb = _tt.willEmitClose, Bb = _tt.kIsClosedPromise;
  function Pb(t) {
    return t.setHeader && typeof t.abort == "function";
  }
  var Us = function Us2() {
  };
  function jf(t, e, r) {
    var i, n;
    if (arguments.length === 2 ? (r = e, e = Ms) : e == null ? e = Ms : mb(e, "options"), _b(r, "callback"), wb(e.signal, "options.signal"), r = Ls(r), Ib(t) || Tb(t))
      return kb(t, e, r);
    if (!Rb(t))
      throw new bb("stream", ["ReadableStream", "WritableStream", "Stream"], t);
    var o = (i = e.readable) !== null && i !== void 0 ? i : xs(t), s = (n = e.writable) !== null && n !== void 0 ? n : Uf(t), a = t._writableState, l = t._readableState, c = function c2() {
      t.writable || g();
    }, h = Cb(t) && xs(t) === o && Uf(t) === s, d = Nf(t, false), g = function g2() {
      d = true, t.destroyed && (h = false), !(h && (!t.readable || o)) && (!o || y) && r.call(t);
    }, y = xf(t, false), w = function w2() {
      y = true, t.destroyed && (h = false), !(h && (!t.writable || s)) && (!s || d) && r.call(t);
    }, S = function S2(N2) {
      r.call(t, N2);
    }, E = Ab(t), I = function I2() {
      E = true;
      var N2 = qf(t) || Mf(t);
      if (N2 && typeof N2 != "boolean")
        return r.call(t, N2);
      if (o && !y && xs(t, true) && !xf(t, false))
        return r.call(t, new kf());
      if (s && !d && !Nf(t, false))
        return r.call(t, new kf());
      r.call(t);
    }, C = function C2() {
      E = true;
      var N2 = qf(t) || Mf(t);
      if (N2 && typeof N2 != "boolean")
        return r.call(t, N2);
      r.call(t);
    }, R = function R2() {
      t.req.on("finish", g);
    };
    Pb(t) ? (t.on("complete", g), h || t.on("abort", I), t.req ? R() : t.on("request", R)) : s && !a && (t.on("end", c), t.on("close", c)), !h && typeof t.aborted == "boolean" && t.on("aborted", I), t.on("end", w), t.on("finish", g), e.error !== false && t.on("error", S), t.on("close", I), E ? qt.nextTick(I) : a != null && a.errorEmitted || l != null && l.errorEmitted ? h || qt.nextTick(C) : (!o && (!h || Of(t)) && (d || Lf(t) === false) || !s && (!h || Lf(t)) && (y || Of(t) === false) || l && t.req && t.aborted) && qt.nextTick(C);
    var U = function U2() {
      r = Us, t.removeListener("aborted", I), t.removeListener("complete", g), t.removeListener("abort", I), t.removeListener("request", R), t.req && t.req.removeListener("finish", g), t.removeListener("end", c), t.removeListener("close", c), t.removeListener("finish", g), t.removeListener("end", w), t.removeListener("error", S), t.removeListener("close", I);
    };
    if (e.signal && !E) {
      var N = function N2() {
        var W2 = r;
        U(), W2.call(t, new Df(void 0, { cause: e.signal.reason }));
      };
      if (e.signal.aborted)
        qt.nextTick(N);
      else {
        var W = r;
        r = Ls(function() {
          for (var _len8 = arguments.length, K = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
            K[_key8] = arguments[_key8];
          }
          e.signal.removeEventListener("abort", N), W.apply(t, K);
        }), e.signal.addEventListener("abort", N);
      }
    }
    return U;
  }
  function kb(t, e, r) {
    var i = false, n = Us;
    if (e.signal)
      if (n = function n2() {
        i = true, r.call(t, new Df(void 0, { cause: e.signal.reason }));
      }, e.signal.aborted)
        qt.nextTick(n);
      else {
        var s = r;
        r = Ls(function() {
          for (var _len9 = arguments.length, a = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            a[_key9] = arguments[_key9];
          }
          e.signal.removeEventListener("abort", n), s.apply(t, a);
        }), e.signal.addEventListener("abort", n);
      }
    var o = function o2() {
      for (var _len10 = arguments.length, s2 = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
        s2[_key10] = arguments[_key10];
      }
      i || qt.nextTick(function() {
        return r.apply(t, s2);
      });
    };
    return Sb(t[Bb].promise, o, o), Us;
  }
  function Ob(t, e) {
    var r;
    var i = false;
    return e === null && (e = Ms), (r = e) !== null && r !== void 0 && r.cleanup && (vb(e.cleanup, "cleanup"), i = e.cleanup), new Eb(function(n, o) {
      var s = jf(t, e, function(a) {
        i && s(), a ? o(a) : n();
      });
    });
  }
  Ns.exports = jf;
  Ns.exports.finished = Ob;
});
var ir = M(function(sT, Gf) {
  _();
  v();
  m();
  var rt = Nt(), _Ae3 = Ae(), xb = _Ae3.aggregateTwoErrors, Mb = _Ae3.codes.ERR_MULTIPLE_CALLBACK, Lb = _Ae3.AbortError, _ce4 = ce(), $f = _ce4.Symbol, _tt2 = tt(), Ub = _tt2.kDestroyed, Nb = _tt2.isDestroyed, qb = _tt2.isFinished, Db = _tt2.isServerRequest, Hf = $f("kDestroy"), qs = $f("kConstruct");
  function Vf(t, e, r) {
    t && (t.stack, e && !e.errored && (e.errored = t), r && !r.errored && (r.errored = t));
  }
  function jb(t, e) {
    var r = this._readableState, i = this._writableState, n = i || r;
    return i != null && i.destroyed || r != null && r.destroyed ? (typeof e == "function" && e(), this) : (Vf(t, i, r), i && (i.destroyed = true), r && (r.destroyed = true), n.constructed ? Ff(this, t, e) : this.once(Hf, function(o) {
      Ff(this, xb(o, t), e);
    }), this);
  }
  function Ff(t, e, r) {
    var i = false;
    function n(o) {
      if (i)
        return;
      i = true;
      var s = t._readableState, a = t._writableState;
      Vf(o, a, s), a && (a.closed = true), s && (s.closed = true), typeof r == "function" && r(o), o ? rt.nextTick(Fb, t, o) : rt.nextTick(zf, t);
    }
    try {
      t._destroy(e || null, n);
    } catch (o) {
      n(o);
    }
  }
  function Fb(t, e) {
    Ds(t, e), zf(t);
  }
  function zf(t) {
    var e = t._readableState, r = t._writableState;
    r && (r.closeEmitted = true), e && (e.closeEmitted = true), (r != null && r.emitClose || e != null && e.emitClose) && t.emit("close");
  }
  function Ds(t, e) {
    var r = t._readableState, i = t._writableState;
    i != null && i.errorEmitted || r != null && r.errorEmitted || (i && (i.errorEmitted = true), r && (r.errorEmitted = true), t.emit("error", e));
  }
  function Wb() {
    var t = this._readableState, e = this._writableState;
    t && (t.constructed = true, t.closed = false, t.closeEmitted = false, t.destroyed = false, t.errored = null, t.errorEmitted = false, t.reading = false, t.ended = t.readable === false, t.endEmitted = t.readable === false), e && (e.constructed = true, e.destroyed = false, e.closed = false, e.closeEmitted = false, e.errored = null, e.errorEmitted = false, e.finalCalled = false, e.prefinished = false, e.ended = e.writable === false, e.ending = e.writable === false, e.finished = e.writable === false);
  }
  function js(t, e, r) {
    var i = t._readableState, n = t._writableState;
    if (n != null && n.destroyed || i != null && i.destroyed)
      return this;
    i != null && i.autoDestroy || n != null && n.autoDestroy ? t.destroy(e) : e && (e.stack, n && !n.errored && (n.errored = e), i && !i.errored && (i.errored = e), r ? rt.nextTick(Ds, t, e) : Ds(t, e));
  }
  function $b(t, e) {
    if (typeof t._construct != "function")
      return;
    var r = t._readableState, i = t._writableState;
    r && (r.constructed = false), i && (i.constructed = false), t.once(qs, e), !(t.listenerCount(qs) > 1) && rt.nextTick(Hb, t);
  }
  function Hb(t) {
    var e = false;
    function r(i) {
      if (e) {
        js(t, i !== null && i !== void 0 ? i : new Mb());
        return;
      }
      e = true;
      var n = t._readableState, o = t._writableState, s = o || n;
      n && (n.constructed = true), o && (o.constructed = true), s.destroyed ? t.emit(Hf, i) : i ? js(t, i, true) : rt.nextTick(Vb, t);
    }
    try {
      t._construct(function(i) {
        rt.nextTick(r, i);
      });
    } catch (i) {
      rt.nextTick(r, i);
    }
  }
  function Vb(t) {
    t.emit(qs);
  }
  function Wf(t) {
    return (t === null || t === void 0 ? void 0 : t.setHeader) && typeof t.abort == "function";
  }
  function Kf(t) {
    t.emit("close");
  }
  function zb(t, e) {
    t.emit("error", e), rt.nextTick(Kf, t);
  }
  function Kb(t, e) {
    !t || Nb(t) || (!e && !qb(t) && (e = new Lb()), Db(t) ? (t.socket = null, t.destroy(e)) : Wf(t) ? t.abort() : Wf(t.req) ? t.req.abort() : typeof t.destroy == "function" ? t.destroy(e) : typeof t.close == "function" ? t.close() : e ? rt.nextTick(zb, t, e) : rt.nextTick(Kf, t), t.destroyed || (t[Ub] = true));
  }
  Gf.exports = { construct: $b, destroyer: Kb, destroy: jb, undestroy: Wb, errorOrDestroy: js };
});
function Y() {
  Y.init.call(this);
}
function en(t) {
  if (typeof t != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + _typeof(t));
}
function nc(t) {
  return t._maxListeners === void 0 ? Y.defaultMaxListeners : t._maxListeners;
}
function Xf(t, e, r, i) {
  var n, o, s, a;
  if (en(r), (o = t._events) === void 0 ? (o = t._events = /* @__PURE__ */ Object.create(null), t._eventsCount = 0) : (o.newListener !== void 0 && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), s = o[e]), s === void 0)
    s = o[e] = r, ++t._eventsCount;
  else if (typeof s == "function" ? s = o[e] = i ? [r, s] : [s, r] : i ? s.unshift(r) : s.push(r), (n = nc(t)) > 0 && s.length > n && !s.warned) {
    s.warned = true;
    var l = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    l.name = "MaxListenersExceededWarning", l.emitter = t, l.type = e, l.count = s.length, a = l, console && console.warn && console.warn(a);
  }
  return t;
}
function Gb() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = true, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function Zf(t, e, r) {
  var i = { fired: false, wrapFn: void 0, target: t, type: e, listener: r }, n = Gb.bind(i);
  return n.listener = r, i.wrapFn = n, n;
}
function ec(t, e, r) {
  var i = t._events;
  if (i === void 0)
    return [];
  var n = i[e];
  return n === void 0 ? [] : typeof n == "function" ? r ? [n.listener || n] : [n] : r ? function(o) {
    for (var s = new Array(o.length), a = 0; a < s.length; ++a)
      s[a] = o[a].listener || o[a];
    return s;
  }(n) : sc(n, n.length);
}
function tc(t) {
  var e = this._events;
  if (e !== void 0) {
    var r = e[t];
    if (typeof r == "function")
      return 1;
    if (r !== void 0)
      return r.length;
  }
  return 0;
}
function sc(t, e) {
  for (var r = new Array(e), i = 0; i < e; ++i)
    r[i] = t[i];
  return r;
}
var rc, ic, qr, Qf, Yf, Jf, Be, Fs = _e(function() {
  _();
  v();
  m();
  qr = (typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) == "object" ? Reflect : null, Qf = qr && typeof qr.apply == "function" ? qr.apply : function(t, e, r) {
    return Function.prototype.apply.call(t, e, r);
  };
  ic = qr && typeof qr.ownKeys == "function" ? qr.ownKeys : Object.getOwnPropertySymbols ? function(t) {
    return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
  } : function(t) {
    return Object.getOwnPropertyNames(t);
  };
  Yf = Number.isNaN || function(t) {
    return t != t;
  };
  rc = Y, Y.EventEmitter = Y, Y.prototype._events = void 0, Y.prototype._eventsCount = 0, Y.prototype._maxListeners = void 0;
  Jf = 10;
  Object.defineProperty(Y, "defaultMaxListeners", { enumerable: true, get: function get2() {
    return Jf;
  }, set: function set(t) {
    if (typeof t != "number" || t < 0 || Yf(t))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
    Jf = t;
  } }), Y.init = function() {
    this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, Y.prototype.setMaxListeners = function(t) {
    if (typeof t != "number" || t < 0 || Yf(t))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
    return this._maxListeners = t, this;
  }, Y.prototype.getMaxListeners = function() {
    return nc(this);
  }, Y.prototype.emit = function(t) {
    for (var e = [], r = 1; r < arguments.length; r++)
      e.push(arguments[r]);
    var i = t === "error", n = this._events;
    if (n !== void 0)
      i = i && n.error === void 0;
    else if (!i)
      return false;
    if (i) {
      var o;
      if (e.length > 0 && (o = e[0]), o instanceof Error)
        throw o;
      var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
      throw s.context = o, s;
    }
    var a = n[t];
    if (a === void 0)
      return false;
    if (typeof a == "function")
      Qf(a, this, e);
    else {
      var l = a.length, c = sc(a, l);
      for (r = 0; r < l; ++r)
        Qf(c[r], this, e);
    }
    return true;
  }, Y.prototype.addListener = function(t, e) {
    return Xf(this, t, e, false);
  }, Y.prototype.on = Y.prototype.addListener, Y.prototype.prependListener = function(t, e) {
    return Xf(this, t, e, true);
  }, Y.prototype.once = function(t, e) {
    return en(e), this.on(t, Zf(this, t, e)), this;
  }, Y.prototype.prependOnceListener = function(t, e) {
    return en(e), this.prependListener(t, Zf(this, t, e)), this;
  }, Y.prototype.removeListener = function(t, e) {
    var r, i, n, o, s;
    if (en(e), (i = this._events) === void 0)
      return this;
    if ((r = i[t]) === void 0)
      return this;
    if (r === e || r.listener === e)
      --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete i[t], i.removeListener && this.emit("removeListener", t, r.listener || e));
    else if (typeof r != "function") {
      for (n = -1, o = r.length - 1; o >= 0; o--)
        if (r[o] === e || r[o].listener === e) {
          s = r[o].listener, n = o;
          break;
        }
      if (n < 0)
        return this;
      n === 0 ? r.shift() : function(a, l) {
        for (; l + 1 < a.length; l++)
          a[l] = a[l + 1];
        a.pop();
      }(r, n), r.length === 1 && (i[t] = r[0]), i.removeListener !== void 0 && this.emit("removeListener", t, s || e);
    }
    return this;
  }, Y.prototype.off = Y.prototype.removeListener, Y.prototype.removeAllListeners = function(t) {
    var e, r, i;
    if ((r = this._events) === void 0)
      return this;
    if (r.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : r[t] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete r[t]), this;
    if (arguments.length === 0) {
      var n, o = Object.keys(r);
      for (i = 0; i < o.length; ++i)
        (n = o[i]) !== "removeListener" && this.removeAllListeners(n);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (typeof (e = r[t]) == "function")
      this.removeListener(t, e);
    else if (e !== void 0)
      for (i = e.length - 1; i >= 0; i--)
        this.removeListener(t, e[i]);
    return this;
  }, Y.prototype.listeners = function(t) {
    return ec(this, t, true);
  }, Y.prototype.rawListeners = function(t) {
    return ec(this, t, false);
  }, Y.listenerCount = function(t, e) {
    return typeof t.listenerCount == "function" ? t.listenerCount(e) : tc.call(t, e);
  }, Y.prototype.listenerCount = tc, Y.prototype.eventNames = function() {
    return this._eventsCount > 0 ? ic(this._events) : [];
  };
  Be = rc;
  Be.EventEmitter;
  Be.defaultMaxListeners;
  Be.init;
  Be.listenerCount;
  Be.EventEmitter;
  Be.defaultMaxListeners;
  Be.init;
  Be.listenerCount;
});
var nr = {};
Jt(nr, { EventEmitter: function EventEmitter() {
  return Qb;
}, default: function _default3() {
  return Be;
}, defaultMaxListeners: function defaultMaxListeners() {
  return Yb;
}, init: function init() {
  return Jb;
}, listenerCount: function listenerCount() {
  return Xb;
}, on: function on2() {
  return Zb;
}, once: function once2() {
  return ew;
} });
var Qb, Yb, Jb, Xb, Zb, ew, sr = _e(function() {
  _();
  v();
  m();
  Fs();
  Fs();
  Be.once = function(t, e) {
    return new Promise(function(r, i) {
      function n() {
        for (var _len11 = arguments.length, s = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          s[_key11] = arguments[_key11];
        }
        o !== void 0 && t.removeListener("error", o), r(s);
      }
      var o;
      e !== "error" && (o = function o2(s) {
        t.removeListener(name, n), i(s);
      }, t.once("error", o)), t.once(e, n);
    });
  };
  Be.on = function(t, e) {
    var r = [], i = [], n = null, o = false, s = _defineProperty({ next: function next() {
      return _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2() {
        var c, h;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1)
            switch (_context2.prev = _context2.next) {
              case 0:
                c = r.shift();
                if (!c) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return", createIterResult(c, false));
              case 3:
                if (!n) {
                  _context2.next = 6;
                  break;
                }
                h = Promise.reject(n);
                return _context2.abrupt("return", (n = null, h));
              case 6:
                return _context2.abrupt("return", o ? createIterResult(void 0, true) : new Promise(function(h2, d) {
                  return i.push({ resolve: h2, reject: d });
                }));
              case 7:
              case "end":
                return _context2.stop();
            }
        }, _callee2);
      }))();
    }, return: function _return() {
      return _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee3() {
        var _i7, _i6, c;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1)
            switch (_context3.prev = _context3.next) {
              case 0:
                t.removeListener(e, a), t.removeListener("error", l), o = true;
                for (_i7 = 0, _i6 = i; _i7 < _i6.length; _i7++) {
                  c = _i6[_i7];
                  c.resolve(createIterResult(void 0, true));
                }
                return _context3.abrupt("return", createIterResult(void 0, true));
              case 3:
              case "end":
                return _context3.stop();
            }
        }, _callee3);
      }))();
    }, throw: function _throw(c) {
      n = c, t.removeListener(e, a), t.removeListener("error", l);
    } }, Symbol.asyncIterator, function() {
      return this;
    });
    return t.on(e, a), t.on("error", l), s;
    function a() {
      var h = i.shift();
      for (var _len12 = arguments.length, c = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        c[_key12] = arguments[_key12];
      }
      h ? h.resolve(createIterResult(c, false)) : r.push(c);
    }
    function l(c) {
      o = true;
      var h = i.shift();
      h ? h.reject(c) : n = c, s.return();
    }
  };
  var _Be = Be;
  Qb = _Be.EventEmitter;
  Yb = _Be.defaultMaxListeners;
  Jb = _Be.init;
  Xb = _Be.listenerCount;
  Zb = _Be.on;
  ew = _Be.once;
});
var nn = M(function(UT, ac) {
  _();
  v();
  m();
  var _ce5 = ce(), tw = _ce5.ArrayIsArray, oc = _ce5.ObjectSetPrototypeOf, _ref10 = (sr(), X(nr)), tn = _ref10.EventEmitter;
  function rn(t) {
    tn.call(this, t);
  }
  oc(rn.prototype, tn.prototype);
  oc(rn, tn);
  rn.prototype.pipe = function(t, e) {
    var r = this;
    function i(h) {
      t.writable && t.write(h) === false && r.pause && r.pause();
    }
    r.on("data", i);
    function n() {
      r.readable && r.resume && r.resume();
    }
    t.on("drain", n), !t._isStdio && (!e || e.end !== false) && (r.on("end", s), r.on("close", a));
    var o = false;
    function s() {
      o || (o = true, t.end());
    }
    function a() {
      o || (o = true, typeof t.destroy == "function" && t.destroy());
    }
    function l(h) {
      c(), tn.listenerCount(this, "error") === 0 && this.emit("error", h);
    }
    Ws(r, "error", l), Ws(t, "error", l);
    function c() {
      r.removeListener("data", i), t.removeListener("drain", n), r.removeListener("end", s), r.removeListener("close", a), r.removeListener("error", l), t.removeListener("error", l), r.removeListener("end", c), r.removeListener("close", c), t.removeListener("close", c);
    }
    return r.on("end", c), r.on("close", c), t.on("close", c), t.emit("pipe", r), t;
  };
  function Ws(t, e, r) {
    if (typeof t.prependListener == "function")
      return t.prependListener(e, r);
    !t._events || !t._events[e] ? t.on(e, r) : tw(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]];
  }
  ac.exports = { Stream: rn, prependListener: Ws };
});
var di = M(function(zT, sn) {
  _();
  v();
  m();
  var _Ae4 = Ae(), lc = _Ae4.AbortError, rw = _Ae4.codes, _tt3 = tt(), uc = _tt3.isNodeStream, iw = _tt3.isWebStream, nw = _tt3.kControllerErrorFunction, sw = vt(), fc = rw.ERR_INVALID_ARG_TYPE, ow = function ow2(t, e) {
    if (_typeof(t) != "object" || !("aborted" in t))
      throw new fc(e, "AbortSignal", t);
  };
  sn.exports.addAbortSignal = function(e, r) {
    if (ow(e, "signal"), !uc(r) && !iw(r))
      throw new fc("stream", ["ReadableStream", "WritableStream", "Stream"], r);
    return sn.exports.addAbortSignalNoValidate(e, r);
  };
  sn.exports.addAbortSignalNoValidate = function(t, e) {
    if (_typeof(t) != "object" || !("aborted" in t))
      return e;
    var r = uc(e) ? function() {
      e.destroy(new lc(void 0, { cause: t.reason }));
    } : function() {
      e[nw](new lc(void 0, { cause: t.reason }));
    };
    return t.aborted ? r() : (t.addEventListener("abort", r), sw(e, function() {
      return t.removeEventListener("abort", r);
    })), e;
  };
});
var dc = M(function(i2, hc) {
  _();
  v();
  m();
  var _ce6 = ce(), cc = _ce6.StringPrototypeSlice, aw = _ce6.SymbolIterator, on3 = _ce6.TypedArrayPrototypeSet, lw = _ce6.Uint8Array, _ref11 = (be(), X(me)), $s = _ref11.Buffer, _Je4 = Je(), uw = _Je4.inspect;
  hc.exports = /* @__PURE__ */ function() {
    function _class2() {
      _classCallCheck(this, _class2);
      this.head = null, this.tail = null, this.length = 0;
    }
    return _createClass(_class2, [{ key: "push", value: function push(e) {
      var r = { data: e, next: null };
      this.length > 0 ? this.tail.next = r : this.head = r, this.tail = r, ++this.length;
    } }, { key: "unshift", value: function unshift(e) {
      var r = { data: e, next: this.head };
      this.length === 0 && (this.tail = r), this.head = r, ++this.length;
    } }, { key: "shift", value: function shift() {
      if (this.length === 0)
        return;
      var e = this.head.data;
      return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, e;
    } }, { key: "clear", value: function clear() {
      this.head = this.tail = null, this.length = 0;
    } }, { key: "join", value: function join(e) {
      if (this.length === 0)
        return "";
      var r = this.head, i = "" + r.data;
      for (; (r = r.next) !== null; )
        i += e + r.data;
      return i;
    } }, { key: "concat", value: function concat(e) {
      if (this.length === 0)
        return $s.alloc(0);
      var r = $s.allocUnsafe(e >>> 0), i = this.head, n = 0;
      for (; i; )
        on3(r, i.data, n), n += i.data.length, i = i.next;
      return r;
    } }, { key: "consume", value: function consume(e, r) {
      var i = this.head.data;
      if (e < i.length) {
        var n = i.slice(0, e);
        return this.head.data = i.slice(e), n;
      }
      return e === i.length ? this.shift() : r ? this._getString(e) : this._getBuffer(e);
    } }, { key: "first", value: function first() {
      return this.head.data;
    } }, { key: aw, value: /* @__PURE__ */ _regeneratorRuntime().mark(function value() {
      var e;
      return _regeneratorRuntime().wrap(function value$(_context4) {
        while (1)
          switch (_context4.prev = _context4.next) {
            case 0:
              e = this.head;
            case 1:
              if (!e) {
                _context4.next = 7;
                break;
              }
              _context4.next = 4;
              return e.data;
            case 4:
              e = e.next;
              _context4.next = 1;
              break;
            case 7:
            case "end":
              return _context4.stop();
          }
      }, value, this);
    }) }, { key: "_getString", value: function _getString(e) {
      var r = "", i = this.head, n = 0;
      do {
        var o = i.data;
        if (e > o.length)
          r += o, e -= o.length;
        else {
          e === o.length ? (r += o, ++n, i.next ? this.head = i.next : this.head = this.tail = null) : (r += cc(o, 0, e), this.head = i, i.data = cc(o, e));
          break;
        }
        ++n;
      } while ((i = i.next) !== null);
      return this.length -= n, r;
    } }, { key: "_getBuffer", value: function _getBuffer(e) {
      var r = $s.allocUnsafe(e), i = e, n = this.head, o = 0;
      do {
        var s = n.data;
        if (e > s.length)
          on3(r, s, i - e), e -= s.length;
        else {
          e === s.length ? (on3(r, s, i - e), ++o, n.next ? this.head = n.next : this.head = this.tail = null) : (on3(r, new lw(s.buffer, s.byteOffset, e), i - e), this.head = n, n.data = s.slice(e));
          break;
        }
        ++o;
      } while ((n = n.next) !== null);
      return this.length -= o, r;
    } }, { key: Symbol.for("nodejs.util.inspect.custom"), value: function value(e, r) {
      return uw(this, _objectSpread(_objectSpread({}, r), {}, { depth: 0, customInspect: false }));
    } }]);
  }();
});
var an = M(function(d2, gc) {
  _();
  v();
  m();
  var _ce7 = ce(), fw = _ce7.MathFloor, cw = _ce7.NumberIsInteger, hw = Ae().codes.ERR_INVALID_ARG_VALUE;
  function dw(t, e, r) {
    return t.highWaterMark != null ? t.highWaterMark : e ? t[r] : null;
  }
  function pc(t) {
    return t ? 16 : 16 * 1024;
  }
  function pw(t, e, r, i) {
    var n = dw(e, i, r);
    if (n != null) {
      if (!cw(n) || n < 0) {
        var o = i ? "options.".concat(r) : "options.highWaterMark";
        throw new hw(o, n);
      }
      return fw(n);
    }
    return pc(t.objectMode);
  }
  gc.exports = { getHighWaterMark: pw, getDefaultHighWaterMark: pc };
});
function wc(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  return r === -1 && (r = e), [r, r === e ? 0 : 4 - r % 4];
}
function gw(t, e, r) {
  for (var i, n, o = [], s = e; s < r; s += 3)
    i = (t[s] << 16 & 16711680) + (t[s + 1] << 8 & 65280) + (255 & t[s + 2]), o.push($e[(n = i) >> 18 & 63] + $e[n >> 12 & 63] + $e[n >> 6 & 63] + $e[63 & n]);
  return o.join("");
}
function Et(t) {
  if (t > 2147483647)
    throw new RangeError('The value "' + t + '" is invalid for option "size"');
  var e = new Uint8Array(t);
  return Object.setPrototypeOf(e, O.prototype), e;
}
function O(t, e, r) {
  if (typeof t == "number") {
    if (typeof e == "string")
      throw new TypeError('The "string" argument must be of type string. Received type number');
    return Ks(t);
  }
  return Cc(t, e, r);
}
function Cc(t, e, r) {
  if (typeof t == "string")
    return function(o, s) {
      if (typeof s == "string" && s !== "" || (s = "utf8"), !O.isEncoding(s))
        throw new TypeError("Unknown encoding: " + s);
      var a = 0 | Pc(o, s), l = Et(a), c = l.write(o, s);
      return c !== a && (l = l.slice(0, c)), l;
    }(t, e);
  if (ArrayBuffer.isView(t))
    return Hs(t);
  if (t == null)
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(t));
  if (St(t, ArrayBuffer) || t && St(t.buffer, ArrayBuffer) || (typeof SharedArrayBuffer === "undefined" ? "undefined" : _typeof(SharedArrayBuffer)) < "u" && (St(t, SharedArrayBuffer) || t && St(t.buffer, SharedArrayBuffer)))
    return mc(t, e, r);
  if (typeof t == "number")
    throw new TypeError('The "value" argument must not be of type number. Received type number');
  var i = t.valueOf && t.valueOf();
  if (i != null && i !== t)
    return O.from(i, e, r);
  var n = function(o) {
    if (O.isBuffer(o)) {
      var s = 0 | Ys(o.length), a = Et(s);
      return a.length === 0 || o.copy(a, 0, 0, s), a;
    }
    if (o.length !== void 0)
      return typeof o.length != "number" || Js(o.length) ? Et(0) : Hs(o);
    if (o.type === "Buffer" && Array.isArray(o.data))
      return Hs(o.data);
  }(t);
  if (n)
    return n;
  if ((typeof Symbol === "undefined" ? "undefined" : _typeof(Symbol)) < "u" && Symbol.toPrimitive != null && typeof t[Symbol.toPrimitive] == "function")
    return O.from(t[Symbol.toPrimitive]("string"), e, r);
  throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(t));
}
function Bc(t) {
  if (typeof t != "number")
    throw new TypeError('"size" argument must be of type number');
  if (t < 0)
    throw new RangeError('The value "' + t + '" is invalid for option "size"');
}
function Ks(t) {
  return Bc(t), Et(t < 0 ? 0 : 0 | Ys(t));
}
function Hs(t) {
  for (var e = t.length < 0 ? 0 : 0 | Ys(t.length), r = Et(e), i = 0; i < e; i += 1)
    r[i] = 255 & t[i];
  return r;
}
function mc(t, e, r) {
  if (e < 0 || t.byteLength < e)
    throw new RangeError('"offset" is outside of buffer bounds');
  if (t.byteLength < e + (r || 0))
    throw new RangeError('"length" is outside of buffer bounds');
  var i;
  return i = e === void 0 && r === void 0 ? new Uint8Array(t) : r === void 0 ? new Uint8Array(t, e) : new Uint8Array(t, e, r), Object.setPrototypeOf(i, O.prototype), i;
}
function Ys(t) {
  if (t >= 2147483647)
    throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + 2147483647 .toString(16) + " bytes");
  return 0 | t;
}
function Pc(t, e) {
  if (O.isBuffer(t))
    return t.length;
  if (ArrayBuffer.isView(t) || St(t, ArrayBuffer))
    return t.byteLength;
  if (typeof t != "string")
    throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + _typeof(t));
  var r = t.length, i = arguments.length > 2 && arguments[2] === true;
  if (!i && r === 0)
    return 0;
  for (var n = false; ; )
    switch (e) {
      case "ascii":
      case "latin1":
      case "binary":
        return r;
      case "utf8":
      case "utf-8":
        return Gs(t).length;
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return 2 * r;
      case "hex":
        return r >>> 1;
      case "base64":
        return Mc(t).length;
      default:
        if (n)
          return i ? -1 : Gs(t).length;
        e = ("" + e).toLowerCase(), n = true;
    }
}
function bw(t, e, r) {
  var i = false;
  if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((r === void 0 || r > this.length) && (r = this.length), r <= 0) || (r >>>= 0) <= (e >>>= 0))
    return "";
  for (t || (t = "utf8"); ; )
    switch (t) {
      case "hex":
        return Tw(this, e, r);
      case "utf8":
      case "utf-8":
        return Oc(this, e, r);
      case "ascii":
        return Aw(this, e, r);
      case "latin1":
      case "binary":
        return Iw(this, e, r);
      case "base64":
        return Sw(this, e, r);
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return Rw(this, e, r);
      default:
        if (i)
          throw new TypeError("Unknown encoding: " + t);
        t = (t + "").toLowerCase(), i = true;
    }
}
function ar(t, e, r) {
  var i = t[e];
  t[e] = t[r], t[r] = i;
}
function vc(t, e, r, i, n) {
  if (t.length === 0)
    return -1;
  if (typeof r == "string" ? (i = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), Js(r = +r) && (r = n ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
    if (n)
      return -1;
    r = t.length - 1;
  } else if (r < 0) {
    if (!n)
      return -1;
    r = 0;
  }
  if (typeof e == "string" && (e = O.from(e, i)), O.isBuffer(e))
    return e.length === 0 ? -1 : Ec(t, e, r, i, n);
  if (typeof e == "number")
    return e &= 255, typeof Uint8Array.prototype.indexOf == "function" ? n ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : Ec(t, [e], r, i, n);
  throw new TypeError("val must be string, number or Buffer");
}
function Ec(t, e, r, i, n) {
  var o, s = 1, a = t.length, l = e.length;
  if (i !== void 0 && ((i = String(i).toLowerCase()) === "ucs2" || i === "ucs-2" || i === "utf16le" || i === "utf-16le")) {
    if (t.length < 2 || e.length < 2)
      return -1;
    s = 2, a /= 2, l /= 2, r /= 2;
  }
  function c(y, w) {
    return s === 1 ? y[w] : y.readUInt16BE(w * s);
  }
  if (n) {
    var h = -1;
    for (o = r; o < a; o++)
      if (c(t, o) === c(e, h === -1 ? 0 : o - h)) {
        if (h === -1 && (h = o), o - h + 1 === l)
          return h * s;
      } else
        h !== -1 && (o -= o - h), h = -1;
  } else
    for (r + l > a && (r = a - l), o = r; o >= 0; o--) {
      for (var d = true, g = 0; g < l; g++)
        if (c(t, o + g) !== c(e, g)) {
          d = false;
          break;
        }
      if (d)
        return o;
    }
  return -1;
}
function ww(t, e, r, i) {
  r = Number(r) || 0;
  var n = t.length - r;
  i ? (i = Number(i)) > n && (i = n) : i = n;
  var o = e.length;
  i > o / 2 && (i = o / 2);
  for (var s = 0; s < i; ++s) {
    var a = parseInt(e.substr(2 * s, 2), 16);
    if (Js(a))
      return s;
    t[r + s] = a;
  }
  return s;
}
function _w(t, e, r, i) {
  return cn(Gs(e, t.length - r), t, r, i);
}
function kc(t, e, r, i) {
  return cn(function(n) {
    for (var o = [], s = 0; s < n.length; ++s)
      o.push(255 & n.charCodeAt(s));
    return o;
  }(e), t, r, i);
}
function mw(t, e, r, i) {
  return kc(t, e, r, i);
}
function vw(t, e, r, i) {
  return cn(Mc(e), t, r, i);
}
function Ew(t, e, r, i) {
  return cn(function(n, o) {
    for (var s, a, l, c = [], h = 0; h < n.length && !((o -= 2) < 0); ++h)
      s = n.charCodeAt(h), a = s >> 8, l = s % 256, c.push(l), c.push(a);
    return c;
  }(e, t.length - r), t, r, i);
}
function Sw(t, e, r) {
  return e === 0 && r === t.length ? zs.fromByteArray(t) : zs.fromByteArray(t.slice(e, r));
}
function Oc(t, e, r) {
  r = Math.min(t.length, r);
  for (var i = [], n = e; n < r; ) {
    var o, s, a, l, c = t[n], h = null, d = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
    if (n + d <= r)
      switch (d) {
        case 1:
          c < 128 && (h = c);
          break;
        case 2:
          (192 & (o = t[n + 1])) == 128 && (l = (31 & c) << 6 | 63 & o) > 127 && (h = l);
          break;
        case 3:
          o = t[n + 1], s = t[n + 2], (192 & o) == 128 && (192 & s) == 128 && (l = (15 & c) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (l < 55296 || l > 57343) && (h = l);
          break;
        case 4:
          o = t[n + 1], s = t[n + 2], a = t[n + 3], (192 & o) == 128 && (192 & s) == 128 && (192 & a) == 128 && (l = (15 & c) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && l < 1114112 && (h = l);
      }
    h === null ? (h = 65533, d = 1) : h > 65535 && (h -= 65536, i.push(h >>> 10 & 1023 | 55296), h = 56320 | 1023 & h), i.push(h), n += d;
  }
  return function(g) {
    var y = g.length;
    if (y <= 4096)
      return String.fromCharCode.apply(String, g);
    for (var w = "", S = 0; S < y; )
      w += String.fromCharCode.apply(String, g.slice(S, S += 4096));
    return w;
  }(i);
}
function Aw(t, e, r) {
  var i = "";
  r = Math.min(t.length, r);
  for (var n = e; n < r; ++n)
    i += String.fromCharCode(127 & t[n]);
  return i;
}
function Iw(t, e, r) {
  var i = "";
  r = Math.min(t.length, r);
  for (var n = e; n < r; ++n)
    i += String.fromCharCode(t[n]);
  return i;
}
function Tw(t, e, r) {
  var i = t.length;
  (!e || e < 0) && (e = 0), (!r || r < 0 || r > i) && (r = i);
  for (var n = "", o = e; o < r; ++o)
    n += Bw[t[o]];
  return n;
}
function Rw(t, e, r) {
  for (var i = t.slice(e, r), n = "", o = 0; o < i.length; o += 2)
    n += String.fromCharCode(i[o] + 256 * i[o + 1]);
  return n;
}
function we(t, e, r) {
  if (t % 1 != 0 || t < 0)
    throw new RangeError("offset is not uint");
  if (t + e > r)
    throw new RangeError("Trying to access beyond buffer length");
}
function Pe(t, e, r, i, n, o) {
  if (!O.isBuffer(t))
    throw new TypeError('"buffer" argument must be a Buffer instance');
  if (e > n || e < o)
    throw new RangeError('"value" argument is out of bounds');
  if (r + i > t.length)
    throw new RangeError("Index out of range");
}
function xc(t, e, r, i, n, o) {
  if (r + i > t.length)
    throw new RangeError("Index out of range");
  if (r < 0)
    throw new RangeError("Index out of range");
}
function Sc(t, e, r, i, n) {
  return e = +e, r >>>= 0, n || xc(t, 0, r, 4), Dr.write(t, e, r, i, 23, 4), r + 4;
}
function Ac(t, e, r, i, n) {
  return e = +e, r >>>= 0, n || xc(t, 0, r, 8), Dr.write(t, e, r, i, 52, 8), r + 8;
}
function Gs(t, e) {
  var r;
  e = e || 1 / 0;
  for (var i = t.length, n = null, o = [], s = 0; s < i; ++s) {
    if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
      if (!n) {
        if (r > 56319) {
          (e -= 3) > -1 && o.push(239, 191, 189);
          continue;
        }
        if (s + 1 === i) {
          (e -= 3) > -1 && o.push(239, 191, 189);
          continue;
        }
        n = r;
        continue;
      }
      if (r < 56320) {
        (e -= 3) > -1 && o.push(239, 191, 189), n = r;
        continue;
      }
      r = 65536 + (n - 55296 << 10 | r - 56320);
    } else
      n && (e -= 3) > -1 && o.push(239, 191, 189);
    if (n = null, r < 128) {
      if ((e -= 1) < 0)
        break;
      o.push(r);
    } else if (r < 2048) {
      if ((e -= 2) < 0)
        break;
      o.push(r >> 6 | 192, 63 & r | 128);
    } else if (r < 65536) {
      if ((e -= 3) < 0)
        break;
      o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
    } else {
      if (!(r < 1114112))
        throw new Error("Invalid code point");
      if ((e -= 4) < 0)
        break;
      o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
    }
  }
  return o;
}
function Mc(t) {
  return zs.toByteArray(function(e) {
    if ((e = (e = e.split("=")[0]).trim().replace(Cw, "")).length < 2)
      return "";
    for (; e.length % 4 != 0; )
      e += "=";
    return e;
  }(t));
}
function cn(t, e, r, i) {
  for (var n = 0; n < i && !(n + r >= e.length || n >= t.length); ++n)
    e[n + r] = t[n];
  return n;
}
function St(t, e) {
  return t instanceof e || t != null && t.constructor != null && t.constructor.name != null && t.constructor.name === e.name;
}
function Js(t) {
  return t != t;
}
function Ic(t, e) {
  for (var r in t)
    e[r] = t[r];
}
function lr(t, e, r) {
  return it(t, e, r);
}
function pi(t) {
  var e;
  switch (this.encoding = function(r) {
    var i = function(n) {
      if (!n)
        return "utf8";
      for (var o; ; )
        switch (n) {
          case "utf8":
          case "utf-8":
            return "utf8";
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return "utf16le";
          case "latin1":
          case "binary":
            return "latin1";
          case "base64":
          case "ascii":
          case "hex":
            return n;
          default:
            if (o)
              return;
            n = ("" + n).toLowerCase(), o = true;
        }
    }(r);
    if (typeof i != "string" && (Qs.isEncoding === Tc || !Tc(r)))
      throw new Error("Unknown encoding: " + r);
    return i || r;
  }(t), this.encoding) {
    case "utf16le":
      this.text = Ow, this.end = xw, e = 4;
      break;
    case "utf8":
      this.fillLast = kw, e = 4;
      break;
    case "base64":
      this.text = Mw, this.end = Lw, e = 3;
      break;
    default:
      return this.write = Uw, this.end = Nw, void 0;
  }
  this.lastNeed = 0, this.lastTotal = 0, this.lastChar = Qs.allocUnsafe(e);
}
function Vs(t) {
  return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2;
}
function kw(t) {
  var e = this.lastTotal - this.lastNeed, r = function(i, n, o) {
    if ((192 & n[0]) != 128)
      return i.lastNeed = 0, "�";
    if (i.lastNeed > 1 && n.length > 1) {
      if ((192 & n[1]) != 128)
        return i.lastNeed = 1, "�";
      if (i.lastNeed > 2 && n.length > 2 && (192 & n[2]) != 128)
        return i.lastNeed = 2, "�";
    }
  }(this, t);
  return r !== void 0 ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), this.lastNeed -= t.length, void 0);
}
function Ow(t, e) {
  if ((t.length - e) % 2 == 0) {
    var r = t.toString("utf16le", e);
    if (r) {
      var i = r.charCodeAt(r.length - 1);
      if (i >= 55296 && i <= 56319)
        return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
    }
    return r;
  }
  return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
}
function xw(t) {
  var e = t && t.length ? this.write(t) : "";
  if (this.lastNeed) {
    var r = this.lastTotal - this.lastNeed;
    return e + this.lastChar.toString("utf16le", 0, r);
  }
  return e;
}
function Mw(t, e) {
  var r = (t.length - e) % 3;
  return r === 0 ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, r === 1 ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
}
function Lw(t) {
  var e = t && t.length ? this.write(t) : "";
  return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
}
function Uw(t) {
  return t.toString(this.encoding);
}
function Nw(t) {
  return t && t.length ? this.write(t) : "";
}
var Rc, $e, Oe, yc, ln, or, bc, yw, At, zs, Dr, _c, Cw, Bw, un, fn, it, Pw, ur, Qs, Tc, Xs = _e(function() {
  _();
  v();
  m();
  for (Rc = { byteLength: function byteLength2(t) {
    var e = wc(t), r = e[0], i = e[1];
    return 3 * (r + i) / 4 - i;
  }, toByteArray: function toByteArray2(t) {
    var e, r, i = wc(t), n = i[0], o = i[1], s = new yc(function(c, h, d) {
      return 3 * (h + d) / 4 - d;
    }(0, n, o)), a = 0, l = o > 0 ? n - 4 : n;
    for (r = 0; r < l; r += 4)
      e = Oe[t.charCodeAt(r)] << 18 | Oe[t.charCodeAt(r + 1)] << 12 | Oe[t.charCodeAt(r + 2)] << 6 | Oe[t.charCodeAt(r + 3)], s[a++] = e >> 16 & 255, s[a++] = e >> 8 & 255, s[a++] = 255 & e;
    return o === 2 && (e = Oe[t.charCodeAt(r)] << 2 | Oe[t.charCodeAt(r + 1)] >> 4, s[a++] = 255 & e), o === 1 && (e = Oe[t.charCodeAt(r)] << 10 | Oe[t.charCodeAt(r + 1)] << 4 | Oe[t.charCodeAt(r + 2)] >> 2, s[a++] = e >> 8 & 255, s[a++] = 255 & e), s;
  }, fromByteArray: function fromByteArray2(t) {
    for (var e, r = t.length, i = r % 3, n = [], o = 0, s = r - i; o < s; o += 16383)
      n.push(gw(t, o, o + 16383 > s ? s : o + 16383));
    return i === 1 ? (e = t[r - 1], n.push($e[e >> 2] + $e[e << 4 & 63] + "==")) : i === 2 && (e = (t[r - 2] << 8) + t[r - 1], n.push($e[e >> 10] + $e[e >> 4 & 63] + $e[e << 2 & 63] + "=")), n.join("");
  } }, $e = [], Oe = [], yc = (typeof Uint8Array === "undefined" ? "undefined" : _typeof(Uint8Array)) < "u" ? Uint8Array : Array, ln = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", or = 0, bc = ln.length; or < bc; ++or)
    $e[or] = ln[or], Oe[ln.charCodeAt(or)] = or;
  Oe["-".charCodeAt(0)] = 62, Oe["_".charCodeAt(0)] = 63;
  yw = { read: function read(t, e, r, i, n) {
    var o, s, a = 8 * n - i - 1, l = (1 << a) - 1, c = l >> 1, h = -7, d = r ? n - 1 : 0, g = r ? -1 : 1, y = t[e + d];
    for (d += g, o = y & (1 << -h) - 1, y >>= -h, h += a; h > 0; o = 256 * o + t[e + d], d += g, h -= 8)
      ;
    for (s = o & (1 << -h) - 1, o >>= -h, h += i; h > 0; s = 256 * s + t[e + d], d += g, h -= 8)
      ;
    if (o === 0)
      o = 1 - c;
    else {
      if (o === l)
        return s ? NaN : 1 / 0 * (y ? -1 : 1);
      s += Math.pow(2, i), o -= c;
    }
    return (y ? -1 : 1) * s * Math.pow(2, o - i);
  }, write: function write3(t, e, r, i, n, o) {
    var s, a, l, c = 8 * o - n - 1, h = (1 << c) - 1, d = h >> 1, g = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, y = i ? 0 : o - 1, w = i ? 1 : -1, S = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
    for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = h) : (s = Math.floor(Math.log(e) / Math.LN2), e * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), (e += s + d >= 1 ? g / l : g * Math.pow(2, 1 - d)) * l >= 2 && (s++, l /= 2), s + d >= h ? (a = 0, s = h) : s + d >= 1 ? (a = (e * l - 1) * Math.pow(2, n), s += d) : (a = e * Math.pow(2, d - 1) * Math.pow(2, n), s = 0)); n >= 8; t[r + y] = 255 & a, y += w, a /= 256, n -= 8)
      ;
    for (s = s << n | a, c += n; c > 0; t[r + y] = 255 & s, y += w, s /= 256, c -= 8)
      ;
    t[r + y - w] |= 128 * S;
  } }, At = {}, zs = Rc, Dr = yw, _c = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  At.Buffer = O, At.SlowBuffer = function(t) {
    return +t != t && (t = 0), O.alloc(+t);
  }, At.INSPECT_MAX_BYTES = 50;
  At.kMaxLength = 2147483647, O.TYPED_ARRAY_SUPPORT = function() {
    try {
      var t = new Uint8Array(1), e = { foo: function foo() {
        return 42;
      } };
      return Object.setPrototypeOf(e, Uint8Array.prototype), Object.setPrototypeOf(t, e), t.foo() === 42;
    } catch (_unused8) {
      return false;
    }
  }(), O.TYPED_ARRAY_SUPPORT || (typeof console === "undefined" ? "undefined" : _typeof(console)) > "u" || typeof console.error != "function" || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(O.prototype, "parent", { enumerable: true, get: function get2() {
    if (O.isBuffer(this))
      return this.buffer;
  } }), Object.defineProperty(O.prototype, "offset", { enumerable: true, get: function get2() {
    if (O.isBuffer(this))
      return this.byteOffset;
  } }), O.poolSize = 8192, O.from = function(t, e, r) {
    return Cc(t, e, r);
  }, Object.setPrototypeOf(O.prototype, Uint8Array.prototype), Object.setPrototypeOf(O, Uint8Array), O.alloc = function(t, e, r) {
    return function(i, n, o) {
      return Bc(i), i <= 0 ? Et(i) : n !== void 0 ? typeof o == "string" ? Et(i).fill(n, o) : Et(i).fill(n) : Et(i);
    }(t, e, r);
  }, O.allocUnsafe = function(t) {
    return Ks(t);
  }, O.allocUnsafeSlow = function(t) {
    return Ks(t);
  }, O.isBuffer = function(t) {
    return t != null && t._isBuffer === true && t !== O.prototype;
  }, O.compare = function(t, e) {
    if (St(t, Uint8Array) && (t = O.from(t, t.offset, t.byteLength)), St(e, Uint8Array) && (e = O.from(e, e.offset, e.byteLength)), !O.isBuffer(t) || !O.isBuffer(e))
      throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (t === e)
      return 0;
    for (var r = t.length, i = e.length, n = 0, o = Math.min(r, i); n < o; ++n)
      if (t[n] !== e[n]) {
        r = t[n], i = e[n];
        break;
      }
    return r < i ? -1 : i < r ? 1 : 0;
  }, O.isEncoding = function(t) {
    switch (String(t).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return true;
      default:
        return false;
    }
  }, O.concat = function(t, e) {
    if (!Array.isArray(t))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (t.length === 0)
      return O.alloc(0);
    var r;
    if (e === void 0)
      for (e = 0, r = 0; r < t.length; ++r)
        e += t[r].length;
    var i = O.allocUnsafe(e), n = 0;
    for (r = 0; r < t.length; ++r) {
      var o = t[r];
      if (St(o, Uint8Array) && (o = O.from(o)), !O.isBuffer(o))
        throw new TypeError('"list" argument must be an Array of Buffers');
      o.copy(i, n), n += o.length;
    }
    return i;
  }, O.byteLength = Pc, O.prototype._isBuffer = true, O.prototype.swap16 = function() {
    var t = this.length;
    if (t % 2 != 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var e = 0; e < t; e += 2)
      ar(this, e, e + 1);
    return this;
  }, O.prototype.swap32 = function() {
    var t = this.length;
    if (t % 4 != 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var e = 0; e < t; e += 4)
      ar(this, e, e + 3), ar(this, e + 1, e + 2);
    return this;
  }, O.prototype.swap64 = function() {
    var t = this.length;
    if (t % 8 != 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var e = 0; e < t; e += 8)
      ar(this, e, e + 7), ar(this, e + 1, e + 6), ar(this, e + 2, e + 5), ar(this, e + 3, e + 4);
    return this;
  }, O.prototype.toString = function() {
    var t = this.length;
    return t === 0 ? "" : arguments.length === 0 ? Oc(this, 0, t) : bw.apply(this, arguments);
  }, O.prototype.toLocaleString = O.prototype.toString, O.prototype.equals = function(t) {
    if (!O.isBuffer(t))
      throw new TypeError("Argument must be a Buffer");
    return this === t || O.compare(this, t) === 0;
  }, O.prototype.inspect = function() {
    var t = "", e = At.INSPECT_MAX_BYTES;
    return t = this.toString("hex", 0, e).replace(/(.{2})/g, "$1 ").trim(), this.length > e && (t += " ... "), "<Buffer " + t + ">";
  }, _c && (O.prototype[_c] = O.prototype.inspect), O.prototype.compare = function(t, e, r, i, n) {
    if (St(t, Uint8Array) && (t = O.from(t, t.offset, t.byteLength)), !O.isBuffer(t))
      throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + _typeof(t));
    if (e === void 0 && (e = 0), r === void 0 && (r = t ? t.length : 0), i === void 0 && (i = 0), n === void 0 && (n = this.length), e < 0 || r > t.length || i < 0 || n > this.length)
      throw new RangeError("out of range index");
    if (i >= n && e >= r)
      return 0;
    if (i >= n)
      return -1;
    if (e >= r)
      return 1;
    if (this === t)
      return 0;
    for (var o = (n >>>= 0) - (i >>>= 0), s = (r >>>= 0) - (e >>>= 0), a = Math.min(o, s), l = this.slice(i, n), c = t.slice(e, r), h = 0; h < a; ++h)
      if (l[h] !== c[h]) {
        o = l[h], s = c[h];
        break;
      }
    return o < s ? -1 : s < o ? 1 : 0;
  }, O.prototype.includes = function(t, e, r) {
    return this.indexOf(t, e, r) !== -1;
  }, O.prototype.indexOf = function(t, e, r) {
    return vc(this, t, e, r, true);
  }, O.prototype.lastIndexOf = function(t, e, r) {
    return vc(this, t, e, r, false);
  }, O.prototype.write = function(t, e, r, i) {
    if (e === void 0)
      i = "utf8", r = this.length, e = 0;
    else if (r === void 0 && typeof e == "string")
      i = e, r = this.length, e = 0;
    else {
      if (!isFinite(e))
        throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
      e >>>= 0, isFinite(r) ? (r >>>= 0, i === void 0 && (i = "utf8")) : (i = r, r = void 0);
    }
    var n = this.length - e;
    if ((r === void 0 || r > n) && (r = n), t.length > 0 && (r < 0 || e < 0) || e > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    i || (i = "utf8");
    for (var o = false; ; )
      switch (i) {
        case "hex":
          return ww(this, t, e, r);
        case "utf8":
        case "utf-8":
          return _w(this, t, e, r);
        case "ascii":
          return kc(this, t, e, r);
        case "latin1":
        case "binary":
          return mw(this, t, e, r);
        case "base64":
          return vw(this, t, e, r);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Ew(this, t, e, r);
        default:
          if (o)
            throw new TypeError("Unknown encoding: " + i);
          i = ("" + i).toLowerCase(), o = true;
      }
  }, O.prototype.toJSON = function() {
    return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
  };
  O.prototype.slice = function(t, e) {
    var r = this.length;
    (t = ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), (e = e === void 0 ? r : ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), e < t && (e = t);
    var i = this.subarray(t, e);
    return Object.setPrototypeOf(i, O.prototype), i;
  }, O.prototype.readUIntLE = function(t, e, r) {
    t >>>= 0, e >>>= 0, r || we(t, e, this.length);
    for (var i = this[t], n = 1, o = 0; ++o < e && (n *= 256); )
      i += this[t + o] * n;
    return i;
  }, O.prototype.readUIntBE = function(t, e, r) {
    t >>>= 0, e >>>= 0, r || we(t, e, this.length);
    for (var i = this[t + --e], n = 1; e > 0 && (n *= 256); )
      i += this[t + --e] * n;
    return i;
  }, O.prototype.readUInt8 = function(t, e) {
    return t >>>= 0, e || we(t, 1, this.length), this[t];
  }, O.prototype.readUInt16LE = function(t, e) {
    return t >>>= 0, e || we(t, 2, this.length), this[t] | this[t + 1] << 8;
  }, O.prototype.readUInt16BE = function(t, e) {
    return t >>>= 0, e || we(t, 2, this.length), this[t] << 8 | this[t + 1];
  }, O.prototype.readUInt32LE = function(t, e) {
    return t >>>= 0, e || we(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
  }, O.prototype.readUInt32BE = function(t, e) {
    return t >>>= 0, e || we(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
  }, O.prototype.readIntLE = function(t, e, r) {
    t >>>= 0, e >>>= 0, r || we(t, e, this.length);
    for (var i = this[t], n = 1, o = 0; ++o < e && (n *= 256); )
      i += this[t + o] * n;
    return i >= (n *= 128) && (i -= Math.pow(2, 8 * e)), i;
  }, O.prototype.readIntBE = function(t, e, r) {
    t >>>= 0, e >>>= 0, r || we(t, e, this.length);
    for (var i = e, n = 1, o = this[t + --i]; i > 0 && (n *= 256); )
      o += this[t + --i] * n;
    return o >= (n *= 128) && (o -= Math.pow(2, 8 * e)), o;
  }, O.prototype.readInt8 = function(t, e) {
    return t >>>= 0, e || we(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
  }, O.prototype.readInt16LE = function(t, e) {
    t >>>= 0, e || we(t, 2, this.length);
    var r = this[t] | this[t + 1] << 8;
    return 32768 & r ? 4294901760 | r : r;
  }, O.prototype.readInt16BE = function(t, e) {
    t >>>= 0, e || we(t, 2, this.length);
    var r = this[t + 1] | this[t] << 8;
    return 32768 & r ? 4294901760 | r : r;
  }, O.prototype.readInt32LE = function(t, e) {
    return t >>>= 0, e || we(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
  }, O.prototype.readInt32BE = function(t, e) {
    return t >>>= 0, e || we(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
  }, O.prototype.readFloatLE = function(t, e) {
    return t >>>= 0, e || we(t, 4, this.length), Dr.read(this, t, true, 23, 4);
  }, O.prototype.readFloatBE = function(t, e) {
    return t >>>= 0, e || we(t, 4, this.length), Dr.read(this, t, false, 23, 4);
  }, O.prototype.readDoubleLE = function(t, e) {
    return t >>>= 0, e || we(t, 8, this.length), Dr.read(this, t, true, 52, 8);
  }, O.prototype.readDoubleBE = function(t, e) {
    return t >>>= 0, e || we(t, 8, this.length), Dr.read(this, t, false, 52, 8);
  }, O.prototype.writeUIntLE = function(t, e, r, i) {
    t = +t, e >>>= 0, r >>>= 0, i || Pe(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
    var n = 1, o = 0;
    for (this[e] = 255 & t; ++o < r && (n *= 256); )
      this[e + o] = t / n & 255;
    return e + r;
  }, O.prototype.writeUIntBE = function(t, e, r, i) {
    t = +t, e >>>= 0, r >>>= 0, i || Pe(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
    var n = r - 1, o = 1;
    for (this[e + n] = 255 & t; --n >= 0 && (o *= 256); )
      this[e + n] = t / o & 255;
    return e + r;
  }, O.prototype.writeUInt8 = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 1, 255, 0), this[e] = 255 & t, e + 1;
  }, O.prototype.writeUInt16LE = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 2, 65535, 0), this[e] = 255 & t, this[e + 1] = t >>> 8, e + 2;
  }, O.prototype.writeUInt16BE = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 2, 65535, 0), this[e] = t >>> 8, this[e + 1] = 255 & t, e + 2;
  }, O.prototype.writeUInt32LE = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 4, 4294967295, 0), this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t, e + 4;
  }, O.prototype.writeUInt32BE = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 4, 4294967295, 0), this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t, e + 4;
  }, O.prototype.writeIntLE = function(t, e, r, i) {
    if (t = +t, e >>>= 0, !i) {
      var n = Math.pow(2, 8 * r - 1);
      Pe(this, t, e, r, n - 1, -n);
    }
    var o = 0, s = 1, a = 0;
    for (this[e] = 255 & t; ++o < r && (s *= 256); )
      t < 0 && a === 0 && this[e + o - 1] !== 0 && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
    return e + r;
  }, O.prototype.writeIntBE = function(t, e, r, i) {
    if (t = +t, e >>>= 0, !i) {
      var n = Math.pow(2, 8 * r - 1);
      Pe(this, t, e, r, n - 1, -n);
    }
    var o = r - 1, s = 1, a = 0;
    for (this[e + o] = 255 & t; --o >= 0 && (s *= 256); )
      t < 0 && a === 0 && this[e + o + 1] !== 0 && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
    return e + r;
  }, O.prototype.writeInt8 = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 1, 127, -128), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
  }, O.prototype.writeInt16LE = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 2, 32767, -32768), this[e] = 255 & t, this[e + 1] = t >>> 8, e + 2;
  }, O.prototype.writeInt16BE = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 2, 32767, -32768), this[e] = t >>> 8, this[e + 1] = 255 & t, e + 2;
  }, O.prototype.writeInt32LE = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 4, 2147483647, -2147483648), this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24, e + 4;
  }, O.prototype.writeInt32BE = function(t, e, r) {
    return t = +t, e >>>= 0, r || Pe(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t, e + 4;
  }, O.prototype.writeFloatLE = function(t, e, r) {
    return Sc(this, t, e, true, r);
  }, O.prototype.writeFloatBE = function(t, e, r) {
    return Sc(this, t, e, false, r);
  }, O.prototype.writeDoubleLE = function(t, e, r) {
    return Ac(this, t, e, true, r);
  }, O.prototype.writeDoubleBE = function(t, e, r) {
    return Ac(this, t, e, false, r);
  }, O.prototype.copy = function(t, e, r, i) {
    if (!O.isBuffer(t))
      throw new TypeError("argument should be a Buffer");
    if (r || (r = 0), i || i === 0 || (i = this.length), e >= t.length && (e = t.length), e || (e = 0), i > 0 && i < r && (i = r), i === r || t.length === 0 || this.length === 0)
      return 0;
    if (e < 0)
      throw new RangeError("targetStart out of bounds");
    if (r < 0 || r >= this.length)
      throw new RangeError("Index out of range");
    if (i < 0)
      throw new RangeError("sourceEnd out of bounds");
    i > this.length && (i = this.length), t.length - e < i - r && (i = t.length - e + r);
    var n = i - r;
    if (this === t && typeof Uint8Array.prototype.copyWithin == "function")
      this.copyWithin(e, r, i);
    else if (this === t && r < e && e < i)
      for (var o = n - 1; o >= 0; --o)
        t[o + e] = this[o + r];
    else
      Uint8Array.prototype.set.call(t, this.subarray(r, i), e);
    return n;
  }, O.prototype.fill = function(t, e, r, i) {
    if (typeof t == "string") {
      if (typeof e == "string" ? (i = e, e = 0, r = this.length) : typeof r == "string" && (i = r, r = this.length), i !== void 0 && typeof i != "string")
        throw new TypeError("encoding must be a string");
      if (typeof i == "string" && !O.isEncoding(i))
        throw new TypeError("Unknown encoding: " + i);
      if (t.length === 1) {
        var n = t.charCodeAt(0);
        (i === "utf8" && n < 128 || i === "latin1") && (t = n);
      }
    } else
      typeof t == "number" ? t &= 255 : typeof t == "boolean" && (t = Number(t));
    if (e < 0 || this.length < e || this.length < r)
      throw new RangeError("Out of range index");
    if (r <= e)
      return this;
    var o;
    if (e >>>= 0, r = r === void 0 ? this.length : r >>> 0, t || (t = 0), typeof t == "number")
      for (o = e; o < r; ++o)
        this[o] = t;
    else {
      var s = O.isBuffer(t) ? t : O.from(t, i), a = s.length;
      if (a === 0)
        throw new TypeError('The value "' + t + '" is invalid for argument "value"');
      for (o = 0; o < r - e; ++o)
        this[o + e] = s[o % a];
    }
    return this;
  };
  Cw = /[^+/0-9A-Za-z-_]/g;
  Bw = function() {
    for (var t = new Array(256), e = 0; e < 16; ++e)
      for (var r = 16 * e, i = 0; i < 16; ++i)
        t[r + i] = "0123456789abcdef"[e] + "0123456789abcdef"[i];
    return t;
  }();
  At.Buffer;
  At.INSPECT_MAX_BYTES;
  At.kMaxLength;
  un = {}, fn = At, it = fn.Buffer;
  it.from && it.alloc && it.allocUnsafe && it.allocUnsafeSlow ? un = fn : (Ic(fn, un), un.Buffer = lr), lr.prototype = Object.create(it.prototype), Ic(it, lr), lr.from = function(t, e, r) {
    if (typeof t == "number")
      throw new TypeError("Argument must not be a number");
    return it(t, e, r);
  }, lr.alloc = function(t, e, r) {
    if (typeof t != "number")
      throw new TypeError("Argument must be a number");
    var i = it(t);
    return e !== void 0 ? typeof r == "string" ? i.fill(e, r) : i.fill(e) : i.fill(0), i;
  }, lr.allocUnsafe = function(t) {
    if (typeof t != "number")
      throw new TypeError("Argument must be a number");
    return it(t);
  }, lr.allocUnsafeSlow = function(t) {
    if (typeof t != "number")
      throw new TypeError("Argument must be a number");
    return fn.SlowBuffer(t);
  };
  Pw = un, ur = {}, Qs = Pw.Buffer, Tc = Qs.isEncoding || function(t) {
    switch ((t = "" + t) && t.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return true;
      default:
        return false;
    }
  };
  ur.StringDecoder = pi, pi.prototype.write = function(t) {
    if (t.length === 0)
      return "";
    var e, r;
    if (this.lastNeed) {
      if ((e = this.fillLast(t)) === void 0)
        return "";
      r = this.lastNeed, this.lastNeed = 0;
    } else
      r = 0;
    return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
  }, pi.prototype.end = function(t) {
    var e = t && t.length ? this.write(t) : "";
    return this.lastNeed ? e + "�" : e;
  }, pi.prototype.text = function(t, e) {
    var r = function(n, o, s) {
      var a = o.length - 1;
      if (a < s)
        return 0;
      var l = Vs(o[a]);
      return l >= 0 ? (l > 0 && (n.lastNeed = l - 1), l) : --a < s || l === -2 ? 0 : (l = Vs(o[a])) >= 0 ? (l > 0 && (n.lastNeed = l - 2), l) : --a < s || l === -2 ? 0 : (l = Vs(o[a])) >= 0 ? (l > 0 && (l === 2 ? l = 0 : n.lastNeed = l - 3), l) : 0;
    }(this, t, e);
    if (!this.lastNeed)
      return t.toString("utf8", e);
    this.lastTotal = r;
    var i = t.length - (r - this.lastNeed);
    return t.copy(this.lastChar, 0, i), t.toString("utf8", e, i);
  }, pi.prototype.fillLast = function(t) {
    if (this.lastNeed <= t.length)
      return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
  };
  ur.StringDecoder;
  ur.StringDecoder;
});
var Lc = {};
Jt(Lc, { StringDecoder: function StringDecoder() {
  return qw;
}, default: function _default4() {
  return ur;
} });
var qw, Uc = _e(function() {
  _();
  v();
  m();
  Xs();
  Xs();
  qw = ur.StringDecoder;
});
var Zs = M(function(H2, jc) {
  _();
  v();
  m();
  var Nc = Nt(), _ce8 = ce(), Dw = _ce8.PromisePrototypeThen, qc = _ce8.SymbolAsyncIterator, Dc = _ce8.SymbolIterator, _ref12 = (be(), X(me)), jw = _ref12.Buffer, _Ae$codes2 = Ae().codes, Fw = _Ae$codes2.ERR_INVALID_ARG_TYPE, Ww = _Ae$codes2.ERR_STREAM_NULL_VALUES;
  function $w(t, e, r) {
    var i;
    if (typeof e == "string" || e instanceof jw)
      return new t(_objectSpread(_objectSpread({ objectMode: true }, r), {}, { read: function read() {
        this.push(e), this.push(null);
      } }));
    var n;
    if (e && e[qc])
      n = true, i = e[qc]();
    else if (e && e[Dc])
      n = false, i = e[Dc]();
    else
      throw new Fw("iterable", ["Iterable"], e);
    var o = new t(_objectSpread({ objectMode: true, highWaterMark: 1 }, r)), s = false;
    o._read = function() {
      s || (s = true, l());
    }, o._destroy = function(c, h) {
      Dw(a(c), function() {
        return Nc.nextTick(h, c);
      }, function(d) {
        return Nc.nextTick(h, d || c);
      });
    };
    function a(_x4) {
      return _a2.apply(this, arguments);
    }
    function _a2() {
      _a2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee4(c) {
        var h, d, _yield$i$throw, g, y, _yield$i$return, _g2;
        return _regeneratorRuntime().wrap(function _callee4$(_context5) {
          while (1)
            switch (_context5.prev = _context5.next) {
              case 0:
                h = c != null, d = typeof i.throw == "function";
                if (!(h && d)) {
                  _context5.next = 11;
                  break;
                }
                _context5.next = 4;
                return i.throw(c);
              case 4:
                _yield$i$throw = _context5.sent;
                g = _yield$i$throw.value;
                y = _yield$i$throw.done;
                _context5.next = 9;
                return g;
              case 9:
                if (!y) {
                  _context5.next = 11;
                  break;
                }
                return _context5.abrupt("return");
              case 11:
                if (!(typeof i.return == "function")) {
                  _context5.next = 18;
                  break;
                }
                _context5.next = 14;
                return i.return();
              case 14:
                _yield$i$return = _context5.sent;
                _g2 = _yield$i$return.value;
                _context5.next = 18;
                return _g2;
              case 18:
              case "end":
                return _context5.stop();
            }
        }, _callee4);
      }));
      return _a2.apply(this, arguments);
    }
    function l() {
      return _l8.apply(this, arguments);
    }
    function _l8() {
      _l8 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee5() {
        var _ref13, c, h, d;
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1)
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                if (!n) {
                  _context6.next = 7;
                  break;
                }
                _context6.next = 4;
                return i.next();
              case 4:
                _context6.t0 = _context6.sent;
                _context6.next = 8;
                break;
              case 7:
                _context6.t0 = i.next();
              case 8:
                _ref13 = _context6.t0;
                c = _ref13.value;
                h = _ref13.done;
                if (!h) {
                  _context6.next = 15;
                  break;
                }
                o.push(null);
                _context6.next = 28;
                break;
              case 15:
                if (!(c && typeof c.then == "function")) {
                  _context6.next = 21;
                  break;
                }
                _context6.next = 18;
                return c;
              case 18:
                _context6.t1 = _context6.sent;
                _context6.next = 22;
                break;
              case 21:
                _context6.t1 = c;
              case 22:
                d = _context6.t1;
                if (!(d === null)) {
                  _context6.next = 25;
                  break;
                }
                throw s = false, new Ww();
              case 25:
                if (!o.push(d)) {
                  _context6.next = 27;
                  break;
                }
                return _context6.abrupt("continue", 34);
              case 27:
                s = false;
              case 28:
                _context6.next = 33;
                break;
              case 30:
                _context6.prev = 30;
                _context6.t2 = _context6["catch"](0);
                o.destroy(_context6.t2);
              case 33:
                return _context6.abrupt("break", 36);
              case 34:
                _context6.next = 0;
                break;
              case 36:
              case "end":
                return _context6.stop();
            }
        }, _callee5, null, [[0, 30]]);
      }));
      return _l8.apply(this, arguments);
    }
    return o;
  }
  jc.exports = $w;
});
var gi = M(function(eR, Zc) {
  _();
  v();
  m();
  var He = Nt(), _ce9 = ce(), Hw = _ce9.ArrayPrototypeIndexOf, Vw = _ce9.NumberIsInteger, zw = _ce9.NumberIsNaN, Kw = _ce9.NumberParseInt, $c = _ce9.ObjectDefineProperties, Gw = _ce9.ObjectKeys, Hc = _ce9.ObjectSetPrototypeOf, Qw = _ce9.Promise, Yw = _ce9.SafeSet, Jw = _ce9.SymbolAsyncIterator, Xw = _ce9.Symbol;
  Zc.exports = F;
  F.ReadableState = so;
  var _ref14 = (sr(), X(nr)), Zw = _ref14.EventEmitter, _nn = nn(), Dt = _nn.Stream, e_ = _nn.prependListener, _ref15 = (be(), X(me)), eo = _ref15.Buffer, _di = di(), t_ = _di.addAbortSignal, r_ = vt(), H = Je().debuglog("stream", function(t) {
    H = t;
  }), i_ = dc(), Fr = ir(), _an = an(), n_ = _an.getHighWaterMark, s_ = _an.getDefaultHighWaterMark, _Ae5 = Ae(), Fc = _Ae5.aggregateTwoErrors, _Ae5$codes = _Ae5.codes, o_ = _Ae5$codes.ERR_INVALID_ARG_TYPE, a_ = _Ae5$codes.ERR_METHOD_NOT_IMPLEMENTED, l_ = _Ae5$codes.ERR_OUT_OF_RANGE, u_ = _Ae5$codes.ERR_STREAM_PUSH_AFTER_EOF, f_ = _Ae5$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, _hi2 = hi(), c_ = _hi2.validateObject, fr = Xw("kPaused"), _ref16 = (Uc(), X(Lc)), Vc = _ref16.StringDecoder, h_ = Zs();
  Hc(F.prototype, Dt.prototype);
  Hc(F, Dt);
  var to = function to2() {
  }, jr = Fr.errorOrDestroy;
  function so(t, e, r) {
    typeof r != "boolean" && (r = e instanceof nt()), this.objectMode = !!(t && t.objectMode), r && (this.objectMode = this.objectMode || !!(t && t.readableObjectMode)), this.highWaterMark = t ? n_(this, t, "readableHighWaterMark", r) : s_(false), this.buffer = new i_(), this.length = 0, this.pipes = [], this.flowing = null, this.ended = false, this.endEmitted = false, this.reading = false, this.constructed = true, this.sync = true, this.needReadable = false, this.emittedReadable = false, this.readableListening = false, this.resumeScheduled = false, this[fr] = null, this.errorEmitted = false, this.emitClose = !t || t.emitClose !== false, this.autoDestroy = !t || t.autoDestroy !== false, this.destroyed = false, this.errored = null, this.closed = false, this.closeEmitted = false, this.defaultEncoding = t && t.defaultEncoding || "utf8", this.awaitDrainWriters = null, this.multiAwaitDrain = false, this.readingMore = false, this.dataEmitted = false, this.decoder = null, this.encoding = null, t && t.encoding && (this.decoder = new Vc(t.encoding), this.encoding = t.encoding);
  }
  function F(t) {
    var _this4 = this;
    if (!(this instanceof F))
      return new F(t);
    var e = this instanceof nt();
    this._readableState = new so(t, this, e), t && (typeof t.read == "function" && (this._read = t.read), typeof t.destroy == "function" && (this._destroy = t.destroy), typeof t.construct == "function" && (this._construct = t.construct), t.signal && !e && t_(t.signal, this)), Dt.call(this, t), Fr.construct(this, function() {
      _this4._readableState.needReadable && hn(_this4, _this4._readableState);
    });
  }
  F.prototype.destroy = Fr.destroy;
  F.prototype._undestroy = Fr.undestroy;
  F.prototype._destroy = function(t, e) {
    e(t);
  };
  F.prototype[Zw.captureRejectionSymbol] = function(t) {
    this.destroy(t);
  };
  F.prototype.push = function(t, e) {
    return zc(this, t, e, false);
  };
  F.prototype.unshift = function(t, e) {
    return zc(this, t, e, true);
  };
  function zc(t, e, r, i) {
    H("readableAddChunk", e);
    var n = t._readableState, o;
    if (n.objectMode || (typeof e == "string" ? (r = r || n.defaultEncoding, n.encoding !== r && (i && n.encoding ? e = eo.from(e, r).toString(n.encoding) : (e = eo.from(e, r), r = ""))) : e instanceof eo ? r = "" : Dt._isUint8Array(e) ? (e = Dt._uint8ArrayToBuffer(e), r = "") : e != null && (o = new o_("chunk", ["string", "Buffer", "Uint8Array"], e))), o)
      jr(t, o);
    else if (e === null)
      n.reading = false, g_(t, n);
    else if (n.objectMode || e && e.length > 0) {
      if (i) {
        if (n.endEmitted)
          jr(t, new f_());
        else {
          if (n.destroyed || n.errored)
            return false;
          ro(t, n, e, true);
        }
      } else if (n.ended)
        jr(t, new u_());
      else {
        if (n.destroyed || n.errored)
          return false;
        n.reading = false, n.decoder && !r ? (e = n.decoder.write(e), n.objectMode || e.length !== 0 ? ro(t, n, e, false) : hn(t, n)) : ro(t, n, e, false);
      }
    } else
      i || (n.reading = false, hn(t, n));
    return !n.ended && (n.length < n.highWaterMark || n.length === 0);
  }
  function ro(t, e, r, i) {
    e.flowing && e.length === 0 && !e.sync && t.listenerCount("data") > 0 ? (e.multiAwaitDrain ? e.awaitDrainWriters.clear() : e.awaitDrainWriters = null, e.dataEmitted = true, t.emit("data", r)) : (e.length += e.objectMode ? 1 : r.length, i ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && dn(t)), hn(t, e);
  }
  F.prototype.isPaused = function() {
    var t = this._readableState;
    return t[fr] === true || t.flowing === false;
  };
  F.prototype.setEncoding = function(t) {
    var e = new Vc(t);
    this._readableState.decoder = e, this._readableState.encoding = this._readableState.decoder.encoding;
    var r = this._readableState.buffer, i = "";
    var _iterator15 = _createForOfIteratorHelper(r), _step15;
    try {
      for (_iterator15.s(); !(_step15 = _iterator15.n()).done; ) {
        var n = _step15.value;
        i += e.write(n);
      }
    } catch (err) {
      _iterator15.e(err);
    } finally {
      _iterator15.f();
    }
    return r.clear(), i !== "" && r.push(i), this._readableState.length = i.length, this;
  };
  var d_ = 1073741824;
  function p_(t) {
    if (t > d_)
      throw new l_("size", "<= 1GiB", t);
    return t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++, t;
  }
  function Wc(t, e) {
    return t <= 0 || e.length === 0 && e.ended ? 0 : e.objectMode ? 1 : zw(t) ? e.flowing && e.length ? e.buffer.first().length : e.length : t <= e.length ? t : e.ended ? e.length : 0;
  }
  F.prototype.read = function(t) {
    H("read", t), t === void 0 ? t = NaN : Vw(t) || (t = Kw(t, 10));
    var e = this._readableState, r = t;
    if (t > e.highWaterMark && (e.highWaterMark = p_(t)), t !== 0 && (e.emittedReadable = false), t === 0 && e.needReadable && ((e.highWaterMark !== 0 ? e.length >= e.highWaterMark : e.length > 0) || e.ended))
      return H("read: emitReadable", e.length, e.ended), e.length === 0 && e.ended ? io(this) : dn(this), null;
    if (t = Wc(t, e), t === 0 && e.ended)
      return e.length === 0 && io(this), null;
    var i = e.needReadable;
    if (H("need readable", i), (e.length === 0 || e.length - t < e.highWaterMark) && (i = true, H("length less than watermark", i)), e.ended || e.reading || e.destroyed || e.errored || !e.constructed)
      i = false, H("reading, ended or constructing", i);
    else if (i) {
      H("do read"), e.reading = true, e.sync = true, e.length === 0 && (e.needReadable = true);
      try {
        this._read(e.highWaterMark);
      } catch (o) {
        jr(this, o);
      }
      e.sync = false, e.reading || (t = Wc(r, e));
    }
    var n;
    return t > 0 ? n = Jc(t, e) : n = null, n === null ? (e.needReadable = e.length <= e.highWaterMark, t = 0) : (e.length -= t, e.multiAwaitDrain ? e.awaitDrainWriters.clear() : e.awaitDrainWriters = null), e.length === 0 && (e.ended || (e.needReadable = true), r !== t && e.ended && io(this)), n !== null && !e.errorEmitted && !e.closeEmitted && (e.dataEmitted = true, this.emit("data", n)), n;
  };
  function g_(t, e) {
    if (H("onEofChunk"), !e.ended) {
      if (e.decoder) {
        var r = e.decoder.end();
        r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
      }
      e.ended = true, e.sync ? dn(t) : (e.needReadable = false, e.emittedReadable = true, Kc(t));
    }
  }
  function dn(t) {
    var e = t._readableState;
    H("emitReadable", e.needReadable, e.emittedReadable), e.needReadable = false, e.emittedReadable || (H("emitReadable", e.flowing), e.emittedReadable = true, He.nextTick(Kc, t));
  }
  function Kc(t) {
    var e = t._readableState;
    H("emitReadable_", e.destroyed, e.length, e.ended), !e.destroyed && !e.errored && (e.length || e.ended) && (t.emit("readable"), e.emittedReadable = false), e.needReadable = !e.flowing && !e.ended && e.length <= e.highWaterMark, Qc(t);
  }
  function hn(t, e) {
    !e.readingMore && e.constructed && (e.readingMore = true, He.nextTick(y_, t, e));
  }
  function y_(t, e) {
    for (; !e.reading && !e.ended && (e.length < e.highWaterMark || e.flowing && e.length === 0); ) {
      var r = e.length;
      if (H("maybeReadMore read 0"), t.read(0), r === e.length)
        break;
    }
    e.readingMore = false;
  }
  F.prototype._read = function(t) {
    throw new a_("_read()");
  };
  F.prototype.pipe = function(t, e) {
    var r = this, i = this._readableState;
    i.pipes.length === 1 && (i.multiAwaitDrain || (i.multiAwaitDrain = true, i.awaitDrainWriters = new Yw(i.awaitDrainWriters ? [i.awaitDrainWriters] : []))), i.pipes.push(t), H("pipe count=%d opts=%j", i.pipes.length, e);
    var o = (!e || e.end !== false) && t !== He.stdout && t !== He.stderr ? a : E;
    i.endEmitted ? He.nextTick(o) : r.once("end", o), t.on("unpipe", s);
    function s(I, C) {
      H("onunpipe"), I === r && C && C.hasUnpiped === false && (C.hasUnpiped = true, h());
    }
    function a() {
      H("onend"), t.end();
    }
    var l, c = false;
    function h() {
      H("cleanup"), t.removeListener("close", w), t.removeListener("finish", S), l && t.removeListener("drain", l), t.removeListener("error", y), t.removeListener("unpipe", s), r.removeListener("end", a), r.removeListener("end", E), r.removeListener("data", g), c = true, l && i.awaitDrainWriters && (!t._writableState || t._writableState.needDrain) && l();
    }
    function d() {
      c || (i.pipes.length === 1 && i.pipes[0] === t ? (H("false write response, pause", 0), i.awaitDrainWriters = t, i.multiAwaitDrain = false) : i.pipes.length > 1 && i.pipes.includes(t) && (H("false write response, pause", i.awaitDrainWriters.size), i.awaitDrainWriters.add(t)), r.pause()), l || (l = b_(r, t), t.on("drain", l));
    }
    r.on("data", g);
    function g(I) {
      H("ondata");
      var C = t.write(I);
      H("dest.write", C), C === false && d();
    }
    function y(I) {
      if (H("onerror", I), E(), t.removeListener("error", y), t.listenerCount("error") === 0) {
        var C = t._writableState || t._readableState;
        C && !C.errorEmitted ? jr(t, I) : t.emit("error", I);
      }
    }
    e_(t, "error", y);
    function w() {
      t.removeListener("finish", S), E();
    }
    t.once("close", w);
    function S() {
      H("onfinish"), t.removeListener("close", w), E();
    }
    t.once("finish", S);
    function E() {
      H("unpipe"), r.unpipe(t);
    }
    return t.emit("pipe", r), t.writableNeedDrain === true ? i.flowing && d() : i.flowing || (H("pipe resume"), r.resume()), t;
  };
  function b_(t, e) {
    return function() {
      var i = t._readableState;
      i.awaitDrainWriters === e ? (H("pipeOnDrain", 1), i.awaitDrainWriters = null) : i.multiAwaitDrain && (H("pipeOnDrain", i.awaitDrainWriters.size), i.awaitDrainWriters.delete(e)), (!i.awaitDrainWriters || i.awaitDrainWriters.size === 0) && t.listenerCount("data") && t.resume();
    };
  }
  F.prototype.unpipe = function(t) {
    var e = this._readableState, r = { hasUnpiped: false };
    if (e.pipes.length === 0)
      return this;
    if (!t) {
      var n = e.pipes;
      e.pipes = [], this.pause();
      for (var o = 0; o < n.length; o++)
        n[o].emit("unpipe", this, { hasUnpiped: false });
      return this;
    }
    var i = Hw(e.pipes, t);
    return i === -1 ? this : (e.pipes.splice(i, 1), e.pipes.length === 0 && this.pause(), t.emit("unpipe", this, r), this);
  };
  F.prototype.on = function(t, e) {
    var r = Dt.prototype.on.call(this, t, e), i = this._readableState;
    return t === "data" ? (i.readableListening = this.listenerCount("readable") > 0, i.flowing !== false && this.resume()) : t === "readable" && !i.endEmitted && !i.readableListening && (i.readableListening = i.needReadable = true, i.flowing = false, i.emittedReadable = false, H("on readable", i.length, i.reading), i.length ? dn(this) : i.reading || He.nextTick(w_, this)), r;
  };
  F.prototype.addListener = F.prototype.on;
  F.prototype.removeListener = function(t, e) {
    var r = Dt.prototype.removeListener.call(this, t, e);
    return t === "readable" && He.nextTick(Gc, this), r;
  };
  F.prototype.off = F.prototype.removeListener;
  F.prototype.removeAllListeners = function(t) {
    var e = Dt.prototype.removeAllListeners.apply(this, arguments);
    return (t === "readable" || t === void 0) && He.nextTick(Gc, this), e;
  };
  function Gc(t) {
    var e = t._readableState;
    e.readableListening = t.listenerCount("readable") > 0, e.resumeScheduled && e[fr] === false ? e.flowing = true : t.listenerCount("data") > 0 ? t.resume() : e.readableListening || (e.flowing = null);
  }
  function w_(t) {
    H("readable nexttick read 0"), t.read(0);
  }
  F.prototype.resume = function() {
    var t = this._readableState;
    return t.flowing || (H("resume"), t.flowing = !t.readableListening, __(this, t)), t[fr] = false, this;
  };
  function __(t, e) {
    e.resumeScheduled || (e.resumeScheduled = true, He.nextTick(m_, t, e));
  }
  function m_(t, e) {
    H("resume", e.reading), e.reading || t.read(0), e.resumeScheduled = false, t.emit("resume"), Qc(t), e.flowing && !e.reading && t.read(0);
  }
  F.prototype.pause = function() {
    return H("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== false && (H("pause"), this._readableState.flowing = false, this.emit("pause")), this._readableState[fr] = true, this;
  };
  function Qc(t) {
    var e = t._readableState;
    for (H("flow", e.flowing); e.flowing && t.read() !== null; )
      ;
  }
  F.prototype.wrap = function(t) {
    var _this5 = this;
    var e = false;
    t.on("data", function(i) {
      !_this5.push(i) && t.pause && (e = true, t.pause());
    }), t.on("end", function() {
      _this5.push(null);
    }), t.on("error", function(i) {
      jr(_this5, i);
    }), t.on("close", function() {
      _this5.destroy();
    }), t.on("destroy", function() {
      _this5.destroy();
    }), this._read = function() {
      e && t.resume && (e = false, t.resume());
    };
    var r = Gw(t);
    for (var _i8 = 1; _i8 < r.length; _i8++) {
      var n = r[_i8];
      this[n] === void 0 && typeof t[n] == "function" && (this[n] = t[n].bind(t));
    }
    return this;
  };
  F.prototype[Jw] = function() {
    return Yc(this);
  };
  F.prototype.iterator = function(t) {
    return t !== void 0 && c_(t, "options"), Yc(this, t);
  };
  function Yc(t, e) {
    typeof t.read != "function" && (t = F.wrap(t, { objectMode: true }));
    var r = v_(t, e);
    return r.stream = t, r;
  }
  function v_(_x, _x2) {
    return _v_.apply(this, arguments);
  }
  function _v_() {
    _v_ = _wrapAsyncGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee6(t, e) {
      var r, i, n, o, s;
      return _regeneratorRuntime().wrap(function _callee6$(_context7) {
        while (1)
          switch (_context7.prev = _context7.next) {
            case 0:
              i = function _i9(s2) {
                this === t ? (r(), r = to) : r = s2;
              };
              r = to;
              t.on("readable", i);
              o = r_(t, { writable: false }, function(s2) {
                n = s2 ? Fc(n, s2) : null, r(), r = to;
              });
              _context7.prev = 4;
            case 5:
              s = t.destroyed ? null : t.read();
              if (!(s !== null)) {
                _context7.next = 11;
                break;
              }
              _context7.next = 9;
              return s;
            case 9:
              _context7.next = 17;
              break;
            case 11:
              if (!n) {
                _context7.next = 13;
                break;
              }
              throw n;
            case 13:
              if (!(n === null)) {
                _context7.next = 15;
                break;
              }
              return _context7.abrupt("return");
            case 15:
              _context7.next = 17;
              return _awaitAsyncGenerator(new Qw(i));
            case 17:
              _context7.next = 5;
              break;
            case 19:
              _context7.next = 24;
              break;
            case 21:
              _context7.prev = 21;
              _context7.t0 = _context7["catch"](4);
              throw n = Fc(n, _context7.t0), n;
            case 24:
              _context7.prev = 24;
              (n || (e === null || e === void 0 ? void 0 : e.destroyOnReturn) !== false) && (n === void 0 || t._readableState.autoDestroy) ? Fr.destroyer(t, null) : (t.off("readable", i), o());
              return _context7.finish(24);
            case 27:
            case "end":
              return _context7.stop();
          }
      }, _callee6, null, [[4, 21, 24, 27]]);
    }));
    return _v_.apply(this, arguments);
  }
  $c(F.prototype, { readable: { __proto__: null, get: function get2() {
    var t = this._readableState;
    return !!t && t.readable !== false && !t.destroyed && !t.errorEmitted && !t.endEmitted;
  }, set: function set(t) {
    this._readableState && (this._readableState.readable = !!t);
  } }, readableDidRead: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState.dataEmitted;
  } }, readableAborted: { __proto__: null, enumerable: false, get: function get2() {
    return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
  } }, readableHighWaterMark: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState.highWaterMark;
  } }, readableBuffer: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState && this._readableState.buffer;
  } }, readableFlowing: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState.flowing;
  }, set: function set(t) {
    this._readableState && (this._readableState.flowing = t);
  } }, readableLength: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState.length;
  } }, readableObjectMode: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState ? this._readableState.objectMode : false;
  } }, readableEncoding: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState ? this._readableState.encoding : null;
  } }, errored: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState ? this._readableState.errored : null;
  } }, closed: { __proto__: null, get: function get2() {
    return this._readableState ? this._readableState.closed : false;
  } }, destroyed: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState ? this._readableState.destroyed : false;
  }, set: function set(t) {
    this._readableState && (this._readableState.destroyed = t);
  } }, readableEnded: { __proto__: null, enumerable: false, get: function get2() {
    return this._readableState ? this._readableState.endEmitted : false;
  } } });
  $c(so.prototype, { pipesCount: { __proto__: null, get: function get2() {
    return this.pipes.length;
  } }, paused: { __proto__: null, get: function get2() {
    return this[fr] !== false;
  }, set: function set(t) {
    this[fr] = !!t;
  } } });
  F._fromList = Jc;
  function Jc(t, e) {
    if (e.length === 0)
      return null;
    var r;
    return e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (e.decoder ? r = e.buffer.join("") : e.buffer.length === 1 ? r = e.buffer.first() : r = e.buffer.concat(e.length), e.buffer.clear()) : r = e.buffer.consume(t, e.decoder), r;
  }
  function io(t) {
    var e = t._readableState;
    H("endReadable", e.endEmitted), e.endEmitted || (e.ended = true, He.nextTick(E_, e, t));
  }
  function E_(t, e) {
    if (H("endReadableNT", t.endEmitted, t.length), !t.errored && !t.closeEmitted && !t.endEmitted && t.length === 0) {
      if (t.endEmitted = true, e.emit("end"), e.writable && e.allowHalfOpen === false)
        He.nextTick(S_, e);
      else if (t.autoDestroy) {
        var _r3 = e._writableState;
        (!_r3 || _r3.autoDestroy && (_r3.finished || _r3.writable === false)) && e.destroy();
      }
    }
  }
  function S_(t) {
    t.writable && !t.writableEnded && !t.destroyed && t.end();
  }
  F.from = function(t, e) {
    return h_(F, t, e);
  };
  var no;
  function Xc() {
    return no === void 0 && (no = {}), no;
  }
  F.fromWeb = function(t, e) {
    return Xc().newStreamReadableFromReadableStream(t, e);
  };
  F.toWeb = function(t, e) {
    return Xc().newReadableStreamFromStreamReadable(t, e);
  };
  F.wrap = function(t, e) {
    var r, i;
    return new F(_objectSpread(_objectSpread({ objectMode: (r = (i = t.readableObjectMode) !== null && i !== void 0 ? i : t.objectMode) !== null && r !== void 0 ? r : true }, e), {}, { destroy: function destroy(n, o) {
      Fr.destroyer(t, n), o(n);
    } })).wrap(t);
  };
});
var ho = M(function(fR, ch) {
  _();
  v();
  m();
  var cr = Nt(), _ce10 = ce(), rh = _ce10.ArrayPrototypeSlice, A_ = _ce10.Error, ih = _ce10.FunctionPrototypeSymbolHasInstance, nh = _ce10.ObjectDefineProperty, I_ = _ce10.ObjectDefineProperties, sh = _ce10.ObjectSetPrototypeOf, T_ = _ce10.StringPrototypeToLowerCase, R_ = _ce10.Symbol, C_ = _ce10.SymbolHasInstance;
  ch.exports = ie;
  ie.WritableState = wi;
  var _ref17 = (sr(), X(nr)), B_ = _ref17.EventEmitter, yi = nn().Stream, _ref18 = (be(), X(me)), pn = _ref18.Buffer, bn = ir(), _di2 = di(), P_ = _di2.addAbortSignal, _an2 = an(), k_ = _an2.getHighWaterMark, O_ = _an2.getDefaultHighWaterMark, _Ae$codes3 = Ae().codes, x_ = _Ae$codes3.ERR_INVALID_ARG_TYPE, M_ = _Ae$codes3.ERR_METHOD_NOT_IMPLEMENTED, oh = _Ae$codes3.ERR_MULTIPLE_CALLBACK, L_ = _Ae$codes3.ERR_STREAM_CANNOT_PIPE, bi = _Ae$codes3.ERR_STREAM_DESTROYED, U_ = _Ae$codes3.ERR_STREAM_ALREADY_FINISHED, N_ = _Ae$codes3.ERR_STREAM_NULL_VALUES, q_ = _Ae$codes3.ERR_STREAM_WRITE_AFTER_END, ah = _Ae$codes3.ERR_UNKNOWN_ENCODING, Wr = bn.errorOrDestroy;
  sh(ie.prototype, yi.prototype);
  sh(ie, yi);
  function lo() {
  }
  var $r = R_("kOnFinished");
  function wi(t, e, r) {
    typeof r != "boolean" && (r = e instanceof nt()), this.objectMode = !!(t && t.objectMode), r && (this.objectMode = this.objectMode || !!(t && t.writableObjectMode)), this.highWaterMark = t ? k_(this, t, "writableHighWaterMark", r) : O_(false), this.finalCalled = false, this.needDrain = false, this.ending = false, this.ended = false, this.finished = false, this.destroyed = false;
    var i = !!(t && t.decodeStrings === false);
    this.decodeStrings = !i, this.defaultEncoding = t && t.defaultEncoding || "utf8", this.length = 0, this.writing = false, this.corked = 0, this.sync = true, this.bufferProcessing = false, this.onwrite = j_.bind(void 0, e), this.writecb = null, this.writelen = 0, this.afterWriteTickInfo = null, yn(this), this.pendingcb = 0, this.constructed = true, this.prefinished = false, this.errorEmitted = false, this.emitClose = !t || t.emitClose !== false, this.autoDestroy = !t || t.autoDestroy !== false, this.errored = null, this.closed = false, this.closeEmitted = false, this[$r] = [];
  }
  function yn(t) {
    t.buffered = [], t.bufferedIndex = 0, t.allBuffers = true, t.allNoop = true;
  }
  wi.prototype.getBuffer = function() {
    return rh(this.buffered, this.bufferedIndex);
  };
  nh(wi.prototype, "bufferedRequestCount", { __proto__: null, get: function get2() {
    return this.buffered.length - this.bufferedIndex;
  } });
  function ie(t) {
    var _this6 = this;
    var e = this instanceof nt();
    if (!e && !ih(ie, this))
      return new ie(t);
    this._writableState = new wi(t, this, e), t && (typeof t.write == "function" && (this._write = t.write), typeof t.writev == "function" && (this._writev = t.writev), typeof t.destroy == "function" && (this._destroy = t.destroy), typeof t.final == "function" && (this._final = t.final), typeof t.construct == "function" && (this._construct = t.construct), t.signal && P_(t.signal, this)), yi.call(this, t), bn.construct(this, function() {
      var r = _this6._writableState;
      r.writing || fo(_this6, r), co(_this6, r);
    });
  }
  nh(ie, C_, { __proto__: null, value: function value(t) {
    return ih(this, t) ? true : this !== ie ? false : t && t._writableState instanceof wi;
  } });
  ie.prototype.pipe = function() {
    Wr(this, new L_());
  };
  function lh(t, e, r, i) {
    var n = t._writableState;
    if (typeof r == "function")
      i = r, r = n.defaultEncoding;
    else {
      if (!r)
        r = n.defaultEncoding;
      else if (r !== "buffer" && !pn.isEncoding(r))
        throw new ah(r);
      typeof i != "function" && (i = lo);
    }
    if (e === null)
      throw new N_();
    if (!n.objectMode)
      if (typeof e == "string")
        n.decodeStrings !== false && (e = pn.from(e, r), r = "buffer");
      else if (e instanceof pn)
        r = "buffer";
      else if (yi._isUint8Array(e))
        e = yi._uint8ArrayToBuffer(e), r = "buffer";
      else
        throw new x_("chunk", ["string", "Buffer", "Uint8Array"], e);
    var o;
    return n.ending ? o = new q_() : n.destroyed && (o = new bi("write")), o ? (cr.nextTick(i, o), Wr(t, o, true), o) : (n.pendingcb++, D_(t, n, e, r, i));
  }
  ie.prototype.write = function(t, e, r) {
    return lh(this, t, e, r) === true;
  };
  ie.prototype.cork = function() {
    this._writableState.corked++;
  };
  ie.prototype.uncork = function() {
    var t = this._writableState;
    t.corked && (t.corked--, t.writing || fo(this, t));
  };
  ie.prototype.setDefaultEncoding = function(e) {
    if (typeof e == "string" && (e = T_(e)), !pn.isEncoding(e))
      throw new ah(e);
    return this._writableState.defaultEncoding = e, this;
  };
  function D_(t, e, r, i, n) {
    var o = e.objectMode ? 1 : r.length;
    e.length += o;
    var s = e.length < e.highWaterMark;
    return s || (e.needDrain = true), e.writing || e.corked || e.errored || !e.constructed ? (e.buffered.push({ chunk: r, encoding: i, callback: n }), e.allBuffers && i !== "buffer" && (e.allBuffers = false), e.allNoop && n !== lo && (e.allNoop = false)) : (e.writelen = o, e.writecb = n, e.writing = true, e.sync = true, t._write(r, i, e.onwrite), e.sync = false), s && !e.errored && !e.destroyed;
  }
  function eh(t, e, r, i, n, o, s) {
    e.writelen = i, e.writecb = s, e.writing = true, e.sync = true, e.destroyed ? e.onwrite(new bi("write")) : r ? t._writev(n, e.onwrite) : t._write(n, o, e.onwrite), e.sync = false;
  }
  function th(t, e, r, i) {
    --e.pendingcb, i(r), uo(e), Wr(t, r);
  }
  function j_(t, e) {
    var r = t._writableState, i = r.sync, n = r.writecb;
    if (typeof n != "function") {
      Wr(t, new oh());
      return;
    }
    r.writing = false, r.writecb = null, r.length -= r.writelen, r.writelen = 0, e ? (e.stack, r.errored || (r.errored = e), t._readableState && !t._readableState.errored && (t._readableState.errored = e), i ? cr.nextTick(th, t, r, e, n) : th(t, r, e, n)) : (r.buffered.length > r.bufferedIndex && fo(t, r), i ? r.afterWriteTickInfo !== null && r.afterWriteTickInfo.cb === n ? r.afterWriteTickInfo.count++ : (r.afterWriteTickInfo = { count: 1, cb: n, stream: t, state: r }, cr.nextTick(F_, r.afterWriteTickInfo)) : uh(t, r, 1, n));
  }
  function F_(_ref19) {
    var t = _ref19.stream, e = _ref19.state, r = _ref19.count, i = _ref19.cb;
    return e.afterWriteTickInfo = null, uh(t, e, r, i);
  }
  function uh(t, e, r, i) {
    for (!e.ending && !t.destroyed && e.length === 0 && e.needDrain && (e.needDrain = false, t.emit("drain")); r-- > 0; )
      e.pendingcb--, i();
    e.destroyed && uo(e), co(t, e);
  }
  function uo(t) {
    if (t.writing)
      return;
    for (var n = t.bufferedIndex; n < t.buffered.length; ++n) {
      var e;
      var _t$buffered$n = t.buffered[n], o = _t$buffered$n.chunk, s = _t$buffered$n.callback, a = t.objectMode ? 1 : o.length;
      t.length -= a, s((e = t.errored) !== null && e !== void 0 ? e : new bi("write"));
    }
    var r = t[$r].splice(0);
    for (var _n2 = 0; _n2 < r.length; _n2++) {
      var i;
      r[_n2]((i = t.errored) !== null && i !== void 0 ? i : new bi("end"));
    }
    yn(t);
  }
  function fo(t, e) {
    if (e.corked || e.bufferProcessing || e.destroyed || !e.constructed)
      return;
    var r = e.buffered, i = e.bufferedIndex, n = e.objectMode, o = r.length - i;
    if (!o)
      return;
    var s = i;
    if (e.bufferProcessing = true, o > 1 && t._writev) {
      e.pendingcb -= o - 1;
      var a = e.allNoop ? lo : function(c2) {
        for (var h2 = s; h2 < r.length; ++h2)
          r[h2].callback(c2);
      }, l = e.allNoop && s === 0 ? r : rh(r, s);
      l.allBuffers = e.allBuffers, eh(t, e, true, e.length, l, "", a), yn(e);
    } else {
      do {
        var _r$s = r[s], _a3 = _r$s.chunk, _l9 = _r$s.encoding, c = _r$s.callback;
        r[s++] = null;
        var h = n ? 1 : _a3.length;
        eh(t, e, false, h, _a3, _l9, c);
      } while (s < r.length && !e.writing);
      s === r.length ? yn(e) : s > 256 ? (r.splice(0, s), e.bufferedIndex = 0) : e.bufferedIndex = s;
    }
    e.bufferProcessing = false;
  }
  ie.prototype._write = function(t, e, r) {
    if (this._writev)
      this._writev([{ chunk: t, encoding: e }], r);
    else
      throw new M_("_write()");
  };
  ie.prototype._writev = null;
  ie.prototype.end = function(t, e, r) {
    var i = this._writableState;
    typeof t == "function" ? (r = t, t = null, e = null) : typeof e == "function" && (r = e, e = null);
    var n;
    if (t != null) {
      var o = lh(this, t, e);
      o instanceof A_ && (n = o);
    }
    return i.corked && (i.corked = 1, this.uncork()), n || (!i.errored && !i.ending ? (i.ending = true, co(this, i, true), i.ended = true) : i.finished ? n = new U_("end") : i.destroyed && (n = new bi("end"))), typeof r == "function" && (n || i.finished ? cr.nextTick(r, n) : i[$r].push(r)), this;
  };
  function gn(t) {
    return t.ending && !t.destroyed && t.constructed && t.length === 0 && !t.errored && t.buffered.length === 0 && !t.finished && !t.writing && !t.errorEmitted && !t.closeEmitted;
  }
  function W_(t, e) {
    var r = false;
    function i(n) {
      if (r) {
        Wr(t, n !== null && n !== void 0 ? n : oh());
        return;
      }
      if (r = true, e.pendingcb--, n) {
        var o = e[$r].splice(0);
        for (var s = 0; s < o.length; s++)
          o[s](n);
        Wr(t, n, e.sync);
      } else
        gn(e) && (e.prefinished = true, t.emit("prefinish"), e.pendingcb++, cr.nextTick(ao, t, e));
    }
    e.sync = true, e.pendingcb++;
    try {
      t._final(i);
    } catch (n) {
      i(n);
    }
    e.sync = false;
  }
  function $_(t, e) {
    !e.prefinished && !e.finalCalled && (typeof t._final == "function" && !e.destroyed ? (e.finalCalled = true, W_(t, e)) : (e.prefinished = true, t.emit("prefinish")));
  }
  function co(t, e, r) {
    gn(e) && ($_(t, e), e.pendingcb === 0 && (r ? (e.pendingcb++, cr.nextTick(function(i, n) {
      gn(n) ? ao(i, n) : n.pendingcb--;
    }, t, e)) : gn(e) && (e.pendingcb++, ao(t, e))));
  }
  function ao(t, e) {
    e.pendingcb--, e.finished = true;
    var r = e[$r].splice(0);
    for (var i = 0; i < r.length; i++)
      r[i]();
    if (t.emit("finish"), e.autoDestroy) {
      var _i10 = t._readableState;
      (!_i10 || _i10.autoDestroy && (_i10.endEmitted || _i10.readable === false)) && t.destroy();
    }
  }
  I_(ie.prototype, { closed: { __proto__: null, get: function get2() {
    return this._writableState ? this._writableState.closed : false;
  } }, destroyed: { __proto__: null, get: function get2() {
    return this._writableState ? this._writableState.destroyed : false;
  }, set: function set(t) {
    this._writableState && (this._writableState.destroyed = t);
  } }, writable: { __proto__: null, get: function get2() {
    var t = this._writableState;
    return !!t && t.writable !== false && !t.destroyed && !t.errored && !t.ending && !t.ended;
  }, set: function set(t) {
    this._writableState && (this._writableState.writable = !!t);
  } }, writableFinished: { __proto__: null, get: function get2() {
    return this._writableState ? this._writableState.finished : false;
  } }, writableObjectMode: { __proto__: null, get: function get2() {
    return this._writableState ? this._writableState.objectMode : false;
  } }, writableBuffer: { __proto__: null, get: function get2() {
    return this._writableState && this._writableState.getBuffer();
  } }, writableEnded: { __proto__: null, get: function get2() {
    return this._writableState ? this._writableState.ending : false;
  } }, writableNeedDrain: { __proto__: null, get: function get2() {
    var t = this._writableState;
    return t ? !t.destroyed && !t.ending && t.needDrain : false;
  } }, writableHighWaterMark: { __proto__: null, get: function get2() {
    return this._writableState && this._writableState.highWaterMark;
  } }, writableCorked: { __proto__: null, get: function get2() {
    return this._writableState ? this._writableState.corked : 0;
  } }, writableLength: { __proto__: null, get: function get2() {
    return this._writableState && this._writableState.length;
  } }, errored: { __proto__: null, enumerable: false, get: function get2() {
    return this._writableState ? this._writableState.errored : null;
  } }, writableAborted: { __proto__: null, enumerable: false, get: function get2() {
    return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
  } } });
  var H_ = bn.destroy;
  ie.prototype.destroy = function(t, e) {
    var r = this._writableState;
    return !r.destroyed && (r.bufferedIndex < r.buffered.length || r[$r].length) && cr.nextTick(uo, r), H_.call(this, t, e), this;
  };
  ie.prototype._undestroy = bn.undestroy;
  ie.prototype._destroy = function(t, e) {
    e(t);
  };
  ie.prototype[B_.captureRejectionSymbol] = function(t) {
    this.destroy(t);
  };
  var oo;
  function fh() {
    return oo === void 0 && (oo = {}), oo;
  }
  ie.fromWeb = function(t, e) {
    return fh().newStreamWritableFromWritableStream(t, e);
  };
  ie.toWeb = function(t) {
    return fh().newWritableStreamFromStreamWritable(t);
  };
});
var Sh = M(function(mR, Eh) {
  _();
  v();
  m();
  var po = Nt(), V_ = (be(), X(me)), _tt4 = tt(), z_ = _tt4.isReadable, K_ = _tt4.isWritable, hh = _tt4.isIterable, G_ = _tt4.isNodeStream, dh = _tt4.isReadableNodeStream, ph = _tt4.isWritableNodeStream, Q_ = _tt4.isDuplexNodeStream, gh = vt(), _Ae6 = Ae(), vh = _Ae6.AbortError, _Ae6$codes = _Ae6.codes, Y_ = _Ae6$codes.ERR_INVALID_ARG_TYPE, yh = _Ae6$codes.ERR_INVALID_RETURN_VALUE, _ir = ir(), Hr = _ir.destroyer, J_ = nt(), X_ = gi(), _Je5 = Je(), bh = _Je5.createDeferredPromise, wh = Zs(), _h = globalThis.Blob || V_.Blob, Z_ = _typeof(_h) < "u" ? function(e) {
    return e instanceof _h;
  } : function(e) {
    return false;
  }, e0 = globalThis.AbortController || zi().AbortController, _ce11 = ce(), mh = _ce11.FunctionPrototypeCall, hr = /* @__PURE__ */ function(_J_) {
    function hr2(e) {
      var _this7;
      _classCallCheck(this, hr2);
      _this7 = _callSuper(this, hr2, [e]), (e === null || e === void 0 ? void 0 : e.readable) === false && (_this7._readableState.readable = false, _this7._readableState.ended = true, _this7._readableState.endEmitted = true), (e === null || e === void 0 ? void 0 : e.writable) === false && (_this7._writableState.writable = false, _this7._writableState.ending = true, _this7._writableState.ended = true, _this7._writableState.finished = true);
      return _this7;
    }
    _inherits(hr2, _J_);
    return _createClass(hr2);
  }(J_);
  Eh.exports = function t(e, r) {
    if (Q_(e))
      return e;
    if (dh(e))
      return wn({ readable: e });
    if (ph(e))
      return wn({ writable: e });
    if (G_(e))
      return wn({ writable: false, readable: false });
    if (typeof e == "function") {
      var _t2 = t0(e), n = _t2.value, o = _t2.write, s = _t2.final, a = _t2.destroy;
      if (hh(n))
        return wh(hr, n, { objectMode: true, write: o, final: s, destroy: a });
      var l = n === null || n === void 0 ? void 0 : n.then;
      if (typeof l == "function") {
        var c, h = mh(l, n, function(d) {
          if (d != null)
            throw new yh("nully", "body", d);
        }, function(d) {
          Hr(c, d);
        });
        return c = new hr({ objectMode: true, readable: false, write: o, final: function final(d) {
          s(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee7() {
            return _regeneratorRuntime().wrap(function _callee7$(_context8) {
              while (1)
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.prev = 0;
                    _context8.next = 3;
                    return h;
                  case 3:
                    po.nextTick(d, null);
                    _context8.next = 9;
                    break;
                  case 6:
                    _context8.prev = 6;
                    _context8.t0 = _context8["catch"](0);
                    po.nextTick(d, _context8.t0);
                  case 9:
                  case "end":
                    return _context8.stop();
                }
            }, _callee7, null, [[0, 6]]);
          })));
        }, destroy: a });
      }
      throw new yh("Iterable, AsyncIterable or AsyncFunction", r, n);
    }
    if (Z_(e))
      return t(e.arrayBuffer());
    if (hh(e))
      return wh(hr, e, { objectMode: true, writable: false });
    if (_typeof(e === null || e === void 0 ? void 0 : e.writable) == "object" || _typeof(e === null || e === void 0 ? void 0 : e.readable) == "object") {
      var _n3 = e != null && e.readable ? dh(e === null || e === void 0 ? void 0 : e.readable) ? e === null || e === void 0 ? void 0 : e.readable : t(e.readable) : void 0, _o2 = e != null && e.writable ? ph(e === null || e === void 0 ? void 0 : e.writable) ? e === null || e === void 0 ? void 0 : e.writable : t(e.writable) : void 0;
      return wn({ readable: _n3, writable: _o2 });
    }
    var i = e === null || e === void 0 ? void 0 : e.then;
    if (typeof i == "function") {
      var _n4;
      return mh(i, e, function(o2) {
        o2 != null && _n4.push(o2), _n4.push(null);
      }, function(o2) {
        Hr(_n4, o2);
      }), _n4 = new hr({ objectMode: true, writable: false, read: function read() {
      } });
    }
    throw new Y_(r, ["Blob", "ReadableStream", "WritableStream", "Stream", "Iterable", "AsyncIterable", "Function", "{ readable, writable } pair", "Promise"], e);
  };
  function t0(t) {
    var _bh = bh(), e = _bh.promise, r = _bh.resolve, i = new e0(), n = i.signal;
    return { value: t(_wrapAsyncGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee8() {
      var _bh2, s, _yield$_awaitAsyncGen, a, l, c;
      return _regeneratorRuntime().wrap(function _callee8$(_context9) {
        while (1)
          switch (_context9.prev = _context9.next) {
            case 0:
              s = e;
              e = null;
              _context9.next = 4;
              return _awaitAsyncGenerator(s);
            case 4:
              _yield$_awaitAsyncGen = _context9.sent;
              a = _yield$_awaitAsyncGen.chunk;
              l = _yield$_awaitAsyncGen.done;
              c = _yield$_awaitAsyncGen.cb;
              if (!(po.nextTick(c), l)) {
                _context9.next = 10;
                break;
              }
              return _context9.abrupt("return");
            case 10:
              if (!n.aborted) {
                _context9.next = 12;
                break;
              }
              throw new vh(void 0, { cause: n.reason });
            case 12:
              _bh2 = bh(), e = _bh2.promise, r = _bh2.resolve;
              _context9.next = 15;
              return a;
            case 15:
              _context9.next = 0;
              break;
            case 17:
            case "end":
              return _context9.stop();
          }
      }, _callee8);
    }))(), { signal: n }), write: function write3(s, a, l) {
      var c = r;
      r = null, c({ chunk: s, done: false, cb: l });
    }, final: function final(s) {
      var a = r;
      r = null, a({ done: true, cb: s });
    }, destroy: function destroy(s, a) {
      i.abort(), a(s);
    } };
  }
  function wn(t) {
    var e = t.readable && typeof t.readable.read != "function" ? X_.wrap(t.readable) : t.readable, r = t.writable, i = !!z_(e), n = !!K_(r), o, s, a, l, c;
    function h(d) {
      var g = l;
      l = null, g ? g(d) : d && c.destroy(d);
    }
    return c = new hr({ readableObjectMode: !!(e != null && e.readableObjectMode), writableObjectMode: !!(r != null && r.writableObjectMode), readable: i, writable: n }), n && (gh(r, function(d) {
      n = false, d && Hr(e, d), h(d);
    }), c._write = function(d, g, y) {
      r.write(d, g) ? y() : o = y;
    }, c._final = function(d) {
      r.end(), s = d;
    }, r.on("drain", function() {
      if (o) {
        var d = o;
        o = null, d();
      }
    }), r.on("finish", function() {
      if (s) {
        var d = s;
        s = null, d();
      }
    })), i && (gh(e, function(d) {
      i = false, d && Hr(e, d), h(d);
    }), e.on("readable", function() {
      if (a) {
        var d = a;
        a = null, d();
      }
    }), e.on("end", function() {
      c.push(null);
    }), c._read = function() {
      for (; ; ) {
        var d = e.read();
        if (d === null) {
          a = c._read;
          return;
        }
        if (!c.push(d))
          return;
      }
    }), c._destroy = function(d, g) {
      !d && l !== null && (d = new vh()), a = null, o = null, s = null, l === null ? g(d) : (l = g, Hr(r, d), Hr(e, d));
    }, c;
  }
});
var nt = M(function(PR, Th) {
  _();
  v();
  m();
  var _ce12 = ce(), r0 = _ce12.ObjectDefineProperties, It = _ce12.ObjectGetOwnPropertyDescriptor, i0 = _ce12.ObjectKeys, Ah = _ce12.ObjectSetPrototypeOf;
  Th.exports = Ve;
  var bo = gi(), Ne = ho();
  Ah(Ve.prototype, bo.prototype);
  Ah(Ve, bo);
  {
    var t = i0(Ne.prototype);
    for (var e = 0; e < t.length; e++) {
      var _r4 = t[e];
      Ve.prototype[_r4] || (Ve.prototype[_r4] = Ne.prototype[_r4]);
    }
  }
  function Ve(t2) {
    if (!(this instanceof Ve))
      return new Ve(t2);
    bo.call(this, t2), Ne.call(this, t2), t2 ? (this.allowHalfOpen = t2.allowHalfOpen !== false, t2.readable === false && (this._readableState.readable = false, this._readableState.ended = true, this._readableState.endEmitted = true), t2.writable === false && (this._writableState.writable = false, this._writableState.ending = true, this._writableState.ended = true, this._writableState.finished = true)) : this.allowHalfOpen = true;
  }
  r0(Ve.prototype, { writable: _objectSpread({ __proto__: null }, It(Ne.prototype, "writable")), writableHighWaterMark: _objectSpread({ __proto__: null }, It(Ne.prototype, "writableHighWaterMark")), writableObjectMode: _objectSpread({ __proto__: null }, It(Ne.prototype, "writableObjectMode")), writableBuffer: _objectSpread({ __proto__: null }, It(Ne.prototype, "writableBuffer")), writableLength: _objectSpread({ __proto__: null }, It(Ne.prototype, "writableLength")), writableFinished: _objectSpread({ __proto__: null }, It(Ne.prototype, "writableFinished")), writableCorked: _objectSpread({ __proto__: null }, It(Ne.prototype, "writableCorked")), writableEnded: _objectSpread({ __proto__: null }, It(Ne.prototype, "writableEnded")), writableNeedDrain: _objectSpread({ __proto__: null }, It(Ne.prototype, "writableNeedDrain")), destroyed: { __proto__: null, get: function get2() {
    return this._readableState === void 0 || this._writableState === void 0 ? false : this._readableState.destroyed && this._writableState.destroyed;
  }, set: function set(t2) {
    this._readableState && this._writableState && (this._readableState.destroyed = t2, this._writableState.destroyed = t2);
  } } });
  var go;
  function Ih() {
    return go === void 0 && (go = {}), go;
  }
  Ve.fromWeb = function(t2, e2) {
    return Ih().newStreamDuplexFromReadableWritablePair(t2, e2);
  };
  Ve.toWeb = function(t2) {
    return Ih().newReadableWritablePairFromDuplex(t2);
  };
  var yo;
  Ve.from = function(t2) {
    return yo || (yo = Sh()), yo(t2, "body");
  };
});
var mo = M(function(jR, Ch) {
  _();
  v();
  m();
  var _ce13 = ce(), Rh = _ce13.ObjectSetPrototypeOf, n0 = _ce13.Symbol;
  Ch.exports = Tt;
  var s0 = Ae().codes.ERR_METHOD_NOT_IMPLEMENTED, _o = nt(), _an3 = an(), o0 = _an3.getHighWaterMark;
  Rh(Tt.prototype, _o.prototype);
  Rh(Tt, _o);
  var _i = n0("kCallback");
  function Tt(t) {
    if (!(this instanceof Tt))
      return new Tt(t);
    var e = t ? o0(this, t, "readableHighWaterMark", true) : null;
    e === 0 && (t = _objectSpread(_objectSpread({}, t), {}, { highWaterMark: null, readableHighWaterMark: e, writableHighWaterMark: t.writableHighWaterMark || 0 })), _o.call(this, t), this._readableState.sync = false, this[_i] = null, t && (typeof t.transform == "function" && (this._transform = t.transform), typeof t.flush == "function" && (this._flush = t.flush)), this.on("prefinish", a0);
  }
  function wo(t) {
    var _this8 = this;
    typeof this._flush == "function" && !this.destroyed ? this._flush(function(e, r) {
      if (e) {
        t ? t(e) : _this8.destroy(e);
        return;
      }
      r != null && _this8.push(r), _this8.push(null), t && t();
    }) : (this.push(null), t && t());
  }
  function a0() {
    this._final !== wo && wo.call(this);
  }
  Tt.prototype._final = wo;
  Tt.prototype._transform = function(t, e, r) {
    throw new s0("_transform()");
  };
  Tt.prototype._write = function(t, e, r) {
    var _this9 = this;
    var i = this._readableState, n = this._writableState, o = i.length;
    this._transform(t, e, function(s, a) {
      if (s) {
        r(s);
        return;
      }
      a != null && _this9.push(a), n.ended || o === i.length || i.length < i.highWaterMark ? r() : _this9[_i] = r;
    });
  };
  Tt.prototype._read = function() {
    if (this[_i]) {
      var t = this[_i];
      this[_i] = null, t();
    }
  };
});
var Eo = M(function(YR, Ph) {
  _();
  v();
  m();
  var _ce14 = ce(), Bh = _ce14.ObjectSetPrototypeOf;
  Ph.exports = Vr;
  var vo = mo();
  Bh(Vr.prototype, vo.prototype);
  Bh(Vr, vo);
  function Vr(t) {
    if (!(this instanceof Vr))
      return new Vr(t);
    vo.call(this, t);
  }
  Vr.prototype._transform = function(t, e, r) {
    r(null, t);
  };
});
var En = M(function(oC, Lh) {
  _();
  v();
  m();
  var mi = Nt(), _ce15 = ce(), l0 = _ce15.ArrayIsArray, u0 = _ce15.Promise, f0 = _ce15.SymbolAsyncIterator, vn = vt(), _Je6 = Je(), c0 = _Je6.once, h0 = ir(), kh = nt(), _Ae7 = Ae(), d0 = _Ae7.aggregateTwoErrors, _Ae7$codes = _Ae7.codes, Po = _Ae7$codes.ERR_INVALID_ARG_TYPE, So = _Ae7$codes.ERR_INVALID_RETURN_VALUE, p0 = _Ae7$codes.ERR_MISSING_ARGS, g0 = _Ae7$codes.ERR_STREAM_DESTROYED, y0 = _Ae7$codes.ERR_STREAM_PREMATURE_CLOSE, b0 = _Ae7.AbortError, _hi3 = hi(), w0 = _hi3.validateFunction, _0 = _hi3.validateAbortSignal, _tt5 = tt(), dr = _tt5.isIterable, Ao = _tt5.isReadable, mn = _tt5.isReadableNodeStream, Oh = _tt5.isNodeStream, zr = _tt5.isTransformStream, m0 = _tt5.isWebStream, Io = _tt5.isReadableStream, v0 = _tt5.isReadableEnded, E0 = globalThis.AbortController || zi().AbortController, To, Ro;
  function xh(t, e, r) {
    var i = false;
    t.on("close", function() {
      i = true;
    });
    var n = vn(t, { readable: e, writable: r }, function(o) {
      i = !o;
    });
    return { destroy: function destroy(o) {
      i || (i = true, h0.destroyer(t, o || new g0("pipe")));
    }, cleanup: n };
  }
  function S0(t) {
    return w0(t[t.length - 1], "streams[stream.length - 1]"), t.pop();
  }
  function Co(t) {
    if (dr(t))
      return t;
    if (mn(t))
      return A0(t);
    throw new Po("val", ["Readable", "Iterable", "AsyncIterable"], t);
  }
  function A0(_x3) {
    return _A.apply(this, arguments);
  }
  function _A() {
    _A = _wrapAsyncGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee9(t) {
      return _regeneratorRuntime().wrap(function _callee9$(_context10) {
        while (1)
          switch (_context10.prev = _context10.next) {
            case 0:
              Ro || (Ro = gi());
              return _context10.delegateYield(_asyncGeneratorDelegate(_asyncIterator(Ro.prototype[f0].call(t)), _awaitAsyncGenerator), "t0", 2);
            case 2:
            case "end":
              return _context10.stop();
          }
      }, _callee9);
    }));
    return _A.apply(this, arguments);
  }
  function _n(_x5, _x6, _x7, _x8) {
    return _n5.apply(this, arguments);
  }
  function _n5() {
    _n5 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee10(t, e, r, _ref21) {
      var i, n, o, s, a, l, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, c;
      return _regeneratorRuntime().wrap(function _callee10$(_context11) {
        while (1)
          switch (_context11.prev = _context11.next) {
            case 0:
              i = _ref21.end;
              o = null, s = function s2(c2) {
                if (c2 && (n = c2), o) {
                  var h = o;
                  o = null, h();
                }
              }, a = function a2() {
                return new u0(function(c2, h) {
                  n ? h(n) : o = function o2() {
                    n ? h(n) : c2();
                  };
                });
              };
              e.on("drain", s);
              l = vn(e, { readable: false }, s);
              _context11.prev = 4;
              _context11.t0 = e.writableNeedDrain;
              if (!_context11.t0) {
                _context11.next = 9;
                break;
              }
              _context11.next = 9;
              return a();
            case 9:
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context11.prev = 11;
              _iterator = _asyncIterator(t);
            case 13:
              _context11.next = 15;
              return _iterator.next();
            case 15:
              if (!(_iteratorAbruptCompletion = !(_step = _context11.sent).done)) {
                _context11.next = 24;
                break;
              }
              c = _step.value;
              _context11.t1 = e.write(c);
              if (_context11.t1) {
                _context11.next = 21;
                break;
              }
              _context11.next = 21;
              return a();
            case 21:
              _iteratorAbruptCompletion = false;
              _context11.next = 13;
              break;
            case 24:
              _context11.next = 30;
              break;
            case 26:
              _context11.prev = 26;
              _context11.t2 = _context11["catch"](11);
              _didIteratorError = true;
              _iteratorError = _context11.t2;
            case 30:
              _context11.prev = 30;
              _context11.prev = 31;
              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context11.next = 35;
                break;
              }
              _context11.next = 35;
              return _iterator.return();
            case 35:
              _context11.prev = 35;
              if (!_didIteratorError) {
                _context11.next = 38;
                break;
              }
              throw _iteratorError;
            case 38:
              return _context11.finish(35);
            case 39:
              return _context11.finish(30);
            case 40:
              i && e.end();
              _context11.next = 43;
              return a();
            case 43:
              r();
              _context11.next = 49;
              break;
            case 46:
              _context11.prev = 46;
              _context11.t3 = _context11["catch"](4);
              r(n !== _context11.t3 ? d0(n, _context11.t3) : _context11.t3);
            case 49:
              _context11.prev = 49;
              l(), e.off("drain", s);
              return _context11.finish(49);
            case 52:
            case "end":
              return _context11.stop();
          }
      }, _callee10, null, [[4, 46, 49, 52], [11, 26, 30, 40], [31, , 35, 39]]);
    }));
    return _n5.apply(this, arguments);
  }
  function Bo(_x9, _x10, _x11, _x12) {
    return _Bo.apply(this, arguments);
  }
  function _Bo() {
    _Bo = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee11(t, e, r, _ref22) {
      var i, n, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _o3;
      return _regeneratorRuntime().wrap(function _callee11$(_context12) {
        while (1)
          switch (_context12.prev = _context12.next) {
            case 0:
              i = _ref22.end;
              zr(e) && (e = e.writable);
              n = e.getWriter();
              _context12.prev = 3;
              _iteratorAbruptCompletion2 = false;
              _didIteratorError2 = false;
              _context12.prev = 6;
              _iterator2 = _asyncIterator(t);
            case 8:
              _context12.next = 10;
              return _iterator2.next();
            case 10:
              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context12.sent).done)) {
                _context12.next = 18;
                break;
              }
              _o3 = _step2.value;
              _context12.next = 14;
              return n.ready;
            case 14:
              n.write(_o3).catch(function() {
              });
            case 15:
              _iteratorAbruptCompletion2 = false;
              _context12.next = 8;
              break;
            case 18:
              _context12.next = 24;
              break;
            case 20:
              _context12.prev = 20;
              _context12.t0 = _context12["catch"](6);
              _didIteratorError2 = true;
              _iteratorError2 = _context12.t0;
            case 24:
              _context12.prev = 24;
              _context12.prev = 25;
              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                _context12.next = 29;
                break;
              }
              _context12.next = 29;
              return _iterator2.return();
            case 29:
              _context12.prev = 29;
              if (!_didIteratorError2) {
                _context12.next = 32;
                break;
              }
              throw _iteratorError2;
            case 32:
              return _context12.finish(29);
            case 33:
              return _context12.finish(24);
            case 34:
              _context12.next = 36;
              return n.ready;
            case 36:
              _context12.t1 = i;
              if (!_context12.t1) {
                _context12.next = 40;
                break;
              }
              _context12.next = 40;
              return n.close();
            case 40:
              r();
              _context12.next = 54;
              break;
            case 43:
              _context12.prev = 43;
              _context12.t2 = _context12["catch"](3);
              _context12.prev = 45;
              _context12.next = 48;
              return n.abort(_context12.t2);
            case 48:
              r(_context12.t2);
              _context12.next = 54;
              break;
            case 51:
              _context12.prev = 51;
              _context12.t3 = _context12["catch"](45);
              r(_context12.t3);
            case 54:
            case "end":
              return _context12.stop();
          }
      }, _callee11, null, [[3, 43], [6, 20, 24, 34], [25, , 29, 33], [45, 51]]);
    }));
    return _Bo.apply(this, arguments);
  }
  function I0() {
    for (var _len13 = arguments.length, t = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
      t[_key13] = arguments[_key13];
    }
    return Mh(t, c0(S0(t)));
  }
  function Mh(t, e, r) {
    if (t.length === 1 && l0(t[0]) && (t = t[0]), t.length < 2)
      throw new p0("streams");
    var i = new E0(), n = i.signal, o = r === null || r === void 0 ? void 0 : r.signal, s = [];
    _0(o, "options.signal");
    function a() {
      y(new b0());
    }
    o === null || o === void 0 || o.addEventListener("abort", a);
    var l, c, h = [], d = 0;
    function g(C2) {
      y(C2, --d === 0);
    }
    function y(C2, R) {
      if (C2 && (!l || l.code === "ERR_STREAM_PREMATURE_CLOSE") && (l = C2), !(!l && !R)) {
        for (; h.length; )
          h.shift()(l);
        o !== null && o !== void 0 && o.removeEventListener("abort", a), i.abort(), R && (l || s.forEach(function(U) {
          return U();
        }), mi.nextTick(e, l, c));
      }
    }
    var w;
    var _loop2 = function _loop22() {
      var R = t[C], U = C < t.length - 1, N = C > 0, W = U || (r === null || r === void 0 ? void 0 : r.end) !== false, K = C === t.length - 1;
      if (Oh(R)) {
        var z = function z2(Q2) {
          Q2 && Q2.name !== "AbortError" && Q2.code !== "ERR_STREAM_PREMATURE_CLOSE" && g(Q2);
        };
        if (W) {
          var _xh = xh(R, U, N), Q = _xh.destroy, pe = _xh.cleanup;
          h.push(Q), Ao(R) && K && s.push(pe);
        }
        R.on("error", z), Ao(R) && K && s.push(function() {
          R.removeListener("error", z);
        });
      }
      if (C === 0) {
        if (typeof R == "function") {
          if (w = R({ signal: n }), !dr(w))
            throw new So("Iterable, AsyncIterable or Stream", "source", w);
        } else
          dr(R) || mn(R) || zr(R) ? w = R : w = kh.from(R);
      } else if (typeof R == "function") {
        if (zr(w)) {
          w = Co((S = w) === null || S === void 0 ? void 0 : S.readable);
        } else
          w = Co(w);
        if (w = R(w, { signal: n }), U) {
          if (!dr(w, true))
            throw new So("AsyncIterable", "transform[".concat(C - 1, "]"), w);
        } else {
          To || (To = Eo());
          var _z = new To({ objectMode: true }), _Q = (E = w) === null || E === void 0 ? void 0 : E.then;
          if (typeof _Q == "function")
            d++, _Q.call(w, function(ge2) {
              c = ge2, ge2 != null && _z.write(ge2), W && _z.end(), mi.nextTick(g);
            }, function(ge2) {
              _z.destroy(ge2), mi.nextTick(g, ge2);
            });
          else if (dr(w, true))
            d++, _n(w, _z, g, { end: W });
          else if (Io(w) || zr(w)) {
            var ge = w.readable || w;
            d++, _n(ge, _z, g, { end: W });
          } else
            throw new So("AsyncIterable or Promise", "destination", w);
          w = _z;
          var _xh2 = xh(w, false, true), _pe = _xh2.destroy, Yt = _xh2.cleanup;
          h.push(_pe), K && s.push(Yt);
        }
      } else if (Oh(R)) {
        if (mn(w)) {
          d += 2;
          var _z2 = T0(w, R, g, { end: W });
          Ao(R) && K && s.push(_z2);
        } else if (zr(w) || Io(w)) {
          var _z3 = w.readable || w;
          d++, _n(_z3, R, g, { end: W });
        } else if (dr(w))
          d++, _n(w, R, g, { end: W });
        else
          throw new Po("val", ["Readable", "Iterable", "AsyncIterable", "ReadableStream", "TransformStream"], w);
        w = R;
      } else if (m0(R)) {
        if (mn(w))
          d++, Bo(Co(w), R, g, { end: W });
        else if (Io(w) || dr(w))
          d++, Bo(w, R, g, { end: W });
        else if (zr(w))
          d++, Bo(w.readable, R, g, { end: W });
        else
          throw new Po("val", ["Readable", "Iterable", "AsyncIterable", "ReadableStream", "TransformStream"], w);
        w = R;
      } else
        w = kh.from(R);
    }, S, E;
    for (var C = 0; C < t.length; C++) {
      _loop2();
    }
    return (n != null && n.aborted || o != null && o.aborted) && mi.nextTick(a), w;
  }
  function T0(t, e, r, _ref23) {
    var i = _ref23.end;
    var n = false;
    if (e.on("close", function() {
      n || r(new y0());
    }), t.pipe(e, { end: false }), i) {
      var s = function s2() {
        n = true, e.end();
      };
      v0(t) ? mi.nextTick(s) : t.once("end", s);
    } else
      r();
    return vn(t, { readable: true, writable: false }, function(s2) {
      var a = t._readableState;
      s2 && s2.code === "ERR_STREAM_PREMATURE_CLOSE" && a && a.ended && !a.errored && !a.errorEmitted ? t.once("end", r).once("error", r) : r(s2);
    }), vn(e, { readable: false, writable: true }, r);
  }
  Lh.exports = { pipelineImpl: Mh, pipeline: I0 };
});
var Oo = M(function(yC, Fh) {
  _();
  v();
  m();
  var _En = En(), R0 = _En.pipeline, Sn = nt(), _ir2 = ir(), C0 = _ir2.destroyer, _tt6 = tt(), An = _tt6.isNodeStream, Uh = _tt6.isReadable, Nh = _tt6.isWritable, ko = _tt6.isWebStream, pr = _tt6.isTransformStream, qh = _tt6.isWritableStream, Dh = _tt6.isReadableStream, _Ae8 = Ae(), B0 = _Ae8.AbortError, _Ae8$codes = _Ae8.codes, jh = _Ae8$codes.ERR_INVALID_ARG_VALUE, P0 = _Ae8$codes.ERR_MISSING_ARGS, k0 = vt();
  Fh.exports = function() {
    for (var _len14 = arguments.length, e = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
      e[_key14] = arguments[_key14];
    }
    if (e.length === 0)
      throw new P0("streams");
    if (e.length === 1)
      return Sn.from(e[0]);
    var r = [].concat(e);
    if (typeof e[0] == "function" && (e[0] = Sn.from(e[0])), typeof e[e.length - 1] == "function") {
      var y = e.length - 1;
      e[y] = Sn.from(e[y]);
    }
    for (var _y2 = 0; _y2 < e.length; ++_y2)
      if (!(!An(e[_y2]) && !ko(e[_y2]))) {
        if (_y2 < e.length - 1 && !(Uh(e[_y2]) || Dh(e[_y2]) || pr(e[_y2])))
          throw new jh("streams[".concat(_y2, "]"), r[_y2], "must be readable");
        if (_y2 > 0 && !(Nh(e[_y2]) || qh(e[_y2]) || pr(e[_y2])))
          throw new jh("streams[".concat(_y2, "]"), r[_y2], "must be writable");
      }
    var i, n, o, s, a;
    function l(y2) {
      var w2 = s;
      s = null, w2 ? w2(y2) : y2 ? a.destroy(y2) : !g && !d && a.destroy();
    }
    var c = e[0], h = R0(e, l), d = !!(Nh(c) || qh(c) || pr(c)), g = !!(Uh(h) || Dh(h) || pr(h));
    if (a = new Sn({ writableObjectMode: !!(c != null && c.writableObjectMode), readableObjectMode: !!(h != null && h.writableObjectMode), writable: d, readable: g }), d) {
      if (An(c))
        a._write = function(w2, S, E) {
          c.write(w2, S) ? E() : i = E;
        }, a._final = function(w2) {
          c.end(), n = w2;
        }, c.on("drain", function() {
          if (i) {
            var w2 = i;
            i = null, w2();
          }
        });
      else if (ko(c)) {
        var _S2 = (pr(c) ? c.writable : c).getWriter();
        a._write = /* @__PURE__ */ function() {
          var _ref24 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee12(E, I, C) {
            return _regeneratorRuntime().wrap(function _callee12$(_context13) {
              while (1)
                switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.prev = 0;
                    _context13.next = 3;
                    return _S2.ready;
                  case 3:
                    _S2.write(E).catch(function() {
                    });
                    C();
                    _context13.next = 10;
                    break;
                  case 7:
                    _context13.prev = 7;
                    _context13.t0 = _context13["catch"](0);
                    C(_context13.t0);
                  case 10:
                  case "end":
                    return _context13.stop();
                }
            }, _callee12, null, [[0, 7]]);
          }));
          return function(_x13, _x14, _x15) {
            return _ref24.apply(this, arguments);
          };
        }(), a._final = /* @__PURE__ */ function() {
          var _ref25 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee13(E) {
            return _regeneratorRuntime().wrap(function _callee13$(_context14) {
              while (1)
                switch (_context14.prev = _context14.next) {
                  case 0:
                    _context14.prev = 0;
                    _context14.next = 3;
                    return _S2.ready;
                  case 3:
                    _S2.close().catch(function() {
                    });
                    n = E;
                    _context14.next = 10;
                    break;
                  case 7:
                    _context14.prev = 7;
                    _context14.t0 = _context14["catch"](0);
                    E(_context14.t0);
                  case 10:
                  case "end":
                    return _context14.stop();
                }
            }, _callee13, null, [[0, 7]]);
          }));
          return function(_x16) {
            return _ref25.apply(this, arguments);
          };
        }();
      }
      var _y3 = pr(h) ? h.readable : h;
      k0(_y3, function() {
        if (n) {
          var w2 = n;
          n = null, w2();
        }
      });
    }
    if (g) {
      if (An(h))
        h.on("readable", function() {
          if (o) {
            var _y4 = o;
            o = null, _y4();
          }
        }), h.on("end", function() {
          a.push(null);
        }), a._read = function() {
          for (; ; ) {
            var _y5 = h.read();
            if (_y5 === null) {
              o = a._read;
              return;
            }
            if (!a.push(_y5))
              return;
          }
        };
      else if (ko(h)) {
        var w = (pr(h) ? h.readable : h).getReader();
        a._read = /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee14() {
          var _yield$w$read, _S3, _E2;
          return _regeneratorRuntime().wrap(function _callee14$(_context15) {
            while (1)
              switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.prev = 0;
                  _context15.next = 3;
                  return w.read();
                case 3:
                  _yield$w$read = _context15.sent;
                  _S3 = _yield$w$read.value;
                  _E2 = _yield$w$read.done;
                  if (a.push(_S3)) {
                    _context15.next = 8;
                    break;
                  }
                  return _context15.abrupt("return");
                case 8:
                  if (!_E2) {
                    _context15.next = 11;
                    break;
                  }
                  a.push(null);
                  return _context15.abrupt("return");
                case 11:
                  _context15.next = 16;
                  break;
                case 13:
                  _context15.prev = 13;
                  _context15.t0 = _context15["catch"](0);
                  return _context15.abrupt("return");
                case 16:
                  _context15.next = 0;
                  break;
                case 18:
                case "end":
                  return _context15.stop();
              }
          }, _callee14, null, [[0, 13]]);
        }));
      }
    }
    return a._destroy = function(y2, w2) {
      !y2 && s !== null && (y2 = new B0()), o = null, i = null, n = null, s === null ? w2(y2) : (s = w2, An(h) && C0(h, y2));
    }, a;
  };
});
var Qh = M(function(TC, Lo) {
  _();
  v();
  m();
  var Vh = globalThis.AbortController || zi().AbortController, _Ae9 = Ae(), _Ae9$codes = _Ae9.codes, O0 = _Ae9$codes.ERR_INVALID_ARG_VALUE, vi = _Ae9$codes.ERR_INVALID_ARG_TYPE, x0 = _Ae9$codes.ERR_MISSING_ARGS, M0 = _Ae9$codes.ERR_OUT_OF_RANGE, st = _Ae9.AbortError, _hi4 = hi(), gr = _hi4.validateAbortSignal, L0 = _hi4.validateInteger, yr = _hi4.validateObject, U0 = ce().Symbol("kWeak"), _vt = vt(), N0 = _vt.finished, q0 = Oo(), _di3 = di(), D0 = _di3.addAbortSignalNoValidate, _tt7 = tt(), j0 = _tt7.isWritable, F0 = _tt7.isNodeStream, _ce16 = ce(), W0 = _ce16.ArrayPrototypePush, $0 = _ce16.MathFloor, H0 = _ce16.Number, V0 = _ce16.NumberIsNaN, Wh = _ce16.Promise, $h = _ce16.PromiseReject, z0 = _ce16.PromisePrototypeThen, zh = _ce16.Symbol, In = zh("kEmpty"), Hh = zh("kEof");
  function K0(t, e) {
    if (e != null && yr(e, "options"), (e === null || e === void 0 ? void 0 : e.signal) != null && gr(e.signal, "options.signal"), F0(t) && !j0(t))
      throw new O0("stream", t, "must be writable");
    var r = q0(this, t);
    return e != null && e.signal && D0(e.signal, r), r;
  }
  function Tn(t, e) {
    if (typeof t != "function")
      throw new vi("fn", ["Function", "AsyncFunction"], t);
    e != null && yr(e, "options"), (e === null || e === void 0 ? void 0 : e.signal) != null && gr(e.signal, "options.signal");
    var r = 1;
    return (e === null || e === void 0 ? void 0 : e.concurrency) != null && (r = $0(e.concurrency)), L0(r, "concurrency", 1), /* @__PURE__ */ _wrapAsyncGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee16() {
      var n, o, s, a, l, c, h, d, g, y, w, S, E, _E3, I;
      return _regeneratorRuntime().wrap(function _callee16$(_context17) {
        while (1)
          switch (_context17.prev = _context17.next) {
            case 0:
              _E3 = function _E5() {
                _E3 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee15() {
                  var _iteratorAbruptCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, R, I2, U, C;
                  return _regeneratorRuntime().wrap(function _callee15$(_context16) {
                    while (1)
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          _context16.prev = 0;
                          _iteratorAbruptCompletion3 = false;
                          _didIteratorError3 = false;
                          _context16.prev = 3;
                          _iterator3 = _asyncIterator(a);
                        case 5:
                          _context16.next = 7;
                          return _iterator3.next();
                        case 7:
                          if (!(_iteratorAbruptCompletion3 = !(_step3 = _context16.sent).done)) {
                            _context16.next = 26;
                            break;
                          }
                          R = _step3.value;
                          if (!w) {
                            _context16.next = 11;
                            break;
                          }
                          return _context16.abrupt("return");
                        case 11:
                          if (!c.aborted) {
                            _context16.next = 13;
                            break;
                          }
                          throw new st();
                        case 13:
                          try {
                            R = t(R, h);
                          } catch (U2) {
                            R = $h(U2);
                          }
                          _context16.t0 = R !== In;
                          if (!_context16.t0) {
                            _context16.next = 23;
                            break;
                          }
                          typeof ((I2 = R) === null || I2 === void 0 ? void 0 : I2.catch) == "function" && R.catch(S);
                          l.push(R);
                          g && (g(), g = null);
                          _context16.t1 = !w && l.length && l.length >= r;
                          if (!_context16.t1) {
                            _context16.next = 23;
                            break;
                          }
                          _context16.next = 23;
                          return new Wh(function(U2) {
                            y = U2;
                          });
                        case 23:
                          _iteratorAbruptCompletion3 = false;
                          _context16.next = 5;
                          break;
                        case 26:
                          _context16.next = 32;
                          break;
                        case 28:
                          _context16.prev = 28;
                          _context16.t2 = _context16["catch"](3);
                          _didIteratorError3 = true;
                          _iteratorError3 = _context16.t2;
                        case 32:
                          _context16.prev = 32;
                          _context16.prev = 33;
                          if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                            _context16.next = 37;
                            break;
                          }
                          _context16.next = 37;
                          return _iterator3.return();
                        case 37:
                          _context16.prev = 37;
                          if (!_didIteratorError3) {
                            _context16.next = 40;
                            break;
                          }
                          throw _iteratorError3;
                        case 40:
                          return _context16.finish(37);
                        case 41:
                          return _context16.finish(32);
                        case 42:
                          l.push(Hh);
                          _context16.next = 49;
                          break;
                        case 45:
                          _context16.prev = 45;
                          _context16.t3 = _context16["catch"](0);
                          U = $h(_context16.t3);
                          z0(U, void 0, S), l.push(U);
                        case 49:
                          _context16.prev = 49;
                          w = true, g && (g(), g = null), e == null || (C = e.signal) === null || C === void 0 || C.removeEventListener("abort", d);
                          return _context16.finish(49);
                        case 52:
                        case "end":
                          return _context16.stop();
                      }
                  }, _callee15, null, [[0, 45, 49, 52], [3, 28, 32, 42], [33, , 37, 41]]);
                }));
                return _E3.apply(this, arguments);
              };
              E = function _E4() {
                return _E3.apply(this, arguments);
              };
              S = function _S4() {
                w = true;
              };
              s = new Vh(), a = this, l = [], c = s.signal, h = { signal: c }, d = function d2() {
                return s.abort();
              };
              e != null && (n = e.signal) !== null && n !== void 0 && n.aborted && d(), e == null || (o = e.signal) === null || o === void 0 || o.addEventListener("abort", d);
              w = false;
              E();
              _context17.prev = 7;
            case 8:
              if (!(l.length > 0)) {
                _context17.next = 24;
                break;
              }
              _context17.next = 11;
              return _awaitAsyncGenerator(l[0]);
            case 11:
              I = _context17.sent;
              if (!(I === Hh)) {
                _context17.next = 14;
                break;
              }
              return _context17.abrupt("return");
            case 14:
              if (!c.aborted) {
                _context17.next = 16;
                break;
              }
              throw new st();
            case 16:
              _context17.t0 = I !== In;
              if (!_context17.t0) {
                _context17.next = 20;
                break;
              }
              _context17.next = 20;
              return I;
            case 20:
              l.shift();
              y && (y(), y = null);
            case 22:
              _context17.next = 8;
              break;
            case 24:
              _context17.next = 26;
              return _awaitAsyncGenerator(new Wh(function(I2) {
                g = I2;
              }));
            case 26:
              _context17.next = 8;
              break;
            case 28:
              _context17.prev = 28;
              s.abort(), w = true, y && (y(), y = null);
              return _context17.finish(28);
            case 31:
            case "end":
              return _context17.stop();
          }
      }, _callee16, this, [[7, , 28, 31]]);
    })).call(this);
  }
  function G0() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
    return t != null && yr(t, "options"), (t === null || t === void 0 ? void 0 : t.signal) != null && gr(t.signal, "options.signal"), /* @__PURE__ */ _wrapAsyncGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee17() {
      var r, _iteratorAbruptCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _n6, i;
      return _regeneratorRuntime().wrap(function _callee17$(_context18) {
        while (1)
          switch (_context18.prev = _context18.next) {
            case 0:
              r = 0;
              _iteratorAbruptCompletion4 = false;
              _didIteratorError4 = false;
              _context18.prev = 3;
              _iterator4 = _asyncIterator(this);
            case 5:
              _context18.next = 7;
              return _awaitAsyncGenerator(_iterator4.next());
            case 7:
              if (!(_iteratorAbruptCompletion4 = !(_step4 = _context18.sent).done)) {
                _context18.next = 16;
                break;
              }
              _n6 = _step4.value;
              if (!(t != null && (i = t.signal) !== null && i !== void 0 && i.aborted)) {
                _context18.next = 11;
                break;
              }
              throw new st({ cause: t.signal.reason });
            case 11:
              _context18.next = 13;
              return [r++, _n6];
            case 13:
              _iteratorAbruptCompletion4 = false;
              _context18.next = 5;
              break;
            case 16:
              _context18.next = 22;
              break;
            case 18:
              _context18.prev = 18;
              _context18.t0 = _context18["catch"](3);
              _didIteratorError4 = true;
              _iteratorError4 = _context18.t0;
            case 22:
              _context18.prev = 22;
              _context18.prev = 23;
              if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
                _context18.next = 27;
                break;
              }
              _context18.next = 27;
              return _awaitAsyncGenerator(_iterator4.return());
            case 27:
              _context18.prev = 27;
              if (!_didIteratorError4) {
                _context18.next = 30;
                break;
              }
              throw _iteratorError4;
            case 30:
              return _context18.finish(27);
            case 31:
              return _context18.finish(22);
            case 32:
            case "end":
              return _context18.stop();
          }
      }, _callee17, this, [[3, 18, 22, 32], [23, , 27, 31]]);
    })).call(this);
  }
  function Kh(_x17) {
    return _Kh.apply(this, arguments);
  }
  function _Kh() {
    _Kh = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee22(t) {
      var e, _iteratorAbruptCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, _r6, _args23 = arguments;
      return _regeneratorRuntime().wrap(function _callee22$(_context23) {
        while (1)
          switch (_context23.prev = _context23.next) {
            case 0:
              e = _args23.length > 1 && _args23[1] !== void 0 ? _args23[1] : void 0;
              _iteratorAbruptCompletion5 = false;
              _didIteratorError5 = false;
              _context23.prev = 3;
              _iterator5 = _asyncIterator(Mo.call(this, t, e));
            case 5:
              _context23.next = 7;
              return _iterator5.next();
            case 7:
              if (!(_iteratorAbruptCompletion5 = !(_step5 = _context23.sent).done)) {
                _context23.next = 13;
                break;
              }
              _r6 = _step5.value;
              return _context23.abrupt("return", true);
            case 10:
              _iteratorAbruptCompletion5 = false;
              _context23.next = 5;
              break;
            case 13:
              _context23.next = 19;
              break;
            case 15:
              _context23.prev = 15;
              _context23.t0 = _context23["catch"](3);
              _didIteratorError5 = true;
              _iteratorError5 = _context23.t0;
            case 19:
              _context23.prev = 19;
              _context23.prev = 20;
              if (!(_iteratorAbruptCompletion5 && _iterator5.return != null)) {
                _context23.next = 24;
                break;
              }
              _context23.next = 24;
              return _iterator5.return();
            case 24:
              _context23.prev = 24;
              if (!_didIteratorError5) {
                _context23.next = 27;
                break;
              }
              throw _iteratorError5;
            case 27:
              return _context23.finish(24);
            case 28:
              return _context23.finish(19);
            case 29:
              return _context23.abrupt("return", false);
            case 30:
            case "end":
              return _context23.stop();
          }
      }, _callee22, this, [[3, 15, 19, 29], [20, , 24, 28]]);
    }));
    return _Kh.apply(this, arguments);
  }
  function Q0(_x18) {
    return _Q2.apply(this, arguments);
  }
  function _Q2() {
    _Q2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee24(t) {
      var e, _args25 = arguments;
      return _regeneratorRuntime().wrap(function _callee24$(_context25) {
        while (1)
          switch (_context25.prev = _context25.next) {
            case 0:
              e = _args25.length > 1 && _args25[1] !== void 0 ? _args25[1] : void 0;
              if (!(typeof t != "function")) {
                _context25.next = 3;
                break;
              }
              throw new vi("fn", ["Function", "AsyncFunction"], t);
            case 3:
              _context25.next = 5;
              return Kh.call(this, /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee23() {
                var _args24 = arguments;
                return _regeneratorRuntime().wrap(function _callee23$(_context24) {
                  while (1)
                    switch (_context24.prev = _context24.next) {
                      case 0:
                        _context24.next = 2;
                        return t.apply(void 0, _args24);
                      case 2:
                        return _context24.abrupt("return", !_context24.sent);
                      case 3:
                      case "end":
                        return _context24.stop();
                    }
                }, _callee23);
              })), e);
            case 5:
              return _context25.abrupt("return", !_context25.sent);
            case 6:
            case "end":
              return _context25.stop();
          }
      }, _callee24, this);
    }));
    return _Q2.apply(this, arguments);
  }
  function Y0(_x19, _x20) {
    return _Y.apply(this, arguments);
  }
  function _Y() {
    _Y = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee25(t, e) {
      var _iteratorAbruptCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, _r7;
      return _regeneratorRuntime().wrap(function _callee25$(_context26) {
        while (1)
          switch (_context26.prev = _context26.next) {
            case 0:
              _iteratorAbruptCompletion6 = false;
              _didIteratorError6 = false;
              _context26.prev = 2;
              _iterator6 = _asyncIterator(Mo.call(this, t, e));
            case 4:
              _context26.next = 6;
              return _iterator6.next();
            case 6:
              if (!(_iteratorAbruptCompletion6 = !(_step6 = _context26.sent).done)) {
                _context26.next = 12;
                break;
              }
              _r7 = _step6.value;
              return _context26.abrupt("return", _r7);
            case 9:
              _iteratorAbruptCompletion6 = false;
              _context26.next = 4;
              break;
            case 12:
              _context26.next = 18;
              break;
            case 14:
              _context26.prev = 14;
              _context26.t0 = _context26["catch"](2);
              _didIteratorError6 = true;
              _iteratorError6 = _context26.t0;
            case 18:
              _context26.prev = 18;
              _context26.prev = 19;
              if (!(_iteratorAbruptCompletion6 && _iterator6.return != null)) {
                _context26.next = 23;
                break;
              }
              _context26.next = 23;
              return _iterator6.return();
            case 23:
              _context26.prev = 23;
              if (!_didIteratorError6) {
                _context26.next = 26;
                break;
              }
              throw _iteratorError6;
            case 26:
              return _context26.finish(23);
            case 27:
              return _context26.finish(18);
            case 28:
            case "end":
              return _context26.stop();
          }
      }, _callee25, this, [[2, 14, 18, 28], [19, , 23, 27]]);
    }));
    return _Y.apply(this, arguments);
  }
  function J0(_x21, _x22) {
    return _J.apply(this, arguments);
  }
  function _J() {
    _J = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee27(t, e) {
      var r, _r8, _iteratorAbruptCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, i;
      return _regeneratorRuntime().wrap(function _callee27$(_context28) {
        while (1)
          switch (_context28.prev = _context28.next) {
            case 0:
              _r8 = function _r10() {
                _r8 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee26(i2, n) {
                  return _regeneratorRuntime().wrap(function _callee26$(_context27) {
                    while (1)
                      switch (_context27.prev = _context27.next) {
                        case 0:
                          _context27.next = 2;
                          return t(i2, n);
                        case 2:
                          return _context27.abrupt("return", In);
                        case 3:
                        case "end":
                          return _context27.stop();
                      }
                  }, _callee26);
                }));
                return _r8.apply(this, arguments);
              };
              r = function _r9(_x30, _x31) {
                return _r8.apply(this, arguments);
              };
              if (!(typeof t != "function")) {
                _context28.next = 4;
                break;
              }
              throw new vi("fn", ["Function", "AsyncFunction"], t);
            case 4:
              _iteratorAbruptCompletion7 = false;
              _didIteratorError7 = false;
              _context28.prev = 6;
              _iterator7 = _asyncIterator(Tn.call(this, r, e));
            case 8:
              _context28.next = 10;
              return _iterator7.next();
            case 10:
              if (!(_iteratorAbruptCompletion7 = !(_step7 = _context28.sent).done)) {
                _context28.next = 16;
                break;
              }
              i = _step7.value;
              ;
            case 13:
              _iteratorAbruptCompletion7 = false;
              _context28.next = 8;
              break;
            case 16:
              _context28.next = 22;
              break;
            case 18:
              _context28.prev = 18;
              _context28.t0 = _context28["catch"](6);
              _didIteratorError7 = true;
              _iteratorError7 = _context28.t0;
            case 22:
              _context28.prev = 22;
              _context28.prev = 23;
              if (!(_iteratorAbruptCompletion7 && _iterator7.return != null)) {
                _context28.next = 27;
                break;
              }
              _context28.next = 27;
              return _iterator7.return();
            case 27:
              _context28.prev = 27;
              if (!_didIteratorError7) {
                _context28.next = 30;
                break;
              }
              throw _iteratorError7;
            case 30:
              return _context28.finish(27);
            case 31:
              return _context28.finish(22);
            case 32:
            case "end":
              return _context28.stop();
          }
      }, _callee27, this, [[6, 18, 22, 32], [23, , 27, 31]]);
    }));
    return _J.apply(this, arguments);
  }
  function Mo(t, e) {
    if (typeof t != "function")
      throw new vi("fn", ["Function", "AsyncFunction"], t);
    function r(_x23, _x24) {
      return _r5.apply(this, arguments);
    }
    function _r5() {
      _r5 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee18(i, n) {
        return _regeneratorRuntime().wrap(function _callee18$(_context19) {
          while (1)
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return t(i, n);
              case 2:
                if (!_context19.sent) {
                  _context19.next = 6;
                  break;
                }
                _context19.t0 = i;
                _context19.next = 7;
                break;
              case 6:
                _context19.t0 = In;
              case 7:
                return _context19.abrupt("return", _context19.t0);
              case 8:
              case "end":
                return _context19.stop();
            }
        }, _callee18);
      }));
      return _r5.apply(this, arguments);
    }
    return Tn.call(this, r, e);
  }
  var xo = /* @__PURE__ */ function(_x25) {
    function xo2() {
      var _this10;
      _classCallCheck(this, xo2);
      _this10 = _callSuper(this, xo2, ["reduce"]), _this10.message = "Reduce of an empty stream requires an initial value";
      return _this10;
    }
    _inherits(xo2, _x25);
    return _createClass(xo2);
  }(x0);
  function X0(_x26, _x27, _x28) {
    return _X.apply(this, arguments);
  }
  function _X() {
    _X = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee28(t, e, r) {
      var i, n, _c2, o, s, _c3, a, _iteratorAbruptCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _c5, l, _args29 = arguments;
      return _regeneratorRuntime().wrap(function _callee28$(_context29) {
        while (1)
          switch (_context29.prev = _context29.next) {
            case 0:
              if (!(typeof t != "function")) {
                _context29.next = 2;
                break;
              }
              throw new vi("reducer", ["Function", "AsyncFunction"], t);
            case 2:
              r != null && yr(r, "options"), (r === null || r === void 0 ? void 0 : r.signal) != null && gr(r.signal, "options.signal");
              n = _args29.length > 1;
              if (!(r != null && (i = r.signal) !== null && i !== void 0 && i.aborted)) {
                _context29.next = 10;
                break;
              }
              _c2 = new st(void 0, { cause: r.signal.reason });
              this.once("error", function() {
              });
              _context29.next = 9;
              return N0(this.destroy(_c2));
            case 9:
              throw _c2;
            case 10:
              o = new Vh(), s = o.signal;
              if (r != null && r.signal) {
                _c3 = _defineProperty({ once: true }, U0, this);
                r.signal.addEventListener("abort", function() {
                  return o.abort();
                }, _c3);
              }
              a = false;
              _context29.prev = 13;
              _iteratorAbruptCompletion8 = false;
              _didIteratorError8 = false;
              _context29.prev = 16;
              _iterator8 = _asyncIterator(this);
            case 18:
              _context29.next = 20;
              return _iterator8.next();
            case 20:
              if (!(_iteratorAbruptCompletion8 = !(_step8 = _context29.sent).done)) {
                _context29.next = 34;
                break;
              }
              _c5 = _step8.value;
              if (!(a = true, r != null && (l = r.signal) !== null && l !== void 0 && l.aborted)) {
                _context29.next = 24;
                break;
              }
              throw new st();
            case 24:
              if (!n) {
                _context29.next = 30;
                break;
              }
              _context29.next = 27;
              return t(e, _c5, { signal: s });
            case 27:
              e = _context29.sent;
              _context29.next = 31;
              break;
            case 30:
              e = _c5, n = true;
            case 31:
              _iteratorAbruptCompletion8 = false;
              _context29.next = 18;
              break;
            case 34:
              _context29.next = 40;
              break;
            case 36:
              _context29.prev = 36;
              _context29.t0 = _context29["catch"](16);
              _didIteratorError8 = true;
              _iteratorError8 = _context29.t0;
            case 40:
              _context29.prev = 40;
              _context29.prev = 41;
              if (!(_iteratorAbruptCompletion8 && _iterator8.return != null)) {
                _context29.next = 45;
                break;
              }
              _context29.next = 45;
              return _iterator8.return();
            case 45:
              _context29.prev = 45;
              if (!_didIteratorError8) {
                _context29.next = 48;
                break;
              }
              throw _iteratorError8;
            case 48:
              return _context29.finish(45);
            case 49:
              return _context29.finish(40);
            case 50:
              if (!(!a && !n)) {
                _context29.next = 52;
                break;
              }
              throw new xo();
            case 52:
              _context29.prev = 52;
              o.abort();
              return _context29.finish(52);
            case 55:
              return _context29.abrupt("return", e);
            case 56:
            case "end":
              return _context29.stop();
          }
      }, _callee28, this, [[13, , 52, 55], [16, 36, 40, 50], [41, , 45, 49]]);
    }));
    return _X.apply(this, arguments);
  }
  function Z0(_x29) {
    return _Z.apply(this, arguments);
  }
  function _Z() {
    _Z = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee29(t) {
      var e, _iteratorAbruptCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, i, r;
      return _regeneratorRuntime().wrap(function _callee29$(_context30) {
        while (1)
          switch (_context30.prev = _context30.next) {
            case 0:
              t != null && yr(t, "options"), (t === null || t === void 0 ? void 0 : t.signal) != null && gr(t.signal, "options.signal");
              e = [];
              _iteratorAbruptCompletion9 = false;
              _didIteratorError9 = false;
              _context30.prev = 4;
              _iterator9 = _asyncIterator(this);
            case 6:
              _context30.next = 8;
              return _iterator9.next();
            case 8:
              if (!(_iteratorAbruptCompletion9 = !(_step9 = _context30.sent).done)) {
                _context30.next = 16;
                break;
              }
              i = _step9.value;
              if (!(t != null && (r = t.signal) !== null && r !== void 0 && r.aborted)) {
                _context30.next = 12;
                break;
              }
              throw new st(void 0, { cause: t.signal.reason });
            case 12:
              W0(e, i);
            case 13:
              _iteratorAbruptCompletion9 = false;
              _context30.next = 6;
              break;
            case 16:
              _context30.next = 22;
              break;
            case 18:
              _context30.prev = 18;
              _context30.t0 = _context30["catch"](4);
              _didIteratorError9 = true;
              _iteratorError9 = _context30.t0;
            case 22:
              _context30.prev = 22;
              _context30.prev = 23;
              if (!(_iteratorAbruptCompletion9 && _iterator9.return != null)) {
                _context30.next = 27;
                break;
              }
              _context30.next = 27;
              return _iterator9.return();
            case 27:
              _context30.prev = 27;
              if (!_didIteratorError9) {
                _context30.next = 30;
                break;
              }
              throw _iteratorError9;
            case 30:
              return _context30.finish(27);
            case 31:
              return _context30.finish(22);
            case 32:
              return _context30.abrupt("return", e);
            case 33:
            case "end":
              return _context30.stop();
          }
      }, _callee29, this, [[4, 18, 22, 32], [23, , 27, 31]]);
    }));
    return _Z.apply(this, arguments);
  }
  function em(t, e) {
    var r = Tn.call(this, t, e);
    return /* @__PURE__ */ _wrapAsyncGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee19() {
      var _iteratorAbruptCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, _n7;
      return _regeneratorRuntime().wrap(function _callee19$(_context20) {
        while (1)
          switch (_context20.prev = _context20.next) {
            case 0:
              _iteratorAbruptCompletion10 = false;
              _didIteratorError10 = false;
              _context20.prev = 2;
              _iterator10 = _asyncIterator(r);
            case 4:
              _context20.next = 6;
              return _awaitAsyncGenerator(_iterator10.next());
            case 6:
              if (!(_iteratorAbruptCompletion10 = !(_step10 = _context20.sent).done)) {
                _context20.next = 12;
                break;
              }
              _n7 = _step10.value;
              return _context20.delegateYield(_asyncGeneratorDelegate(_asyncIterator(_n7), _awaitAsyncGenerator), "t0", 9);
            case 9:
              _iteratorAbruptCompletion10 = false;
              _context20.next = 4;
              break;
            case 12:
              _context20.next = 18;
              break;
            case 14:
              _context20.prev = 14;
              _context20.t1 = _context20["catch"](2);
              _didIteratorError10 = true;
              _iteratorError10 = _context20.t1;
            case 18:
              _context20.prev = 18;
              _context20.prev = 19;
              if (!(_iteratorAbruptCompletion10 && _iterator10.return != null)) {
                _context20.next = 23;
                break;
              }
              _context20.next = 23;
              return _awaitAsyncGenerator(_iterator10.return());
            case 23:
              _context20.prev = 23;
              if (!_didIteratorError10) {
                _context20.next = 26;
                break;
              }
              throw _iteratorError10;
            case 26:
              return _context20.finish(23);
            case 27:
              return _context20.finish(18);
            case 28:
            case "end":
              return _context20.stop();
          }
      }, _callee19, null, [[2, 14, 18, 28], [19, , 23, 27]]);
    })).call(this);
  }
  function Gh(t) {
    if (t = H0(t), V0(t))
      return 0;
    if (t < 0)
      throw new M0("number", ">= 0", t);
    return t;
  }
  function tm(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
    return e != null && yr(e, "options"), (e === null || e === void 0 ? void 0 : e.signal) != null && gr(e.signal, "options.signal"), t = Gh(t), /* @__PURE__ */ _wrapAsyncGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee20() {
      var i, _iteratorAbruptCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, _o4, n;
      return _regeneratorRuntime().wrap(function _callee20$(_context21) {
        while (1)
          switch (_context21.prev = _context21.next) {
            case 0:
              if (!(e != null && (i = e.signal) !== null && i !== void 0 && i.aborted)) {
                _context21.next = 2;
                break;
              }
              throw new st();
            case 2:
              _iteratorAbruptCompletion11 = false;
              _didIteratorError11 = false;
              _context21.prev = 4;
              _iterator11 = _asyncIterator(this);
            case 6:
              _context21.next = 8;
              return _awaitAsyncGenerator(_iterator11.next());
            case 8:
              if (!(_iteratorAbruptCompletion11 = !(_step11 = _context21.sent).done)) {
                _context21.next = 19;
                break;
              }
              _o4 = _step11.value;
              if (!(e != null && (n = e.signal) !== null && n !== void 0 && n.aborted)) {
                _context21.next = 12;
                break;
              }
              throw new st();
            case 12:
              _context21.t0 = t-- <= 0;
              if (!_context21.t0) {
                _context21.next = 16;
                break;
              }
              _context21.next = 16;
              return _o4;
            case 16:
              _iteratorAbruptCompletion11 = false;
              _context21.next = 6;
              break;
            case 19:
              _context21.next = 25;
              break;
            case 21:
              _context21.prev = 21;
              _context21.t1 = _context21["catch"](4);
              _didIteratorError11 = true;
              _iteratorError11 = _context21.t1;
            case 25:
              _context21.prev = 25;
              _context21.prev = 26;
              if (!(_iteratorAbruptCompletion11 && _iterator11.return != null)) {
                _context21.next = 30;
                break;
              }
              _context21.next = 30;
              return _awaitAsyncGenerator(_iterator11.return());
            case 30:
              _context21.prev = 30;
              if (!_didIteratorError11) {
                _context21.next = 33;
                break;
              }
              throw _iteratorError11;
            case 33:
              return _context21.finish(30);
            case 34:
              return _context21.finish(25);
            case 35:
            case "end":
              return _context21.stop();
          }
      }, _callee20, this, [[4, 21, 25, 35], [26, , 30, 34]]);
    })).call(this);
  }
  function rm(t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
    return e != null && yr(e, "options"), (e === null || e === void 0 ? void 0 : e.signal) != null && gr(e.signal, "options.signal"), t = Gh(t), /* @__PURE__ */ _wrapAsyncGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee21() {
      var i, _iteratorAbruptCompletion12, _didIteratorError12, _iteratorError12, _iterator12, _step12, _o5, n;
      return _regeneratorRuntime().wrap(function _callee21$(_context22) {
        while (1)
          switch (_context22.prev = _context22.next) {
            case 0:
              if (!(e != null && (i = e.signal) !== null && i !== void 0 && i.aborted)) {
                _context22.next = 2;
                break;
              }
              throw new st();
            case 2:
              _iteratorAbruptCompletion12 = false;
              _didIteratorError12 = false;
              _context22.prev = 4;
              _iterator12 = _asyncIterator(this);
            case 6:
              _context22.next = 8;
              return _awaitAsyncGenerator(_iterator12.next());
            case 8:
              if (!(_iteratorAbruptCompletion12 = !(_step12 = _context22.sent).done)) {
                _context22.next = 21;
                break;
              }
              _o5 = _step12.value;
              if (!(e != null && (n = e.signal) !== null && n !== void 0 && n.aborted)) {
                _context22.next = 12;
                break;
              }
              throw new st();
            case 12:
              if (!(t-- > 0)) {
                _context22.next = 17;
                break;
              }
              _context22.next = 15;
              return _o5;
            case 15:
              _context22.next = 18;
              break;
            case 17:
              return _context22.abrupt("return");
            case 18:
              _iteratorAbruptCompletion12 = false;
              _context22.next = 6;
              break;
            case 21:
              _context22.next = 27;
              break;
            case 23:
              _context22.prev = 23;
              _context22.t0 = _context22["catch"](4);
              _didIteratorError12 = true;
              _iteratorError12 = _context22.t0;
            case 27:
              _context22.prev = 27;
              _context22.prev = 28;
              if (!(_iteratorAbruptCompletion12 && _iterator12.return != null)) {
                _context22.next = 32;
                break;
              }
              _context22.next = 32;
              return _awaitAsyncGenerator(_iterator12.return());
            case 32:
              _context22.prev = 32;
              if (!_didIteratorError12) {
                _context22.next = 35;
                break;
              }
              throw _iteratorError12;
            case 35:
              return _context22.finish(32);
            case 36:
              return _context22.finish(27);
            case 37:
            case "end":
              return _context22.stop();
          }
      }, _callee21, this, [[4, 23, 27, 37], [28, , 32, 36]]);
    })).call(this);
  }
  Lo.exports.streamReturningOperators = { asIndexedPairs: G0, drop: tm, filter: Mo, flatMap: em, map: Tn, take: rm, compose: K0 };
  Lo.exports.promiseReturningOperators = { every: Q0, forEach: J0, reduce: X0, toArray: Z0, some: Kh, find: Y0 };
});
var Uo = M(function(UC, Yh) {
  _();
  v();
  m();
  var _ce17 = ce(), im = _ce17.ArrayPrototypePop, nm = _ce17.Promise, _tt8 = tt(), sm = _tt8.isIterable, om = _tt8.isNodeStream, am = _tt8.isWebStream, _En2 = En(), lm = _En2.pipelineImpl, _vt2 = vt(), um = _vt2.finished;
  No();
  function fm() {
    for (var _len15 = arguments.length, t = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
      t[_key15] = arguments[_key15];
    }
    return new nm(function(e, r) {
      var i, n, o = t[t.length - 1];
      if (o && _typeof(o) == "object" && !om(o) && !sm(o) && !am(o)) {
        var _s3 = im(t);
        i = _s3.signal, n = _s3.end;
      }
      lm(t, function(s, a) {
        s ? r(s) : e(a);
      }, { signal: i, end: n });
    });
  }
  Yh.exports = { finished: um, pipeline: fm };
});
var No = M(function(zC, sd) {
  _();
  v();
  m();
  var _ref28 = (be(), X(me)), cm = _ref28.Buffer, _ce18 = ce(), Rt = _ce18.ObjectDefineProperty, Zh = _ce18.ObjectKeys, ed = _ce18.ReflectApply, _Je7 = Je(), td = _Je7.promisify.custom, _Qh = Qh(), Jh = _Qh.streamReturningOperators, Xh = _Qh.promiseReturningOperators, _Ae10 = Ae(), rd = _Ae10.codes.ERR_ILLEGAL_CONSTRUCTOR, hm = Oo(), _En3 = En(), id = _En3.pipeline, _ir3 = ir(), dm = _ir3.destroyer, nd = vt(), qo = Uo(), Do = tt(), le = sd.exports = nn().Stream;
  le.isDisturbed = Do.isDisturbed;
  le.isErrored = Do.isErrored;
  le.isReadable = Do.isReadable;
  le.Readable = gi();
  var _iterator16 = _createForOfIteratorHelper(Zh(Jh)), _step16;
  try {
    var _loop3 = function _loop32() {
      var t = _step16.value;
      var r = function _target() {
        if (this instanceof _target ? this.constructor : void 0)
          throw rd();
        for (var _len16 = arguments.length, i = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
          i[_key16] = arguments[_key16];
        }
        return le.Readable.from(ed(e, this, i));
      };
      var e = Jh[t];
      Rt(r, "name", { __proto__: null, value: e.name }), Rt(r, "length", { __proto__: null, value: e.length }), Rt(le.Readable.prototype, t, { __proto__: null, value: r, enumerable: false, configurable: true, writable: true });
    };
    for (_iterator16.s(); !(_step16 = _iterator16.n()).done; ) {
      _loop3();
    }
  } catch (err) {
    _iterator16.e(err);
  } finally {
    _iterator16.f();
  }
  var _iterator17 = _createForOfIteratorHelper(Zh(Xh)), _step17;
  try {
    var _loop4 = function _loop42() {
      var t = _step17.value;
      var r = function _target2() {
        if (this instanceof _target2 ? this.constructor : void 0)
          throw rd();
        for (var _len17 = arguments.length, n = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
          n[_key17] = arguments[_key17];
        }
        return ed(e, this, n);
      };
      var e = Xh[t];
      Rt(r, "name", { __proto__: null, value: e.name }), Rt(r, "length", { __proto__: null, value: e.length }), Rt(le.Readable.prototype, t, { __proto__: null, value: r, enumerable: false, configurable: true, writable: true });
    };
    for (_iterator17.s(); !(_step17 = _iterator17.n()).done; ) {
      _loop4();
    }
  } catch (err) {
    _iterator17.e(err);
  } finally {
    _iterator17.f();
  }
  le.Writable = ho();
  le.Duplex = nt();
  le.Transform = mo();
  le.PassThrough = Eo();
  le.pipeline = id;
  var _di4 = di(), pm = _di4.addAbortSignal;
  le.addAbortSignal = pm;
  le.finished = nd;
  le.destroy = dm;
  le.compose = hm;
  Rt(le, "promises", { __proto__: null, configurable: true, enumerable: true, get: function get2() {
    return qo;
  } });
  Rt(id, td, { __proto__: null, enumerable: true, get: function get2() {
    return qo.pipeline;
  } });
  Rt(nd, td, { __proto__: null, enumerable: true, get: function get2() {
    return qo.finished;
  } });
  le.Stream = le;
  le._isUint8Array = function(e) {
    return e instanceof Uint8Array;
  };
  le._uint8ArrayToBuffer = function(e) {
    return cm.from(e.buffer, e.byteOffset, e.byteLength);
  };
});
var jt = M(function(rB, ue) {
  _();
  v();
  m();
  var he = No(), gm = Uo(), ym = he.Readable.destroy;
  ue.exports = he.Readable;
  ue.exports._uint8ArrayToBuffer = he._uint8ArrayToBuffer;
  ue.exports._isUint8Array = he._isUint8Array;
  ue.exports.isDisturbed = he.isDisturbed;
  ue.exports.isErrored = he.isErrored;
  ue.exports.isReadable = he.isReadable;
  ue.exports.Readable = he.Readable;
  ue.exports.Writable = he.Writable;
  ue.exports.Duplex = he.Duplex;
  ue.exports.Transform = he.Transform;
  ue.exports.PassThrough = he.PassThrough;
  ue.exports.addAbortSignal = he.addAbortSignal;
  ue.exports.finished = he.finished;
  ue.exports.destroy = he.destroy;
  ue.exports.destroy = ym;
  ue.exports.pipeline = he.pipeline;
  ue.exports.compose = he.compose;
  Object.defineProperty(he, "promises", { configurable: true, enumerable: true, get: function get2() {
    return gm;
  } });
  ue.exports.Stream = he.Stream;
  ue.exports.default = ue.exports;
});
var od = M(function(hB, Fo) {
  _();
  v();
  m();
  typeof Object.create == "function" ? Fo.exports = function(e, r) {
    r && (e.super_ = r, e.prototype = Object.create(r.prototype, { constructor: { value: e, enumerable: false, writable: true, configurable: true } }));
  } : Fo.exports = function(e, r) {
    if (r) {
      e.super_ = r;
      var i = function i2() {
      };
      i.prototype = r.prototype, e.prototype = new i(), e.prototype.constructor = e;
    }
  };
});
var ud = M(function(EB, ld) {
  _();
  v();
  m();
  var _ref29 = (be(), X(me)), ze = _ref29.Buffer, ad = Symbol.for("BufferList");
  function ee(t) {
    if (!(this instanceof ee))
      return new ee(t);
    ee._init.call(this, t);
  }
  ee._init = function(e) {
    Object.defineProperty(this, ad, { value: true }), this._bufs = [], this.length = 0, e && this.append(e);
  };
  ee.prototype._new = function(e) {
    return new ee(e);
  };
  ee.prototype._offset = function(e) {
    if (e === 0)
      return [0, 0];
    var r = 0;
    for (var i = 0; i < this._bufs.length; i++) {
      var _n8 = r + this._bufs[i].length;
      if (e < _n8 || i === this._bufs.length - 1)
        return [i, e - r];
      r = _n8;
    }
  };
  ee.prototype._reverseOffset = function(t) {
    var e = t[0], r = t[1];
    for (var i = 0; i < e; i++)
      r += this._bufs[i].length;
    return r;
  };
  ee.prototype.get = function(e) {
    if (e > this.length || e < 0)
      return;
    var r = this._offset(e);
    return this._bufs[r[0]][r[1]];
  };
  ee.prototype.slice = function(e, r) {
    return typeof e == "number" && e < 0 && (e += this.length), typeof r == "number" && r < 0 && (r += this.length), this.copy(null, 0, e, r);
  };
  ee.prototype.copy = function(e, r, i, n) {
    if ((typeof i != "number" || i < 0) && (i = 0), (typeof n != "number" || n > this.length) && (n = this.length), i >= this.length || n <= 0)
      return e || ze.alloc(0);
    var o = !!e, s = this._offset(i), a = n - i, l = a, c = o && r || 0, h = s[1];
    if (i === 0 && n === this.length) {
      if (!o)
        return this._bufs.length === 1 ? this._bufs[0] : ze.concat(this._bufs, this.length);
      for (var _d2 = 0; _d2 < this._bufs.length; _d2++)
        this._bufs[_d2].copy(e, c), c += this._bufs[_d2].length;
      return e;
    }
    if (l <= this._bufs[s[0]].length - h)
      return o ? this._bufs[s[0]].copy(e, r, h, h + l) : this._bufs[s[0]].slice(h, h + l);
    o || (e = ze.allocUnsafe(a));
    for (var _d3 = s[0]; _d3 < this._bufs.length; _d3++) {
      var _g3 = this._bufs[_d3].length - h;
      if (l > _g3)
        this._bufs[_d3].copy(e, c, h), c += _g3;
      else {
        this._bufs[_d3].copy(e, c, h, h + l), c += _g3;
        break;
      }
      l -= _g3, h && (h = 0);
    }
    return e.length > c ? e.slice(0, c) : e;
  };
  ee.prototype.shallowSlice = function(e, r) {
    if (e = e || 0, r = typeof r != "number" ? this.length : r, e < 0 && (e += this.length), r < 0 && (r += this.length), e === r)
      return this._new();
    var i = this._offset(e), n = this._offset(r), o = this._bufs.slice(i[0], n[0] + 1);
    return n[1] === 0 ? o.pop() : o[o.length - 1] = o[o.length - 1].slice(0, n[1]), i[1] !== 0 && (o[0] = o[0].slice(i[1])), this._new(o);
  };
  ee.prototype.toString = function(e, r, i) {
    return this.slice(r, i).toString(e);
  };
  ee.prototype.consume = function(e) {
    if (e = Math.trunc(e), Number.isNaN(e) || e <= 0)
      return this;
    for (; this._bufs.length; )
      if (e >= this._bufs[0].length)
        e -= this._bufs[0].length, this.length -= this._bufs[0].length, this._bufs.shift();
      else {
        this._bufs[0] = this._bufs[0].slice(e), this.length -= e;
        break;
      }
    return this;
  };
  ee.prototype.duplicate = function() {
    var e = this._new();
    for (var _r11 = 0; _r11 < this._bufs.length; _r11++)
      e.append(this._bufs[_r11]);
    return e;
  };
  ee.prototype.append = function(e) {
    if (e == null)
      return this;
    if (e.buffer)
      this._appendBuffer(ze.from(e.buffer, e.byteOffset, e.byteLength));
    else if (Array.isArray(e))
      for (var _r12 = 0; _r12 < e.length; _r12++)
        this.append(e[_r12]);
    else if (this._isBufferList(e))
      for (var _r13 = 0; _r13 < e._bufs.length; _r13++)
        this.append(e._bufs[_r13]);
    else
      typeof e == "number" && (e = e.toString()), this._appendBuffer(ze.from(e));
    return this;
  };
  ee.prototype._appendBuffer = function(e) {
    this._bufs.push(e), this.length += e.length;
  };
  ee.prototype.indexOf = function(t, e, r) {
    if (r === void 0 && typeof e == "string" && (r = e, e = void 0), typeof t == "function" || Array.isArray(t))
      throw new TypeError('The "value" argument must be one of type string, Buffer, BufferList, or Uint8Array.');
    if (typeof t == "number" ? t = ze.from([t]) : typeof t == "string" ? t = ze.from(t, r) : this._isBufferList(t) ? t = t.slice() : Array.isArray(t.buffer) ? t = ze.from(t.buffer, t.byteOffset, t.byteLength) : ze.isBuffer(t) || (t = ze.from(t)), e = Number(e || 0), isNaN(e) && (e = 0), e < 0 && (e = this.length + e), e < 0 && (e = 0), t.length === 0)
      return e > this.length ? this.length : e;
    var i = this._offset(e), n = i[0], o = i[1];
    for (; n < this._bufs.length; n++) {
      var _s4 = this._bufs[n];
      for (; o < _s4.length; )
        if (_s4.length - o >= t.length) {
          var _l10 = _s4.indexOf(t, o);
          if (_l10 !== -1)
            return this._reverseOffset([n, _l10]);
          o = _s4.length - t.length + 1;
        } else {
          var _l11 = this._reverseOffset([n, o]);
          if (this._match(_l11, t))
            return _l11;
          o++;
        }
      o = 0;
    }
    return -1;
  };
  ee.prototype._match = function(t, e) {
    if (this.length - t < e.length)
      return false;
    for (var _r14 = 0; _r14 < e.length; _r14++)
      if (this.get(t + _r14) !== e[_r14])
        return false;
    return true;
  };
  (function() {
    var t = { readDoubleBE: 8, readDoubleLE: 8, readFloatBE: 4, readFloatLE: 4, readBigInt64BE: 8, readBigInt64LE: 8, readBigUInt64BE: 8, readBigUInt64LE: 8, readInt32BE: 4, readInt32LE: 4, readUInt32BE: 4, readUInt32LE: 4, readInt16BE: 2, readInt16LE: 2, readUInt16BE: 2, readUInt16LE: 2, readInt8: 1, readUInt8: 1, readIntBE: null, readIntLE: null, readUIntBE: null, readUIntLE: null };
    for (var e in t)
      (function(r) {
        t[r] === null ? ee.prototype[r] = function(i, n) {
          return this.slice(i, i + n)[r](0, n);
        } : ee.prototype[r] = function() {
          var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          return this.slice(i, i + t[r])[r](0);
        };
      })(e);
  })();
  ee.prototype._isBufferList = function(e) {
    return e instanceof ee || ee.isBufferList(e);
  };
  ee.isBufferList = function(e) {
    return e != null && e[ad];
  };
  ld.exports = ee;
});
var fd = M(function(OB, Rn) {
  _();
  v();
  m();
  var Wo = jt().Duplex, bm = od(), Ei = ud();
  function Se(t) {
    if (!(this instanceof Se))
      return new Se(t);
    if (typeof t == "function") {
      this._callback = t;
      var e = (function(i) {
        this._callback && (this._callback(i), this._callback = null);
      }).bind(this);
      this.on("pipe", function(i) {
        i.on("error", e);
      }), this.on("unpipe", function(i) {
        i.removeListener("error", e);
      }), t = null;
    }
    Ei._init.call(this, t), Wo.call(this);
  }
  bm(Se, Wo);
  Object.assign(Se.prototype, Ei.prototype);
  Se.prototype._new = function(e) {
    return new Se(e);
  };
  Se.prototype._write = function(e, r, i) {
    this._appendBuffer(e), typeof i == "function" && i();
  };
  Se.prototype._read = function(e) {
    if (!this.length)
      return this.push(null);
    e = Math.min(e, this.length), this.push(this.slice(0, e)), this.consume(e);
  };
  Se.prototype.end = function(e) {
    Wo.prototype.end.call(this, e), this._callback && (this._callback(null, this.slice()), this._callback = null);
  };
  Se.prototype._destroy = function(e, r) {
    this._bufs.length = 0, this.length = 0, r(e);
  };
  Se.prototype._isBufferList = function(e) {
    return e instanceof Se || e instanceof Ei || Se.isBufferList(e);
  };
  Se.isBufferList = Ei.isBufferList;
  Rn.exports = Se;
  Rn.exports.BufferListStream = Se;
  Rn.exports.BufferList = Ei;
});
var hd = M(function(WB, cd) {
  _();
  v();
  m();
  var $o = /* @__PURE__ */ _createClass(function $o2() {
    _classCallCheck(this, $o2);
    this.cmd = null, this.retain = false, this.qos = 0, this.dup = false, this.length = -1, this.topic = null, this.payload = null;
  });
  cd.exports = $o;
});
var Ho = M(function(XB, dd) {
  _();
  v();
  m();
  var L = dd.exports, _ref30 = (be(), X(me)), ke = _ref30.Buffer;
  L.types = { 0: "reserved", 1: "connect", 2: "connack", 3: "publish", 4: "puback", 5: "pubrec", 6: "pubrel", 7: "pubcomp", 8: "subscribe", 9: "suback", 10: "unsubscribe", 11: "unsuback", 12: "pingreq", 13: "pingresp", 14: "disconnect", 15: "auth" };
  L.requiredHeaderFlags = { 1: 0, 2: 0, 4: 0, 5: 0, 6: 2, 7: 0, 8: 2, 9: 0, 10: 2, 11: 0, 12: 0, 13: 0, 14: 0, 15: 0 };
  L.requiredHeaderFlagsErrors = {};
  for (var t in L.requiredHeaderFlags) {
    var e = L.requiredHeaderFlags[t];
    L.requiredHeaderFlagsErrors[t] = "Invalid header flag bits, must be 0x" + e.toString(16) + " for " + L.types[t] + " packet";
  }
  L.codes = {};
  for (var _t3 in L.types) {
    var _e22 = L.types[_t3];
    L.codes[_e22] = _t3;
  }
  L.CMD_SHIFT = 4;
  L.CMD_MASK = 240;
  L.DUP_MASK = 8;
  L.QOS_MASK = 3;
  L.QOS_SHIFT = 1;
  L.RETAIN_MASK = 1;
  L.VARBYTEINT_MASK = 127;
  L.VARBYTEINT_FIN_MASK = 128;
  L.VARBYTEINT_MAX = 268435455;
  L.SESSIONPRESENT_MASK = 1;
  L.SESSIONPRESENT_HEADER = ke.from([L.SESSIONPRESENT_MASK]);
  L.CONNACK_HEADER = ke.from([L.codes.connack << L.CMD_SHIFT]);
  L.USERNAME_MASK = 128;
  L.PASSWORD_MASK = 64;
  L.WILL_RETAIN_MASK = 32;
  L.WILL_QOS_MASK = 24;
  L.WILL_QOS_SHIFT = 3;
  L.WILL_FLAG_MASK = 4;
  L.CLEAN_SESSION_MASK = 2;
  L.CONNECT_HEADER = ke.from([L.codes.connect << L.CMD_SHIFT]);
  L.properties = { sessionExpiryInterval: 17, willDelayInterval: 24, receiveMaximum: 33, maximumPacketSize: 39, topicAliasMaximum: 34, requestResponseInformation: 25, requestProblemInformation: 23, userProperties: 38, authenticationMethod: 21, authenticationData: 22, payloadFormatIndicator: 1, messageExpiryInterval: 2, contentType: 3, responseTopic: 8, correlationData: 9, maximumQoS: 36, retainAvailable: 37, assignedClientIdentifier: 18, reasonString: 31, wildcardSubscriptionAvailable: 40, subscriptionIdentifiersAvailable: 41, sharedSubscriptionAvailable: 42, serverKeepAlive: 19, responseInformation: 26, serverReference: 28, topicAlias: 35, subscriptionIdentifier: 11 };
  L.propertiesCodes = {};
  for (var _t4 in L.properties) {
    var _e3 = L.properties[_t4];
    L.propertiesCodes[_e3] = _t4;
  }
  L.propertiesTypes = { sessionExpiryInterval: "int32", willDelayInterval: "int32", receiveMaximum: "int16", maximumPacketSize: "int32", topicAliasMaximum: "int16", requestResponseInformation: "byte", requestProblemInformation: "byte", userProperties: "pair", authenticationMethod: "string", authenticationData: "binary", payloadFormatIndicator: "byte", messageExpiryInterval: "int32", contentType: "string", responseTopic: "string", correlationData: "binary", maximumQoS: "int8", retainAvailable: "byte", assignedClientIdentifier: "string", reasonString: "string", wildcardSubscriptionAvailable: "byte", subscriptionIdentifiersAvailable: "byte", sharedSubscriptionAvailable: "byte", serverKeepAlive: "int16", responseInformation: "string", serverReference: "string", topicAlias: "int16", subscriptionIdentifier: "var" };
  function Ft(t2) {
    return [0, 1, 2].map(function(e2) {
      return [0, 1].map(function(r) {
        return [0, 1].map(function(i) {
          var n = ke.alloc(1);
          return n.writeUInt8(L.codes[t2] << L.CMD_SHIFT | (r ? L.DUP_MASK : 0) | e2 << L.QOS_SHIFT | i, 0, true), n;
        });
      });
    });
  }
  L.PUBLISH_HEADER = Ft("publish");
  L.SUBSCRIBE_HEADER = Ft("subscribe");
  L.SUBSCRIBE_OPTIONS_QOS_MASK = 3;
  L.SUBSCRIBE_OPTIONS_NL_MASK = 1;
  L.SUBSCRIBE_OPTIONS_NL_SHIFT = 2;
  L.SUBSCRIBE_OPTIONS_RAP_MASK = 1;
  L.SUBSCRIBE_OPTIONS_RAP_SHIFT = 3;
  L.SUBSCRIBE_OPTIONS_RH_MASK = 3;
  L.SUBSCRIBE_OPTIONS_RH_SHIFT = 4;
  L.SUBSCRIBE_OPTIONS_RH = [0, 16, 32];
  L.SUBSCRIBE_OPTIONS_NL = 4;
  L.SUBSCRIBE_OPTIONS_RAP = 8;
  L.SUBSCRIBE_OPTIONS_QOS = [0, 1, 2];
  L.UNSUBSCRIBE_HEADER = Ft("unsubscribe");
  L.ACKS = { unsuback: Ft("unsuback"), puback: Ft("puback"), pubcomp: Ft("pubcomp"), pubrel: Ft("pubrel"), pubrec: Ft("pubrec") };
  L.SUBACK_HEADER = ke.from([L.codes.suback << L.CMD_SHIFT]);
  L.VERSION3 = ke.from([3]);
  L.VERSION4 = ke.from([4]);
  L.VERSION5 = ke.from([5]);
  L.VERSION131 = ke.from([131]);
  L.VERSION132 = ke.from([132]);
  L.QOS = [0, 1, 2].map(function(t2) {
    return ke.from([t2]);
  });
  L.EMPTY = { pingreq: ke.from([L.codes.pingreq << 4, 0]), pingresp: ke.from([L.codes.pingresp << 4, 0]), disconnect: ke.from([L.codes.disconnect << 4, 0]) };
  L.MQTT5_PUBACK_PUBREC_CODES = { 0: "Success", 16: "No matching subscribers", 128: "Unspecified error", 131: "Implementation specific error", 135: "Not authorized", 144: "Topic Name invalid", 145: "Packet identifier in use", 151: "Quota exceeded", 153: "Payload format invalid" };
  L.MQTT5_PUBREL_PUBCOMP_CODES = { 0: "Success", 146: "Packet Identifier not found" };
  L.MQTT5_SUBACK_CODES = { 0: "Granted QoS 0", 1: "Granted QoS 1", 2: "Granted QoS 2", 128: "Unspecified error", 131: "Implementation specific error", 135: "Not authorized", 143: "Topic Filter invalid", 145: "Packet Identifier in use", 151: "Quota exceeded", 158: "Shared Subscriptions not supported", 161: "Subscription Identifiers not supported", 162: "Wildcard Subscriptions not supported" };
  L.MQTT5_UNSUBACK_CODES = { 0: "Success", 17: "No subscription existed", 128: "Unspecified error", 131: "Implementation specific error", 135: "Not authorized", 143: "Topic Filter invalid", 145: "Packet Identifier in use" };
  L.MQTT5_DISCONNECT_CODES = { 0: "Normal disconnection", 4: "Disconnect with Will Message", 128: "Unspecified error", 129: "Malformed Packet", 130: "Protocol Error", 131: "Implementation specific error", 135: "Not authorized", 137: "Server busy", 139: "Server shutting down", 141: "Keep Alive timeout", 142: "Session taken over", 143: "Topic Filter invalid", 144: "Topic Name invalid", 147: "Receive Maximum exceeded", 148: "Topic Alias invalid", 149: "Packet too large", 150: "Message rate too high", 151: "Quota exceeded", 152: "Administrative action", 153: "Payload format invalid", 154: "Retain not supported", 155: "QoS not supported", 156: "Use another server", 157: "Server moved", 158: "Shared Subscriptions not supported", 159: "Connection rate exceeded", 160: "Maximum connect time", 161: "Subscription Identifiers not supported", 162: "Wildcard Subscriptions not supported" };
  L.MQTT5_AUTH_CODES = { 0: "Success", 24: "Continue authentication", 25: "Re-authenticate" };
});
var gd = M(function(lP, pd) {
  _();
  v();
  m();
  var Kr = 1e3, Gr = Kr * 60, Qr = Gr * 60, br = Qr * 24, wm = br * 7, _m = br * 365.25;
  pd.exports = function(t, e) {
    e = e || {};
    var r = _typeof(t);
    if (r === "string" && t.length > 0)
      return mm(t);
    if (r === "number" && isFinite(t))
      return e.long ? Em(t) : vm(t);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
  };
  function mm(t) {
    if (t = String(t), !(t.length > 100)) {
      var e = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(t);
      if (e) {
        var r = parseFloat(e[1]), i = (e[2] || "ms").toLowerCase();
        switch (i) {
          case "years":
          case "year":
          case "yrs":
          case "yr":
          case "y":
            return r * _m;
          case "weeks":
          case "week":
          case "w":
            return r * wm;
          case "days":
          case "day":
          case "d":
            return r * br;
          case "hours":
          case "hour":
          case "hrs":
          case "hr":
          case "h":
            return r * Qr;
          case "minutes":
          case "minute":
          case "mins":
          case "min":
          case "m":
            return r * Gr;
          case "seconds":
          case "second":
          case "secs":
          case "sec":
          case "s":
            return r * Kr;
          case "milliseconds":
          case "millisecond":
          case "msecs":
          case "msec":
          case "ms":
            return r;
          default:
            return;
        }
      }
    }
  }
  function vm(t) {
    var e = Math.abs(t);
    return e >= br ? Math.round(t / br) + "d" : e >= Qr ? Math.round(t / Qr) + "h" : e >= Gr ? Math.round(t / Gr) + "m" : e >= Kr ? Math.round(t / Kr) + "s" : t + "ms";
  }
  function Em(t) {
    var e = Math.abs(t);
    return e >= br ? Cn(t, e, br, "day") : e >= Qr ? Cn(t, e, Qr, "hour") : e >= Gr ? Cn(t, e, Gr, "minute") : e >= Kr ? Cn(t, e, Kr, "second") : t + " ms";
  }
  function Cn(t, e, r, i) {
    var n = e >= r * 1.5;
    return Math.round(t / r) + " " + i + (n ? "s" : "");
  }
});
var bd = M(function(wP, yd) {
  _();
  v();
  m();
  function Sm(t) {
    r.debug = r, r.default = r, r.coerce = l, r.disable = o, r.enable = n, r.enabled = s, r.humanize = gd(), r.destroy = c, Object.keys(t).forEach(function(h) {
      r[h] = t[h];
    }), r.names = [], r.skips = [], r.formatters = {};
    function e(h) {
      var d = 0;
      for (var _g4 = 0; _g4 < h.length; _g4++)
        d = (d << 5) - d + h.charCodeAt(_g4), d |= 0;
      return r.colors[Math.abs(d) % r.colors.length];
    }
    r.selectColor = e;
    function r(h) {
      var d, g = null, y, w;
      function S() {
        for (var _len18 = arguments.length, E = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
          E[_key18] = arguments[_key18];
        }
        if (!S.enabled)
          return;
        var I = S, C = Number(/* @__PURE__ */ new Date()), R = C - (d || C);
        I.diff = R, I.prev = d, I.curr = C, d = C, E[0] = r.coerce(E[0]), typeof E[0] != "string" && E.unshift("%O");
        var U = 0;
        E[0] = E[0].replace(/%([a-zA-Z%])/g, function(W, K) {
          if (W === "%%")
            return "%";
          U++;
          var z = r.formatters[K];
          if (typeof z == "function") {
            var Q = E[U];
            W = z.call(I, Q), E.splice(U, 1), U--;
          }
          return W;
        }), r.formatArgs.call(I, E), (I.log || r.log).apply(I, E);
      }
      return S.namespace = h, S.useColors = r.useColors(), S.color = r.selectColor(h), S.extend = i, S.destroy = r.destroy, Object.defineProperty(S, "enabled", { enumerable: true, configurable: false, get: function get2() {
        return g !== null ? g : (y !== r.namespaces && (y = r.namespaces, w = r.enabled(h)), w);
      }, set: function set(E) {
        g = E;
      } }), typeof r.init == "function" && r.init(S), S;
    }
    function i(h, d) {
      var g = r(this.namespace + (_typeof(d) > "u" ? ":" : d) + h);
      return g.log = this.log, g;
    }
    function n(h) {
      r.save(h), r.namespaces = h, r.names = [], r.skips = [];
      var d, g = (typeof h == "string" ? h : "").split(/[\s,]+/), y = g.length;
      for (d = 0; d < y; d++)
        g[d] && (h = g[d].replace(/\*/g, ".*?"), h[0] === "-" ? r.skips.push(new RegExp("^" + h.slice(1) + "$")) : r.names.push(new RegExp("^" + h + "$")));
    }
    function o() {
      var h = [].concat(_toConsumableArray(r.names.map(a)), _toConsumableArray(r.skips.map(a).map(function(d) {
        return "-" + d;
      }))).join(",");
      return r.enable(""), h;
    }
    function s(h) {
      if (h[h.length - 1] === "*")
        return true;
      var d, g;
      for (d = 0, g = r.skips.length; d < g; d++)
        if (r.skips[d].test(h))
          return false;
      for (d = 0, g = r.names.length; d < g; d++)
        if (r.names[d].test(h))
          return true;
      return false;
    }
    function a(h) {
      return h.toString().substring(2, h.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    function l(h) {
      return h instanceof Error ? h.stack || h.message : h;
    }
    function c() {
      console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    return r.enable(r.load()), r;
  }
  yd.exports = Sm;
});
var ot = M(function(xe, Bn) {
  _();
  v();
  m();
  xe.formatArgs = Im;
  xe.save = Tm;
  xe.load = Rm;
  xe.useColors = Am;
  xe.storage = Cm();
  xe.destroy = function() {
    var t = false;
    return function() {
      t || (t = true, console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));
    };
  }();
  xe.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"];
  function Am() {
    return (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && window.process && (window.process.type === "renderer" || window.process.__nwjs) ? true : (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/) ? false : (typeof document === "undefined" ? "undefined" : _typeof(document)) < "u" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" && window.console && (window.console.firebug || window.console.exception && window.console.table) || (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  function Im(t) {
    if (t[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + t[0] + (this.useColors ? "%c " : " ") + "+" + Bn.exports.humanize(this.diff), !this.useColors)
      return;
    var e = "color: " + this.color;
    t.splice(1, 0, e, "color: inherit");
    var r = 0, i = 0;
    t[0].replace(/%[a-zA-Z%]/g, function(n) {
      n !== "%%" && (r++, n === "%c" && (i = r));
    }), t.splice(i, 0, e);
  }
  xe.log = console.debug || console.log || function() {
  };
  function Tm(t) {
    try {
      t ? xe.storage.setItem("debug", t) : xe.storage.removeItem("debug");
    } catch (_unused10) {
    }
  }
  function Rm() {
    var t;
    try {
      t = xe.storage.getItem("debug");
    } catch (_unused11) {
    }
    return !t && _typeof(B) < "u" && "env" in B && (t = B.env.DEBUG), t;
  }
  function Cm() {
    try {
      return localStorage;
    } catch (_unused12) {
    }
  }
  Bn.exports = bd()(xe);
  var Bm = Bn.exports.formatters;
  Bm.j = function(t) {
    try {
      return JSON.stringify(t);
    } catch (e) {
      return "[UnexpectedJSONParseError]: " + e.message;
    }
  };
});
var md = M(function(NP, _d) {
  _();
  v();
  m();
  var Pm = fd(), _ref31 = (sr(), X(nr)), km = _ref31.EventEmitter, wd = hd(), V = Ho(), D = ot()("mqtt-packet:parser"), Vo = /* @__PURE__ */ function(_km) {
    function t() {
      var _this11;
      _classCallCheck(this, t);
      _this11 = _callSuper(this, t), _this11.parser = _this11.constructor.parser;
      return _this11;
    }
    _inherits(t, _km);
    return _createClass(t, [{ key: "_resetState", value: function _resetState() {
      D("_resetState: resetting packet, error, _list, and _stateCounter"), this.packet = new wd(), this.error = null, this._list = Pm(), this._stateCounter = 0;
    } }, { key: "parse", value: function parse2(e) {
      for (this.error && this._resetState(), this._list.append(e), D("parse: current state: %s", this._states[this._stateCounter]); (this.packet.length !== -1 || this._list.length > 0) && this[this._states[this._stateCounter]]() && !this.error; )
        this._stateCounter++, D("parse: state complete. _stateCounter is now: %d", this._stateCounter), D("parse: packet.length: %d, buffer list length: %d", this.packet.length, this._list.length), this._stateCounter >= this._states.length && (this._stateCounter = 0);
      return D("parse: exited while loop. packet: %d, buffer list length: %d", this.packet.length, this._list.length), this._list.length;
    } }, { key: "_parseHeader", value: function _parseHeader() {
      var e = this._list.readUInt8(0), r = e >> V.CMD_SHIFT;
      this.packet.cmd = V.types[r];
      var i = e & 15, n = V.requiredHeaderFlags[r];
      return n != null && i !== n ? this._emitError(new Error(V.requiredHeaderFlagsErrors[r])) : (this.packet.retain = (e & V.RETAIN_MASK) !== 0, this.packet.qos = e >> V.QOS_SHIFT & V.QOS_MASK, this.packet.qos > 2 ? this._emitError(new Error("Packet must not have both QoS bits set to 1")) : (this.packet.dup = (e & V.DUP_MASK) !== 0, D("_parseHeader: packet: %o", this.packet), this._list.consume(1), true));
    } }, { key: "_parseLength", value: function _parseLength() {
      var e = this._parseVarByteNum(true);
      return e && (this.packet.length = e.value, this._list.consume(e.bytes)), D("_parseLength %d", e.value), !!e;
    } }, { key: "_parsePayload", value: function _parsePayload() {
      D("_parsePayload: payload %O", this._list);
      var e = false;
      if (this.packet.length === 0 || this._list.length >= this.packet.length) {
        switch (this._pos = 0, this.packet.cmd) {
          case "connect":
            this._parseConnect();
            break;
          case "connack":
            this._parseConnack();
            break;
          case "publish":
            this._parsePublish();
            break;
          case "puback":
          case "pubrec":
          case "pubrel":
          case "pubcomp":
            this._parseConfirmation();
            break;
          case "subscribe":
            this._parseSubscribe();
            break;
          case "suback":
            this._parseSuback();
            break;
          case "unsubscribe":
            this._parseUnsubscribe();
            break;
          case "unsuback":
            this._parseUnsuback();
            break;
          case "pingreq":
          case "pingresp":
            break;
          case "disconnect":
            this._parseDisconnect();
            break;
          case "auth":
            this._parseAuth();
            break;
          default:
            this._emitError(new Error("Not supported"));
        }
        e = true;
      }
      return D("_parsePayload complete result: %s", e), e;
    } }, { key: "_parseConnect", value: function _parseConnect() {
      D("_parseConnect");
      var e, r, i, n, o = {}, s = this.packet, a = this._parseString();
      if (a === null)
        return this._emitError(new Error("Cannot parse protocolId"));
      if (a !== "MQTT" && a !== "MQIsdp")
        return this._emitError(new Error("Invalid protocolId"));
      if (s.protocolId = a, this._pos >= this._list.length)
        return this._emitError(new Error("Packet too short"));
      if (s.protocolVersion = this._list.readUInt8(this._pos), s.protocolVersion >= 128 && (s.bridgeMode = true, s.protocolVersion = s.protocolVersion - 128), s.protocolVersion !== 3 && s.protocolVersion !== 4 && s.protocolVersion !== 5)
        return this._emitError(new Error("Invalid protocol version"));
      if (this._pos++, this._pos >= this._list.length)
        return this._emitError(new Error("Packet too short"));
      if (this._list.readUInt8(this._pos) & 1)
        return this._emitError(new Error("Connect flag bit 0 must be 0, but got 1"));
      o.username = this._list.readUInt8(this._pos) & V.USERNAME_MASK, o.password = this._list.readUInt8(this._pos) & V.PASSWORD_MASK, o.will = this._list.readUInt8(this._pos) & V.WILL_FLAG_MASK;
      var l = !!(this._list.readUInt8(this._pos) & V.WILL_RETAIN_MASK), c = (this._list.readUInt8(this._pos) & V.WILL_QOS_MASK) >> V.WILL_QOS_SHIFT;
      if (o.will)
        s.will = {}, s.will.retain = l, s.will.qos = c;
      else {
        if (l)
          return this._emitError(new Error("Will Retain Flag must be set to zero when Will Flag is set to 0"));
        if (c)
          return this._emitError(new Error("Will QoS must be set to zero when Will Flag is set to 0"));
      }
      if (s.clean = (this._list.readUInt8(this._pos) & V.CLEAN_SESSION_MASK) !== 0, this._pos++, s.keepalive = this._parseNum(), s.keepalive === -1)
        return this._emitError(new Error("Packet too short"));
      if (s.protocolVersion === 5) {
        var _d4 = this._parseProperties();
        Object.getOwnPropertyNames(_d4).length && (s.properties = _d4);
      }
      var h = this._parseString();
      if (h === null)
        return this._emitError(new Error("Packet too short"));
      if (s.clientId = h, D("_parseConnect: packet.clientId: %s", s.clientId), o.will) {
        if (s.protocolVersion === 5) {
          var _d5 = this._parseProperties();
          Object.getOwnPropertyNames(_d5).length && (s.will.properties = _d5);
        }
        if (e = this._parseString(), e === null)
          return this._emitError(new Error("Cannot parse will topic"));
        if (s.will.topic = e, D("_parseConnect: packet.will.topic: %s", s.will.topic), r = this._parseBuffer(), r === null)
          return this._emitError(new Error("Cannot parse will payload"));
        s.will.payload = r, D("_parseConnect: packet.will.paylaod: %s", s.will.payload);
      }
      if (o.username) {
        if (n = this._parseString(), n === null)
          return this._emitError(new Error("Cannot parse username"));
        s.username = n, D("_parseConnect: packet.username: %s", s.username);
      }
      if (o.password) {
        if (i = this._parseBuffer(), i === null)
          return this._emitError(new Error("Cannot parse password"));
        s.password = i;
      }
      return this.settings = s, D("_parseConnect: complete"), s;
    } }, { key: "_parseConnack", value: function _parseConnack() {
      D("_parseConnack");
      var e = this.packet;
      if (this._list.length < 1)
        return null;
      var r = this._list.readUInt8(this._pos++);
      if (r > 1)
        return this._emitError(new Error("Invalid connack flags, bits 7-1 must be set to 0"));
      if (e.sessionPresent = !!(r & V.SESSIONPRESENT_MASK), this.settings.protocolVersion === 5)
        this._list.length >= 2 ? e.reasonCode = this._list.readUInt8(this._pos++) : e.reasonCode = 0;
      else {
        if (this._list.length < 2)
          return null;
        e.returnCode = this._list.readUInt8(this._pos++);
      }
      if (e.returnCode === -1 || e.reasonCode === -1)
        return this._emitError(new Error("Cannot parse return code"));
      if (this.settings.protocolVersion === 5) {
        var i = this._parseProperties();
        Object.getOwnPropertyNames(i).length && (e.properties = i);
      }
      D("_parseConnack: complete");
    } }, { key: "_parsePublish", value: function _parsePublish() {
      D("_parsePublish");
      var e = this.packet;
      if (e.topic = this._parseString(), e.topic === null)
        return this._emitError(new Error("Cannot parse topic"));
      if (!(e.qos > 0 && !this._parseMessageId())) {
        if (this.settings.protocolVersion === 5) {
          var _r15 = this._parseProperties();
          Object.getOwnPropertyNames(_r15).length && (e.properties = _r15);
        }
        e.payload = this._list.slice(this._pos, e.length), D("_parsePublish: payload from buffer list: %o", e.payload);
      }
    } }, { key: "_parseSubscribe", value: function _parseSubscribe() {
      D("_parseSubscribe");
      var e = this.packet, r, i, n, o, s, a, l;
      if (e.subscriptions = [], !!this._parseMessageId()) {
        if (this.settings.protocolVersion === 5) {
          var _c6 = this._parseProperties();
          Object.getOwnPropertyNames(_c6).length && (e.properties = _c6);
        }
        if (e.length <= 0)
          return this._emitError(new Error("Malformed subscribe, no payload specified"));
        for (; this._pos < e.length; ) {
          if (r = this._parseString(), r === null)
            return this._emitError(new Error("Cannot parse topic"));
          if (this._pos >= e.length)
            return this._emitError(new Error("Malformed Subscribe Payload"));
          if (i = this._parseByte(), this.settings.protocolVersion === 5) {
            if (i & 192)
              return this._emitError(new Error("Invalid subscribe topic flag bits, bits 7-6 must be 0"));
          } else if (i & 252)
            return this._emitError(new Error("Invalid subscribe topic flag bits, bits 7-2 must be 0"));
          if (n = i & V.SUBSCRIBE_OPTIONS_QOS_MASK, n > 2)
            return this._emitError(new Error("Invalid subscribe QoS, must be <= 2"));
          if (a = (i >> V.SUBSCRIBE_OPTIONS_NL_SHIFT & V.SUBSCRIBE_OPTIONS_NL_MASK) !== 0, s = (i >> V.SUBSCRIBE_OPTIONS_RAP_SHIFT & V.SUBSCRIBE_OPTIONS_RAP_MASK) !== 0, o = i >> V.SUBSCRIBE_OPTIONS_RH_SHIFT & V.SUBSCRIBE_OPTIONS_RH_MASK, o > 2)
            return this._emitError(new Error("Invalid retain handling, must be <= 2"));
          l = { topic: r, qos: n }, this.settings.protocolVersion === 5 ? (l.nl = a, l.rap = s, l.rh = o) : this.settings.bridgeMode && (l.rh = 0, l.rap = true, l.nl = true), D("_parseSubscribe: push subscription `%s` to subscription", l), e.subscriptions.push(l);
        }
      }
    } }, { key: "_parseSuback", value: function _parseSuback() {
      D("_parseSuback");
      var e = this.packet;
      if (this.packet.granted = [], !!this._parseMessageId()) {
        if (this.settings.protocolVersion === 5) {
          var _r16 = this._parseProperties();
          Object.getOwnPropertyNames(_r16).length && (e.properties = _r16);
        }
        if (e.length <= 0)
          return this._emitError(new Error("Malformed suback, no payload specified"));
        for (; this._pos < this.packet.length; ) {
          var _r17 = this._list.readUInt8(this._pos++);
          if (this.settings.protocolVersion === 5) {
            if (!V.MQTT5_SUBACK_CODES[_r17])
              return this._emitError(new Error("Invalid suback code"));
          } else if (_r17 > 2 && _r17 !== 128)
            return this._emitError(new Error("Invalid suback QoS, must be 0, 1, 2 or 128"));
          this.packet.granted.push(_r17);
        }
      }
    } }, { key: "_parseUnsubscribe", value: function _parseUnsubscribe() {
      D("_parseUnsubscribe");
      var e = this.packet;
      if (e.unsubscriptions = [], !!this._parseMessageId()) {
        if (this.settings.protocolVersion === 5) {
          var _r18 = this._parseProperties();
          Object.getOwnPropertyNames(_r18).length && (e.properties = _r18);
        }
        if (e.length <= 0)
          return this._emitError(new Error("Malformed unsubscribe, no payload specified"));
        for (; this._pos < e.length; ) {
          var _r19 = this._parseString();
          if (_r19 === null)
            return this._emitError(new Error("Cannot parse topic"));
          D("_parseUnsubscribe: push topic `%s` to unsubscriptions", _r19), e.unsubscriptions.push(_r19);
        }
      }
    } }, { key: "_parseUnsuback", value: function _parseUnsuback() {
      D("_parseUnsuback");
      var e = this.packet;
      if (!this._parseMessageId())
        return this._emitError(new Error("Cannot parse messageId"));
      if ((this.settings.protocolVersion === 3 || this.settings.protocolVersion === 4) && e.length !== 2)
        return this._emitError(new Error("Malformed unsuback, payload length must be 2"));
      if (e.length <= 0)
        return this._emitError(new Error("Malformed unsuback, no payload specified"));
      if (this.settings.protocolVersion === 5) {
        var _r20 = this._parseProperties();
        for (Object.getOwnPropertyNames(_r20).length && (e.properties = _r20), e.granted = []; this._pos < this.packet.length; ) {
          var i = this._list.readUInt8(this._pos++);
          if (!V.MQTT5_UNSUBACK_CODES[i])
            return this._emitError(new Error("Invalid unsuback code"));
          this.packet.granted.push(i);
        }
      }
    } }, { key: "_parseConfirmation", value: function _parseConfirmation() {
      D("_parseConfirmation: packet.cmd: `%s`", this.packet.cmd);
      var e = this.packet;
      if (this._parseMessageId(), this.settings.protocolVersion === 5) {
        if (e.length > 2) {
          switch (e.reasonCode = this._parseByte(), this.packet.cmd) {
            case "puback":
            case "pubrec":
              if (!V.MQTT5_PUBACK_PUBREC_CODES[e.reasonCode])
                return this._emitError(new Error("Invalid " + this.packet.cmd + " reason code"));
              break;
            case "pubrel":
            case "pubcomp":
              if (!V.MQTT5_PUBREL_PUBCOMP_CODES[e.reasonCode])
                return this._emitError(new Error("Invalid " + this.packet.cmd + " reason code"));
              break;
          }
          D("_parseConfirmation: packet.reasonCode `%d`", e.reasonCode);
        } else
          e.reasonCode = 0;
        if (e.length > 3) {
          var _r21 = this._parseProperties();
          Object.getOwnPropertyNames(_r21).length && (e.properties = _r21);
        }
      }
      return true;
    } }, { key: "_parseDisconnect", value: function _parseDisconnect() {
      var e = this.packet;
      if (D("_parseDisconnect"), this.settings.protocolVersion === 5) {
        this._list.length > 0 ? (e.reasonCode = this._parseByte(), V.MQTT5_DISCONNECT_CODES[e.reasonCode] || this._emitError(new Error("Invalid disconnect reason code"))) : e.reasonCode = 0;
        var _r22 = this._parseProperties();
        Object.getOwnPropertyNames(_r22).length && (e.properties = _r22);
      }
      return D("_parseDisconnect result: true"), true;
    } }, { key: "_parseAuth", value: function _parseAuth() {
      D("_parseAuth");
      var e = this.packet;
      if (this.settings.protocolVersion !== 5)
        return this._emitError(new Error("Not supported auth packet for this version MQTT"));
      if (e.reasonCode = this._parseByte(), !V.MQTT5_AUTH_CODES[e.reasonCode])
        return this._emitError(new Error("Invalid auth reason code"));
      var r = this._parseProperties();
      return Object.getOwnPropertyNames(r).length && (e.properties = r), D("_parseAuth: result: true"), true;
    } }, { key: "_parseMessageId", value: function _parseMessageId() {
      var e = this.packet;
      return e.messageId = this._parseNum(), e.messageId === null ? (this._emitError(new Error("Cannot parse messageId")), false) : (D("_parseMessageId: packet.messageId %d", e.messageId), true);
    } }, { key: "_parseString", value: function _parseString(e) {
      var r = this._parseNum(), i = r + this._pos;
      if (r === -1 || i > this._list.length || i > this.packet.length)
        return null;
      var n = this._list.toString("utf8", this._pos, i);
      return this._pos += r, D("_parseString: result: %s", n), n;
    } }, { key: "_parseStringPair", value: function _parseStringPair() {
      return D("_parseStringPair"), { name: this._parseString(), value: this._parseString() };
    } }, { key: "_parseBuffer", value: function _parseBuffer() {
      var e = this._parseNum(), r = e + this._pos;
      if (e === -1 || r > this._list.length || r > this.packet.length)
        return null;
      var i = this._list.slice(this._pos, r);
      return this._pos += e, D("_parseBuffer: result: %o", i), i;
    } }, { key: "_parseNum", value: function _parseNum() {
      if (this._list.length - this._pos < 2)
        return -1;
      var e = this._list.readUInt16BE(this._pos);
      return this._pos += 2, D("_parseNum: result: %s", e), e;
    } }, { key: "_parse4ByteNum", value: function _parse4ByteNum() {
      if (this._list.length - this._pos < 4)
        return -1;
      var e = this._list.readUInt32BE(this._pos);
      return this._pos += 4, D("_parse4ByteNum: result: %s", e), e;
    } }, { key: "_parseVarByteNum", value: function _parseVarByteNum(e) {
      D("_parseVarByteNum");
      var r = 4, i = 0, n = 1, o = 0, s = false, a, l = this._pos ? this._pos : 0;
      for (; i < r && l + i < this._list.length; ) {
        if (a = this._list.readUInt8(l + i++), o += n * (a & V.VARBYTEINT_MASK), n *= 128, !(a & V.VARBYTEINT_FIN_MASK)) {
          s = true;
          break;
        }
        if (this._list.length <= i)
          break;
      }
      return !s && i === r && this._list.length >= i && this._emitError(new Error("Invalid variable byte integer")), l && (this._pos += i), s ? e ? s = { bytes: i, value: o } : s = o : s = false, D("_parseVarByteNum: result: %o", s), s;
    } }, { key: "_parseByte", value: function _parseByte() {
      var e;
      return this._pos < this._list.length && (e = this._list.readUInt8(this._pos), this._pos++), D("_parseByte: result: %o", e), e;
    } }, { key: "_parseByType", value: function _parseByType(e) {
      switch (D("_parseByType: type: %s", e), e) {
        case "byte":
          return this._parseByte() !== 0;
        case "int8":
          return this._parseByte();
        case "int16":
          return this._parseNum();
        case "int32":
          return this._parse4ByteNum();
        case "var":
          return this._parseVarByteNum();
        case "string":
          return this._parseString();
        case "pair":
          return this._parseStringPair();
        case "binary":
          return this._parseBuffer();
      }
    } }, { key: "_parseProperties", value: function _parseProperties() {
      D("_parseProperties");
      var e = this._parseVarByteNum(), i = this._pos + e, n = {};
      for (; this._pos < i; ) {
        var _o6 = this._parseByte();
        if (!_o6)
          return this._emitError(new Error("Cannot parse property code type")), false;
        var _s5 = V.propertiesCodes[_o6];
        if (!_s5)
          return this._emitError(new Error("Unknown property")), false;
        if (_s5 === "userProperties") {
          n[_s5] || (n[_s5] = /* @__PURE__ */ Object.create(null));
          var _a4 = this._parseByType(V.propertiesTypes[_s5]);
          if (n[_s5][_a4.name]) {
            if (Array.isArray(n[_s5][_a4.name]))
              n[_s5][_a4.name].push(_a4.value);
            else {
              var _l12 = n[_s5][_a4.name];
              n[_s5][_a4.name] = [_l12], n[_s5][_a4.name].push(_a4.value);
            }
          } else
            n[_s5][_a4.name] = _a4.value;
          continue;
        }
        n[_s5] ? Array.isArray(n[_s5]) ? n[_s5].push(this._parseByType(V.propertiesTypes[_s5])) : (n[_s5] = [n[_s5]], n[_s5].push(this._parseByType(V.propertiesTypes[_s5]))) : n[_s5] = this._parseByType(V.propertiesTypes[_s5]);
      }
      return n;
    } }, { key: "_newPacket", value: function _newPacket() {
      return D("_newPacket"), this.packet && (this._list.consume(this.packet.length), D("_newPacket: parser emit packet: packet.cmd: %s, packet.payload: %s, packet.length: %d", this.packet.cmd, this.packet.payload, this.packet.length), this.emit("packet", this.packet)), D("_newPacket: new packet"), this.packet = new wd(), this._pos = 0, true;
    } }, { key: "_emitError", value: function _emitError(e) {
      D("_emitError", e), this.error = e, this.emit("error", e);
    } }], [{ key: "parser", value: function parser(e) {
      return this instanceof t ? (this.settings = e || {}, this._states = ["_parseHeader", "_parseLength", "_parsePayload", "_newPacket"], this._resetState(), this) : new t().parser(e);
    } }]);
  }(km);
  _d.exports = Vo;
});
var Ad = M(function(KP, Sd) {
  _();
  v();
  m();
  var _ref32 = (be(), X(me)), Si = _ref32.Buffer, Om = 65536, vd = {}, xm = Si.isBuffer(Si.from([1, 2]).subarray(0, 1));
  function Ed(t) {
    var e = Si.allocUnsafe(2);
    return e.writeUInt8(t >> 8, 0), e.writeUInt8(t & 255, 0 + 1), e;
  }
  function Mm() {
    for (var t = 0; t < Om; t++)
      vd[t] = Ed(t);
  }
  function Lm(t) {
    var r = 0, i = 0, n = Si.allocUnsafe(4);
    do
      r = t % 128 | 0, t = t / 128 | 0, t > 0 && (r = r | 128), n.writeUInt8(r, i++);
    while (t > 0 && i < 4);
    return t > 0 && (i = 0), xm ? n.subarray(0, i) : n.slice(0, i);
  }
  function Um(t) {
    var e = Si.allocUnsafe(4);
    return e.writeUInt32BE(t, 0), e;
  }
  Sd.exports = { cache: vd, generateCache: Mm, generateNumber: Ed, genBufVariableByteInt: Lm, generate4ByteBuffer: Um };
});
var Id = M(function(ik, zo) {
  _();
  v();
  m();
  _typeof(B) > "u" || !B.version || B.version.indexOf("v0.") === 0 || B.version.indexOf("v1.") === 0 && B.version.indexOf("v1.8.") !== 0 ? zo.exports = { nextTick: Nm } : zo.exports = B;
  function Nm(t, e, r, i) {
    if (typeof t != "function")
      throw new TypeError('"callback" argument must be a function');
    var n = arguments.length, o, s;
    switch (n) {
      case 0:
      case 1:
        return B.nextTick(t);
      case 2:
        return B.nextTick(function() {
          t.call(null, e);
        });
      case 3:
        return B.nextTick(function() {
          t.call(null, e, r);
        });
      case 4:
        return B.nextTick(function() {
          t.call(null, e, r, i);
        });
      default:
        for (o = new Array(n - 1), s = 0; s < o.length; )
          o[s++] = arguments[s];
        return B.nextTick(function() {
          t.apply(null, o);
        });
    }
  }
});
var Qo = M(function(dk, xd) {
  _();
  v();
  m();
  var j = Ho(), _ref33 = (be(), X(me)), q = _ref33.Buffer, qm = q.allocUnsafe(0), Dm = q.from([0]), Ai = Ad(), jm = Id().nextTick, qe = ot()("mqtt-packet:writeToStream"), Pn = Ai.cache, Fm = Ai.generateNumber, Wm = Ai.generateCache, Ko = Ai.genBufVariableByteInt, $m = Ai.generate4ByteBuffer, Te = Go, kn = true;
  function kd(t, e, r) {
    switch (qe("generate called"), e.cork && (e.cork(), jm(Hm, e)), kn && (kn = false, Wm()), qe("generate: packet.cmd: %s", t.cmd), t.cmd) {
      case "connect":
        return Vm(t, e);
      case "connack":
        return zm(t, e, r);
      case "publish":
        return Km(t, e, r);
      case "puback":
      case "pubrec":
      case "pubrel":
      case "pubcomp":
        return Gm(t, e, r);
      case "subscribe":
        return Qm(t, e, r);
      case "suback":
        return Ym(t, e, r);
      case "unsubscribe":
        return Jm(t, e, r);
      case "unsuback":
        return Xm(t, e, r);
      case "pingreq":
      case "pingresp":
        return Zm(t, e);
      case "disconnect":
        return e1(t, e, r);
      case "auth":
        return t1(t, e, r);
      default:
        return e.destroy(new Error("Unknown command")), false;
    }
  }
  Object.defineProperty(kd, "cacheNumbers", { get: function get2() {
    return Te === Go;
  }, set: function set(t) {
    t ? ((!Pn || Object.keys(Pn).length === 0) && (kn = true), Te = Go) : (kn = false, Te = r1);
  } });
  function Hm(t) {
    t.uncork();
  }
  function Vm(t, e, r) {
    var i = t || {}, n = i.protocolId || "MQTT", o = i.protocolVersion || 4, s = i.will, a = i.clean, l = i.keepalive || 0, c = i.clientId || "", h = i.username, d = i.password, g = i.properties;
    a === void 0 && (a = true);
    var y = 0;
    if (!n || typeof n != "string" && !q.isBuffer(n))
      return e.destroy(new Error("Invalid protocolId")), false;
    if (y += n.length + 2, o !== 3 && o !== 4 && o !== 5)
      return e.destroy(new Error("Invalid protocol version")), false;
    if (y += 1, (typeof c == "string" || q.isBuffer(c)) && (c || o >= 4) && (c || a))
      y += q.byteLength(c) + 2;
    else {
      if (o < 4)
        return e.destroy(new Error("clientId must be supplied before 3.1.1")), false;
      if (a * 1 === 0)
        return e.destroy(new Error("clientId must be given if cleanSession set to 0")), false;
    }
    if (typeof l != "number" || l < 0 || l > 65535 || l % 1 !== 0)
      return e.destroy(new Error("Invalid keepalive")), false;
    y += 2, y += 1;
    var w, S;
    if (o === 5) {
      if (w = Wt(e, g), !w)
        return false;
      y += w.length;
    }
    if (s) {
      if (_typeof(s) != "object")
        return e.destroy(new Error("Invalid will")), false;
      if (!s.topic || typeof s.topic != "string")
        return e.destroy(new Error("Invalid will topic")), false;
      if (y += q.byteLength(s.topic) + 2, y += 2, s.payload)
        if (s.payload.length >= 0)
          typeof s.payload == "string" ? y += q.byteLength(s.payload) : y += s.payload.length;
        else
          return e.destroy(new Error("Invalid will payload")), false;
      if (S = {}, o === 5) {
        if (S = Wt(e, s.properties), !S)
          return false;
        y += S.length;
      }
    }
    var E = false;
    if (h != null)
      if (Pd(h))
        E = true, y += q.byteLength(h) + 2;
      else
        return e.destroy(new Error("Invalid username")), false;
    if (d != null) {
      if (!E)
        return e.destroy(new Error("Username is required to use password")), false;
      if (Pd(d))
        y += Od(d) + 2;
      else
        return e.destroy(new Error("Invalid password")), false;
    }
    e.write(j.CONNECT_HEADER), De(e, y), Yr(e, n), i.bridgeMode && (o += 128), e.write(o === 131 ? j.VERSION131 : o === 132 ? j.VERSION132 : o === 4 ? j.VERSION4 : o === 5 ? j.VERSION5 : j.VERSION3);
    var I = 0;
    return I |= h != null ? j.USERNAME_MASK : 0, I |= d != null ? j.PASSWORD_MASK : 0, I |= s && s.retain ? j.WILL_RETAIN_MASK : 0, I |= s && s.qos ? s.qos << j.WILL_QOS_SHIFT : 0, I |= s ? j.WILL_FLAG_MASK : 0, I |= a ? j.CLEAN_SESSION_MASK : 0, e.write(q.from([I])), Te(e, l), o === 5 && w.write(), Yr(e, c), s && (o === 5 && S.write(), wr(e, s.topic), Yr(e, s.payload)), h != null && Yr(e, h), d != null && Yr(e, d), true;
  }
  function zm(t, e, r) {
    var _l13;
    var i = r ? r.protocolVersion : 4, n = t || {}, o = i === 5 ? n.reasonCode : n.returnCode, s = n.properties, a = 2;
    if (typeof o != "number")
      return e.destroy(new Error("Invalid return code")), false;
    var l = null;
    if (i === 5) {
      if (l = Wt(e, s), !l)
        return false;
      a += l.length;
    }
    return e.write(j.CONNACK_HEADER), De(e, a), e.write(n.sessionPresent ? j.SESSIONPRESENT_HEADER : Dm), e.write(q.from([o])), (_l13 = l) !== null && _l13 !== void 0 && _l13.write(), true;
  }
  function Km(t, e, r) {
    var _g5;
    qe("publish: packet: %o", t);
    var i = r ? r.protocolVersion : 4, n = t || {}, o = n.qos || 0, s = n.retain ? j.RETAIN_MASK : 0, a = n.topic, l = n.payload || qm, c = n.messageId, h = n.properties, d = 0;
    if (typeof a == "string")
      d += q.byteLength(a) + 2;
    else if (q.isBuffer(a))
      d += a.length + 2;
    else
      return e.destroy(new Error("Invalid topic")), false;
    if (q.isBuffer(l) ? d += l.length : d += q.byteLength(l), o && typeof c != "number")
      return e.destroy(new Error("Invalid messageId")), false;
    o && (d += 2);
    var g = null;
    if (i === 5) {
      if (g = Wt(e, h), !g)
        return false;
      d += g.length;
    }
    return e.write(j.PUBLISH_HEADER[o][n.dup ? 1 : 0][s ? 1 : 0]), De(e, d), Te(e, Od(a)), e.write(a), o > 0 && Te(e, c), (_g5 = g) !== null && _g5 !== void 0 && _g5.write(), qe("publish: payload: %o", l), e.write(l);
  }
  function Gm(t, e, r) {
    var i = r ? r.protocolVersion : 4, n = t || {}, o = n.cmd || "puback", s = n.messageId, a = n.dup && o === "pubrel" ? j.DUP_MASK : 0, l = 0, c = n.reasonCode, h = n.properties, d = i === 5 ? 3 : 2;
    if (o === "pubrel" && (l = 1), typeof s != "number")
      return e.destroy(new Error("Invalid messageId")), false;
    var g = null;
    if (i === 5 && _typeof(h) == "object") {
      if (g = Ii(e, h, r, d), !g)
        return false;
      d += g.length;
    }
    return e.write(j.ACKS[o][l][a][0]), d === 3 && (d += c !== 0 ? 1 : -1), De(e, d), Te(e, s), i === 5 && d !== 2 && e.write(q.from([c])), g !== null ? g.write() : d === 4 && e.write(q.from([0])), true;
  }
  function Qm(t, e, r) {
    qe("subscribe: packet: ");
    var i = r ? r.protocolVersion : 4, n = t || {}, o = n.dup ? j.DUP_MASK : 0, s = n.messageId, a = n.subscriptions, l = n.properties, c = 0;
    if (typeof s != "number")
      return e.destroy(new Error("Invalid messageId")), false;
    c += 2;
    var h = null;
    if (i === 5) {
      if (h = Wt(e, l), !h)
        return false;
      c += h.length;
    }
    if (_typeof(a) == "object" && a.length)
      for (var _g6 = 0; _g6 < a.length; _g6 += 1) {
        var _y6 = a[_g6].topic, _w2 = a[_g6].qos;
        if (typeof _y6 != "string")
          return e.destroy(new Error("Invalid subscriptions - invalid topic")), false;
        if (typeof _w2 != "number")
          return e.destroy(new Error("Invalid subscriptions - invalid qos")), false;
        if (i === 5) {
          if (typeof (a[_g6].nl || false) != "boolean")
            return e.destroy(new Error("Invalid subscriptions - invalid No Local")), false;
          if (typeof (a[_g6].rap || false) != "boolean")
            return e.destroy(new Error("Invalid subscriptions - invalid Retain as Published")), false;
          var I = a[_g6].rh || 0;
          if (typeof I != "number" || I > 2)
            return e.destroy(new Error("Invalid subscriptions - invalid Retain Handling")), false;
        }
        c += q.byteLength(_y6) + 2 + 1;
      }
    else
      return e.destroy(new Error("Invalid subscriptions")), false;
    qe("subscribe: writing to stream: %o", j.SUBSCRIBE_HEADER), e.write(j.SUBSCRIBE_HEADER[1][o ? 1 : 0][0]), De(e, c), Te(e, s), h !== null && h.write();
    var d = true;
    var _iterator18 = _createForOfIteratorHelper(a), _step18;
    try {
      for (_iterator18.s(); !(_step18 = _iterator18.n()).done; ) {
        var _g7 = _step18.value;
        var _y7 = _g7.topic, _w3 = _g7.qos, _S5 = +_g7.nl, _E6 = +_g7.rap, _I2 = _g7.rh, C = void 0;
        wr(e, _y7), C = j.SUBSCRIBE_OPTIONS_QOS[_w3], i === 5 && (C |= _S5 ? j.SUBSCRIBE_OPTIONS_NL : 0, C |= _E6 ? j.SUBSCRIBE_OPTIONS_RAP : 0, C |= _I2 ? j.SUBSCRIBE_OPTIONS_RH[_I2] : 0), d = e.write(q.from([C]));
      }
    } catch (err) {
      _iterator18.e(err);
    } finally {
      _iterator18.f();
    }
    return d;
  }
  function Ym(t, e, r) {
    var i = r ? r.protocolVersion : 4, n = t || {}, o = n.messageId, s = n.granted, a = n.properties, l = 0;
    if (typeof o != "number")
      return e.destroy(new Error("Invalid messageId")), false;
    if (l += 2, _typeof(s) == "object" && s.length)
      for (var _h2 = 0; _h2 < s.length; _h2 += 1) {
        if (typeof s[_h2] != "number")
          return e.destroy(new Error("Invalid qos vector")), false;
        l += 1;
      }
    else
      return e.destroy(new Error("Invalid qos vector")), false;
    var c = null;
    if (i === 5) {
      if (c = Ii(e, a, r, l), !c)
        return false;
      l += c.length;
    }
    return e.write(j.SUBACK_HEADER), De(e, l), Te(e, o), c !== null && c.write(), e.write(q.from(s));
  }
  function Jm(t, e, r) {
    var i = r ? r.protocolVersion : 4, n = t || {}, o = n.messageId, s = n.dup ? j.DUP_MASK : 0, a = n.unsubscriptions, l = n.properties, c = 0;
    if (typeof o != "number")
      return e.destroy(new Error("Invalid messageId")), false;
    if (c += 2, _typeof(a) == "object" && a.length)
      for (var _g8 = 0; _g8 < a.length; _g8 += 1) {
        if (typeof a[_g8] != "string")
          return e.destroy(new Error("Invalid unsubscriptions")), false;
        c += q.byteLength(a[_g8]) + 2;
      }
    else
      return e.destroy(new Error("Invalid unsubscriptions")), false;
    var h = null;
    if (i === 5) {
      if (h = Wt(e, l), !h)
        return false;
      c += h.length;
    }
    e.write(j.UNSUBSCRIBE_HEADER[1][s ? 1 : 0][0]), De(e, c), Te(e, o), h !== null && h.write();
    var d = true;
    for (var _g9 = 0; _g9 < a.length; _g9++)
      d = wr(e, a[_g9]);
    return d;
  }
  function Xm(t, e, r) {
    var i = r ? r.protocolVersion : 4, n = t || {}, o = n.messageId, s = n.dup ? j.DUP_MASK : 0, a = n.granted, l = n.properties, c = n.cmd, h = 0, d = 2;
    if (typeof o != "number")
      return e.destroy(new Error("Invalid messageId")), false;
    if (i === 5)
      if (_typeof(a) == "object" && a.length)
        for (var _y8 = 0; _y8 < a.length; _y8 += 1) {
          if (typeof a[_y8] != "number")
            return e.destroy(new Error("Invalid qos vector")), false;
          d += 1;
        }
      else
        return e.destroy(new Error("Invalid qos vector")), false;
    var g = null;
    if (i === 5) {
      if (g = Ii(e, l, r, d), !g)
        return false;
      d += g.length;
    }
    return e.write(j.ACKS[c][h][s][0]), De(e, d), Te(e, o), g !== null && g.write(), i === 5 && e.write(q.from(a)), true;
  }
  function Zm(t, e, r) {
    return e.write(j.EMPTY[t.cmd]);
  }
  function e1(t, e, r) {
    var i = r ? r.protocolVersion : 4, n = t || {}, o = n.reasonCode, s = n.properties, a = i === 5 ? 1 : 0, l = null;
    if (i === 5) {
      if (l = Ii(e, s, r, a), !l)
        return false;
      a += l.length;
    }
    return e.write(q.from([j.codes.disconnect << 4])), De(e, a), i === 5 && e.write(q.from([o])), l !== null && l.write(), true;
  }
  function t1(t, e, r) {
    var i = r ? r.protocolVersion : 4, n = t || {}, o = n.reasonCode, s = n.properties, a = i === 5 ? 1 : 0;
    i !== 5 && e.destroy(new Error("Invalid mqtt version for auth packet"));
    var l = Ii(e, s, r, a);
    return l ? (a += l.length, e.write(q.from([j.codes.auth << 4])), De(e, a), e.write(q.from([o])), l !== null && l.write(), true) : false;
  }
  var Td = {};
  function De(t, e) {
    if (e > j.VARBYTEINT_MAX)
      return t.destroy(new Error("Invalid variable byte integer: ".concat(e))), false;
    var r = Td[e];
    return r || (r = Ko(e), e < 16384 && (Td[e] = r)), qe("writeVarByteInt: writing to stream: %o", r), t.write(r);
  }
  function wr(t, e) {
    var r = q.byteLength(e);
    return Te(t, r), qe("writeString: %s", e), t.write(e, "utf8");
  }
  function Rd(t, e, r) {
    wr(t, e), wr(t, r);
  }
  function Go(t, e) {
    return qe("writeNumberCached: number: %d", e), qe("writeNumberCached: %o", Pn[e]), t.write(Pn[e]);
  }
  function r1(t, e) {
    var r = Fm(e);
    return qe("writeNumberGenerated: %o", r), t.write(r);
  }
  function i1(t, e) {
    var r = $m(e);
    return qe("write4ByteNumber: %o", r), t.write(r);
  }
  function Yr(t, e) {
    typeof e == "string" ? wr(t, e) : e ? (Te(t, e.length), t.write(e)) : Te(t, 0);
  }
  function Wt(t, e) {
    if (_typeof(e) != "object" || e.length != null)
      return { length: 1, write: function write3() {
        Bd(t, {}, 0);
      } };
    var r = 0;
    function i(o, s) {
      var a = j.propertiesTypes[o], l = 0;
      switch (a) {
        case "byte": {
          if (typeof s != "boolean")
            return t.destroy(new Error("Invalid ".concat(o, ": ").concat(s))), false;
          l += 1 + 1;
          break;
        }
        case "int8": {
          if (typeof s != "number" || s < 0 || s > 255)
            return t.destroy(new Error("Invalid ".concat(o, ": ").concat(s))), false;
          l += 1 + 1;
          break;
        }
        case "binary": {
          if (s && s === null)
            return t.destroy(new Error("Invalid ".concat(o, ": ").concat(s))), false;
          l += 1 + q.byteLength(s) + 2;
          break;
        }
        case "int16": {
          if (typeof s != "number" || s < 0 || s > 65535)
            return t.destroy(new Error("Invalid ".concat(o, ": ").concat(s))), false;
          l += 1 + 2;
          break;
        }
        case "int32": {
          if (typeof s != "number" || s < 0 || s > 4294967295)
            return t.destroy(new Error("Invalid ".concat(o, ": ").concat(s))), false;
          l += 1 + 4;
          break;
        }
        case "var": {
          if (typeof s != "number" || s < 0 || s > 268435455)
            return t.destroy(new Error("Invalid ".concat(o, ": ").concat(s))), false;
          l += 1 + q.byteLength(Ko(s));
          break;
        }
        case "string": {
          if (typeof s != "string")
            return t.destroy(new Error("Invalid ".concat(o, ": ").concat(s))), false;
          l += 1 + 2 + q.byteLength(s.toString());
          break;
        }
        case "pair": {
          if (_typeof(s) != "object")
            return t.destroy(new Error("Invalid ".concat(o, ": ").concat(s))), false;
          l += Object.getOwnPropertyNames(s).reduce(function(c, h) {
            var d = s[h];
            return Array.isArray(d) ? c += d.reduce(function(g, y) {
              return g += 1 + 2 + q.byteLength(h.toString()) + 2 + q.byteLength(y.toString()), g;
            }, 0) : c += 1 + 2 + q.byteLength(h.toString()) + 2 + q.byteLength(s[h].toString()), c;
          }, 0);
          break;
        }
        default:
          return t.destroy(new Error("Invalid property ".concat(o, ": ").concat(s))), false;
      }
      return l;
    }
    if (e)
      for (var _o7 in e) {
        var _s6 = 0, _a5 = 0, _l14 = e[_o7];
        if (Array.isArray(_l14))
          for (var _c7 = 0; _c7 < _l14.length; _c7++) {
            if (_a5 = i(_o7, _l14[_c7]), !_a5)
              return false;
            _s6 += _a5;
          }
        else {
          if (_a5 = i(_o7, _l14), !_a5)
            return false;
          _s6 = _a5;
        }
        if (!_s6)
          return false;
        r += _s6;
      }
    return { length: q.byteLength(Ko(r)) + r, write: function write3() {
      Bd(t, e, r);
    } };
  }
  function Ii(t, e, r, i) {
    var n = ["reasonString", "userProperties"], o = r && r.properties && r.properties.maximumPacketSize ? r.properties.maximumPacketSize : 0, s = Wt(t, e);
    if (o)
      for (; i + s.length > o; ) {
        var _a6 = n.shift();
        if (_a6 && e[_a6])
          delete e[_a6], s = Wt(t, e);
        else
          return false;
      }
    return s;
  }
  function Cd(t, e, r) {
    switch (j.propertiesTypes[e]) {
      case "byte": {
        t.write(q.from([j.properties[e]])), t.write(q.from([+r]));
        break;
      }
      case "int8": {
        t.write(q.from([j.properties[e]])), t.write(q.from([r]));
        break;
      }
      case "binary": {
        t.write(q.from([j.properties[e]])), Yr(t, r);
        break;
      }
      case "int16": {
        t.write(q.from([j.properties[e]])), Te(t, r);
        break;
      }
      case "int32": {
        t.write(q.from([j.properties[e]])), i1(t, r);
        break;
      }
      case "var": {
        t.write(q.from([j.properties[e]])), De(t, r);
        break;
      }
      case "string": {
        t.write(q.from([j.properties[e]])), wr(t, r);
        break;
      }
      case "pair": {
        Object.getOwnPropertyNames(r).forEach(function(n) {
          var o = r[n];
          Array.isArray(o) ? o.forEach(function(s) {
            t.write(q.from([j.properties[e]])), Rd(t, n.toString(), s.toString());
          }) : (t.write(q.from([j.properties[e]])), Rd(t, n.toString(), o.toString()));
        });
        break;
      }
      default:
        return t.destroy(new Error("Invalid property ".concat(e, " value: ").concat(r))), false;
    }
  }
  function Bd(t, e, r) {
    De(t, r);
    for (var i in e)
      if (Object.prototype.hasOwnProperty.call(e, i) && e[i] !== null) {
        var _n9 = e[i];
        if (Array.isArray(_n9))
          for (var _o8 = 0; _o8 < _n9.length; _o8++)
            Cd(t, i, _n9[_o8]);
        else
          Cd(t, i, _n9);
      }
  }
  function Od(t) {
    return t ? t instanceof q ? t.length : q.byteLength(t) : 0;
  }
  function Pd(t) {
    return typeof t == "string" || t instanceof q;
  }
  xd.exports = kd;
});
var Ud = M(function(Sk, Ld) {
  _();
  v();
  m();
  var n1 = Qo(), _ref34 = (sr(), X(nr)), s1 = _ref34.EventEmitter, _ref35 = (be(), X(me)), Md = _ref35.Buffer;
  function o1(t, e) {
    var r = new Yo();
    return n1(t, r, e), r.concat();
  }
  var Yo = /* @__PURE__ */ function(_s7) {
    function Yo2() {
      var _this12;
      _classCallCheck(this, Yo2);
      _this12 = _callSuper(this, Yo2), _this12._array = new Array(20), _this12._i = 0;
      return _this12;
    }
    _inherits(Yo2, _s7);
    return _createClass(Yo2, [{ key: "write", value: function write3(e) {
      return this._array[this._i++] = e, true;
    } }, { key: "concat", value: function concat() {
      var e = 0, r = new Array(this._array.length), i = this._array, n = 0, o;
      for (o = 0; o < i.length && i[o] !== void 0; o++)
        typeof i[o] != "string" ? r[o] = i[o].length : r[o] = Md.byteLength(i[o]), e += r[o];
      var s = Md.allocUnsafe(e);
      for (o = 0; o < i.length && i[o] !== void 0; o++)
        typeof i[o] != "string" ? (i[o].copy(s, n), n += r[o]) : (s.write(i[o], n), n += r[o]);
      return s;
    } }, { key: "destroy", value: function destroy(e) {
      e && this.emit("error", e);
    } }]);
  }(s1);
  Ld.exports = o1;
});
var Nd = M(function(On) {
  _();
  v();
  m();
  On.parser = md().parser;
  On.generate = Ud();
  On.writeToStream = Qo();
});
var Zo = M(function(Xo) {
  _();
  v();
  m();
  Object.defineProperty(Xo, "__esModule", { value: true });
  var Jo = /* @__PURE__ */ function() {
    function Jo2() {
      _classCallCheck(this, Jo2);
      this.nextId = Math.max(1, Math.floor(Math.random() * 65535));
    }
    return _createClass(Jo2, [{ key: "allocate", value: function allocate() {
      var e = this.nextId++;
      return this.nextId === 65536 && (this.nextId = 1), e;
    } }, { key: "getLastAllocated", value: function getLastAllocated() {
      return this.nextId === 1 ? 65535 : this.nextId - 1;
    } }, { key: "register", value: function register(e) {
      return true;
    } }, { key: "deallocate", value: function deallocate(e) {
    } }, { key: "clear", value: function clear() {
    } }]);
  }();
  Xo.default = Jo;
});
var Dd = M(function(Zk, qd) {
  _();
  v();
  m();
  qd.exports = a1;
  function Jr(t) {
    return t instanceof x ? x.from(t) : new t.constructor(t.buffer.slice(), t.byteOffset, t.length);
  }
  function a1(t) {
    if (t = t || {}, t.circles)
      return l1(t);
    return t.proto ? i : r;
    function e(n, o) {
      for (var s = Object.keys(n), a = new Array(s.length), l = 0; l < s.length; l++) {
        var c = s[l], h = n[c];
        _typeof(h) != "object" || h === null ? a[c] = h : h instanceof Date ? a[c] = new Date(h) : ArrayBuffer.isView(h) ? a[c] = Jr(h) : a[c] = o(h);
      }
      return a;
    }
    function r(n) {
      if (_typeof(n) != "object" || n === null)
        return n;
      if (n instanceof Date)
        return new Date(n);
      if (Array.isArray(n))
        return e(n, r);
      if (n instanceof Map)
        return new Map(e(Array.from(n), r));
      if (n instanceof Set)
        return new Set(e(Array.from(n), r));
      var o = {};
      for (var s in n)
        if (Object.hasOwnProperty.call(n, s) !== false) {
          var a = n[s];
          _typeof(a) != "object" || a === null ? o[s] = a : a instanceof Date ? o[s] = new Date(a) : a instanceof Map ? o[s] = new Map(e(Array.from(a), r)) : a instanceof Set ? o[s] = new Set(e(Array.from(a), r)) : ArrayBuffer.isView(a) ? o[s] = Jr(a) : o[s] = r(a);
        }
      return o;
    }
    function i(n) {
      if (_typeof(n) != "object" || n === null)
        return n;
      if (n instanceof Date)
        return new Date(n);
      if (Array.isArray(n))
        return e(n, i);
      if (n instanceof Map)
        return new Map(e(Array.from(n), i));
      if (n instanceof Set)
        return new Set(e(Array.from(n), i));
      var o = {};
      for (var s in n) {
        var a = n[s];
        _typeof(a) != "object" || a === null ? o[s] = a : a instanceof Date ? o[s] = new Date(a) : a instanceof Map ? o[s] = new Map(e(Array.from(a), i)) : a instanceof Set ? o[s] = new Set(e(Array.from(a), i)) : ArrayBuffer.isView(a) ? o[s] = Jr(a) : o[s] = i(a);
      }
      return o;
    }
  }
  function l1(t) {
    var e = [], r = [];
    return t.proto ? o : n;
    function i(s, a) {
      for (var l = Object.keys(s), c = new Array(l.length), h = 0; h < l.length; h++) {
        var d = l[h], g = s[d];
        if (_typeof(g) != "object" || g === null)
          c[d] = g;
        else if (g instanceof Date)
          c[d] = new Date(g);
        else if (ArrayBuffer.isView(g))
          c[d] = Jr(g);
        else {
          var y = e.indexOf(g);
          y !== -1 ? c[d] = r[y] : c[d] = a(g);
        }
      }
      return c;
    }
    function n(s) {
      if (_typeof(s) != "object" || s === null)
        return s;
      if (s instanceof Date)
        return new Date(s);
      if (Array.isArray(s))
        return i(s, n);
      if (s instanceof Map)
        return new Map(i(Array.from(s), n));
      if (s instanceof Set)
        return new Set(i(Array.from(s), n));
      var a = {};
      e.push(s), r.push(a);
      for (var l in s)
        if (Object.hasOwnProperty.call(s, l) !== false) {
          var c = s[l];
          if (_typeof(c) != "object" || c === null)
            a[l] = c;
          else if (c instanceof Date)
            a[l] = new Date(c);
          else if (c instanceof Map)
            a[l] = new Map(i(Array.from(c), n));
          else if (c instanceof Set)
            a[l] = new Set(i(Array.from(c), n));
          else if (ArrayBuffer.isView(c))
            a[l] = Jr(c);
          else {
            var h = e.indexOf(c);
            h !== -1 ? a[l] = r[h] : a[l] = n(c);
          }
        }
      return e.pop(), r.pop(), a;
    }
    function o(s) {
      if (_typeof(s) != "object" || s === null)
        return s;
      if (s instanceof Date)
        return new Date(s);
      if (Array.isArray(s))
        return i(s, o);
      if (s instanceof Map)
        return new Map(i(Array.from(s), o));
      if (s instanceof Set)
        return new Set(i(Array.from(s), o));
      var a = {};
      e.push(s), r.push(a);
      for (var l in s) {
        var c = s[l];
        if (_typeof(c) != "object" || c === null)
          a[l] = c;
        else if (c instanceof Date)
          a[l] = new Date(c);
        else if (c instanceof Map)
          a[l] = new Map(i(Array.from(c), o));
        else if (c instanceof Set)
          a[l] = new Set(i(Array.from(c), o));
        else if (ArrayBuffer.isView(c))
          a[l] = Jr(c);
        else {
          var h = e.indexOf(c);
          h !== -1 ? a[l] = r[h] : a[l] = o(c);
        }
      }
      return e.pop(), r.pop(), a;
    }
  }
});
var Fd = M(function(uO, jd) {
  _();
  v();
  m();
  jd.exports = Dd()();
});
var $d = M(function(Xr) {
  _();
  v();
  m();
  Object.defineProperty(Xr, "__esModule", { value: true });
  Xr.validateTopics = Xr.validateTopic = void 0;
  function Wd(t) {
    var e = t.split("/");
    for (var _r23 = 0; _r23 < e.length; _r23++)
      if (e[_r23] !== "+") {
        if (e[_r23] === "#")
          return _r23 === e.length - 1;
        if (e[_r23].indexOf("+") !== -1 || e[_r23].indexOf("#") !== -1)
          return false;
      }
    return true;
  }
  Xr.validateTopic = Wd;
  function u1(t) {
    if (t.length === 0)
      return "empty_topic_list";
    for (var e = 0; e < t.length; e++)
      if (!Wd(t[e]))
        return t[e];
    return null;
  }
  Xr.validateTopics = u1;
});
var ra = M(function(ta) {
  _();
  v();
  m();
  Object.defineProperty(ta, "__esModule", { value: true });
  var f1 = jt(), c1 = { objectMode: true }, h1 = { clean: true }, ea = /* @__PURE__ */ function() {
    function ea2(e) {
      _classCallCheck(this, ea2);
      this.options = e || {}, this.options = Object.assign(Object.assign({}, h1), e), this._inflights = /* @__PURE__ */ new Map();
    }
    return _createClass(ea2, [{ key: "put", value: function put2(e, r) {
      return this._inflights.set(e.messageId, e), r && r(), this;
    } }, { key: "createStream", value: function createStream() {
      var e = new f1.Readable(c1), r = [], i = false, n = 0;
      return this._inflights.forEach(function(o, s) {
        r.push(o);
      }), e._read = function() {
        !i && n < r.length ? e.push(r[n++]) : e.push(null);
      }, e.destroy = function(o) {
        if (!i)
          return i = true, setTimeout(function() {
            e.emit("close");
          }, 0), e;
      }, e;
    } }, { key: "del", value: function del(e, r) {
      var i = this._inflights.get(e.messageId);
      return i ? (this._inflights.delete(e.messageId), r(null, i)) : r && r(new Error("missing packet")), this;
    } }, { key: "get", value: function get2(e, r) {
      var i = this._inflights.get(e.messageId);
      return i ? r(null, i) : r && r(new Error("missing packet")), this;
    } }, { key: "close", value: function close(e) {
      this.options.clean && (this._inflights = null), e && e();
    } }]);
  }();
  ta.default = ea;
});
var Vd = M(function(ia) {
  _();
  v();
  m();
  Object.defineProperty(ia, "__esModule", { value: true });
  var Hd = [0, 16, 128, 131, 135, 144, 145, 151, 153], d1 = function d12(t, e, r) {
    t.log("handlePublish: packet %o", e), r = _typeof(r) < "u" ? r : t.noop;
    var i = e.topic.toString(), n = e.payload, o = e.qos, s = e.messageId, a = t.options;
    if (t.options.protocolVersion === 5) {
      var _l15;
      if (e.properties && (_l15 = e.properties.topicAlias), _typeof(_l15) < "u")
        if (i.length === 0) {
          if (_l15 > 0 && _l15 <= 65535) {
            var _c8 = t.topicAliasRecv.getTopicByAlias(_l15);
            if (_c8)
              i = _c8, t.log("handlePublish :: topic complemented by alias. topic: %s - alias: %d", i, _l15);
            else {
              t.log("handlePublish :: unregistered topic alias. alias: %d", _l15), t.emit("error", new Error("Received unregistered Topic Alias"));
              return;
            }
          } else {
            t.log("handlePublish :: topic alias out of range. alias: %d", _l15), t.emit("error", new Error("Received Topic Alias is out of range"));
            return;
          }
        } else if (t.topicAliasRecv.put(i, _l15))
          t.log("handlePublish :: registered topic: %s - alias: %d", i, _l15);
        else {
          t.log("handlePublish :: topic alias out of range. alias: %d", _l15), t.emit("error", new Error("Received Topic Alias is out of range"));
          return;
        }
    }
    switch (t.log("handlePublish: qos %d", o), o) {
      case 2: {
        a.customHandleAcks(i, n, e, function(l, c) {
          if (typeof l == "number" && (c = l, l = null), l)
            return t.emit("error", l);
          if (Hd.indexOf(c) === -1)
            return t.emit("error", new Error("Wrong reason code for pubrec"));
          c ? t._sendPacket({ cmd: "pubrec", messageId: s, reasonCode: c }, r) : t.incomingStore.put(e, function() {
            t._sendPacket({ cmd: "pubrec", messageId: s }, r);
          });
        });
        break;
      }
      case 1: {
        a.customHandleAcks(i, n, e, function(l, c) {
          if (typeof l == "number" && (c = l, l = null), l)
            return t.emit("error", l);
          if (Hd.indexOf(c) === -1)
            return t.emit("error", new Error("Wrong reason code for puback"));
          c || t.emit("message", i, n, e), t.handleMessage(e, function(h) {
            if (h)
              return r && r(h);
            t._sendPacket({ cmd: "puback", messageId: s, reasonCode: c }, r);
          });
        });
        break;
      }
      case 0:
        t.emit("message", i, n, e), t.handleMessage(e, r);
        break;
      default:
        t.log("handlePublish: unknown QoS. Doing nothing.");
        break;
    }
  };
  ia.default = d1;
});
var zd = M(function(QO, p1) {
  p1.exports = { version: "5.10.3" };
});
var _r = M(function(at) {
  _();
  v();
  m();
  Object.defineProperty(at, "__esModule", { value: true });
  at.MQTTJS_VERSION = at.nextTick = at.applyMixin = at.ErrorWithReasonCode = void 0;
  var na = /* @__PURE__ */ function(_Error3) {
    function t(e, r) {
      var _this13;
      _classCallCheck(this, t);
      _this13 = _callSuper(this, t, [e]), _this13.code = r, Object.setPrototypeOf(_assertThisInitialized(_this13), t.prototype), Object.getPrototypeOf(_assertThisInitialized(_this13)).name = "ErrorWithReasonCode";
      return _this13;
    }
    _inherits(t, _Error3);
    return _createClass(t);
  }(/* @__PURE__ */ _wrapNativeSuper(Error));
  at.ErrorWithReasonCode = na;
  function g1(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var i;
    var n = [e];
    for (; ; ) {
      var _o9 = n[0], _s8 = Object.getPrototypeOf(_o9);
      if (_s8 !== null && _s8 !== void 0 && _s8.prototype)
        n.unshift(_s8);
      else
        break;
    }
    for (var _i11 = 0, _n10 = n; _i11 < _n10.length; _i11++) {
      var _o10 = _n10[_i11];
      var _iterator19 = _createForOfIteratorHelper(Object.getOwnPropertyNames(_o10.prototype)), _step19;
      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done; ) {
          var _s9 = _step19.value;
          (r || _s9 !== "constructor") && Object.defineProperty(t.prototype, _s9, (i = Object.getOwnPropertyDescriptor(_o10.prototype, _s9)) !== null && i !== void 0 ? i : /* @__PURE__ */ Object.create(null));
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }
    }
  }
  at.applyMixin = g1;
  at.nextTick = typeof (B === null || B === void 0 ? void 0 : B.nextTick) == "function" ? B.nextTick : function(t) {
    setTimeout(t, 0);
  };
  at.MQTTJS_VERSION = zd().version;
});
var Ti = M(function($t) {
  _();
  v();
  m();
  Object.defineProperty($t, "__esModule", { value: true });
  $t.ReasonCodes = void 0;
  var Kd = _r();
  $t.ReasonCodes = { 0: "", 1: "Unacceptable protocol version", 2: "Identifier rejected", 3: "Server unavailable", 4: "Bad username or password", 5: "Not authorized", 16: "No matching subscribers", 17: "No subscription existed", 128: "Unspecified error", 129: "Malformed Packet", 130: "Protocol Error", 131: "Implementation specific error", 132: "Unsupported Protocol Version", 133: "Client Identifier not valid", 134: "Bad User Name or Password", 135: "Not authorized", 136: "Server unavailable", 137: "Server busy", 138: "Banned", 139: "Server shutting down", 140: "Bad authentication method", 141: "Keep Alive timeout", 142: "Session taken over", 143: "Topic Filter invalid", 144: "Topic Name invalid", 145: "Packet identifier in use", 146: "Packet Identifier not found", 147: "Receive Maximum exceeded", 148: "Topic Alias invalid", 149: "Packet too large", 150: "Message rate too high", 151: "Quota exceeded", 152: "Administrative action", 153: "Payload format invalid", 154: "Retain not supported", 155: "QoS not supported", 156: "Use another server", 157: "Server moved", 158: "Shared Subscriptions not supported", 159: "Connection rate exceeded", 160: "Maximum connect time", 161: "Subscription Identifiers not supported", 162: "Wildcard Subscriptions not supported" };
  var y1 = function y12(t, e) {
    var r = e.messageId, i = e.cmd, n = null, o = t.outgoing[r] ? t.outgoing[r].cb : null, s = null;
    if (!o) {
      t.log("_handleAck :: Server sent an ack in error. Ignoring.");
      return;
    }
    switch (t.log("_handleAck :: packet type", i), i) {
      case "pubcomp":
      case "puback": {
        var _a7 = e.reasonCode;
        _a7 && _a7 > 0 && _a7 !== 16 ? (s = new Kd.ErrorWithReasonCode("Publish error: ".concat($t.ReasonCodes[_a7]), _a7), t._removeOutgoingAndStoreMessage(r, function() {
          o(s, e);
        })) : t._removeOutgoingAndStoreMessage(r, o);
        break;
      }
      case "pubrec": {
        n = { cmd: "pubrel", qos: 2, messageId: r };
        var _a8 = e.reasonCode;
        _a8 && _a8 > 0 && _a8 !== 16 ? (s = new Kd.ErrorWithReasonCode("Publish error: ".concat($t.ReasonCodes[_a8]), _a8), t._removeOutgoingAndStoreMessage(r, function() {
          o(s, e);
        })) : t._sendPacket(n);
        break;
      }
      case "suback": {
        delete t.outgoing[r], t.messageIdProvider.deallocate(r);
        var _a9 = e.granted;
        for (var _l16 = 0; _l16 < _a9.length; _l16++) {
          var _c9 = _a9[_l16];
          if (_c9 & 128) {
            s = new Error("Subscribe error: ".concat($t.ReasonCodes[_c9])), s.code = _c9;
            var _h3 = t.messageIdToTopic[r];
            _h3 && _h3.forEach(function(d) {
              delete t._resubscribeTopics[d];
            });
          }
        }
        delete t.messageIdToTopic[r], t._invokeStoreProcessingQueue(), o(s, e);
        break;
      }
      case "unsuback": {
        delete t.outgoing[r], t.messageIdProvider.deallocate(r), t._invokeStoreProcessingQueue(), o(null, e);
        break;
      }
      default:
        t.emit("error", new Error("unrecognized packet type"));
    }
    t.disconnecting && Object.keys(t.outgoing).length === 0 && t.emit("outgoingEmpty");
  };
  $t.default = y1;
});
var Qd = M(function(sa) {
  _();
  v();
  m();
  Object.defineProperty(sa, "__esModule", { value: true });
  var Gd = _r(), b1 = Ti(), w1 = function w12(t, e) {
    var r = t.options, i = r.protocolVersion, n = i === 5 ? e.reasonCode : e.returnCode;
    if (i !== 5) {
      var _o11 = new Gd.ErrorWithReasonCode("Protocol error: Auth packets are only supported in MQTT 5. Your version:".concat(i), n);
      t.emit("error", _o11);
      return;
    }
    t.handleAuth(e, function(o, s) {
      if (o) {
        t.emit("error", o);
        return;
      }
      if (n === 24)
        t.reconnecting = false, t._sendPacket(s);
      else {
        var _a10 = new Gd.ErrorWithReasonCode("Connection refused: ".concat(b1.ReasonCodes[n]), n);
        t.emit("error", _a10);
      }
    });
  };
  sa.default = w1;
});
var ep = M(function(Mn) {
  var _t5, _l17, _l18, _c10, _p2, _g10, _B, _i12, _y9, _n12, _r24, _e5, _u2, _h4, _a11, _s10, _b2, _o12, _E7, _S6, _w4, _2, _I3, _f3, _t6_brand, _T, _A2, _M, _d6, _R, _P2, _L;
  _();
  v();
  m();
  Object.defineProperty(Mn, "__esModule", { value: true });
  Mn.LRUCache = void 0;
  var Ri = (typeof performance === "undefined" ? "undefined" : _typeof(performance)) == "object" && performance && typeof performance.now == "function" ? performance : Date, Jd = /* @__PURE__ */ new Set(), oa = _typeof(B) == "object" && B ? B : {}, Xd = function Xd2(t2, e, r, i) {
    typeof oa.emitWarning == "function" ? oa.emitWarning(t2, e, r, i) : console.error("[".concat(r, "] ").concat(e, ": ").concat(t2));
  }, xn = globalThis.AbortController, Yd = globalThis.AbortSignal;
  if (_typeof(xn) > "u") {
    var _oa$env;
    Yd = /* @__PURE__ */ function() {
      function Yd2() {
        _classCallCheck(this, Yd2);
        _defineProperty(this, "onabort", void 0);
        _defineProperty(this, "_onabort", []);
        _defineProperty(this, "reason", void 0);
        _defineProperty(this, "aborted", false);
      }
      return _createClass(Yd2, [{ key: "addEventListener", value: function addEventListener(i, n) {
        this._onabort.push(n);
      } }]);
    }(), xn = /* @__PURE__ */ function() {
      function xn2() {
        _classCallCheck(this, xn2);
        _defineProperty(this, "signal", new Yd());
        _e4();
      }
      return _createClass(xn2, [{ key: "abort", value: function abort2(i) {
        if (!this.signal.aborted) {
          var _this$signal$onabort, _this$signal;
          this.signal.reason = i, this.signal.aborted = true;
          var _iterator20 = _createForOfIteratorHelper(this.signal._onabort), _step20;
          try {
            for (_iterator20.s(); !(_step20 = _iterator20.n()).done; ) {
              var _n11 = _step20.value;
              _n11(i);
            }
          } catch (err) {
            _iterator20.e(err);
          } finally {
            _iterator20.f();
          }
          (_this$signal$onabort = (_this$signal = this.signal).onabort) === null || _this$signal$onabort === void 0 || _this$signal$onabort.call(_this$signal, i);
        }
      } }]);
    }();
    var t = ((_oa$env = oa.env) === null || _oa$env === void 0 ? void 0 : _oa$env.LRU_CACHE_IGNORE_AC_WARNING) !== "1", _e4 = function e() {
      t && (t = false, Xd("AbortController is not defined. If using lru-cache in node 14, load an AbortController polyfill from the `node-abort-controller` package. A minimal polyfill is provided for use by LRUCache.fetch(), but it should not be relied upon in other contexts (eg, passing it to other APIs that use AbortController/AbortSignal might have undesirable effects). You may disable this with LRU_CACHE_IGNORE_AC_WARNING=1 in the env.", "NO_ABORT_CONTROLLER", "ENOTSUP", _e4));
    };
  }
  var _1 = function _12(t2) {
    return !Jd.has(t2);
  }, Ht = function Ht2(t2) {
    return t2 && t2 === Math.floor(t2) && t2 > 0 && isFinite(t2);
  }, Zd = function Zd2(t2) {
    return Ht(t2) ? t2 <= Math.pow(2, 8) ? Uint8Array : t2 <= Math.pow(2, 16) ? Uint16Array : t2 <= Math.pow(2, 32) ? Uint32Array : t2 <= Number.MAX_SAFE_INTEGER ? Zr : null : null;
  }, Zr = /* @__PURE__ */ function(_Array) {
    function Zr2(e) {
      var _this14;
      _classCallCheck(this, Zr2);
      _this14 = _callSuper(this, Zr2, [e]), _this14.fill(0);
      return _this14;
    }
    _inherits(Zr2, _Array);
    return _createClass(Zr2);
  }(/* @__PURE__ */ _wrapNativeSuper(Array)), aa = (_t5 = /* @__PURE__ */ function() {
    function t2(e, r) {
      _classCallCheck(this, t2);
      _defineProperty(this, "heap", void 0);
      _defineProperty(this, "length", void 0);
      if (!_assertClassBrand(_t5, t2, _l17)._)
        throw new TypeError("instantiate Stack using Stack.create(n)");
      this.heap = new r(e), this.length = 0;
    }
    return _createClass(t2, [{ key: "push", value: function push(e) {
      this.heap[this.length++] = e;
    } }, { key: "pop", value: function pop() {
      return this.heap[--this.length];
    } }], [{ key: "create", value: function create2(e) {
      var r = Zd(e);
      if (!r)
        return [];
      _l17._ = _assertClassBrand(_t5, t2, true);
      var i = new t2(e, r);
      return _l17._ = _assertClassBrand(_t5, t2, false), i;
    } }]);
  }(), _l17 = { _: false }, _t5), la = (_l18 = /* @__PURE__ */ new WeakMap(), _c10 = /* @__PURE__ */ new WeakMap(), _p2 = /* @__PURE__ */ new WeakMap(), _g10 = /* @__PURE__ */ new WeakMap(), _B = /* @__PURE__ */ new WeakMap(), _i12 = /* @__PURE__ */ new WeakMap(), _y9 = /* @__PURE__ */ new WeakMap(), _n12 = /* @__PURE__ */ new WeakMap(), _r24 = /* @__PURE__ */ new WeakMap(), _e5 = /* @__PURE__ */ new WeakMap(), _u2 = /* @__PURE__ */ new WeakMap(), _h4 = /* @__PURE__ */ new WeakMap(), _a11 = /* @__PURE__ */ new WeakMap(), _s10 = /* @__PURE__ */ new WeakMap(), _b2 = /* @__PURE__ */ new WeakMap(), _o12 = /* @__PURE__ */ new WeakMap(), _E7 = /* @__PURE__ */ new WeakMap(), _S6 = /* @__PURE__ */ new WeakMap(), _w4 = /* @__PURE__ */ new WeakMap(), _2 = /* @__PURE__ */ new WeakMap(), _I3 = /* @__PURE__ */ new WeakMap(), _f3 = /* @__PURE__ */ new WeakMap(), _t6_brand = /* @__PURE__ */ new WeakSet(), _T = /* @__PURE__ */ new WeakMap(), _A2 = /* @__PURE__ */ new WeakMap(), _M = /* @__PURE__ */ new WeakMap(), _d6 = /* @__PURE__ */ new WeakMap(), _R = /* @__PURE__ */ new WeakMap(), _P2 = /* @__PURE__ */ new WeakMap(), _L = /* @__PURE__ */ new WeakMap(), /* @__PURE__ */ function() {
    function t2(_e6) {
      _classCallCheck(this, t2);
      _classPrivateMethodInitSpec(this, _t6_brand);
      _classPrivateFieldInitSpec(this, _l18, void 0);
      _classPrivateFieldInitSpec(this, _c10, void 0);
      _classPrivateFieldInitSpec(this, _p2, void 0);
      _classPrivateFieldInitSpec(this, _g10, void 0);
      _classPrivateFieldInitSpec(this, _B, void 0);
      _defineProperty(this, "ttl", void 0);
      _defineProperty(this, "ttlResolution", void 0);
      _defineProperty(this, "ttlAutopurge", void 0);
      _defineProperty(this, "updateAgeOnGet", void 0);
      _defineProperty(this, "updateAgeOnHas", void 0);
      _defineProperty(this, "allowStale", void 0);
      _defineProperty(this, "noDisposeOnSet", void 0);
      _defineProperty(this, "noUpdateTTL", void 0);
      _defineProperty(this, "maxEntrySize", void 0);
      _defineProperty(this, "sizeCalculation", void 0);
      _defineProperty(this, "noDeleteOnFetchRejection", void 0);
      _defineProperty(this, "noDeleteOnStaleGet", void 0);
      _defineProperty(this, "allowStaleOnFetchAbort", void 0);
      _defineProperty(this, "allowStaleOnFetchRejection", void 0);
      _defineProperty(this, "ignoreFetchAbort", void 0);
      _classPrivateFieldInitSpec(this, _i12, void 0);
      _classPrivateFieldInitSpec(this, _y9, void 0);
      _classPrivateFieldInitSpec(this, _n12, void 0);
      _classPrivateFieldInitSpec(this, _r24, void 0);
      _classPrivateFieldInitSpec(this, _e5, void 0);
      _classPrivateFieldInitSpec(this, _u2, void 0);
      _classPrivateFieldInitSpec(this, _h4, void 0);
      _classPrivateFieldInitSpec(this, _a11, void 0);
      _classPrivateFieldInitSpec(this, _s10, void 0);
      _classPrivateFieldInitSpec(this, _b2, void 0);
      _classPrivateFieldInitSpec(this, _o12, void 0);
      _classPrivateFieldInitSpec(this, _E7, void 0);
      _classPrivateFieldInitSpec(this, _S6, void 0);
      _classPrivateFieldInitSpec(this, _w4, void 0);
      _classPrivateFieldInitSpec(this, _2, void 0);
      _classPrivateFieldInitSpec(this, _I3, void 0);
      _classPrivateFieldInitSpec(this, _f3, void 0);
      _classPrivateFieldInitSpec(this, _T, function() {
      });
      _classPrivateFieldInitSpec(this, _A2, function() {
      });
      _classPrivateFieldInitSpec(this, _M, function() {
      });
      _classPrivateFieldInitSpec(this, _d6, function() {
        return false;
      });
      _classPrivateFieldInitSpec(this, _R, function(e) {
      });
      _classPrivateFieldInitSpec(this, _P2, function(e, r, i) {
      });
      _classPrivateFieldInitSpec(this, _L, function(e, r, i, n) {
        if (i || n)
          throw new TypeError("cannot set size without setting maxSize or maxEntrySize on cache");
        return 0;
      });
      var _e6$max = _e6.max, _r25 = _e6$max === void 0 ? 0 : _e6$max, _i13 = _e6.ttl, _e6$ttlResolution = _e6.ttlResolution, _n13 = _e6$ttlResolution === void 0 ? 1 : _e6$ttlResolution, _o13 = _e6.ttlAutopurge, _s11 = _e6.updateAgeOnGet, _a12 = _e6.updateAgeOnHas, _l19 = _e6.allowStale, _c11 = _e6.dispose, _h5 = _e6.disposeAfter, _d7 = _e6.noDisposeOnSet, _g11 = _e6.noUpdateTTL, _e6$maxSize = _e6.maxSize, _y10 = _e6$maxSize === void 0 ? 0 : _e6$maxSize, _e6$maxEntrySize = _e6.maxEntrySize, _w5 = _e6$maxEntrySize === void 0 ? 0 : _e6$maxEntrySize, _S7 = _e6.sizeCalculation, _E8 = _e6.fetchMethod, _I4 = _e6.noDeleteOnFetchRejection, _C2 = _e6.noDeleteOnStaleGet, _R2 = _e6.allowStaleOnFetchRejection, _U2 = _e6.allowStaleOnFetchAbort, N = _e6.ignoreFetchAbort;
      if (_r25 !== 0 && !Ht(_r25))
        throw new TypeError("max option must be a nonnegative integer");
      var W = _r25 ? Zd(_r25) : Array;
      if (!W)
        throw new Error("invalid max value: " + _r25);
      if (_classPrivateFieldSet(_l18, this, _r25), _classPrivateFieldSet(_c10, this, _y10), this.maxEntrySize = _w5 || _classPrivateFieldGet(_c10, this), this.sizeCalculation = _S7, this.sizeCalculation) {
        if (!_classPrivateFieldGet(_c10, this) && !this.maxEntrySize)
          throw new TypeError("cannot set sizeCalculation without setting maxSize or maxEntrySize");
        if (typeof this.sizeCalculation != "function")
          throw new TypeError("sizeCalculation set to non-function");
      }
      if (_E8 !== void 0 && typeof _E8 != "function")
        throw new TypeError("fetchMethod must be a function if specified");
      if (_classPrivateFieldSet(_B, this, _E8), _classPrivateFieldSet(_I3, this, !!_E8), _classPrivateFieldSet(_n12, this, /* @__PURE__ */ new Map()), _classPrivateFieldSet(_r24, this, new Array(_r25).fill(void 0)), _classPrivateFieldSet(_e5, this, new Array(_r25).fill(void 0)), _classPrivateFieldSet(_u2, this, new W(_r25)), _classPrivateFieldSet(_h4, this, new W(_r25)), _classPrivateFieldSet(_a11, this, 0), _classPrivateFieldSet(_s10, this, 0), _classPrivateFieldSet(_b2, this, aa.create(_r25)), _classPrivateFieldSet(_i12, this, 0), _classPrivateFieldSet(_y9, this, 0), typeof _c11 == "function" && _classPrivateFieldSet(_p2, this, _c11), typeof _h5 == "function" ? (_classPrivateFieldSet(_g10, this, _h5), _classPrivateFieldSet(_o12, this, [])) : (_classPrivateFieldSet(_g10, this, void 0), _classPrivateFieldSet(_o12, this, void 0)), _classPrivateFieldSet(_2, this, !!_classPrivateFieldGet(_p2, this)), _classPrivateFieldSet(_f3, this, !!_classPrivateFieldGet(_g10, this)), this.noDisposeOnSet = !!_d7, this.noUpdateTTL = !!_g11, this.noDeleteOnFetchRejection = !!_I4, this.allowStaleOnFetchRejection = !!_R2, this.allowStaleOnFetchAbort = !!_U2, this.ignoreFetchAbort = !!N, this.maxEntrySize !== 0) {
        if (_classPrivateFieldGet(_c10, this) !== 0 && !Ht(_classPrivateFieldGet(_c10, this)))
          throw new TypeError("maxSize must be a positive integer if specified");
        if (!Ht(this.maxEntrySize))
          throw new TypeError("maxEntrySize must be a positive integer if specified");
        _assertClassBrand(_t6_brand, this, _q).call(this);
      }
      if (this.allowStale = !!_l19, this.noDeleteOnStaleGet = !!_C2, this.updateAgeOnGet = !!_s11, this.updateAgeOnHas = !!_a12, this.ttlResolution = Ht(_n13) || _n13 === 0 ? _n13 : 1, this.ttlAutopurge = !!_o13, this.ttl = _i13 || 0, this.ttl) {
        if (!Ht(this.ttl))
          throw new TypeError("ttl must be a positive integer if specified");
        _assertClassBrand(_t6_brand, this, _x32).call(this);
      }
      if (_classPrivateFieldGet(_l18, this) === 0 && this.ttl === 0 && _classPrivateFieldGet(_c10, this) === 0)
        throw new TypeError("At least one of max, maxSize, or ttl is required");
      if (!this.ttlAutopurge && !_classPrivateFieldGet(_l18, this) && !_classPrivateFieldGet(_c10, this)) {
        var K = "LRU_CACHE_UNBOUNDED";
        _1(K) && (Jd.add(K), Xd("TTL caching without ttlAutopurge, max, or maxSize can result in unbounded memory consumption.", "UnboundedCacheWarning", K, t2));
      }
    }
    return _createClass(t2, [{ key: "max", get: function get2() {
      return _classPrivateFieldGet(_l18, this);
    } }, { key: "maxSize", get: function get2() {
      return _classPrivateFieldGet(_c10, this);
    } }, { key: "calculatedSize", get: function get2() {
      return _classPrivateFieldGet(_y9, this);
    } }, { key: "size", get: function get2() {
      return _classPrivateFieldGet(_i12, this);
    } }, { key: "fetchMethod", get: function get2() {
      return _classPrivateFieldGet(_B, this);
    } }, { key: "dispose", get: function get2() {
      return _classPrivateFieldGet(_p2, this);
    } }, { key: "disposeAfter", get: function get2() {
      return _classPrivateFieldGet(_g10, this);
    } }, { key: "getRemainingTTL", value: function getRemainingTTL(e) {
      return _classPrivateFieldGet(_n12, this).has(e) ? 1 / 0 : 0;
    } }, { key: "entries", value: /* @__PURE__ */ _regeneratorRuntime().mark(function entries() {
      var _iterator21, _step21, e;
      return _regeneratorRuntime().wrap(function entries$(_context31) {
        while (1)
          switch (_context31.prev = _context31.next) {
            case 0:
              _iterator21 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _m2).call(this));
              _context31.prev = 1;
              _iterator21.s();
            case 3:
              if ((_step21 = _iterator21.n()).done) {
                _context31.next = 11;
                break;
              }
              e = _step21.value;
              _context31.t0 = _classPrivateFieldGet(_e5, this)[e] !== void 0 && _classPrivateFieldGet(_r24, this)[e] !== void 0 && !_assertClassBrand(_t6_brand, this, _t7).call(this, _classPrivateFieldGet(_e5, this)[e]);
              if (!_context31.t0) {
                _context31.next = 9;
                break;
              }
              _context31.next = 9;
              return [_classPrivateFieldGet(_r24, this)[e], _classPrivateFieldGet(_e5, this)[e]];
            case 9:
              _context31.next = 3;
              break;
            case 11:
              _context31.next = 16;
              break;
            case 13:
              _context31.prev = 13;
              _context31.t1 = _context31["catch"](1);
              _iterator21.e(_context31.t1);
            case 16:
              _context31.prev = 16;
              _iterator21.f();
              return _context31.finish(16);
            case 19:
            case "end":
              return _context31.stop();
          }
      }, entries, this, [[1, 13, 16, 19]]);
    }) }, { key: "rentries", value: /* @__PURE__ */ _regeneratorRuntime().mark(function rentries() {
      var _iterator22, _step22, e;
      return _regeneratorRuntime().wrap(function rentries$(_context32) {
        while (1)
          switch (_context32.prev = _context32.next) {
            case 0:
              _iterator22 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _v2).call(this));
              _context32.prev = 1;
              _iterator22.s();
            case 3:
              if ((_step22 = _iterator22.n()).done) {
                _context32.next = 11;
                break;
              }
              e = _step22.value;
              _context32.t0 = _classPrivateFieldGet(_e5, this)[e] !== void 0 && _classPrivateFieldGet(_r24, this)[e] !== void 0 && !_assertClassBrand(_t6_brand, this, _t7).call(this, _classPrivateFieldGet(_e5, this)[e]);
              if (!_context32.t0) {
                _context32.next = 9;
                break;
              }
              _context32.next = 9;
              return [_classPrivateFieldGet(_r24, this)[e], _classPrivateFieldGet(_e5, this)[e]];
            case 9:
              _context32.next = 3;
              break;
            case 11:
              _context32.next = 16;
              break;
            case 13:
              _context32.prev = 13;
              _context32.t1 = _context32["catch"](1);
              _iterator22.e(_context32.t1);
            case 16:
              _context32.prev = 16;
              _iterator22.f();
              return _context32.finish(16);
            case 19:
            case "end":
              return _context32.stop();
          }
      }, rentries, this, [[1, 13, 16, 19]]);
    }) }, { key: "keys", value: /* @__PURE__ */ _regeneratorRuntime().mark(function keys() {
      var _iterator23, _step23, e, _r26;
      return _regeneratorRuntime().wrap(function keys$(_context33) {
        while (1)
          switch (_context33.prev = _context33.next) {
            case 0:
              _iterator23 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _m2).call(this));
              _context33.prev = 1;
              _iterator23.s();
            case 3:
              if ((_step23 = _iterator23.n()).done) {
                _context33.next = 12;
                break;
              }
              e = _step23.value;
              _r26 = _classPrivateFieldGet(_r24, this)[e];
              _context33.t0 = _r26 !== void 0 && !_assertClassBrand(_t6_brand, this, _t7).call(this, _classPrivateFieldGet(_e5, this)[e]);
              if (!_context33.t0) {
                _context33.next = 10;
                break;
              }
              _context33.next = 10;
              return _r26;
            case 10:
              _context33.next = 3;
              break;
            case 12:
              _context33.next = 17;
              break;
            case 14:
              _context33.prev = 14;
              _context33.t1 = _context33["catch"](1);
              _iterator23.e(_context33.t1);
            case 17:
              _context33.prev = 17;
              _iterator23.f();
              return _context33.finish(17);
            case 20:
            case "end":
              return _context33.stop();
          }
      }, keys, this, [[1, 14, 17, 20]]);
    }) }, { key: "rkeys", value: /* @__PURE__ */ _regeneratorRuntime().mark(function rkeys() {
      var _iterator24, _step24, e, _r27;
      return _regeneratorRuntime().wrap(function rkeys$(_context34) {
        while (1)
          switch (_context34.prev = _context34.next) {
            case 0:
              _iterator24 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _v2).call(this));
              _context34.prev = 1;
              _iterator24.s();
            case 3:
              if ((_step24 = _iterator24.n()).done) {
                _context34.next = 12;
                break;
              }
              e = _step24.value;
              _r27 = _classPrivateFieldGet(_r24, this)[e];
              _context34.t0 = _r27 !== void 0 && !_assertClassBrand(_t6_brand, this, _t7).call(this, _classPrivateFieldGet(_e5, this)[e]);
              if (!_context34.t0) {
                _context34.next = 10;
                break;
              }
              _context34.next = 10;
              return _r27;
            case 10:
              _context34.next = 3;
              break;
            case 12:
              _context34.next = 17;
              break;
            case 14:
              _context34.prev = 14;
              _context34.t1 = _context34["catch"](1);
              _iterator24.e(_context34.t1);
            case 17:
              _context34.prev = 17;
              _iterator24.f();
              return _context34.finish(17);
            case 20:
            case "end":
              return _context34.stop();
          }
      }, rkeys, this, [[1, 14, 17, 20]]);
    }) }, { key: "values", value: /* @__PURE__ */ _regeneratorRuntime().mark(function values() {
      var _iterator25, _step25, e;
      return _regeneratorRuntime().wrap(function values$(_context35) {
        while (1)
          switch (_context35.prev = _context35.next) {
            case 0:
              _iterator25 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _m2).call(this));
              _context35.prev = 1;
              _iterator25.s();
            case 3:
              if ((_step25 = _iterator25.n()).done) {
                _context35.next = 11;
                break;
              }
              e = _step25.value;
              _context35.t0 = _classPrivateFieldGet(_e5, this)[e] !== void 0 && !_assertClassBrand(_t6_brand, this, _t7).call(this, _classPrivateFieldGet(_e5, this)[e]);
              if (!_context35.t0) {
                _context35.next = 9;
                break;
              }
              _context35.next = 9;
              return _classPrivateFieldGet(_e5, this)[e];
            case 9:
              _context35.next = 3;
              break;
            case 11:
              _context35.next = 16;
              break;
            case 13:
              _context35.prev = 13;
              _context35.t1 = _context35["catch"](1);
              _iterator25.e(_context35.t1);
            case 16:
              _context35.prev = 16;
              _iterator25.f();
              return _context35.finish(16);
            case 19:
            case "end":
              return _context35.stop();
          }
      }, values, this, [[1, 13, 16, 19]]);
    }) }, { key: "rvalues", value: /* @__PURE__ */ _regeneratorRuntime().mark(function rvalues() {
      var _iterator26, _step26, e;
      return _regeneratorRuntime().wrap(function rvalues$(_context36) {
        while (1)
          switch (_context36.prev = _context36.next) {
            case 0:
              _iterator26 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _v2).call(this));
              _context36.prev = 1;
              _iterator26.s();
            case 3:
              if ((_step26 = _iterator26.n()).done) {
                _context36.next = 11;
                break;
              }
              e = _step26.value;
              _context36.t0 = _classPrivateFieldGet(_e5, this)[e] !== void 0 && !_assertClassBrand(_t6_brand, this, _t7).call(this, _classPrivateFieldGet(_e5, this)[e]);
              if (!_context36.t0) {
                _context36.next = 9;
                break;
              }
              _context36.next = 9;
              return _classPrivateFieldGet(_e5, this)[e];
            case 9:
              _context36.next = 3;
              break;
            case 11:
              _context36.next = 16;
              break;
            case 13:
              _context36.prev = 13;
              _context36.t1 = _context36["catch"](1);
              _iterator26.e(_context36.t1);
            case 16:
              _context36.prev = 16;
              _iterator26.f();
              return _context36.finish(16);
            case 19:
            case "end":
              return _context36.stop();
          }
      }, rvalues, this, [[1, 13, 16, 19]]);
    }) }, { key: Symbol.iterator, value: function value() {
      return this.entries();
    } }, { key: "find", value: function find(e) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var _iterator27 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _m2).call(this)), _step27;
      try {
        for (_iterator27.s(); !(_step27 = _iterator27.n()).done; ) {
          var i = _step27.value;
          var _n14 = _classPrivateFieldGet(_e5, this)[i], _o14 = _assertClassBrand(_t6_brand, this, _t7).call(this, _n14) ? _n14.__staleWhileFetching : _n14;
          if (_o14 !== void 0 && e(_o14, _classPrivateFieldGet(_r24, this)[i], this))
            return this.get(_classPrivateFieldGet(_r24, this)[i], r);
        }
      } catch (err) {
        _iterator27.e(err);
      } finally {
        _iterator27.f();
      }
    } }, { key: "forEach", value: function forEach(e) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
      var _iterator28 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _m2).call(this)), _step28;
      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done; ) {
          var i = _step28.value;
          var _n15 = _classPrivateFieldGet(_e5, this)[i], _o15 = _assertClassBrand(_t6_brand, this, _t7).call(this, _n15) ? _n15.__staleWhileFetching : _n15;
          _o15 !== void 0 && e.call(r, _o15, _classPrivateFieldGet(_r24, this)[i], this);
        }
      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }
    } }, { key: "rforEach", value: function rforEach(e) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
      var _iterator29 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _v2).call(this)), _step29;
      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done; ) {
          var i = _step29.value;
          var _n16 = _classPrivateFieldGet(_e5, this)[i], _o16 = _assertClassBrand(_t6_brand, this, _t7).call(this, _n16) ? _n16.__staleWhileFetching : _n16;
          _o16 !== void 0 && e.call(r, _o16, _classPrivateFieldGet(_r24, this)[i], this);
        }
      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    } }, { key: "purgeStale", value: function purgeStale() {
      var e = false;
      var _iterator30 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _v2).call(this, { allowStale: true })), _step30;
      try {
        for (_iterator30.s(); !(_step30 = _iterator30.n()).done; ) {
          var _r28 = _step30.value;
          _classPrivateFieldGet(_d6, this).call(this, _r28) && (this.delete(_classPrivateFieldGet(_r24, this)[_r28]), e = true);
        }
      } catch (err) {
        _iterator30.e(err);
      } finally {
        _iterator30.f();
      }
      return e;
    } }, { key: "dump", value: function dump() {
      var e = [];
      var _iterator31 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _m2).call(this, { allowStale: true })), _step31;
      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done; ) {
          var _r29 = _step31.value;
          var i = _classPrivateFieldGet(_r24, this)[_r29], _n17 = _classPrivateFieldGet(_e5, this)[_r29], _o17 = _assertClassBrand(_t6_brand, this, _t7).call(this, _n17) ? _n17.__staleWhileFetching : _n17;
          if (_o17 === void 0 || i === void 0)
            continue;
          var _s12 = { value: _o17 };
          if (_classPrivateFieldGet(_w4, this) && _classPrivateFieldGet(_S6, this)) {
            _s12.ttl = _classPrivateFieldGet(_w4, this)[_r29];
            var _a13 = Ri.now() - _classPrivateFieldGet(_S6, this)[_r29];
            _s12.start = Math.floor(Date.now() - _a13);
          }
          _classPrivateFieldGet(_E7, this) && (_s12.size = _classPrivateFieldGet(_E7, this)[_r29]), e.unshift([i, _s12]);
        }
      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }
      return e;
    } }, { key: "load", value: function load(e) {
      this.clear();
      var _iterator32 = _createForOfIteratorHelper(e), _step32;
      try {
        for (_iterator32.s(); !(_step32 = _iterator32.n()).done; ) {
          var _step32$value = _slicedToArray(_step32.value, 2), _r30 = _step32$value[0], i = _step32$value[1];
          if (i.start) {
            var _n18 = Date.now() - i.start;
            i.start = Ri.now() - _n18;
          }
          this.set(_r30, i.value, i);
        }
      } catch (err) {
        _iterator32.e(err);
      } finally {
        _iterator32.f();
      }
    } }, { key: "set", value: function set(e, r) {
      var _this$i, _this$i2;
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (r === void 0)
        return this.delete(e), this;
      var _i$ttl = i.ttl, n = _i$ttl === void 0 ? this.ttl : _i$ttl, o = i.start, _i$noDisposeOnSet = i.noDisposeOnSet, s = _i$noDisposeOnSet === void 0 ? this.noDisposeOnSet : _i$noDisposeOnSet, _i$sizeCalculation = i.sizeCalculation, a = _i$sizeCalculation === void 0 ? this.sizeCalculation : _i$sizeCalculation, l = i.status, _i$noUpdateTTL = i.noUpdateTTL, c = _i$noUpdateTTL === void 0 ? this.noUpdateTTL : _i$noUpdateTTL, h = _classPrivateFieldGet(_L, this).call(this, e, r, i.size || 0, a);
      if (this.maxEntrySize && h > this.maxEntrySize)
        return l && (l.set = "miss", l.maxEntrySizeExceeded = true), this.delete(e), this;
      var d = _classPrivateFieldGet(_i12, this) === 0 ? void 0 : _classPrivateFieldGet(_n12, this).get(e);
      if (d === void 0)
        d = _classPrivateFieldGet(_i12, this) === 0 ? _classPrivateFieldGet(_s10, this) : _classPrivateFieldGet(_b2, this).length !== 0 ? _classPrivateFieldGet(_b2, this).pop() : _classPrivateFieldGet(_i12, this) === _classPrivateFieldGet(_l18, this) ? _assertClassBrand(_t6_brand, this, _k).call(this, false) : _classPrivateFieldGet(_i12, this), _classPrivateFieldGet(_r24, this)[d] = e, _classPrivateFieldGet(_e5, this)[d] = r, _classPrivateFieldGet(_n12, this).set(e, d), _classPrivateFieldGet(_u2, this)[_classPrivateFieldGet(_s10, this)] = d, _classPrivateFieldGet(_h4, this)[d] = _classPrivateFieldGet(_s10, this), _classPrivateFieldSet(_s10, this, d), _classPrivateFieldSet(_i12, this, (_this$i = _classPrivateFieldGet(_i12, this), _this$i2 = _this$i++, _this$i)), _this$i2, _classPrivateFieldGet(_P2, this).call(this, d, h, l), l && (l.set = "add"), c = false;
      else {
        _assertClassBrand(_t6_brand, this, _C).call(this, d);
        var _g12 = _classPrivateFieldGet(_e5, this)[d];
        if (r !== _g12) {
          var _classPrivateFieldGet4, _classPrivateFieldGet5;
          if (_classPrivateFieldGet(_I3, this) && _assertClassBrand(_t6_brand, this, _t7).call(this, _g12)) {
            var _classPrivateFieldGet2, _classPrivateFieldGet3;
            _g12.__abortController.abort(new Error("replaced"));
            var _y11 = _g12.__staleWhileFetching;
            _y11 !== void 0 && !s && (_classPrivateFieldGet(_2, this) && (_classPrivateFieldGet2 = _classPrivateFieldGet(_p2, this)) !== null && _classPrivateFieldGet2 !== void 0 && _classPrivateFieldGet2.call(this, _y11, e, "set"), _classPrivateFieldGet(_f3, this) && ((_classPrivateFieldGet3 = _classPrivateFieldGet(_o12, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.push([_y11, e, "set"])));
          } else
            s || (_classPrivateFieldGet(_2, this) && (_classPrivateFieldGet4 = _classPrivateFieldGet(_p2, this)) !== null && _classPrivateFieldGet4 !== void 0 && _classPrivateFieldGet4.call(this, _g12, e, "set"), _classPrivateFieldGet(_f3, this) && ((_classPrivateFieldGet5 = _classPrivateFieldGet(_o12, this)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.push([_g12, e, "set"])));
          if (_classPrivateFieldGet(_R, this).call(this, d), _classPrivateFieldGet(_P2, this).call(this, d, h, l), _classPrivateFieldGet(_e5, this)[d] = r, l) {
            l.set = "replace";
            var _y12 = _g12 && _assertClassBrand(_t6_brand, this, _t7).call(this, _g12) ? _g12.__staleWhileFetching : _g12;
            _y12 !== void 0 && (l.oldValue = _y12);
          }
        } else
          l && (l.set = "update");
      }
      if (n !== 0 && !_classPrivateFieldGet(_w4, this) && _assertClassBrand(_t6_brand, this, _x32).call(this), _classPrivateFieldGet(_w4, this) && (c || _classPrivateFieldGet(_M, this).call(this, d, n, o), l && _classPrivateFieldGet(_A2, this).call(this, l, d)), !s && _classPrivateFieldGet(_f3, this) && _classPrivateFieldGet(_o12, this)) {
        var _g13 = _classPrivateFieldGet(_o12, this), _y13;
        for (; _y13 = _g13 === null || _g13 === void 0 ? void 0 : _g13.shift(); ) {
          var _classPrivateFieldGet6, _classPrivateFieldGet7;
          (_classPrivateFieldGet6 = _classPrivateFieldGet(_g10, this)) === null || _classPrivateFieldGet6 === void 0 || (_classPrivateFieldGet7 = _classPrivateFieldGet6).call.apply(_classPrivateFieldGet7, [this].concat(_toConsumableArray(_y13)));
        }
      }
      return this;
    } }, { key: "pop", value: function pop() {
      try {
        for (; _classPrivateFieldGet(_i12, this); ) {
          var e = _classPrivateFieldGet(_e5, this)[_classPrivateFieldGet(_a11, this)];
          if (_assertClassBrand(_t6_brand, this, _k).call(this, true), _assertClassBrand(_t6_brand, this, _t7).call(this, e)) {
            if (e.__staleWhileFetching)
              return e.__staleWhileFetching;
          } else if (e !== void 0)
            return e;
        }
      } finally {
        if (_classPrivateFieldGet(_f3, this) && _classPrivateFieldGet(_o12, this)) {
          var _e7 = _classPrivateFieldGet(_o12, this), _r31;
          for (; _r31 = _e7 === null || _e7 === void 0 ? void 0 : _e7.shift(); ) {
            var _classPrivateFieldGet8, _classPrivateFieldGet9;
            (_classPrivateFieldGet8 = _classPrivateFieldGet(_g10, this)) === null || _classPrivateFieldGet8 === void 0 || (_classPrivateFieldGet9 = _classPrivateFieldGet8).call.apply(_classPrivateFieldGet9, [this].concat(_toConsumableArray(_r31)));
          }
        }
      }
    } }, { key: "has", value: function has(e) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var _r$updateAgeOnHas = r.updateAgeOnHas, i = _r$updateAgeOnHas === void 0 ? this.updateAgeOnHas : _r$updateAgeOnHas, n = r.status, o = _classPrivateFieldGet(_n12, this).get(e);
      if (o !== void 0) {
        var _s13 = _classPrivateFieldGet(_e5, this)[o];
        if (_assertClassBrand(_t6_brand, this, _t7).call(this, _s13) && _s13.__staleWhileFetching === void 0)
          return false;
        if (_classPrivateFieldGet(_d6, this).call(this, o))
          n && (n.has = "stale", _classPrivateFieldGet(_A2, this).call(this, n, o));
        else
          return i && _classPrivateFieldGet(_T, this).call(this, o), n && (n.has = "hit", _classPrivateFieldGet(_A2, this).call(this, n, o)), true;
      } else
        n && (n.has = "miss");
      return false;
    } }, { key: "peek", value: function peek(e) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var _r$allowStale = r.allowStale, i = _r$allowStale === void 0 ? this.allowStale : _r$allowStale, n = _classPrivateFieldGet(_n12, this).get(e);
      if (n !== void 0 && (i || !_classPrivateFieldGet(_d6, this).call(this, n))) {
        var _o18 = _classPrivateFieldGet(_e5, this)[n];
        return _assertClassBrand(_t6_brand, this, _t7).call(this, _o18) ? _o18.__staleWhileFetching : _o18;
      }
    } }, { key: "fetch", value: function() {
      var _fetch = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee30(e) {
        var r, _r$allowStale2, i, _r$updateAgeOnGet, n, _r$noDeleteOnStaleGet, o, _r$ttl, s, _r$noDisposeOnSet, a, _r$size, l, _r$sizeCalculation, c, _r$noUpdateTTL, h, _r$noDeleteOnFetchRej, d, _r$allowStaleOnFetchR, g, _r$ignoreFetchAbort, y, _r$allowStaleOnFetchA, w, S, _r$forceRefresh, E, I, C, R, U, N, _N2, pe, W, K, Q, _args37 = arguments;
        return _regeneratorRuntime().wrap(function _callee30$(_context37) {
          while (1)
            switch (_context37.prev = _context37.next) {
              case 0:
                r = _args37.length > 1 && _args37[1] !== void 0 ? _args37[1] : {};
                _r$allowStale2 = r.allowStale, i = _r$allowStale2 === void 0 ? this.allowStale : _r$allowStale2, _r$updateAgeOnGet = r.updateAgeOnGet, n = _r$updateAgeOnGet === void 0 ? this.updateAgeOnGet : _r$updateAgeOnGet, _r$noDeleteOnStaleGet = r.noDeleteOnStaleGet, o = _r$noDeleteOnStaleGet === void 0 ? this.noDeleteOnStaleGet : _r$noDeleteOnStaleGet, _r$ttl = r.ttl, s = _r$ttl === void 0 ? this.ttl : _r$ttl, _r$noDisposeOnSet = r.noDisposeOnSet, a = _r$noDisposeOnSet === void 0 ? this.noDisposeOnSet : _r$noDisposeOnSet, _r$size = r.size, l = _r$size === void 0 ? 0 : _r$size, _r$sizeCalculation = r.sizeCalculation, c = _r$sizeCalculation === void 0 ? this.sizeCalculation : _r$sizeCalculation, _r$noUpdateTTL = r.noUpdateTTL, h = _r$noUpdateTTL === void 0 ? this.noUpdateTTL : _r$noUpdateTTL, _r$noDeleteOnFetchRej = r.noDeleteOnFetchRejection, d = _r$noDeleteOnFetchRej === void 0 ? this.noDeleteOnFetchRejection : _r$noDeleteOnFetchRej, _r$allowStaleOnFetchR = r.allowStaleOnFetchRejection, g = _r$allowStaleOnFetchR === void 0 ? this.allowStaleOnFetchRejection : _r$allowStaleOnFetchR, _r$ignoreFetchAbort = r.ignoreFetchAbort, y = _r$ignoreFetchAbort === void 0 ? this.ignoreFetchAbort : _r$ignoreFetchAbort, _r$allowStaleOnFetchA = r.allowStaleOnFetchAbort, w = _r$allowStaleOnFetchA === void 0 ? this.allowStaleOnFetchAbort : _r$allowStaleOnFetchA, S = r.context, _r$forceRefresh = r.forceRefresh, E = _r$forceRefresh === void 0 ? false : _r$forceRefresh, I = r.status, C = r.signal;
                if (_classPrivateFieldGet(_I3, this)) {
                  _context37.next = 4;
                  break;
                }
                return _context37.abrupt("return", (I && (I.fetch = "get"), this.get(e, { allowStale: i, updateAgeOnGet: n, noDeleteOnStaleGet: o, status: I })));
              case 4:
                R = { allowStale: i, updateAgeOnGet: n, noDeleteOnStaleGet: o, ttl: s, noDisposeOnSet: a, size: l, sizeCalculation: c, noUpdateTTL: h, noDeleteOnFetchRejection: d, allowStaleOnFetchRejection: g, allowStaleOnFetchAbort: w, ignoreFetchAbort: y, status: I, signal: C }, U = _classPrivateFieldGet(_n12, this).get(e);
                if (!(U === void 0)) {
                  _context37.next = 11;
                  break;
                }
                I && (I.fetch = "miss");
                N = _assertClassBrand(_t6_brand, this, _O).call(this, e, U, R, S);
                return _context37.abrupt("return", N.__returned = N);
              case 11:
                _N2 = _classPrivateFieldGet(_e5, this)[U];
                if (!_assertClassBrand(_t6_brand, this, _t7).call(this, _N2)) {
                  _context37.next = 15;
                  break;
                }
                pe = i && _N2.__staleWhileFetching !== void 0;
                return _context37.abrupt("return", (I && (I.fetch = "inflight", pe && (I.returnedStale = true)), pe ? _N2.__staleWhileFetching : _N2.__returned = _N2));
              case 15:
                W = _classPrivateFieldGet(_d6, this).call(this, U);
                if (!(!E && !W)) {
                  _context37.next = 18;
                  break;
                }
                return _context37.abrupt("return", (I && (I.fetch = "hit"), _assertClassBrand(_t6_brand, this, _C).call(this, U), n && _classPrivateFieldGet(_T, this).call(this, U), I && _classPrivateFieldGet(_A2, this).call(this, I, U), _N2));
              case 18:
                K = _assertClassBrand(_t6_brand, this, _O).call(this, e, U, R, S), Q = K.__staleWhileFetching !== void 0 && i;
                return _context37.abrupt("return", (I && (I.fetch = W ? "stale" : "refresh", Q && W && (I.returnedStale = true)), Q ? K.__staleWhileFetching : K.__returned = K));
              case 20:
              case "end":
                return _context37.stop();
            }
        }, _callee30, this);
      }));
      function fetch(_x33) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }() }, { key: "get", value: function get2(e) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var _r$allowStale3 = r.allowStale, i = _r$allowStale3 === void 0 ? this.allowStale : _r$allowStale3, _r$updateAgeOnGet2 = r.updateAgeOnGet, n = _r$updateAgeOnGet2 === void 0 ? this.updateAgeOnGet : _r$updateAgeOnGet2, _r$noDeleteOnStaleGet2 = r.noDeleteOnStaleGet, o = _r$noDeleteOnStaleGet2 === void 0 ? this.noDeleteOnStaleGet : _r$noDeleteOnStaleGet2, s = r.status, a = _classPrivateFieldGet(_n12, this).get(e);
      if (a !== void 0) {
        var _l20 = _classPrivateFieldGet(_e5, this)[a], _c12 = _assertClassBrand(_t6_brand, this, _t7).call(this, _l20);
        return s && _classPrivateFieldGet(_A2, this).call(this, s, a), _classPrivateFieldGet(_d6, this).call(this, a) ? (s && (s.get = "stale"), _c12 ? (s && i && _l20.__staleWhileFetching !== void 0 && (s.returnedStale = true), i ? _l20.__staleWhileFetching : void 0) : (o || this.delete(e), s && i && (s.returnedStale = true), i ? _l20 : void 0)) : (s && (s.get = "hit"), _c12 ? _l20.__staleWhileFetching : (_assertClassBrand(_t6_brand, this, _C).call(this, a), n && _classPrivateFieldGet(_T, this).call(this, a), _l20));
      } else
        s && (s.get = "miss");
    } }, { key: "delete", value: function _delete(e) {
      var _classPrivateFieldGet12;
      var r = false;
      if (_classPrivateFieldGet(_i12, this) !== 0) {
        var i = _classPrivateFieldGet(_n12, this).get(e);
        if (i !== void 0)
          if (r = true, _classPrivateFieldGet(_i12, this) === 1)
            this.clear();
          else {
            var _this$i5, _this$i6, _classPrivateFieldGet10, _classPrivateFieldGet11;
            _classPrivateFieldGet(_R, this).call(this, i);
            var _n19 = _classPrivateFieldGet(_e5, this)[i];
            _assertClassBrand(_t6_brand, this, _t7).call(this, _n19) ? _n19.__abortController.abort(new Error("deleted")) : (_classPrivateFieldGet(_2, this) || _classPrivateFieldGet(_f3, this)) && (_classPrivateFieldGet(_2, this) && (_classPrivateFieldGet10 = _classPrivateFieldGet(_p2, this)) !== null && _classPrivateFieldGet10 !== void 0 && _classPrivateFieldGet10.call(this, _n19, e, "delete"), _classPrivateFieldGet(_f3, this) && ((_classPrivateFieldGet11 = _classPrivateFieldGet(_o12, this)) === null || _classPrivateFieldGet11 === void 0 ? void 0 : _classPrivateFieldGet11.push([_n19, e, "delete"]))), _classPrivateFieldGet(_n12, this).delete(e), _classPrivateFieldGet(_r24, this)[i] = void 0, _classPrivateFieldGet(_e5, this)[i] = void 0, i === _classPrivateFieldGet(_s10, this) ? _classPrivateFieldSet(_s10, this, _classPrivateFieldGet(_h4, this)[i]) : i === _classPrivateFieldGet(_a11, this) ? _classPrivateFieldSet(_a11, this, _classPrivateFieldGet(_u2, this)[i]) : (_classPrivateFieldGet(_u2, this)[_classPrivateFieldGet(_h4, this)[i]] = _classPrivateFieldGet(_u2, this)[i], _classPrivateFieldGet(_h4, this)[_classPrivateFieldGet(_u2, this)[i]] = _classPrivateFieldGet(_h4, this)[i]), _classPrivateFieldSet(_i12, this, (_this$i5 = _classPrivateFieldGet(_i12, this), _this$i6 = _this$i5--, _this$i5)), _this$i6, _classPrivateFieldGet(_b2, this).push(i);
          }
      }
      if (_classPrivateFieldGet(_f3, this) && (_classPrivateFieldGet12 = _classPrivateFieldGet(_o12, this)) !== null && _classPrivateFieldGet12 !== void 0 && _classPrivateFieldGet12.length) {
        var _i14 = _classPrivateFieldGet(_o12, this), _n20;
        for (; _n20 = _i14 === null || _i14 === void 0 ? void 0 : _i14.shift(); ) {
          var _classPrivateFieldGet13, _classPrivateFieldGet14;
          (_classPrivateFieldGet13 = _classPrivateFieldGet(_g10, this)) === null || _classPrivateFieldGet13 === void 0 || (_classPrivateFieldGet14 = _classPrivateFieldGet13).call.apply(_classPrivateFieldGet14, [this].concat(_toConsumableArray(_n20)));
        }
      }
      return r;
    } }, { key: "clear", value: function clear() {
      var _iterator33 = _createForOfIteratorHelper(_assertClassBrand(_t6_brand, this, _v2).call(this, { allowStale: true })), _step33;
      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done; ) {
          var _e8 = _step33.value;
          var _r33 = _classPrivateFieldGet(_e5, this)[_e8];
          if (_assertClassBrand(_t6_brand, this, _t7).call(this, _r33))
            _r33.__abortController.abort(new Error("deleted"));
          else {
            var _classPrivateFieldGet17, _classPrivateFieldGet18;
            var i = _classPrivateFieldGet(_r24, this)[_e8];
            _classPrivateFieldGet(_2, this) && (_classPrivateFieldGet17 = _classPrivateFieldGet(_p2, this)) !== null && _classPrivateFieldGet17 !== void 0 && _classPrivateFieldGet17.call(this, _r33, i, "delete"), _classPrivateFieldGet(_f3, this) && ((_classPrivateFieldGet18 = _classPrivateFieldGet(_o12, this)) === null || _classPrivateFieldGet18 === void 0 ? void 0 : _classPrivateFieldGet18.push([_r33, i, "delete"]));
          }
        }
      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }
      if (_classPrivateFieldGet(_n12, this).clear(), _classPrivateFieldGet(_e5, this).fill(void 0), _classPrivateFieldGet(_r24, this).fill(void 0), _classPrivateFieldGet(_w4, this) && _classPrivateFieldGet(_S6, this) && (_classPrivateFieldGet(_w4, this).fill(0), _classPrivateFieldGet(_S6, this).fill(0)), _classPrivateFieldGet(_E7, this) && _classPrivateFieldGet(_E7, this).fill(0), _classPrivateFieldSet(_a11, this, 0), _classPrivateFieldSet(_s10, this, 0), _classPrivateFieldGet(_b2, this).length = 0, _classPrivateFieldSet(_y9, this, 0), _classPrivateFieldSet(_i12, this, 0), _classPrivateFieldGet(_f3, this) && _classPrivateFieldGet(_o12, this)) {
        var e = _classPrivateFieldGet(_o12, this), _r32;
        for (; _r32 = e === null || e === void 0 ? void 0 : e.shift(); ) {
          var _classPrivateFieldGet15, _classPrivateFieldGet16;
          (_classPrivateFieldGet15 = _classPrivateFieldGet(_g10, this)) === null || _classPrivateFieldGet15 === void 0 || (_classPrivateFieldGet16 = _classPrivateFieldGet15).call.apply(_classPrivateFieldGet16, [this].concat(_toConsumableArray(_r32)));
        }
      }
    } }], [{ key: "unsafeExposeInternals", value: function unsafeExposeInternals(e) {
      return { starts: _classPrivateFieldGet(_S6, e), ttls: _classPrivateFieldGet(_w4, e), sizes: _classPrivateFieldGet(_E7, e), keyMap: _classPrivateFieldGet(_n12, e), keyList: _classPrivateFieldGet(_r24, e), valList: _classPrivateFieldGet(_e5, e), next: _classPrivateFieldGet(_u2, e), prev: _classPrivateFieldGet(_h4, e), get head() {
        return _classPrivateFieldGet(_a11, e);
      }, get tail() {
        return _classPrivateFieldGet(_s10, e);
      }, free: _classPrivateFieldGet(_b2, e), isBackgroundFetch: function isBackgroundFetch(r) {
        return _assertClassBrand(_t6_brand, e, _t7).call(e, r);
      }, backgroundFetch: function backgroundFetch(r, i, n, o) {
        return _assertClassBrand(_t6_brand, e, _O).call(e, r, i, n, o);
      }, moveToTail: function moveToTail(r) {
        return _assertClassBrand(_t6_brand, e, _C).call(e, r);
      }, indexes: function indexes(r) {
        return _assertClassBrand(_t6_brand, e, _m2).call(e, r);
      }, rindexes: function rindexes(r) {
        return _assertClassBrand(_t6_brand, e, _v2).call(e, r);
      }, isStale: function isStale(r) {
        return _classPrivateFieldGet(_d6, e).call(e, r);
      } };
    } }]);
  }());
  function _x32() {
    var _this15 = this;
    var e = new Zr(_classPrivateFieldGet(_l18, this)), r = new Zr(_classPrivateFieldGet(_l18, this));
    _classPrivateFieldSet(_w4, this, e), _classPrivateFieldSet(_S6, this, r), _classPrivateFieldSet(_M, this, function(o, s) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Ri.now();
      if (r[o] = s !== 0 ? a : 0, e[o] = s, s !== 0 && _this15.ttlAutopurge) {
        var _l21 = setTimeout(function() {
          _classPrivateFieldGet(_d6, _this15).call(_this15, o) && _this15.delete(_classPrivateFieldGet(_r24, _this15)[o]);
        }, s + 1);
        _l21.unref && _l21.unref();
      }
    }), _classPrivateFieldSet(_T, this, function(o) {
      r[o] = e[o] !== 0 ? Ri.now() : 0;
    }), _classPrivateFieldSet(_A2, this, function(o, s) {
      if (e[s]) {
        var _a14 = e[s], _l22 = r[s];
        o.ttl = _a14, o.start = _l22, o.now = i || n();
        var _c13 = o.now - _l22;
        o.remainingTTL = _a14 - _c13;
      }
    });
    var i = 0, n = function n2() {
      var o = Ri.now();
      if (_this15.ttlResolution > 0) {
        i = o;
        var _s14 = setTimeout(function() {
          return i = 0;
        }, _this15.ttlResolution);
        _s14.unref && _s14.unref();
      }
      return o;
    };
    this.getRemainingTTL = function(o) {
      var s = _classPrivateFieldGet(_n12, _this15).get(o);
      if (s === void 0)
        return 0;
      var a = e[s], l = r[s];
      if (a === 0 || l === 0)
        return 1 / 0;
      var c = (i || n()) - l;
      return a - c;
    }, _classPrivateFieldSet(_d6, this, function(o) {
      return e[o] !== 0 && r[o] !== 0 && (i || n()) - r[o] > e[o];
    });
  }
  function _q() {
    var _this16 = this;
    var e = new Zr(_classPrivateFieldGet(_l18, this));
    _classPrivateFieldSet(_y9, this, 0), _classPrivateFieldSet(_E7, this, e), _classPrivateFieldSet(_R, this, function(r) {
      _classPrivateFieldSet(_y9, _this16, _classPrivateFieldGet(_y9, _this16) - e[r]), e[r] = 0;
    }), _classPrivateFieldSet(_L, this, function(r, i, n, o) {
      if (_assertClassBrand(_t6_brand, _this16, _t7).call(_this16, i))
        return 0;
      if (!Ht(n))
        if (o) {
          if (typeof o != "function")
            throw new TypeError("sizeCalculation must be a function");
          if (n = o(i, r), !Ht(n))
            throw new TypeError("sizeCalculation return invalid (expect positive integer)");
        } else
          throw new TypeError("invalid size value (must be positive integer). When maxSize or maxEntrySize is used, sizeCalculation or size must be set.");
      return n;
    }), _classPrivateFieldSet(_P2, this, function(r, i, n) {
      if (e[r] = i, _classPrivateFieldGet(_c10, _this16)) {
        var _o19 = _classPrivateFieldGet(_c10, _this16) - e[r];
        for (; _classPrivateFieldGet(_y9, _this16) > _o19; )
          _assertClassBrand(_t6_brand, _this16, _k).call(_this16, true);
      }
      _classPrivateFieldSet(_y9, _this16, _classPrivateFieldGet(_y9, _this16) + e[r]), n && (n.entrySize = i, n.totalCalculatedSize = _classPrivateFieldGet(_y9, _this16));
    });
  }
  function _m2() {
    var _this17 = this;
    var _ref36 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref36$allowStale = _ref36.allowStale, e = _ref36$allowStale === void 0 ? this.allowStale : _ref36$allowStale;
    return /* @__PURE__ */ _regeneratorRuntime().mark(function _callee31() {
      var _r34;
      return _regeneratorRuntime().wrap(function _callee31$(_context38) {
        while (1)
          switch (_context38.prev = _context38.next) {
            case 0:
              if (!_classPrivateFieldGet(_i12, _this17)) {
                _context38.next = 13;
                break;
              }
              _r34 = _classPrivateFieldGet(_s10, _this17);
            case 2:
              _context38.t0 = !_assertClassBrand(_t6_brand, _this17, _U).call(_this17, _r34);
              if (_context38.t0) {
                _context38.next = 9;
                break;
              }
              _context38.t1 = e || !_classPrivateFieldGet(_d6, _this17).call(_this17, _r34);
              if (!_context38.t1) {
                _context38.next = 8;
                break;
              }
              _context38.next = 8;
              return _r34;
            case 8:
              _context38.t0 = _r34 === _classPrivateFieldGet(_a11, _this17);
            case 9:
              if (_context38.t0) {
                _context38.next = 13;
                break;
              }
              _r34 = _classPrivateFieldGet(_h4, _this17)[_r34];
            case 11:
              _context38.next = 2;
              break;
            case 13:
            case "end":
              return _context38.stop();
          }
      }, _callee31);
    })();
  }
  function _v2() {
    var _this18 = this;
    var _ref37 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref37$allowStale = _ref37.allowStale, e = _ref37$allowStale === void 0 ? this.allowStale : _ref37$allowStale;
    return /* @__PURE__ */ _regeneratorRuntime().mark(function _callee32() {
      var _r35;
      return _regeneratorRuntime().wrap(function _callee32$(_context39) {
        while (1)
          switch (_context39.prev = _context39.next) {
            case 0:
              if (!_classPrivateFieldGet(_i12, _this18)) {
                _context39.next = 13;
                break;
              }
              _r35 = _classPrivateFieldGet(_a11, _this18);
            case 2:
              _context39.t0 = !_assertClassBrand(_t6_brand, _this18, _U).call(_this18, _r35);
              if (_context39.t0) {
                _context39.next = 9;
                break;
              }
              _context39.t1 = e || !_classPrivateFieldGet(_d6, _this18).call(_this18, _r35);
              if (!_context39.t1) {
                _context39.next = 8;
                break;
              }
              _context39.next = 8;
              return _r35;
            case 8:
              _context39.t0 = _r35 === _classPrivateFieldGet(_s10, _this18);
            case 9:
              if (_context39.t0) {
                _context39.next = 13;
                break;
              }
              _r35 = _classPrivateFieldGet(_u2, _this18)[_r35];
            case 11:
              _context39.next = 2;
              break;
            case 13:
            case "end":
              return _context39.stop();
          }
      }, _callee32);
    })();
  }
  function _U(e) {
    return e !== void 0 && _classPrivateFieldGet(_n12, this).get(_classPrivateFieldGet(_r24, this)[e]) === e;
  }
  function _k(e) {
    var _classPrivateFieldGet19, _classPrivateFieldGet20;
    var _this$i3, _this$i4;
    var r = _classPrivateFieldGet(_a11, this), i = _classPrivateFieldGet(_r24, this)[r], n = _classPrivateFieldGet(_e5, this)[r];
    return _classPrivateFieldGet(_I3, this) && _assertClassBrand(_t6_brand, this, _t7).call(this, n) ? n.__abortController.abort(new Error("evicted")) : (_classPrivateFieldGet(_2, this) || _classPrivateFieldGet(_f3, this)) && (_classPrivateFieldGet(_2, this) && (_classPrivateFieldGet19 = _classPrivateFieldGet(_p2, this)) !== null && _classPrivateFieldGet19 !== void 0 && _classPrivateFieldGet19.call(this, n, i, "evict"), _classPrivateFieldGet(_f3, this) && ((_classPrivateFieldGet20 = _classPrivateFieldGet(_o12, this)) === null || _classPrivateFieldGet20 === void 0 ? void 0 : _classPrivateFieldGet20.push([n, i, "evict"]))), _classPrivateFieldGet(_R, this).call(this, r), e && (_classPrivateFieldGet(_r24, this)[r] = void 0, _classPrivateFieldGet(_e5, this)[r] = void 0, _classPrivateFieldGet(_b2, this).push(r)), _classPrivateFieldGet(_i12, this) === 1 ? (_classPrivateFieldSet(_a11, this, _classPrivateFieldSet(_s10, this, 0)), _classPrivateFieldGet(_b2, this).length = 0) : _classPrivateFieldSet(_a11, this, _classPrivateFieldGet(_u2, this)[r]), _classPrivateFieldGet(_n12, this).delete(i), _classPrivateFieldSet(_i12, this, (_this$i3 = _classPrivateFieldGet(_i12, this), _this$i4 = _this$i3--, _this$i3)), _this$i4, r;
  }
  function _O(e, r, i, n) {
    var _this19 = this;
    var o = r === void 0 ? void 0 : _classPrivateFieldGet(_e5, this)[r];
    if (_assertClassBrand(_t6_brand, this, _t7).call(this, o))
      return o;
    var s = new xn(), a = i.signal;
    a === null || a === void 0 || a.addEventListener("abort", function() {
      return s.abort(a.reason);
    }, { signal: s.signal });
    var l = { signal: s.signal, options: i, context: n }, c = function c2(S) {
      var E = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var I = s.signal.aborted, C = i.ignoreFetchAbort && S !== void 0;
      if (i.status && (I && !E ? (i.status.fetchAborted = true, i.status.fetchError = s.signal.reason, C && (i.status.fetchAbortIgnored = true)) : i.status.fetchResolved = true), I && !C && !E)
        return d(s.signal.reason);
      var R = y;
      return _classPrivateFieldGet(_e5, _this19)[r] === y && (S === void 0 ? R.__staleWhileFetching ? _classPrivateFieldGet(_e5, _this19)[r] = R.__staleWhileFetching : _this19.delete(e) : (i.status && (i.status.fetchUpdated = true), _this19.set(e, S, l.options))), S;
    }, h = function h2(S) {
      return i.status && (i.status.fetchRejected = true, i.status.fetchError = S), d(S);
    }, d = function d2(S) {
      var E = s.signal.aborted, I = E && i.allowStaleOnFetchAbort, C = I || i.allowStaleOnFetchRejection, R = C || i.noDeleteOnFetchRejection, U = y;
      if (_classPrivateFieldGet(_e5, _this19)[r] === y && (!R || U.__staleWhileFetching === void 0 ? _this19.delete(e) : I || (_classPrivateFieldGet(_e5, _this19)[r] = U.__staleWhileFetching)), C)
        return i.status && U.__staleWhileFetching !== void 0 && (i.status.returnedStale = true), U.__staleWhileFetching;
      if (U.__returned === U)
        throw S;
    }, g = function g2(S, E) {
      var _classPrivateFieldGet21;
      var I = (_classPrivateFieldGet21 = _classPrivateFieldGet(_B, _this19)) === null || _classPrivateFieldGet21 === void 0 ? void 0 : _classPrivateFieldGet21.call(_this19, e, o, l);
      I && I instanceof Promise && I.then(function(C) {
        return S(C === void 0 ? void 0 : C);
      }, E), s.signal.addEventListener("abort", function() {
        (!i.ignoreFetchAbort || i.allowStaleOnFetchAbort) && (S(void 0), i.allowStaleOnFetchAbort && (S = function S2(C) {
          return c(C, true);
        }));
      });
    };
    i.status && (i.status.fetchDispatched = true);
    var y = new Promise(g).then(c, h), w = Object.assign(y, { __abortController: s, __staleWhileFetching: o, __returned: void 0 });
    return r === void 0 ? (this.set(e, w, _objectSpread(_objectSpread({}, l.options), {}, { status: void 0 })), r = _classPrivateFieldGet(_n12, this).get(e)) : _classPrivateFieldGet(_e5, this)[r] = w, w;
  }
  function _t7(e) {
    if (!_classPrivateFieldGet(_I3, this))
      return false;
    var r = e;
    return !!r && r instanceof Promise && r.hasOwnProperty("__staleWhileFetching") && r.__abortController instanceof xn;
  }
  function _N(e, r) {
    _classPrivateFieldGet(_h4, this)[r] = e, _classPrivateFieldGet(_u2, this)[e] = r;
  }
  function _C(e) {
    e !== _classPrivateFieldGet(_s10, this) && (e === _classPrivateFieldGet(_a11, this) ? _classPrivateFieldSet(_a11, this, _classPrivateFieldGet(_u2, this)[e]) : _assertClassBrand(_t6_brand, this, _N).call(this, _classPrivateFieldGet(_h4, this)[e], _classPrivateFieldGet(_u2, this)[e]), _assertClassBrand(_t6_brand, this, _N).call(this, _classPrivateFieldGet(_s10, this), e), _classPrivateFieldSet(_s10, this, e));
  }
  Mn.LRUCache = la;
});
var lt = M(function(Vt) {
  _();
  v();
  m();
  Object.defineProperty(Vt, "t", { value: true });
  Vt.ContainerIterator = Vt.Container = Vt.Base = void 0;
  var ua = /* @__PURE__ */ function() {
    function ua2() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      _classCallCheck(this, ua2);
      this.iteratorType = e;
    }
    return _createClass(ua2, [{ key: "equals", value: function equals(e) {
      return this.o === e.o;
    } }]);
  }();
  Vt.ContainerIterator = ua;
  var Ln = /* @__PURE__ */ function() {
    function Ln2() {
      _classCallCheck(this, Ln2);
      this.i = 0;
    }
    return _createClass(Ln2, [{ key: "length", get: function get2() {
      return this.i;
    } }, { key: "size", value: function size() {
      return this.i;
    } }, { key: "empty", value: function empty() {
      return this.i === 0;
    } }]);
  }();
  Vt.Base = Ln;
  var fa = /* @__PURE__ */ function(_Ln) {
    function fa2() {
      _classCallCheck(this, fa2);
      return _callSuper(this, fa2, arguments);
    }
    _inherits(fa2, _Ln);
    return _createClass(fa2);
  }(Ln);
  Vt.Container = fa;
});
var tp = M(function(Un) {
  _();
  v();
  m();
  Object.defineProperty(Un, "t", { value: true });
  Un.default = void 0;
  var m1 = lt(), ca = /* @__PURE__ */ function(_m1$Base) {
    function ca2() {
      var _this20;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      _classCallCheck(this, ca2);
      _this20 = _callSuper(this, ca2), _this20.S = [];
      var r = _this20;
      e.forEach(function(i) {
        r.push(i);
      });
      return _this20;
    }
    _inherits(ca2, _m1$Base);
    return _createClass(ca2, [{ key: "clear", value: function clear() {
      this.i = 0, this.S = [];
    } }, { key: "push", value: function push(e) {
      return this.S.push(e), this.i += 1, this.i;
    } }, { key: "pop", value: function pop() {
      if (this.i !== 0)
        return this.i -= 1, this.S.pop();
    } }, { key: "top", value: function top() {
      return this.S[this.i - 1];
    } }]);
  }(m1.Base), v1 = ca;
  Un.default = v1;
});
var rp = M(function(Nn) {
  _();
  v();
  m();
  Object.defineProperty(Nn, "t", { value: true });
  Nn.default = void 0;
  var E1 = lt(), ha = /* @__PURE__ */ function(_E1$Base) {
    function ha2() {
      var _this21;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      _classCallCheck(this, ha2);
      _this21 = _callSuper(this, ha2), _this21.j = 0, _this21.q = [];
      var r = _this21;
      e.forEach(function(i) {
        r.push(i);
      });
      return _this21;
    }
    _inherits(ha2, _E1$Base);
    return _createClass(ha2, [{ key: "clear", value: function clear() {
      this.q = [], this.i = this.j = 0;
    } }, { key: "push", value: function push(e) {
      var r = this.q.length;
      if (this.j / r > 0.5 && this.j + this.i >= r && r > 4096) {
        var i = this.i;
        for (var _n21 = 0; _n21 < i; ++_n21)
          this.q[_n21] = this.q[this.j + _n21];
        this.j = 0, this.q[this.i] = e;
      } else
        this.q[this.j + this.i] = e;
      return ++this.i;
    } }, { key: "pop", value: function pop() {
      if (this.i === 0)
        return;
      var e = this.q[this.j++];
      return this.i -= 1, e;
    } }, { key: "front", value: function front() {
      if (this.i !== 0)
        return this.q[this.j];
    } }]);
  }(E1.Base), S1 = ha;
  Nn.default = S1;
});
var ip = M(function(qn) {
  _();
  v();
  m();
  Object.defineProperty(qn, "t", { value: true });
  qn.default = void 0;
  var A1 = lt(), da = /* @__PURE__ */ function(_A1$Base) {
    function da2() {
      var _this22;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(n2, o) {
        return n2 > o ? -1 : n2 < o ? 1 : 0;
      };
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
      _classCallCheck(this, da2);
      if (_this22 = _callSuper(this, da2), _this22.v = r, Array.isArray(e))
        _this22.C = i ? _toConsumableArray(e) : e;
      else {
        _this22.C = [];
        var _o20 = _assertThisInitialized(_this22);
        e.forEach(function(s) {
          _o20.C.push(s);
        });
      }
      _this22.i = _this22.C.length;
      var n = _this22.i >> 1;
      for (var _o21 = _this22.i - 1 >> 1; _o21 >= 0; --_o21)
        _this22.k(_o21, n);
      return _this22;
    }
    _inherits(da2, _A1$Base);
    return _createClass(da2, [{ key: "m", value: function m2(e) {
      var r = this.C[e];
      for (; e > 0; ) {
        var i = e - 1 >> 1, _n22 = this.C[i];
        if (this.v(_n22, r) <= 0)
          break;
        this.C[e] = _n22, e = i;
      }
      this.C[e] = r;
    } }, { key: "k", value: function k(e, r) {
      var i = this.C[e];
      for (; e < r; ) {
        var _n23 = e << 1 | 1, _o22 = _n23 + 1, _s15 = this.C[_n23];
        if (_o22 < this.i && this.v(_s15, this.C[_o22]) > 0 && (_n23 = _o22, _s15 = this.C[_o22]), this.v(_s15, i) >= 0)
          break;
        this.C[e] = _s15, e = _n23;
      }
      this.C[e] = i;
    } }, { key: "clear", value: function clear() {
      this.i = 0, this.C.length = 0;
    } }, { key: "push", value: function push(e) {
      this.C.push(e), this.m(this.i), this.i += 1;
    } }, { key: "pop", value: function pop() {
      if (this.i === 0)
        return;
      var e = this.C[0], r = this.C.pop();
      return this.i -= 1, this.i && (this.C[0] = r, this.k(0, this.i >> 1)), e;
    } }, { key: "top", value: function top() {
      return this.C[0];
    } }, { key: "find", value: function find(e) {
      return this.C.indexOf(e) >= 0;
    } }, { key: "remove", value: function remove(e) {
      var r = this.C.indexOf(e);
      return r < 0 ? false : (r === 0 ? this.pop() : r === this.i - 1 ? (this.C.pop(), this.i -= 1) : (this.C.splice(r, 1, this.C.pop()), this.i -= 1, this.m(r), this.k(r, this.i >> 1)), true);
    } }, { key: "updateItem", value: function updateItem(e) {
      var r = this.C.indexOf(e);
      return r < 0 ? false : (this.m(r), this.k(r, this.i >> 1), true);
    } }, { key: "toArray", value: function toArray() {
      return _toConsumableArray(this.C);
    } }]);
  }(A1.Base), I1 = da;
  qn.default = I1;
});
var jn = M(function(Dn) {
  _();
  v();
  m();
  Object.defineProperty(Dn, "t", { value: true });
  Dn.default = void 0;
  var T1 = lt(), pa = /* @__PURE__ */ function(_T1$Container) {
    function pa2() {
      _classCallCheck(this, pa2);
      return _callSuper(this, pa2, arguments);
    }
    _inherits(pa2, _T1$Container);
    return _createClass(pa2);
  }(T1.Container), R1 = pa;
  Dn.default = R1;
});
var ut = M(function(ga) {
  _();
  v();
  m();
  Object.defineProperty(ga, "t", { value: true });
  ga.throwIteratorAccessError = C1;
  function C1() {
    throw new RangeError("Iterator access denied!");
  }
});
var ba = M(function(Wn) {
  _();
  v();
  m();
  Object.defineProperty(Wn, "t", { value: true });
  Wn.RandomIterator = void 0;
  var B1 = lt(), Fn = ut(), ya = /* @__PURE__ */ function(_B1$ContainerIterator) {
    function ya2(e, r) {
      var _this23;
      _classCallCheck(this, ya2);
      _this23 = _callSuper(this, ya2, [r]), _this23.o = e, _this23.iteratorType === 0 ? (_this23.pre = function() {
        return this.o === 0 && (0, Fn.throwIteratorAccessError)(), this.o -= 1, this;
      }, _this23.next = function() {
        return this.o === this.container.size() && (0, Fn.throwIteratorAccessError)(), this.o += 1, this;
      }) : (_this23.pre = function() {
        return this.o === this.container.size() - 1 && (0, Fn.throwIteratorAccessError)(), this.o += 1, this;
      }, _this23.next = function() {
        return this.o === -1 && (0, Fn.throwIteratorAccessError)(), this.o -= 1, this;
      });
      return _this23;
    }
    _inherits(ya2, _B1$ContainerIterator);
    return _createClass(ya2, [{ key: "pointer", get: function get2() {
      return this.container.getElementByPos(this.o);
    }, set: function set(e) {
      this.container.setElementByPos(this.o, e);
    } }]);
  }(B1.ContainerIterator);
  Wn.RandomIterator = ya;
});
var np = M(function($n) {
  _();
  v();
  m();
  Object.defineProperty($n, "t", { value: true });
  $n.default = void 0;
  var P1 = O1(jn()), k1 = ba();
  function O1(t) {
    return t && t.t ? t : { default: t };
  }
  var mr = /* @__PURE__ */ function(_k1$RandomIterator) {
    function t(e, r, i) {
      var _this24;
      _classCallCheck(this, t);
      _this24 = _callSuper(this, t, [e, i]), _this24.container = r;
      return _this24;
    }
    _inherits(t, _k1$RandomIterator);
    return _createClass(t, [{ key: "copy", value: function copy() {
      return new t(this.o, this.container, this.iteratorType);
    } }]);
  }(k1.RandomIterator), wa = /* @__PURE__ */ function(_P1$default) {
    function wa2() {
      var _this25;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
      _classCallCheck(this, wa2);
      if (_this25 = _callSuper(this, wa2), Array.isArray(e))
        _this25.J = r ? _toConsumableArray(e) : e, _this25.i = e.length;
      else {
        _this25.J = [];
        var i = _assertThisInitialized(_this25);
        e.forEach(function(n) {
          i.pushBack(n);
        });
      }
      return _this25;
    }
    _inherits(wa2, _P1$default);
    return _createClass(wa2, [{ key: "clear", value: function clear() {
      this.i = 0, this.J.length = 0;
    } }, { key: "begin", value: function begin() {
      return new mr(0, this);
    } }, { key: "end", value: function end() {
      return new mr(this.i, this);
    } }, { key: "rBegin", value: function rBegin() {
      return new mr(this.i - 1, this, 1);
    } }, { key: "rEnd", value: function rEnd() {
      return new mr(-1, this, 1);
    } }, { key: "front", value: function front() {
      return this.J[0];
    } }, { key: "back", value: function back() {
      return this.J[this.i - 1];
    } }, { key: "getElementByPos", value: function getElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      return this.J[e];
    } }, { key: "eraseElementByPos", value: function eraseElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      return this.J.splice(e, 1), this.i -= 1, this.i;
    } }, { key: "eraseElementByValue", value: function eraseElementByValue(e) {
      var r = 0;
      for (var i = 0; i < this.i; ++i)
        this.J[i] !== e && (this.J[r++] = this.J[i]);
      return this.i = this.J.length = r, this.i;
    } }, { key: "eraseElementByIterator", value: function eraseElementByIterator(e) {
      var r = e.o;
      return e = e.next(), this.eraseElementByPos(r), e;
    } }, { key: "pushBack", value: function pushBack(e) {
      return this.J.push(e), this.i += 1, this.i;
    } }, { key: "popBack", value: function popBack() {
      if (this.i !== 0)
        return this.i -= 1, this.J.pop();
    } }, { key: "setElementByPos", value: function setElementByPos(e, r) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      this.J[e] = r;
    } }, { key: "insert", value: function insert(e, r) {
      var _this$J;
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
      if (e < 0 || e > this.i)
        throw new RangeError();
      return (_this$J = this.J).splice.apply(_this$J, [e, 0].concat(_toConsumableArray(new Array(i).fill(r)))), this.i += i, this.i;
    } }, { key: "find", value: function find(e) {
      for (var _r36 = 0; _r36 < this.i; ++_r36)
        if (this.J[_r36] === e)
          return new mr(_r36, this);
      return this.end();
    } }, { key: "reverse", value: function reverse() {
      this.J.reverse();
    } }, { key: "unique", value: function unique() {
      var e = 1;
      for (var _r37 = 1; _r37 < this.i; ++_r37)
        this.J[_r37] !== this.J[_r37 - 1] && (this.J[e++] = this.J[_r37]);
      return this.i = this.J.length = e, this.i;
    } }, { key: "sort", value: function sort(e) {
      this.J.sort(e);
    } }, { key: "forEach", value: function forEach(e) {
      for (var _r38 = 0; _r38 < this.i; ++_r38)
        e(this.J[_r38], _r38, this);
    } }, { key: Symbol.iterator, value: function value() {
      return /* @__PURE__ */ _regeneratorRuntime().mark(function _callee33() {
        return _regeneratorRuntime().wrap(function _callee33$(_context40) {
          while (1)
            switch (_context40.prev = _context40.next) {
              case 0:
                return _context40.delegateYield(this.J, "t0", 1);
              case 1:
              case "end":
                return _context40.stop();
            }
        }, _callee33, this);
      }).bind(this)();
    } }]);
  }(P1.default), x1 = wa;
  $n.default = x1;
});
var sp = M(function(Hn) {
  _();
  v();
  m();
  Object.defineProperty(Hn, "t", { value: true });
  Hn.default = void 0;
  var M1 = U1(jn()), L1 = lt(), vr = ut();
  function U1(t) {
    return t && t.t ? t : { default: t };
  }
  var Er = /* @__PURE__ */ function(_L1$ContainerIterator) {
    function t(e, r, i, n) {
      var _this26;
      _classCallCheck(this, t);
      _this26 = _callSuper(this, t, [n]), _this26.o = e, _this26.h = r, _this26.container = i, _this26.iteratorType === 0 ? (_this26.pre = function() {
        return this.o.L === this.h && (0, vr.throwIteratorAccessError)(), this.o = this.o.L, this;
      }, _this26.next = function() {
        return this.o === this.h && (0, vr.throwIteratorAccessError)(), this.o = this.o.B, this;
      }) : (_this26.pre = function() {
        return this.o.B === this.h && (0, vr.throwIteratorAccessError)(), this.o = this.o.B, this;
      }, _this26.next = function() {
        return this.o === this.h && (0, vr.throwIteratorAccessError)(), this.o = this.o.L, this;
      });
      return _this26;
    }
    _inherits(t, _L1$ContainerIterator);
    return _createClass(t, [{ key: "pointer", get: function get2() {
      return this.o === this.h && (0, vr.throwIteratorAccessError)(), this.o.l;
    }, set: function set(e) {
      this.o === this.h && (0, vr.throwIteratorAccessError)(), this.o.l = e;
    } }, { key: "copy", value: function copy() {
      return new t(this.o, this.h, this.container, this.iteratorType);
    } }]);
  }(L1.ContainerIterator), _a = /* @__PURE__ */ function(_M1$default) {
    function _a2() {
      var _this27;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      _classCallCheck(this, _a2);
      _this27 = _callSuper(this, _a2), _this27.h = {}, _this27.p = _this27._ = _this27.h.L = _this27.h.B = _this27.h;
      var r = _this27;
      e.forEach(function(i) {
        r.pushBack(i);
      });
      return _this27;
    }
    _inherits(_a2, _M1$default);
    return _createClass(_a2, [{ key: "V", value: function V(e) {
      var r = e.L, i = e.B;
      r.B = i, i.L = r, e === this.p && (this.p = i), e === this._ && (this._ = r), this.i -= 1;
    } }, { key: "G", value: function G(e, r) {
      var i = r.B, n = { l: e, L: r, B: i };
      r.B = n, i.L = n, r === this.h && (this.p = n), i === this.h && (this._ = n), this.i += 1;
    } }, { key: "clear", value: function clear() {
      this.i = 0, this.p = this._ = this.h.L = this.h.B = this.h;
    } }, { key: "begin", value: function begin() {
      return new Er(this.p, this.h, this);
    } }, { key: "end", value: function end() {
      return new Er(this.h, this.h, this);
    } }, { key: "rBegin", value: function rBegin() {
      return new Er(this._, this.h, this, 1);
    } }, { key: "rEnd", value: function rEnd() {
      return new Er(this.h, this.h, this, 1);
    } }, { key: "front", value: function front() {
      return this.p.l;
    } }, { key: "back", value: function back() {
      return this._.l;
    } }, { key: "getElementByPos", value: function getElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var r = this.p;
      for (; e--; )
        r = r.B;
      return r.l;
    } }, { key: "eraseElementByPos", value: function eraseElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var r = this.p;
      for (; e--; )
        r = r.B;
      return this.V(r), this.i;
    } }, { key: "eraseElementByValue", value: function eraseElementByValue(e) {
      var r = this.p;
      for (; r !== this.h; )
        r.l === e && this.V(r), r = r.B;
      return this.i;
    } }, { key: "eraseElementByIterator", value: function eraseElementByIterator(e) {
      var r = e.o;
      return r === this.h && (0, vr.throwIteratorAccessError)(), e = e.next(), this.V(r), e;
    } }, { key: "pushBack", value: function pushBack(e) {
      return this.G(e, this._), this.i;
    } }, { key: "popBack", value: function popBack() {
      if (this.i === 0)
        return;
      var e = this._.l;
      return this.V(this._), e;
    } }, { key: "pushFront", value: function pushFront(e) {
      return this.G(e, this.h), this.i;
    } }, { key: "popFront", value: function popFront() {
      if (this.i === 0)
        return;
      var e = this.p.l;
      return this.V(this.p), e;
    } }, { key: "setElementByPos", value: function setElementByPos(e, r) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var i = this.p;
      for (; e--; )
        i = i.B;
      i.l = r;
    } }, { key: "insert", value: function insert(e, r) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
      if (e < 0 || e > this.i)
        throw new RangeError();
      if (i <= 0)
        return this.i;
      if (e === 0)
        for (; i--; )
          this.pushFront(r);
      else if (e === this.i)
        for (; i--; )
          this.pushBack(r);
      else {
        var _n24 = this.p;
        for (var _s16 = 1; _s16 < e; ++_s16)
          _n24 = _n24.B;
        var _o23 = _n24.B;
        for (this.i += i; i--; )
          _n24.B = { l: r, L: _n24 }, _n24.B.L = _n24, _n24 = _n24.B;
        _n24.B = _o23, _o23.L = _n24;
      }
      return this.i;
    } }, { key: "find", value: function find(e) {
      var r = this.p;
      for (; r !== this.h; ) {
        if (r.l === e)
          return new Er(r, this.h, this);
        r = r.B;
      }
      return this.end();
    } }, { key: "reverse", value: function reverse() {
      if (this.i <= 1)
        return;
      var e = this.p, r = this._, i = 0;
      for (; i << 1 < this.i; ) {
        var _n25 = e.l;
        e.l = r.l, r.l = _n25, e = e.B, r = r.L, i += 1;
      }
    } }, { key: "unique", value: function unique() {
      if (this.i <= 1)
        return this.i;
      var e = this.p;
      for (; e !== this.h; ) {
        var _r39 = e;
        for (; _r39.B !== this.h && _r39.l === _r39.B.l; )
          _r39 = _r39.B, this.i -= 1;
        e.B = _r39.B, e.B.L = e, e = e.B;
      }
      return this.i;
    } }, { key: "sort", value: function sort(e) {
      if (this.i <= 1)
        return;
      var r = [];
      this.forEach(function(n) {
        r.push(n);
      }), r.sort(e);
      var i = this.p;
      r.forEach(function(n) {
        i.l = n, i = i.B;
      });
    } }, { key: "merge", value: function merge(e) {
      var r = this;
      if (this.i === 0)
        e.forEach(function(i2) {
          r.pushBack(i2);
        });
      else {
        var i = this.p;
        e.forEach(function(n) {
          for (; i !== r.h && i.l <= n; )
            i = i.B;
          r.G(n, i.L);
        });
      }
      return this.i;
    } }, { key: "forEach", value: function forEach(e) {
      var r = this.p, i = 0;
      for (; r !== this.h; )
        e(r.l, i++, this), r = r.B;
    } }, { key: Symbol.iterator, value: function value() {
      return /* @__PURE__ */ _regeneratorRuntime().mark(function _callee34() {
        var e;
        return _regeneratorRuntime().wrap(function _callee34$(_context41) {
          while (1)
            switch (_context41.prev = _context41.next) {
              case 0:
                if (!(this.i === 0)) {
                  _context41.next = 2;
                  break;
                }
                return _context41.abrupt("return");
              case 2:
                e = this.p;
              case 3:
                if (!(e !== this.h)) {
                  _context41.next = 9;
                  break;
                }
                _context41.next = 6;
                return e.l;
              case 6:
                e = e.B;
              case 7:
                _context41.next = 3;
                break;
              case 9:
              case "end":
                return _context41.stop();
            }
        }, _callee34, this);
      }).bind(this)();
    } }]);
  }(M1.default), N1 = _a;
  Hn.default = N1;
});
var op = M(function(Vn) {
  _();
  v();
  m();
  Object.defineProperty(Vn, "t", { value: true });
  Vn.default = void 0;
  var q1 = j1(jn()), D1 = ba();
  function j1(t) {
    return t && t.t ? t : { default: t };
  }
  var Sr = /* @__PURE__ */ function(_D1$RandomIterator) {
    function t(e, r, i) {
      var _this28;
      _classCallCheck(this, t);
      _this28 = _callSuper(this, t, [e, i]), _this28.container = r;
      return _this28;
    }
    _inherits(t, _D1$RandomIterator);
    return _createClass(t, [{ key: "copy", value: function copy() {
      return new t(this.o, this.container, this.iteratorType);
    } }]);
  }(D1.RandomIterator), ma = /* @__PURE__ */ function(_q1$default) {
    function ma2() {
      var _this29;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4096;
      _classCallCheck(this, ma2);
      _this29 = _callSuper(this, ma2), _this29.j = 0, _this29.D = 0, _this29.R = 0, _this29.N = 0, _this29.P = 0, _this29.A = [];
      var i = function() {
        if (typeof e.length == "number")
          return e.length;
        if (typeof e.size == "number")
          return e.size;
        if (typeof e.size == "function")
          return e.size();
        throw new TypeError("Cannot get the length or size of the container");
      }();
      _this29.F = r, _this29.P = Math.max(Math.ceil(i / _this29.F), 1);
      for (var _s17 = 0; _s17 < _this29.P; ++_s17)
        _this29.A.push(new Array(_this29.F));
      var n = Math.ceil(i / _this29.F);
      _this29.j = _this29.R = (_this29.P >> 1) - (n >> 1), _this29.D = _this29.N = _this29.F - i % _this29.F >> 1;
      var o = _this29;
      e.forEach(function(s) {
        o.pushBack(s);
      });
      return _this29;
    }
    _inherits(ma2, _q1$default);
    return _createClass(ma2, [{ key: "T", value: function T() {
      var e = [], r = Math.max(this.P >> 1, 1);
      for (var i = 0; i < r; ++i)
        e[i] = new Array(this.F);
      for (var _i15 = this.j; _i15 < this.P; ++_i15)
        e[e.length] = this.A[_i15];
      for (var _i16 = 0; _i16 < this.R; ++_i16)
        e[e.length] = this.A[_i16];
      e[e.length] = _toConsumableArray(this.A[this.R]), this.j = r, this.R = e.length - 1;
      for (var _i17 = 0; _i17 < r; ++_i17)
        e[e.length] = new Array(this.F);
      this.A = e, this.P = e.length;
    } }, { key: "O", value: function O2(e) {
      var r = this.D + e + 1, i = r % this.F, n = i - 1, o = this.j + (r - i) / this.F;
      return i === 0 && (o -= 1), o %= this.P, n < 0 && (n += this.F), { curNodeBucketIndex: o, curNodePointerIndex: n };
    } }, { key: "clear", value: function clear() {
      this.A = [new Array(this.F)], this.P = 1, this.j = this.R = this.i = 0, this.D = this.N = this.F >> 1;
    } }, { key: "begin", value: function begin() {
      return new Sr(0, this);
    } }, { key: "end", value: function end() {
      return new Sr(this.i, this);
    } }, { key: "rBegin", value: function rBegin() {
      return new Sr(this.i - 1, this, 1);
    } }, { key: "rEnd", value: function rEnd() {
      return new Sr(-1, this, 1);
    } }, { key: "front", value: function front() {
      if (this.i !== 0)
        return this.A[this.j][this.D];
    } }, { key: "back", value: function back() {
      if (this.i !== 0)
        return this.A[this.R][this.N];
    } }, { key: "pushBack", value: function pushBack(e) {
      return this.i && (this.N < this.F - 1 ? this.N += 1 : this.R < this.P - 1 ? (this.R += 1, this.N = 0) : (this.R = 0, this.N = 0), this.R === this.j && this.N === this.D && this.T()), this.i += 1, this.A[this.R][this.N] = e, this.i;
    } }, { key: "popBack", value: function popBack() {
      if (this.i === 0)
        return;
      var e = this.A[this.R][this.N];
      return this.i !== 1 && (this.N > 0 ? this.N -= 1 : this.R > 0 ? (this.R -= 1, this.N = this.F - 1) : (this.R = this.P - 1, this.N = this.F - 1)), this.i -= 1, e;
    } }, { key: "pushFront", value: function pushFront(e) {
      return this.i && (this.D > 0 ? this.D -= 1 : this.j > 0 ? (this.j -= 1, this.D = this.F - 1) : (this.j = this.P - 1, this.D = this.F - 1), this.j === this.R && this.D === this.N && this.T()), this.i += 1, this.A[this.j][this.D] = e, this.i;
    } }, { key: "popFront", value: function popFront() {
      if (this.i === 0)
        return;
      var e = this.A[this.j][this.D];
      return this.i !== 1 && (this.D < this.F - 1 ? this.D += 1 : this.j < this.P - 1 ? (this.j += 1, this.D = 0) : (this.j = 0, this.D = 0)), this.i -= 1, e;
    } }, { key: "getElementByPos", value: function getElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var _this$O = this.O(e), r = _this$O.curNodeBucketIndex, i = _this$O.curNodePointerIndex;
      return this.A[r][i];
    } }, { key: "setElementByPos", value: function setElementByPos(e, r) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var _this$O2 = this.O(e), i = _this$O2.curNodeBucketIndex, n = _this$O2.curNodePointerIndex;
      this.A[i][n] = r;
    } }, { key: "insert", value: function insert(e, r) {
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
      if (e < 0 || e > this.i)
        throw new RangeError();
      if (e === 0)
        for (; i--; )
          this.pushFront(r);
      else if (e === this.i)
        for (; i--; )
          this.pushBack(r);
      else {
        var _n26 = [];
        for (var _o24 = e; _o24 < this.i; ++_o24)
          _n26.push(this.getElementByPos(_o24));
        this.cut(e - 1);
        for (var _o25 = 0; _o25 < i; ++_o25)
          this.pushBack(r);
        for (var _o26 = 0; _o26 < _n26.length; ++_o26)
          this.pushBack(_n26[_o26]);
      }
      return this.i;
    } }, { key: "cut", value: function cut(e) {
      if (e < 0)
        return this.clear(), 0;
      var _this$O3 = this.O(e), r = _this$O3.curNodeBucketIndex, i = _this$O3.curNodePointerIndex;
      return this.R = r, this.N = i, this.i = e + 1, this.i;
    } }, { key: "eraseElementByPos", value: function eraseElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      if (e === 0)
        this.popFront();
      else if (e === this.i - 1)
        this.popBack();
      else {
        var _r40 = [];
        for (var _n27 = e + 1; _n27 < this.i; ++_n27)
          _r40.push(this.getElementByPos(_n27));
        this.cut(e), this.popBack();
        var i = this;
        _r40.forEach(function(n) {
          i.pushBack(n);
        });
      }
      return this.i;
    } }, { key: "eraseElementByValue", value: function eraseElementByValue(e) {
      if (this.i === 0)
        return 0;
      var r = [];
      for (var _n28 = 0; _n28 < this.i; ++_n28) {
        var _o27 = this.getElementByPos(_n28);
        _o27 !== e && r.push(_o27);
      }
      var i = r.length;
      for (var _n29 = 0; _n29 < i; ++_n29)
        this.setElementByPos(_n29, r[_n29]);
      return this.cut(i - 1);
    } }, { key: "eraseElementByIterator", value: function eraseElementByIterator(e) {
      var r = e.o;
      return this.eraseElementByPos(r), e = e.next(), e;
    } }, { key: "find", value: function find(e) {
      for (var _r41 = 0; _r41 < this.i; ++_r41)
        if (this.getElementByPos(_r41) === e)
          return new Sr(_r41, this);
      return this.end();
    } }, { key: "reverse", value: function reverse() {
      var e = 0, r = this.i - 1;
      for (; e < r; ) {
        var i = this.getElementByPos(e);
        this.setElementByPos(e, this.getElementByPos(r)), this.setElementByPos(r, i), e += 1, r -= 1;
      }
    } }, { key: "unique", value: function unique() {
      if (this.i <= 1)
        return this.i;
      var e = 1, r = this.getElementByPos(0);
      for (var i = 1; i < this.i; ++i) {
        var _n30 = this.getElementByPos(i);
        _n30 !== r && (r = _n30, this.setElementByPos(e++, _n30));
      }
      for (; this.i > e; )
        this.popBack();
      return this.i;
    } }, { key: "sort", value: function sort(e) {
      var r = [];
      for (var i = 0; i < this.i; ++i)
        r.push(this.getElementByPos(i));
      r.sort(e);
      for (var _i18 = 0; _i18 < this.i; ++_i18)
        this.setElementByPos(_i18, r[_i18]);
    } }, { key: "shrinkToFit", value: function shrinkToFit() {
      if (this.i === 0)
        return;
      var e = [];
      this.forEach(function(r) {
        e.push(r);
      }), this.P = Math.max(Math.ceil(this.i / this.F), 1), this.i = this.j = this.R = this.D = this.N = 0, this.A = [];
      for (var _r42 = 0; _r42 < this.P; ++_r42)
        this.A.push(new Array(this.F));
      for (var _r43 = 0; _r43 < e.length; ++_r43)
        this.pushBack(e[_r43]);
    } }, { key: "forEach", value: function forEach(e) {
      for (var _r44 = 0; _r44 < this.i; ++_r44)
        e(this.getElementByPos(_r44), _r44, this);
    } }, { key: Symbol.iterator, value: function value() {
      return /* @__PURE__ */ _regeneratorRuntime().mark(function _callee35() {
        var e;
        return _regeneratorRuntime().wrap(function _callee35$(_context42) {
          while (1)
            switch (_context42.prev = _context42.next) {
              case 0:
                e = 0;
              case 1:
                if (!(e < this.i)) {
                  _context42.next = 7;
                  break;
                }
                _context42.next = 4;
                return this.getElementByPos(e);
              case 4:
                ++e;
                _context42.next = 1;
                break;
              case 7:
              case "end":
                return _context42.stop();
            }
        }, _callee35, this);
      }).bind(this)();
    } }]);
  }(q1.default), F1 = ma;
  Vn.default = F1;
});
var ap = M(function(ei) {
  _();
  v();
  m();
  Object.defineProperty(ei, "t", { value: true });
  ei.TreeNodeEnableIndex = ei.TreeNode = void 0;
  var zn = /* @__PURE__ */ function() {
    function zn2(e, r) {
      _classCallCheck(this, zn2);
      this.ee = 1, this.u = void 0, this.l = void 0, this.U = void 0, this.W = void 0, this.tt = void 0, this.u = e, this.l = r;
    }
    return _createClass(zn2, [{ key: "L", value: function L() {
      var e = this;
      if (e.ee === 1 && e.tt.tt === e)
        e = e.W;
      else if (e.U)
        for (e = e.U; e.W; )
          e = e.W;
      else {
        var _r45 = e.tt;
        for (; _r45.U === e; )
          e = _r45, _r45 = e.tt;
        e = _r45;
      }
      return e;
    } }, { key: "B", value: function B2() {
      var e = this;
      if (e.W) {
        for (e = e.W; e.U; )
          e = e.U;
        return e;
      } else {
        var _r46 = e.tt;
        for (; _r46.W === e; )
          e = _r46, _r46 = e.tt;
        return e.W !== _r46 ? _r46 : e;
      }
    } }, { key: "te", value: function te() {
      var e = this.tt, r = this.W, i = r.U;
      return e.tt === this ? e.tt = r : e.U === this ? e.U = r : e.W = r, r.tt = e, r.U = this, this.tt = r, this.W = i, i && (i.tt = this), r;
    } }, { key: "se", value: function se() {
      var e = this.tt, r = this.U, i = r.W;
      return e.tt === this ? e.tt = r : e.U === this ? e.U = r : e.W = r, r.tt = e, r.W = this, this.tt = r, this.U = i, i && (i.tt = this), r;
    } }]);
  }();
  ei.TreeNode = zn;
  var va = /* @__PURE__ */ function(_zn) {
    function va2() {
      var _this30;
      _classCallCheck(this, va2);
      _this30 = _callSuper(this, va2, arguments), _this30.rt = 1;
      return _this30;
    }
    _inherits(va2, _zn);
    return _createClass(va2, [{ key: "te", value: function te() {
      var e = _superPropGet(va2, "te", this, 3)([]);
      return this.ie(), e.ie(), e;
    } }, { key: "se", value: function se() {
      var e = _superPropGet(va2, "se", this, 3)([]);
      return this.ie(), e.ie(), e;
    } }, { key: "ie", value: function ie() {
      this.rt = 1, this.U && (this.rt += this.U.rt), this.W && (this.rt += this.W.rt);
    } }]);
  }(zn);
  ei.TreeNodeEnableIndex = va;
});
var Sa = M(function(Kn) {
  _();
  v();
  m();
  Object.defineProperty(Kn, "t", { value: true });
  Kn.default = void 0;
  var lp = ap(), W1 = lt(), up = ut(), Ea = /* @__PURE__ */ function(_W1$Container) {
    function Ea2() {
      var _this31;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(i, n) {
        return i < n ? -1 : i > n ? 1 : 0;
      };
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      _classCallCheck(this, Ea2);
      _this31 = _callSuper(this, Ea2), _this31.Y = void 0, _this31.v = e, r ? (_this31.re = lp.TreeNodeEnableIndex, _this31.M = function(i, n, o) {
        var s = this.ne(i, n, o);
        if (s) {
          var _a15 = s.tt;
          for (; _a15 !== this.h; )
            _a15.rt += 1, _a15 = _a15.tt;
          var _l23 = this.he(s);
          if (_l23) {
            var _c14 = _l23.parentNode, _h6 = _l23.grandParent, _d8 = _l23.curNode;
            _c14.ie(), _h6.ie(), _d8.ie();
          }
        }
        return this.i;
      }, _this31.V = function(i) {
        var n = this.fe(i);
        for (; n !== this.h; )
          n.rt -= 1, n = n.tt;
      }) : (_this31.re = lp.TreeNode, _this31.M = function(i, n, o) {
        var s = this.ne(i, n, o);
        return s && this.he(s), this.i;
      }, _this31.V = _this31.fe), _this31.h = new _this31.re();
      return _this31;
    }
    _inherits(Ea2, _W1$Container);
    return _createClass(Ea2, [{ key: "X", value: function X3(e, r) {
      var i = this.h;
      for (; e; ) {
        var _n31 = this.v(e.u, r);
        if (_n31 < 0)
          e = e.W;
        else if (_n31 > 0)
          i = e, e = e.U;
        else
          return e;
      }
      return i;
    } }, { key: "Z", value: function Z2(e, r) {
      var i = this.h;
      for (; e; )
        this.v(e.u, r) <= 0 ? e = e.W : (i = e, e = e.U);
      return i;
    } }, { key: "$", value: function $(e, r) {
      var i = this.h;
      for (; e; ) {
        var _n32 = this.v(e.u, r);
        if (_n32 < 0)
          i = e, e = e.W;
        else if (_n32 > 0)
          e = e.U;
        else
          return e;
      }
      return i;
    } }, { key: "rr", value: function rr(e, r) {
      var i = this.h;
      for (; e; )
        this.v(e.u, r) < 0 ? (i = e, e = e.W) : e = e.U;
      return i;
    } }, { key: "ue", value: function ue(e) {
      for (; ; ) {
        var _r47 = e.tt;
        if (_r47 === this.h)
          return;
        if (e.ee === 1) {
          e.ee = 0;
          return;
        }
        if (e === _r47.U) {
          var i = _r47.W;
          if (i.ee === 1)
            i.ee = 0, _r47.ee = 1, _r47 === this.Y ? this.Y = _r47.te() : _r47.te();
          else if (i.W && i.W.ee === 1) {
            i.ee = _r47.ee, _r47.ee = 0, i.W.ee = 0, _r47 === this.Y ? this.Y = _r47.te() : _r47.te();
            return;
          } else
            i.U && i.U.ee === 1 ? (i.ee = 1, i.U.ee = 0, i.se()) : (i.ee = 1, e = _r47);
        } else {
          var _i19 = _r47.U;
          if (_i19.ee === 1)
            _i19.ee = 0, _r47.ee = 1, _r47 === this.Y ? this.Y = _r47.se() : _r47.se();
          else if (_i19.U && _i19.U.ee === 1) {
            _i19.ee = _r47.ee, _r47.ee = 0, _i19.U.ee = 0, _r47 === this.Y ? this.Y = _r47.se() : _r47.se();
            return;
          } else
            _i19.W && _i19.W.ee === 1 ? (_i19.ee = 1, _i19.W.ee = 0, _i19.te()) : (_i19.ee = 1, e = _r47);
        }
      }
    } }, { key: "fe", value: function fe2(e) {
      if (this.i === 1)
        return this.clear(), this.h;
      var r = e;
      for (; r.U || r.W; ) {
        var _ref38, _ref39;
        if (r.W)
          for (r = r.W; r.U; )
            r = r.U;
        else
          r = r.U;
        _ref38 = [r.u, e.u], e.u = _ref38[0], r.u = _ref38[1], _ref39 = [r.l, e.l], e.l = _ref39[0], r.l = _ref39[1], e = r;
      }
      this.h.U === r ? this.h.U = r.tt : this.h.W === r && (this.h.W = r.tt), this.ue(r);
      var i = r.tt;
      return r === i.U ? i.U = void 0 : i.W = void 0, this.i -= 1, this.Y.ee = 0, i;
    } }, { key: "oe", value: function oe(e, r) {
      return e === void 0 ? false : this.oe(e.U, r) || r(e) ? true : this.oe(e.W, r);
    } }, { key: "he", value: function he(e) {
      for (; ; ) {
        var _r48 = e.tt;
        if (_r48.ee === 0)
          return;
        var i = _r48.tt;
        if (_r48 === i.U) {
          var _n33 = i.W;
          if (_n33 && _n33.ee === 1) {
            if (_n33.ee = _r48.ee = 0, i === this.Y)
              return;
            i.ee = 1, e = i;
            continue;
          } else if (e === _r48.W) {
            if (e.ee = 0, e.U && (e.U.tt = _r48), e.W && (e.W.tt = i), _r48.W = e.U, i.U = e.W, e.U = _r48, e.W = i, i === this.Y)
              this.Y = e, this.h.tt = e;
            else {
              var _o28 = i.tt;
              _o28.U === i ? _o28.U = e : _o28.W = e;
            }
            return e.tt = i.tt, _r48.tt = e, i.tt = e, i.ee = 1, { parentNode: _r48, grandParent: i, curNode: e };
          } else
            _r48.ee = 0, i === this.Y ? this.Y = i.se() : i.se(), i.ee = 1;
        } else {
          var _n34 = i.U;
          if (_n34 && _n34.ee === 1) {
            if (_n34.ee = _r48.ee = 0, i === this.Y)
              return;
            i.ee = 1, e = i;
            continue;
          } else if (e === _r48.U) {
            if (e.ee = 0, e.U && (e.U.tt = i), e.W && (e.W.tt = _r48), i.W = e.U, _r48.U = e.W, e.U = i, e.W = _r48, i === this.Y)
              this.Y = e, this.h.tt = e;
            else {
              var _o29 = i.tt;
              _o29.U === i ? _o29.U = e : _o29.W = e;
            }
            return e.tt = i.tt, _r48.tt = e, i.tt = e, i.ee = 1, { parentNode: _r48, grandParent: i, curNode: e };
          } else
            _r48.ee = 0, i === this.Y ? this.Y = i.te() : i.te(), i.ee = 1;
        }
        return;
      }
    } }, { key: "ne", value: function ne2(e, r, i) {
      if (this.Y === void 0) {
        this.i += 1, this.Y = new this.re(e, r), this.Y.ee = 0, this.Y.tt = this.h, this.h.tt = this.Y, this.h.U = this.Y, this.h.W = this.Y;
        return;
      }
      var n, o = this.h.U, s = this.v(o.u, e);
      if (s === 0) {
        o.l = r;
        return;
      } else if (s > 0)
        o.U = new this.re(e, r), o.U.tt = o, n = o.U, this.h.U = n;
      else {
        var _a16 = this.h.W, _l24 = this.v(_a16.u, e);
        if (_l24 === 0) {
          _a16.l = r;
          return;
        } else if (_l24 < 0)
          _a16.W = new this.re(e, r), _a16.W.tt = _a16, n = _a16.W, this.h.W = n;
        else {
          if (i !== void 0) {
            var _c15 = i.o;
            if (_c15 !== this.h) {
              var _h7 = this.v(_c15.u, e);
              if (_h7 === 0) {
                _c15.l = r;
                return;
              } else if (_h7 > 0) {
                var _d9 = _c15.L(), _g14 = this.v(_d9.u, e);
                if (_g14 === 0) {
                  _d9.l = r;
                  return;
                } else
                  _g14 < 0 && (n = new this.re(e, r), _d9.W === void 0 ? (_d9.W = n, n.tt = _d9) : (_c15.U = n, n.tt = _c15));
              }
            }
          }
          if (n === void 0)
            for (n = this.Y; ; ) {
              var _c16 = this.v(n.u, e);
              if (_c16 > 0) {
                if (n.U === void 0) {
                  n.U = new this.re(e, r), n.U.tt = n, n = n.U;
                  break;
                }
                n = n.U;
              } else if (_c16 < 0) {
                if (n.W === void 0) {
                  n.W = new this.re(e, r), n.W.tt = n, n = n.W;
                  break;
                }
                n = n.W;
              } else {
                n.l = r;
                return;
              }
            }
        }
      }
      return this.i += 1, n;
    } }, { key: "I", value: function I(e, r) {
      for (; e; ) {
        var i = this.v(e.u, r);
        if (i < 0)
          e = e.W;
        else if (i > 0)
          e = e.U;
        else
          return e;
      }
      return e || this.h;
    } }, { key: "clear", value: function clear() {
      this.i = 0, this.Y = void 0, this.h.tt = void 0, this.h.U = this.h.W = void 0;
    } }, { key: "updateKeyByIterator", value: function updateKeyByIterator(e, r) {
      var i = e.o;
      if (i === this.h && (0, up.throwIteratorAccessError)(), this.i === 1)
        return i.u = r, true;
      if (i === this.h.U)
        return this.v(i.B().u, r) > 0 ? (i.u = r, true) : false;
      if (i === this.h.W)
        return this.v(i.L().u, r) < 0 ? (i.u = r, true) : false;
      var n = i.L().u;
      if (this.v(n, r) >= 0)
        return false;
      var o = i.B().u;
      return this.v(o, r) <= 0 ? false : (i.u = r, true);
    } }, { key: "eraseElementByPos", value: function eraseElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var r = 0, i = this;
      return this.oe(this.Y, function(n) {
        return e === r ? (i.V(n), true) : (r += 1, false);
      }), this.i;
    } }, { key: "eraseElementByKey", value: function eraseElementByKey(e) {
      if (this.i === 0)
        return false;
      var r = this.I(this.Y, e);
      return r === this.h ? false : (this.V(r), true);
    } }, { key: "eraseElementByIterator", value: function eraseElementByIterator(e) {
      var r = e.o;
      r === this.h && (0, up.throwIteratorAccessError)();
      var i = r.W === void 0;
      return e.iteratorType === 0 ? i && e.next() : (!i || r.U === void 0) && e.next(), this.V(r), e;
    } }, { key: "forEach", value: function forEach(e) {
      var r = 0;
      var _iterator34 = _createForOfIteratorHelper(this), _step34;
      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done; ) {
          var i = _step34.value;
          e(i, r++, this);
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
    } }, { key: "getElementByPos", value: function getElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var r, i = 0;
      var _iterator35 = _createForOfIteratorHelper(this), _step35;
      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done; ) {
          var _n35 = _step35.value;
          if (i === e) {
            r = _n35;
            break;
          }
          i += 1;
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }
      return r;
    } }, { key: "getHeight", value: function getHeight() {
      if (this.i === 0)
        return 0;
      var _e9 = function e(r) {
        return r ? Math.max(_e9(r.U), _e9(r.W)) + 1 : 0;
      };
      return _e9(this.Y);
    } }]);
  }(W1.Container), $1 = Ea;
  Kn.default = $1;
});
var Ia = M(function(Qn) {
  _();
  v();
  m();
  Object.defineProperty(Qn, "t", { value: true });
  Qn.default = void 0;
  var H1 = lt(), Gn = ut(), Aa = /* @__PURE__ */ function(_H1$ContainerIterator) {
    function Aa2(e, r, i) {
      var _this32;
      _classCallCheck(this, Aa2);
      _this32 = _callSuper(this, Aa2, [i]), _this32.o = e, _this32.h = r, _this32.iteratorType === 0 ? (_this32.pre = function() {
        return this.o === this.h.U && (0, Gn.throwIteratorAccessError)(), this.o = this.o.L(), this;
      }, _this32.next = function() {
        return this.o === this.h && (0, Gn.throwIteratorAccessError)(), this.o = this.o.B(), this;
      }) : (_this32.pre = function() {
        return this.o === this.h.W && (0, Gn.throwIteratorAccessError)(), this.o = this.o.B(), this;
      }, _this32.next = function() {
        return this.o === this.h && (0, Gn.throwIteratorAccessError)(), this.o = this.o.L(), this;
      });
      return _this32;
    }
    _inherits(Aa2, _H1$ContainerIterator);
    return _createClass(Aa2, [{ key: "index", get: function get2() {
      var e = this.o, r = this.h.tt;
      if (e === this.h)
        return r ? r.rt - 1 : 0;
      var i = 0;
      for (e.U && (i += e.U.rt); e !== r; ) {
        var _n36 = e.tt;
        e === _n36.W && (i += 1, _n36.U && (i += _n36.U.rt)), e = _n36;
      }
      return i;
    } }]);
  }(H1.ContainerIterator), V1 = Aa;
  Qn.default = V1;
});
var cp = M(function(Yn) {
  _();
  v();
  m();
  Object.defineProperty(Yn, "t", { value: true });
  Yn.default = void 0;
  var z1 = fp(Sa()), K1 = fp(Ia()), G1 = ut();
  function fp(t) {
    return t && t.t ? t : { default: t };
  }
  var Ke = /* @__PURE__ */ function(_K1$default) {
    function t(e, r, i, n) {
      var _this33;
      _classCallCheck(this, t);
      _this33 = _callSuper(this, t, [e, r, n]), _this33.container = i;
      return _this33;
    }
    _inherits(t, _K1$default);
    return _createClass(t, [{ key: "pointer", get: function get2() {
      return this.o === this.h && (0, G1.throwIteratorAccessError)(), this.o.u;
    } }, { key: "copy", value: function copy() {
      return new t(this.o, this.h, this.container, this.iteratorType);
    } }]);
  }(K1.default), Ta = /* @__PURE__ */ function(_z1$default) {
    function Ta2() {
      var _this34;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var r = arguments.length > 1 ? arguments[1] : void 0;
      var i = arguments.length > 2 ? arguments[2] : void 0;
      _classCallCheck(this, Ta2);
      _this34 = _callSuper(this, Ta2, [r, i]);
      var n = _this34;
      e.forEach(function(o) {
        n.insert(o);
      });
      return _this34;
    }
    _inherits(Ta2, _z1$default);
    return _createClass(Ta2, [{ key: "K", value: /* @__PURE__ */ _regeneratorRuntime().mark(function K(e) {
      return _regeneratorRuntime().wrap(function K$(_context43) {
        while (1)
          switch (_context43.prev = _context43.next) {
            case 0:
              _context43.t0 = e !== void 0;
              if (!_context43.t0) {
                _context43.next = 6;
                break;
              }
              return _context43.delegateYield(this.K(e.U), "t1", 3);
            case 3:
              _context43.next = 5;
              return e.u;
            case 5:
              return _context43.delegateYield(this.K(e.W), "t2", 6);
            case 6:
            case "end":
              return _context43.stop();
          }
      }, K, this);
    }) }, { key: "begin", value: function begin() {
      return new Ke(this.h.U || this.h, this.h, this);
    } }, { key: "end", value: function end() {
      return new Ke(this.h, this.h, this);
    } }, { key: "rBegin", value: function rBegin() {
      return new Ke(this.h.W || this.h, this.h, this, 1);
    } }, { key: "rEnd", value: function rEnd() {
      return new Ke(this.h, this.h, this, 1);
    } }, { key: "front", value: function front() {
      return this.h.U ? this.h.U.u : void 0;
    } }, { key: "back", value: function back() {
      return this.h.W ? this.h.W.u : void 0;
    } }, { key: "insert", value: function insert(e, r) {
      return this.M(e, void 0, r);
    } }, { key: "find", value: function find(e) {
      var r = this.I(this.Y, e);
      return new Ke(r, this.h, this);
    } }, { key: "lowerBound", value: function lowerBound(e) {
      var r = this.X(this.Y, e);
      return new Ke(r, this.h, this);
    } }, { key: "upperBound", value: function upperBound(e) {
      var r = this.Z(this.Y, e);
      return new Ke(r, this.h, this);
    } }, { key: "reverseLowerBound", value: function reverseLowerBound(e) {
      var r = this.$(this.Y, e);
      return new Ke(r, this.h, this);
    } }, { key: "reverseUpperBound", value: function reverseUpperBound(e) {
      var r = this.rr(this.Y, e);
      return new Ke(r, this.h, this);
    } }, { key: "union", value: function union(e) {
      var r = this;
      return e.forEach(function(i) {
        r.insert(i);
      }), this.i;
    } }, { key: Symbol.iterator, value: function value() {
      return this.K(this.Y);
    } }]);
  }(z1.default), Q1 = Ta;
  Yn.default = Q1;
});
var dp = M(function(Jn) {
  _();
  v();
  m();
  Object.defineProperty(Jn, "t", { value: true });
  Jn.default = void 0;
  var Y1 = hp(Sa()), J1 = hp(Ia()), X1 = ut();
  function hp(t) {
    return t && t.t ? t : { default: t };
  }
  var Ge = /* @__PURE__ */ function(_J1$default) {
    function t(e, r, i, n) {
      var _this35;
      _classCallCheck(this, t);
      _this35 = _callSuper(this, t, [e, r, n]), _this35.container = i;
      return _this35;
    }
    _inherits(t, _J1$default);
    return _createClass(t, [{ key: "pointer", get: function get2() {
      this.o === this.h && (0, X1.throwIteratorAccessError)();
      var e = this;
      return new Proxy([], { get: function get3(r, i) {
        if (i === "0")
          return e.o.u;
        if (i === "1")
          return e.o.l;
      }, set: function set(r, i, n) {
        if (i !== "1")
          throw new TypeError("props must be 1");
        return e.o.l = n, true;
      } });
    } }, { key: "copy", value: function copy() {
      return new t(this.o, this.h, this.container, this.iteratorType);
    } }]);
  }(J1.default), Ra = /* @__PURE__ */ function(_Y1$default) {
    function Ra2() {
      var _this36;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      var r = arguments.length > 1 ? arguments[1] : void 0;
      var i = arguments.length > 2 ? arguments[2] : void 0;
      _classCallCheck(this, Ra2);
      _this36 = _callSuper(this, Ra2, [r, i]);
      var n = _this36;
      e.forEach(function(o) {
        n.setElement(o[0], o[1]);
      });
      return _this36;
    }
    _inherits(Ra2, _Y1$default);
    return _createClass(Ra2, [{ key: "K", value: /* @__PURE__ */ _regeneratorRuntime().mark(function K(e) {
      return _regeneratorRuntime().wrap(function K$(_context44) {
        while (1)
          switch (_context44.prev = _context44.next) {
            case 0:
              _context44.t0 = e !== void 0;
              if (!_context44.t0) {
                _context44.next = 6;
                break;
              }
              return _context44.delegateYield(this.K(e.U), "t1", 3);
            case 3:
              _context44.next = 5;
              return [e.u, e.l];
            case 5:
              return _context44.delegateYield(this.K(e.W), "t2", 6);
            case 6:
            case "end":
              return _context44.stop();
          }
      }, K, this);
    }) }, { key: "begin", value: function begin() {
      return new Ge(this.h.U || this.h, this.h, this);
    } }, { key: "end", value: function end() {
      return new Ge(this.h, this.h, this);
    } }, { key: "rBegin", value: function rBegin() {
      return new Ge(this.h.W || this.h, this.h, this, 1);
    } }, { key: "rEnd", value: function rEnd() {
      return new Ge(this.h, this.h, this, 1);
    } }, { key: "front", value: function front() {
      if (this.i === 0)
        return;
      var e = this.h.U;
      return [e.u, e.l];
    } }, { key: "back", value: function back() {
      if (this.i === 0)
        return;
      var e = this.h.W;
      return [e.u, e.l];
    } }, { key: "lowerBound", value: function lowerBound(e) {
      var r = this.X(this.Y, e);
      return new Ge(r, this.h, this);
    } }, { key: "upperBound", value: function upperBound(e) {
      var r = this.Z(this.Y, e);
      return new Ge(r, this.h, this);
    } }, { key: "reverseLowerBound", value: function reverseLowerBound(e) {
      var r = this.$(this.Y, e);
      return new Ge(r, this.h, this);
    } }, { key: "reverseUpperBound", value: function reverseUpperBound(e) {
      var r = this.rr(this.Y, e);
      return new Ge(r, this.h, this);
    } }, { key: "setElement", value: function setElement(e, r, i) {
      return this.M(e, r, i);
    } }, { key: "find", value: function find(e) {
      var r = this.I(this.Y, e);
      return new Ge(r, this.h, this);
    } }, { key: "getElementByKey", value: function getElementByKey(e) {
      return this.I(this.Y, e).l;
    } }, { key: "union", value: function union(e) {
      var r = this;
      return e.forEach(function(i) {
        r.setElement(i[0], i[1]);
      }), this.i;
    } }, { key: Symbol.iterator, value: function value() {
      return this.K(this.Y);
    } }]);
  }(Y1.default), Z1 = Ra;
  Jn.default = Z1;
});
var Ba = M(function(Ca) {
  _();
  v();
  m();
  Object.defineProperty(Ca, "t", { value: true });
  Ca.default = ev;
  function ev(t) {
    var e = _typeof(t);
    return e === "object" && t !== null || e === "function";
  }
});
var xa = M(function(ti) {
  _();
  v();
  m();
  Object.defineProperty(ti, "t", { value: true });
  ti.HashContainerIterator = ti.HashContainer = void 0;
  var pp = lt(), Pa = tv(Ba()), Ci = ut();
  function tv(t) {
    return t && t.t ? t : { default: t };
  }
  var ka = /* @__PURE__ */ function(_pp$ContainerIterator) {
    function ka2(e, r, i) {
      var _this37;
      _classCallCheck(this, ka2);
      _this37 = _callSuper(this, ka2, [i]), _this37.o = e, _this37.h = r, _this37.iteratorType === 0 ? (_this37.pre = function() {
        return this.o.L === this.h && (0, Ci.throwIteratorAccessError)(), this.o = this.o.L, this;
      }, _this37.next = function() {
        return this.o === this.h && (0, Ci.throwIteratorAccessError)(), this.o = this.o.B, this;
      }) : (_this37.pre = function() {
        return this.o.B === this.h && (0, Ci.throwIteratorAccessError)(), this.o = this.o.B, this;
      }, _this37.next = function() {
        return this.o === this.h && (0, Ci.throwIteratorAccessError)(), this.o = this.o.L, this;
      });
      return _this37;
    }
    _inherits(ka2, _pp$ContainerIterator);
    return _createClass(ka2);
  }(pp.ContainerIterator);
  ti.HashContainerIterator = ka;
  var Oa = /* @__PURE__ */ function(_pp$Container) {
    function Oa2() {
      var _this38;
      _classCallCheck(this, Oa2);
      _this38 = _callSuper(this, Oa2), _this38.H = [], _this38.g = {}, _this38.HASH_TAG = Symbol("@@HASH_TAG"), Object.setPrototypeOf(_this38.g, null), _this38.h = {}, _this38.h.L = _this38.h.B = _this38.p = _this38._ = _this38.h;
      return _this38;
    }
    _inherits(Oa2, _pp$Container);
    return _createClass(Oa2, [{ key: "V", value: function V(e) {
      var r = e.L, i = e.B;
      r.B = i, i.L = r, e === this.p && (this.p = i), e === this._ && (this._ = r), this.i -= 1;
    } }, { key: "M", value: function M3(e, r, i) {
      i === void 0 && (i = (0, Pa.default)(e));
      var n;
      if (i) {
        var _o30 = e[this.HASH_TAG];
        if (_o30 !== void 0)
          return this.H[_o30].l = r, this.i;
        Object.defineProperty(e, this.HASH_TAG, { value: this.H.length, configurable: true }), n = { u: e, l: r, L: this._, B: this.h }, this.H.push(n);
      } else {
        var _o31 = this.g[e];
        if (_o31)
          return _o31.l = r, this.i;
        n = { u: e, l: r, L: this._, B: this.h }, this.g[e] = n;
      }
      return this.i === 0 ? (this.p = n, this.h.B = n) : this._.B = n, this._ = n, this.h.L = n, ++this.i;
    } }, { key: "I", value: function I(e, r) {
      if (r === void 0 && (r = (0, Pa.default)(e)), r) {
        var i = e[this.HASH_TAG];
        return i === void 0 ? this.h : this.H[i];
      } else
        return this.g[e] || this.h;
    } }, { key: "clear", value: function clear() {
      var e = this.HASH_TAG;
      this.H.forEach(function(r) {
        delete r.u[e];
      }), this.H = [], this.g = {}, Object.setPrototypeOf(this.g, null), this.i = 0, this.p = this._ = this.h.L = this.h.B = this.h;
    } }, { key: "eraseElementByKey", value: function eraseElementByKey(e, r) {
      var i;
      if (r === void 0 && (r = (0, Pa.default)(e)), r) {
        var _n37 = e[this.HASH_TAG];
        if (_n37 === void 0)
          return false;
        delete e[this.HASH_TAG], i = this.H[_n37], delete this.H[_n37];
      } else {
        if (i = this.g[e], i === void 0)
          return false;
        delete this.g[e];
      }
      return this.V(i), true;
    } }, { key: "eraseElementByIterator", value: function eraseElementByIterator(e) {
      var r = e.o;
      return r === this.h && (0, Ci.throwIteratorAccessError)(), this.V(r), e.next();
    } }, { key: "eraseElementByPos", value: function eraseElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var r = this.p;
      for (; e--; )
        r = r.B;
      return this.V(r), this.i;
    } }]);
  }(pp.Container);
  ti.HashContainer = Oa;
});
var yp = M(function(Xn) {
  _();
  v();
  m();
  Object.defineProperty(Xn, "t", { value: true });
  Xn.default = void 0;
  var gp = xa(), rv = ut(), Ar = /* @__PURE__ */ function(_gp$HashContainerIter) {
    function t(e, r, i, n) {
      var _this39;
      _classCallCheck(this, t);
      _this39 = _callSuper(this, t, [e, r, n]), _this39.container = i;
      return _this39;
    }
    _inherits(t, _gp$HashContainerIter);
    return _createClass(t, [{ key: "pointer", get: function get2() {
      return this.o === this.h && (0, rv.throwIteratorAccessError)(), this.o.u;
    } }, { key: "copy", value: function copy() {
      return new t(this.o, this.h, this.container, this.iteratorType);
    } }]);
  }(gp.HashContainerIterator), Ma = /* @__PURE__ */ function(_gp$HashContainer) {
    function Ma2() {
      var _this40;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      _classCallCheck(this, Ma2);
      _this40 = _callSuper(this, Ma2);
      var r = _this40;
      e.forEach(function(i) {
        r.insert(i);
      });
      return _this40;
    }
    _inherits(Ma2, _gp$HashContainer);
    return _createClass(Ma2, [{ key: "begin", value: function begin() {
      return new Ar(this.p, this.h, this);
    } }, { key: "end", value: function end() {
      return new Ar(this.h, this.h, this);
    } }, { key: "rBegin", value: function rBegin() {
      return new Ar(this._, this.h, this, 1);
    } }, { key: "rEnd", value: function rEnd() {
      return new Ar(this.h, this.h, this, 1);
    } }, { key: "front", value: function front() {
      return this.p.u;
    } }, { key: "back", value: function back() {
      return this._.u;
    } }, { key: "insert", value: function insert(e, r) {
      return this.M(e, void 0, r);
    } }, { key: "getElementByPos", value: function getElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var r = this.p;
      for (; e--; )
        r = r.B;
      return r.u;
    } }, { key: "find", value: function find(e, r) {
      var i = this.I(e, r);
      return new Ar(i, this.h, this);
    } }, { key: "forEach", value: function forEach(e) {
      var r = 0, i = this.p;
      for (; i !== this.h; )
        e(i.u, r++, this), i = i.B;
    } }, { key: Symbol.iterator, value: function value() {
      return /* @__PURE__ */ _regeneratorRuntime().mark(function _callee36() {
        var e;
        return _regeneratorRuntime().wrap(function _callee36$(_context45) {
          while (1)
            switch (_context45.prev = _context45.next) {
              case 0:
                e = this.p;
              case 1:
                if (!(e !== this.h)) {
                  _context45.next = 7;
                  break;
                }
                _context45.next = 4;
                return e.u;
              case 4:
                e = e.B;
              case 5:
                _context45.next = 1;
                break;
              case 7:
              case "end":
                return _context45.stop();
            }
        }, _callee36, this);
      }).bind(this)();
    } }]);
  }(gp.HashContainer), iv = Ma;
  Xn.default = iv;
});
var wp = M(function(Zn) {
  _();
  v();
  m();
  Object.defineProperty(Zn, "t", { value: true });
  Zn.default = void 0;
  var bp = xa(), nv = ov(Ba()), sv = ut();
  function ov(t) {
    return t && t.t ? t : { default: t };
  }
  var Ir = /* @__PURE__ */ function(_bp$HashContainerIter) {
    function t(e, r, i, n) {
      var _this41;
      _classCallCheck(this, t);
      _this41 = _callSuper(this, t, [e, r, n]), _this41.container = i;
      return _this41;
    }
    _inherits(t, _bp$HashContainerIter);
    return _createClass(t, [{ key: "pointer", get: function get2() {
      this.o === this.h && (0, sv.throwIteratorAccessError)();
      var e = this;
      return new Proxy([], { get: function get3(r, i) {
        if (i === "0")
          return e.o.u;
        if (i === "1")
          return e.o.l;
      }, set: function set(r, i, n) {
        if (i !== "1")
          throw new TypeError("props must be 1");
        return e.o.l = n, true;
      } });
    } }, { key: "copy", value: function copy() {
      return new t(this.o, this.h, this.container, this.iteratorType);
    } }]);
  }(bp.HashContainerIterator), La = /* @__PURE__ */ function(_bp$HashContainer) {
    function La2() {
      var _this42;
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      _classCallCheck(this, La2);
      _this42 = _callSuper(this, La2);
      var r = _this42;
      e.forEach(function(i) {
        r.setElement(i[0], i[1]);
      });
      return _this42;
    }
    _inherits(La2, _bp$HashContainer);
    return _createClass(La2, [{ key: "begin", value: function begin() {
      return new Ir(this.p, this.h, this);
    } }, { key: "end", value: function end() {
      return new Ir(this.h, this.h, this);
    } }, { key: "rBegin", value: function rBegin() {
      return new Ir(this._, this.h, this, 1);
    } }, { key: "rEnd", value: function rEnd() {
      return new Ir(this.h, this.h, this, 1);
    } }, { key: "front", value: function front() {
      if (this.i !== 0)
        return [this.p.u, this.p.l];
    } }, { key: "back", value: function back() {
      if (this.i !== 0)
        return [this._.u, this._.l];
    } }, { key: "setElement", value: function setElement(e, r, i) {
      return this.M(e, r, i);
    } }, { key: "getElementByKey", value: function getElementByKey(e, r) {
      if (r === void 0 && (r = (0, nv.default)(e)), r) {
        var _n38 = e[this.HASH_TAG];
        return _n38 !== void 0 ? this.H[_n38].l : void 0;
      }
      var i = this.g[e];
      return i ? i.l : void 0;
    } }, { key: "getElementByPos", value: function getElementByPos(e) {
      if (e < 0 || e > this.i - 1)
        throw new RangeError();
      var r = this.p;
      for (; e--; )
        r = r.B;
      return [r.u, r.l];
    } }, { key: "find", value: function find(e, r) {
      var i = this.I(e, r);
      return new Ir(i, this.h, this);
    } }, { key: "forEach", value: function forEach(e) {
      var r = 0, i = this.p;
      for (; i !== this.h; )
        e([i.u, i.l], r++, this), i = i.B;
    } }, { key: Symbol.iterator, value: function value() {
      return /* @__PURE__ */ _regeneratorRuntime().mark(function _callee37() {
        var e;
        return _regeneratorRuntime().wrap(function _callee37$(_context46) {
          while (1)
            switch (_context46.prev = _context46.next) {
              case 0:
                e = this.p;
              case 1:
                if (!(e !== this.h)) {
                  _context46.next = 7;
                  break;
                }
                _context46.next = 4;
                return [e.u, e.l];
              case 4:
                e = e.B;
              case 5:
                _context46.next = 1;
                break;
              case 7:
              case "end":
                return _context46.stop();
            }
        }, _callee37, this);
      }).bind(this)();
    } }]);
  }(bp.HashContainer), av = La;
  Zn.default = av;
});
var _p = M(function(je) {
  _();
  v();
  m();
  Object.defineProperty(je, "t", { value: true });
  Object.defineProperty(je, "Deque", { enumerable: true, get: function get2() {
    return dv.default;
  } });
  Object.defineProperty(je, "HashMap", { enumerable: true, get: function get2() {
    return bv.default;
  } });
  Object.defineProperty(je, "HashSet", { enumerable: true, get: function get2() {
    return yv.default;
  } });
  Object.defineProperty(je, "LinkList", { enumerable: true, get: function get2() {
    return hv.default;
  } });
  Object.defineProperty(je, "OrderedMap", { enumerable: true, get: function get2() {
    return gv.default;
  } });
  Object.defineProperty(je, "OrderedSet", { enumerable: true, get: function get2() {
    return pv.default;
  } });
  Object.defineProperty(je, "PriorityQueue", { enumerable: true, get: function get2() {
    return fv.default;
  } });
  Object.defineProperty(je, "Queue", { enumerable: true, get: function get2() {
    return uv.default;
  } });
  Object.defineProperty(je, "Stack", { enumerable: true, get: function get2() {
    return lv.default;
  } });
  Object.defineProperty(je, "Vector", { enumerable: true, get: function get2() {
    return cv.default;
  } });
  var lv = ft(tp()), uv = ft(rp()), fv = ft(ip()), cv = ft(np()), hv = ft(sp()), dv = ft(op()), pv = ft(cp()), gv = ft(dp()), yv = ft(yp()), bv = ft(wp());
  function ft(t) {
    return t && t.t ? t : { default: t };
  }
});
var vp = M(function(AN, mp) {
  _();
  v();
  m();
  var wv = _p().OrderedSet, ct = ot()("number-allocator:trace"), _v = ot()("number-allocator:error");
  function Re(t, e) {
    this.low = t, this.high = e;
  }
  Re.prototype.equals = function(t) {
    return this.low === t.low && this.high === t.high;
  };
  Re.prototype.compare = function(t) {
    return this.low < t.low && this.high < t.low ? -1 : t.low < this.low && t.high < this.low ? 1 : 0;
  };
  function ht(t, e) {
    if (!(this instanceof ht))
      return new ht(t, e);
    this.min = t, this.max = e, this.ss = new wv([], function(r, i) {
      return r.compare(i);
    }), ct("Create"), this.clear();
  }
  ht.prototype.firstVacant = function() {
    return this.ss.size() === 0 ? null : this.ss.front().low;
  };
  ht.prototype.alloc = function() {
    if (this.ss.size() === 0)
      return ct("alloc():empty"), null;
    var t = this.ss.begin(), e = t.pointer.low, r = t.pointer.high, i = e;
    return i + 1 <= r ? this.ss.updateKeyByIterator(t, new Re(e + 1, r)) : this.ss.eraseElementByPos(0), ct("alloc():" + i), i;
  };
  ht.prototype.use = function(t) {
    var e = new Re(t, t), r = this.ss.lowerBound(e);
    if (!r.equals(this.ss.end())) {
      var i = r.pointer.low, _n39 = r.pointer.high;
      return r.pointer.equals(e) ? (this.ss.eraseElementByIterator(r), ct("use():" + t), true) : i > t ? false : i === t ? (this.ss.updateKeyByIterator(r, new Re(i + 1, _n39)), ct("use():" + t), true) : _n39 === t ? (this.ss.updateKeyByIterator(r, new Re(i, _n39 - 1)), ct("use():" + t), true) : (this.ss.updateKeyByIterator(r, new Re(t + 1, _n39)), this.ss.insert(new Re(i, t - 1)), ct("use():" + t), true);
    }
    return ct("use():failed"), false;
  };
  ht.prototype.free = function(t) {
    if (t < this.min || t > this.max) {
      _v("free():" + t + " is out of range");
      return;
    }
    var e = new Re(t, t), r = this.ss.upperBound(e);
    if (r.equals(this.ss.end())) {
      if (r.equals(this.ss.begin())) {
        this.ss.insert(e);
        return;
      }
      r.pre();
      var i = r.pointer.high;
      r.pointer.high + 1 === t ? this.ss.updateKeyByIterator(r, new Re(i, t)) : this.ss.insert(e);
    } else if (r.equals(this.ss.begin())) {
      if (t + 1 === r.pointer.low) {
        var _i20 = r.pointer.high;
        this.ss.updateKeyByIterator(r, new Re(t, _i20));
      } else
        this.ss.insert(e);
    } else {
      var _i21 = r.pointer.low, _n40 = r.pointer.high;
      r.pre();
      var _o32 = r.pointer.low;
      r.pointer.high + 1 === t ? t + 1 === _i21 ? (this.ss.eraseElementByIterator(r), this.ss.updateKeyByIterator(r, new Re(_o32, _n40))) : this.ss.updateKeyByIterator(r, new Re(_o32, t)) : t + 1 === _i21 ? (this.ss.eraseElementByIterator(r.next()), this.ss.insert(new Re(t, _n40))) : this.ss.insert(e);
    }
    ct("free():" + t);
  };
  ht.prototype.clear = function() {
    ct("clear()"), this.ss.clear(), this.ss.insert(new Re(this.min, this.max));
  };
  ht.prototype.intervalCount = function() {
    return this.ss.size();
  };
  ht.prototype.dump = function() {
    console.log("length:" + this.ss.size());
    var _iterator36 = _createForOfIteratorHelper(this.ss), _step36;
    try {
      for (_iterator36.s(); !(_step36 = _iterator36.n()).done; ) {
        var t = _step36.value;
        console.log(t);
      }
    } catch (err) {
      _iterator36.e(err);
    } finally {
      _iterator36.f();
    }
  };
  mp.exports = ht;
});
var Ua = M(function(MN, Ep) {
  _();
  v();
  m();
  var mv = vp();
  Ep.exports.NumberAllocator = mv;
});
var Sp = M(function(qa) {
  _();
  v();
  m();
  Object.defineProperty(qa, "__esModule", { value: true });
  var vv = ep(), Ev = Ua(), Na = /* @__PURE__ */ function() {
    function Na2(e) {
      _classCallCheck(this, Na2);
      e > 0 && (this.aliasToTopic = new vv.LRUCache({ max: e }), this.topicToAlias = {}, this.numberAllocator = new Ev.NumberAllocator(1, e), this.max = e, this.length = 0);
    }
    return _createClass(Na2, [{ key: "put", value: function put2(e, r) {
      if (r === 0 || r > this.max)
        return false;
      var i = this.aliasToTopic.get(r);
      return i && delete this.topicToAlias[i], this.aliasToTopic.set(r, e), this.topicToAlias[e] = r, this.numberAllocator.use(r), this.length = this.aliasToTopic.size, true;
    } }, { key: "getTopicByAlias", value: function getTopicByAlias(e) {
      return this.aliasToTopic.get(e);
    } }, { key: "getAliasByTopic", value: function getAliasByTopic(e) {
      var r = this.topicToAlias[e];
      return _typeof(r) < "u" && this.aliasToTopic.get(r), r;
    } }, { key: "clear", value: function clear() {
      this.aliasToTopic.clear(), this.topicToAlias = {}, this.numberAllocator.clear(), this.length = 0;
    } }, { key: "getLruAlias", value: function getLruAlias() {
      var e = this.numberAllocator.firstVacant();
      return e || _toConsumableArray(this.aliasToTopic.keys())[this.aliasToTopic.size - 1];
    } }]);
  }();
  qa.default = Na;
});
var Ap = M(function(Bi) {
  _();
  v();
  m();
  var Sv = Bi && Bi.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(Bi, "__esModule", { value: true });
  var Av = Ti(), Iv = Sv(Sp()), Tv = _r(), Rv = function Rv2(t, e) {
    t.log("_handleConnack");
    var r = t.options, n = r.protocolVersion === 5 ? e.reasonCode : e.returnCode;
    if (clearTimeout(t.connackTimer), delete t.topicAliasSend, e.properties) {
      if (e.properties.topicAliasMaximum) {
        if (e.properties.topicAliasMaximum > 65535) {
          t.emit("error", new Error("topicAliasMaximum from broker is out of range"));
          return;
        }
        e.properties.topicAliasMaximum > 0 && (t.topicAliasSend = new Iv.default(e.properties.topicAliasMaximum));
      }
      e.properties.serverKeepAlive && r.keepalive && (r.keepalive = e.properties.serverKeepAlive), e.properties.maximumPacketSize && (r.properties || (r.properties = {}), r.properties.maximumPacketSize = e.properties.maximumPacketSize);
    }
    if (n === 0)
      t.reconnecting = false, t._onConnect(e);
    else if (n > 0) {
      var _o33 = new Tv.ErrorWithReasonCode("Connection refused: ".concat(Av.ReasonCodes[n]), n);
      t.emit("error", _o33), t.options.reconnectOnConnackError && t._cleanUp(true);
    }
  };
  Bi.default = Rv;
});
var Ip = M(function(Da) {
  _();
  v();
  m();
  Object.defineProperty(Da, "__esModule", { value: true });
  var Cv = function Cv2(t, e, r) {
    t.log("handling pubrel packet");
    var i = _typeof(r) < "u" ? r : t.noop, n = e.messageId, o = { cmd: "pubcomp", messageId: n };
    t.incomingStore.get(e, function(s, a) {
      s ? t._sendPacket(o, i) : (t.emit("message", a.topic, a.payload, a), t.handleMessage(a, function(l) {
        if (l)
          return i(l);
        t.incomingStore.del(a, t.noop), t._sendPacket(o, i);
      }));
    });
  };
  Da.default = Cv;
});
var Tp = M(function(Pi) {
  _();
  v();
  m();
  var ki = Pi && Pi.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(Pi, "__esModule", { value: true });
  var Bv = ki(Vd()), Pv = ki(Qd()), kv = ki(Ap()), Ov = ki(Ti()), xv = ki(Ip()), Mv = function Mv2(t, e, r) {
    var i = t.options;
    if (i.protocolVersion === 5 && i.properties && i.properties.maximumPacketSize && i.properties.maximumPacketSize < e.length)
      return t.emit("error", new Error("exceeding packets size ".concat(e.cmd))), t.end({ reasonCode: 149, properties: { reasonString: "Maximum packet size was exceeded" } }), t;
    switch (t.log("_handlePacket :: emitting packetreceive"), t.emit("packetreceive", e), e.cmd) {
      case "publish":
        (0, Bv.default)(t, e, r);
        break;
      case "puback":
      case "pubrec":
      case "pubcomp":
      case "suback":
      case "unsuback":
        t.reschedulePing(), (0, Ov.default)(t, e), r();
        break;
      case "pubrel":
        t.reschedulePing(), (0, xv.default)(t, e, r);
        break;
      case "connack":
        (0, kv.default)(t, e), r();
        break;
      case "auth":
        t.reschedulePing(), (0, Pv.default)(t, e), r();
        break;
      case "pingresp":
        t.log("_handlePacket :: received pingresp"), t.reschedulePing(true), r();
        break;
      case "disconnect":
        t.emit("disconnect", e), r();
        break;
      default:
        t.log("_handlePacket :: unknown command"), r();
        break;
    }
  };
  Pi.default = Mv;
});
var Rp = M(function(ri) {
  _();
  v();
  m();
  var Lv = ri && ri.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(ri, "__esModule", { value: true });
  ri.TypedEventEmitter = void 0;
  var Uv = Lv((sr(), X(nr))), Nv = _r(), es = /* @__PURE__ */ _createClass(function es2() {
    _classCallCheck(this, es2);
  });
  ri.TypedEventEmitter = es;
  (0, Nv.applyMixin)(es, Uv.default);
});
var Oi = M(function(Tr) {
  _();
  v();
  m();
  Object.defineProperty(Tr, "__esModule", { value: true });
  Tr.isReactNativeBrowser = Tr.isWebWorker = void 0;
  var qv = function qv2() {
    var t;
    return (typeof window === "undefined" ? "undefined" : _typeof(window)) < "u" ? (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) < "u" && ((t = navigator.userAgent) === null || t === void 0 ? void 0 : t.toLowerCase().indexOf(" electron/")) > -1 && !(B === null || B === void 0) && B.versions ? !Object.prototype.hasOwnProperty.call(B.versions, "electron") : _typeof(window.document) < "u" : false;
  }, Cp = function Cp2() {
    var _self;
    var t, e;
    return !!((typeof self === "undefined" ? "undefined" : _typeof(self)) == "object" && !((e = (t = (_self = self) === null || _self === void 0 ? void 0 : _self.constructor) === null || t === void 0 ? void 0 : t.name) === null || e === void 0) && e.includes("WorkerGlobalScope"));
  }, Bp = function Bp2() {
    return (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) < "u" && navigator.product === "ReactNative";
  }, Dv = qv() || Cp() || Bp();
  Tr.isWebWorker = Cp();
  Tr.isReactNativeBrowser = Bp();
  Tr.default = Dv;
});
var kp = M(function(ts, Pp) {
  _();
  v();
  m();
  (function(t, e) {
    _typeof(ts) == "object" && _typeof(Pp) < "u" ? e(ts) : typeof define == "function" && define.amd ? define(["exports"], e) : (t = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : t || self, e(t.fastUniqueNumbers = {}));
  })(ts, function(t) {
    var e = function e2(g) {
      return function(y) {
        var w = g(y);
        return y.add(w), w;
      };
    }, r = function r2(g) {
      return function(y, w) {
        return g.set(y, w), w;
      };
    }, i = Number.MAX_SAFE_INTEGER === void 0 ? 9007199254740991 : Number.MAX_SAFE_INTEGER, n = 536870912, o = n * 2, s = function s2(g, y) {
      return function(w) {
        var S = y.get(w), E = S === void 0 ? w.size : S < o ? S + 1 : 0;
        if (!w.has(E))
          return g(w, E);
        if (w.size < n) {
          for (; w.has(E); )
            E = Math.floor(Math.random() * o);
          return g(w, E);
        }
        if (w.size > i)
          throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
        for (; w.has(E); )
          E = Math.floor(Math.random() * i);
        return g(w, E);
      };
    }, a = /* @__PURE__ */ new WeakMap(), l = r(a), c = s(l, a), h = e(c);
    t.addUniqueNumber = h, t.generateUniqueNumber = c;
  });
});
var xp = M(function(rs, Op) {
  _();
  v();
  m();
  (function(t, e) {
    _typeof(rs) == "object" && _typeof(Op) < "u" ? e(rs, kp()) : typeof define == "function" && define.amd ? define(["exports", "fast-unique-numbers"], e) : (t = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : t || self, e(t.workerTimersBroker = {}, t.fastUniqueNumbers));
  })(rs, function(t, e) {
    var r = function r2(s) {
      return s.method !== void 0 && s.method === "call";
    }, i = function i2(s) {
      return s.error === null && typeof s.id == "number";
    }, n = function n2(s) {
      var a = /* @__PURE__ */ new Map([[0, function() {
      }]]), l = /* @__PURE__ */ new Map([[0, function() {
      }]]), c = /* @__PURE__ */ new Map(), h = new Worker(s);
      h.addEventListener("message", function(S) {
        var E = S.data;
        if (r(E)) {
          var I = E.params, C = I.timerId, R = I.timerType;
          if (R === "interval") {
            var U = a.get(C);
            if (typeof U == "number") {
              var N = c.get(U);
              if (N === void 0 || N.timerId !== C || N.timerType !== R)
                throw new Error("The timer is in an undefined state.");
            } else if (_typeof(U) < "u")
              U();
            else
              throw new Error("The timer is in an undefined state.");
          } else if (R === "timeout") {
            var W = l.get(C);
            if (typeof W == "number") {
              var K = c.get(W);
              if (K === void 0 || K.timerId !== C || K.timerType !== R)
                throw new Error("The timer is in an undefined state.");
            } else if (_typeof(W) < "u")
              W(), l.delete(C);
            else
              throw new Error("The timer is in an undefined state.");
          }
        } else if (i(E)) {
          var z = E.id, Q = c.get(z);
          if (Q === void 0)
            throw new Error("The timer is in an undefined state.");
          var pe = Q.timerId, Yt = Q.timerType;
          c.delete(z), Yt === "interval" ? a.delete(pe) : l.delete(pe);
        } else {
          var ge = E.error.message;
          throw new Error(ge);
        }
      });
      var d = function d2(E) {
        var I = e.generateUniqueNumber(c);
        c.set(I, { timerId: E, timerType: "interval" }), a.set(E, I), h.postMessage({ id: I, method: "clear", params: { timerId: E, timerType: "interval" } });
      }, g = function g2(E) {
        var I = e.generateUniqueNumber(c);
        c.set(I, { timerId: E, timerType: "timeout" }), l.set(E, I), h.postMessage({ id: I, method: "clear", params: { timerId: E, timerType: "timeout" } });
      }, y = function y2(E) {
        var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, C = e.generateUniqueNumber(a);
        return a.set(C, function() {
          E(), typeof a.get(C) == "function" && h.postMessage({ id: null, method: "set", params: { delay: I, now: performance.now(), timerId: C, timerType: "interval" } });
        }), h.postMessage({ id: null, method: "set", params: { delay: I, now: performance.now(), timerId: C, timerType: "interval" } }), C;
      }, w = function w2(E) {
        var I = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, C = e.generateUniqueNumber(l);
        return l.set(C, E), h.postMessage({ id: null, method: "set", params: { delay: I, now: performance.now(), timerId: C, timerType: "timeout" } }), C;
      };
      return { clearInterval: d, clearTimeout: g, setInterval: y, setTimeout: w };
    };
    t.load = n;
  });
});
var Lp = M(function(is, Mp) {
  _();
  v();
  m();
  (function(t, e) {
    _typeof(is) == "object" && _typeof(Mp) < "u" ? e(is, xp()) : typeof define == "function" && define.amd ? define(["exports", "worker-timers-broker"], e) : (t = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : t || self, e(t.workerTimers = {}, t.workerTimersBroker));
  })(is, function(t, e) {
    var r = function r2(h, d) {
      var g = null;
      return function() {
        if (g !== null)
          return g;
        var y = new Blob([d], { type: "application/javascript; charset=utf-8" }), w = URL.createObjectURL(y);
        return g = h(w), setTimeout(function() {
          return URL.revokeObjectURL(w);
        }), g;
      };
    }, i = `(()=>{var e={472:(e,t,r)=>{var o,i;void 0===(i="function"==typeof(o=function(){"use strict";var e=new Map,t=new Map,r=function(t){var r=e.get(t);if(void 0===r)throw new Error('There is no interval scheduled with the given id "'.concat(t,'".'));clearTimeout(r),e.delete(t)},o=function(e){var r=t.get(e);if(void 0===r)throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));clearTimeout(r),t.delete(e)},i=function(e,t){var r,o=performance.now();return{expected:o+(r=e-Math.max(0,o-t)),remainingDelay:r}},n=function e(t,r,o,i){var n=performance.now();n>o?postMessage({id:null,method:"call",params:{timerId:r,timerType:i}}):t.set(r,setTimeout(e,o-n,t,r,o,i))},a=function(t,r,o){var a=i(t,o),s=a.expected,d=a.remainingDelay;e.set(r,setTimeout(n,d,e,r,s,"interval"))},s=function(e,r,o){var a=i(e,o),s=a.expected,d=a.remainingDelay;t.set(r,setTimeout(n,d,t,r,s,"timeout"))};addEventListener("message",(function(e){var t=e.data;try{if("clear"===t.method){var i=t.id,n=t.params,d=n.timerId,c=n.timerType;if("interval"===c)r(d),postMessage({error:null,id:i});else{if("timeout"!==c)throw new Error('The given type "'.concat(c,'" is not supported'));o(d),postMessage({error:null,id:i})}}else{if("set"!==t.method)throw new Error('The given method "'.concat(t.method,'" is not supported'));var u=t.params,l=u.delay,p=u.now,m=u.timerId,v=u.timerType;if("interval"===v)a(l,m,p);else{if("timeout"!==v)throw new Error('The given type "'.concat(v,'" is not supported'));s(l,m,p)}}}catch(e){postMessage({error:{message:e.message},id:t.id,result:null})}}))})?o.call(t,r,t,e):o)||(e.exports=i)}},t={};function r(o){var i=t[o];if(void 0!==i)return i.exports;var n=t[o]={exports:{}};return e[o](n,n.exports,r),n.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var o in t)r.o(t,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]})},r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),(()=>{"use strict";r(472)})()})();`, n = r(e.load, i), o = function o2(h) {
      return n().clearInterval(h);
    }, s = function s2(h) {
      return n().clearTimeout(h);
    }, a = function a2() {
      var h;
      return (h = n()).setInterval.apply(h, arguments);
    }, l = function l2() {
      var h;
      return (h = n()).setTimeout.apply(h, arguments);
    };
    t.clearInterval = o, t.clearTimeout = s, t.setInterval = a, t.setTimeout = l;
  });
});
var Dp = M(function(Ct) {
  _();
  v();
  m();
  var jv = Ct && Ct.__createBinding || (Object.create ? function(t, e, r, i) {
    i === void 0 && (i = r);
    var n = Object.getOwnPropertyDescriptor(e, r);
    (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = { enumerable: true, get: function get2() {
      return e[r];
    } }), Object.defineProperty(t, i, n);
  } : function(t, e, r, i) {
    i === void 0 && (i = r), t[i] = e[r];
  }), Fv = Ct && Ct.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", { enumerable: true, value: e });
  } : function(t, e) {
    t.default = e;
  }), Wv = Ct && Ct.__importStar || function(t) {
    if (t && t.__esModule)
      return t;
    var e = {};
    if (t != null)
      for (var r in t)
        r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && jv(e, t, r);
    return Fv(e, t), e;
  };
  Object.defineProperty(Ct, "__esModule", { value: true });
  var ja = Wv(Oi()), Up = Lp(), Np = { set: Up.setInterval, clear: Up.clearInterval }, qp = { set: function set(t, e) {
    return setInterval(t, e);
  }, clear: function clear(t) {
    return clearInterval(t);
  } }, $v = function $v2(t) {
    switch (t) {
      case "native":
        return qp;
      case "worker":
        return Np;
      case "auto":
      default:
        return ja.default && !ja.isWebWorker && !ja.isReactNativeBrowser ? Np : qp;
    }
  };
  Ct.default = $v;
});
var Wa = M(function(xi) {
  _();
  v();
  m();
  var Hv = xi && xi.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(xi, "__esModule", { value: true });
  var Vv = Hv(Dp()), Fa = /* @__PURE__ */ function() {
    function Fa2(e, r) {
      _classCallCheck(this, Fa2);
      this.destroyed = false, this.client = e, this.timer = _typeof(r) == "object" && "set" in r && "clear" in r ? r : (0, Vv.default)(r), this.setKeepalive(e.options.keepalive);
    }
    return _createClass(Fa2, [{ key: "keepaliveTimeoutTimestamp", get: function get2() {
      return this._keepaliveTimeoutTimestamp;
    } }, { key: "intervalEvery", get: function get2() {
      return this._intervalEvery;
    } }, { key: "keepalive", get: function get2() {
      return this._keepalive;
    } }, { key: "clear", value: function clear() {
      this.timerId && (this.timer.clear(this.timerId), this.timerId = null);
    } }, { key: "setKeepalive", value: function setKeepalive(e) {
      if (e *= 1e3, isNaN(e) || e <= 0 || e > 2147483647)
        throw new Error("Keepalive value must be an integer between 0 and 2147483647. Provided value is ".concat(e));
      this._keepalive = e, this.reschedule(), this.client.log("KeepaliveManager: set keepalive to ".concat(e, "ms"));
    } }, { key: "destroy", value: function destroy() {
      this.clear(), this.destroyed = true;
    } }, { key: "reschedule", value: function reschedule() {
      var _this43 = this;
      if (this.destroyed)
        return;
      this.clear(), this.counter = 0;
      var e = Math.ceil(this._keepalive * 1.5);
      this._keepaliveTimeoutTimestamp = Date.now() + e, this._intervalEvery = Math.ceil(this._keepalive / 2), this.timerId = this.timer.set(function() {
        _this43.destroyed || (_this43.counter += 1, _this43.counter === 2 ? _this43.client.sendPing() : _this43.counter > 2 && _this43.client.onKeepaliveTimeout());
      }, this._intervalEvery);
    } }]);
  }();
  xi.default = Fa;
});
var os = M(function(Qe) {
  _();
  v();
  m();
  var zv = Qe && Qe.__createBinding || (Object.create ? function(t, e, r, i) {
    i === void 0 && (i = r);
    var n = Object.getOwnPropertyDescriptor(e, r);
    (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = { enumerable: true, get: function get2() {
      return e[r];
    } }), Object.defineProperty(t, i, n);
  } : function(t, e, r, i) {
    i === void 0 && (i = r), t[i] = e[r];
  }), Kv = Qe && Qe.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", { enumerable: true, value: e });
  } : function(t, e) {
    t.default = e;
  }), Hp = Qe && Qe.__importStar || function(t) {
    if (t && t.__esModule)
      return t;
    var e = {};
    if (t != null)
      for (var r in t)
        r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && zv(e, t, r);
    return Kv(e, t), e;
  }, zt = Qe && Qe.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(Qe, "__esModule", { value: true });
  var Gv = zt(Gu()), $a = zt(Nd()), Qv = zt(Zo()), Yv = jt(), jp = zt(Fd()), Fp = Hp($d()), Jv = zt(ot()), ii = zt(ra()), Xv = zt(Tp()), ns = _r(), Zv = Rp(), eE = zt(Wa()), Wp = Hp(Oi()), Ha = globalThis.setImmediate || function() {
    for (var _len19 = arguments.length, t = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
      t[_key19] = arguments[_key19];
    }
    var e = t.shift();
    (0, ns.nextTick)(function() {
      e.apply(void 0, t);
    });
  }, $p = { keepalive: 60, reschedulePings: true, protocolId: "MQTT", protocolVersion: 4, reconnectPeriod: 1e3, connectTimeout: 30 * 1e3, clean: true, resubscribe: true, writeCache: true, timerVariant: "auto" }, ss = /* @__PURE__ */ function(_Zv$TypedEventEmitter) {
    function t(e, r) {
      var _this44;
      _classCallCheck(this, t);
      _this44 = _callSuper(this, t), _this44.options = r || {};
      for (var i in $p)
        _typeof(_this44.options[i]) > "u" ? _this44.options[i] = $p[i] : _this44.options[i] = r[i];
      _this44.log = _this44.options.log || (0, Jv.default)("mqttjs:client"), _this44.noop = _this44._noop.bind(_this44), _this44.log("MqttClient :: version:", t.VERSION), Wp.isWebWorker ? _this44.log("MqttClient :: environment", "webworker") : _this44.log("MqttClient :: environment", Wp.default ? "browser" : "node"), _this44.log("MqttClient :: options.protocol", r.protocol), _this44.log("MqttClient :: options.protocolVersion", r.protocolVersion), _this44.log("MqttClient :: options.username", r.username), _this44.log("MqttClient :: options.keepalive", r.keepalive), _this44.log("MqttClient :: options.reconnectPeriod", r.reconnectPeriod), _this44.log("MqttClient :: options.rejectUnauthorized", r.rejectUnauthorized), _this44.log("MqttClient :: options.properties.topicAliasMaximum", r.properties ? r.properties.topicAliasMaximum : void 0), _this44.options.clientId = typeof r.clientId == "string" ? r.clientId : t.defaultId(), _this44.log("MqttClient :: clientId", _this44.options.clientId), _this44.options.customHandleAcks = r.protocolVersion === 5 && r.customHandleAcks ? r.customHandleAcks : function() {
        for (var _len20 = arguments.length, i2 = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
          i2[_key20] = arguments[_key20];
        }
        i2[3](null, 0);
      }, _this44.options.writeCache || ($a.default.writeToStream.cacheNumbers = false), _this44.streamBuilder = e, _this44.messageIdProvider = _typeof(_this44.options.messageIdProvider) > "u" ? new Qv.default() : _this44.options.messageIdProvider, _this44.outgoingStore = r.outgoingStore || new ii.default(), _this44.incomingStore = r.incomingStore || new ii.default(), _this44.queueQoSZero = r.queueQoSZero === void 0 ? true : r.queueQoSZero, _this44._resubscribeTopics = {}, _this44.messageIdToTopic = {}, _this44.keepaliveManager = null, _this44.connected = false, _this44.disconnecting = false, _this44.reconnecting = false, _this44.queue = [], _this44.connackTimer = null, _this44.reconnectTimer = null, _this44._storeProcessing = false, _this44._packetIdsDuringStoreProcessing = {}, _this44._storeProcessingQueue = [], _this44.outgoing = {}, _this44._firstConnection = true, r.properties && r.properties.topicAliasMaximum > 0 && (r.properties.topicAliasMaximum > 65535 ? _this44.log("MqttClient :: options.properties.topicAliasMaximum is out of range") : _this44.topicAliasRecv = new Gv.default(r.properties.topicAliasMaximum)), _this44.on("connect", function() {
        var _this45 = _this44, i2 = _this45.queue, n = function(_n41) {
          function n2() {
            return _n41.apply(this, arguments);
          }
          n2.toString = function() {
            return _n41.toString();
          };
          return n2;
        }(function() {
          var o = i2.shift();
          _this44.log("deliver :: entry %o", o);
          var s = null;
          if (!o) {
            _this44._resubscribe();
            return;
          }
          s = o.packet, _this44.log("deliver :: call _sendPacket for %o", s);
          var a = true;
          s.messageId && s.messageId !== 0 && (_this44.messageIdProvider.register(s.messageId) || (a = false)), a ? _this44._sendPacket(s, function(l) {
            o.cb && o.cb(l), n();
          }) : (_this44.log("messageId: %d has already used. The message is skipped and removed.", s.messageId), n());
        });
        _this44.log("connect :: sending queued packets"), n();
      }), _this44.on("close", function() {
        _this44.log("close :: connected set to `false`"), _this44.connected = false, _this44.log("close :: clearing connackTimer"), clearTimeout(_this44.connackTimer), _this44._destroyKeepaliveManager(), _this44.topicAliasRecv && _this44.topicAliasRecv.clear(), _this44.log("close :: calling _setupReconnect"), _this44._setupReconnect();
      }), _this44.options.manualConnect || (_this44.log("MqttClient :: setting up stream"), _this44.connect());
      return _this44;
    }
    _inherits(t, _Zv$TypedEventEmitter);
    return _createClass(t, [{ key: "handleAuth", value: function handleAuth(e, r) {
      r();
    } }, { key: "handleMessage", value: function handleMessage(e, r) {
      r();
    } }, { key: "_nextId", value: function _nextId() {
      return this.messageIdProvider.allocate();
    } }, { key: "getLastMessageId", value: function getLastMessageId() {
      return this.messageIdProvider.getLastAllocated();
    } }, { key: "connect", value: function connect2() {
      var _this46 = this;
      var e;
      var r = new Yv.Writable(), i = $a.default.parser(this.options), n = null, o = [];
      this.log("connect :: calling method to clear reconnect"), this._clearReconnect(), this.disconnected && !this.reconnecting && (this.incomingStore = this.options.incomingStore || new ii.default(), this.outgoingStore = this.options.outgoingStore || new ii.default(), this.disconnecting = false, this.disconnected = false), this.log("connect :: using streamBuilder provided to client to create stream"), this.stream = this.streamBuilder(this), i.on("packet", function(h) {
        _this46.log("parser :: on packet push to packets array."), o.push(h);
      });
      var s = function s2() {
        _this46.log("work :: getting next packet in queue");
        var h = o.shift();
        if (h)
          _this46.log("work :: packet pulled from queue"), (0, Xv.default)(_this46, h, a);
        else {
          _this46.log("work :: no packets in queue");
          var _d10 = n;
          n = null, _this46.log("work :: done flag is %s", !!_d10), _d10 && _d10();
        }
      }, a = function a2() {
        if (o.length)
          (0, ns.nextTick)(s);
        else {
          var _h8 = n;
          n = null, _h8();
        }
      };
      r._write = function(h, d, g) {
        n = g, _this46.log("writable stream :: parsing buffer"), i.parse(h), s();
      };
      var l = function l2(h) {
        _this46.log("streamErrorHandler :: error", h.message), h.code ? (_this46.log("streamErrorHandler :: emitting error"), _this46.emit("error", h)) : _this46.noop(h);
      };
      this.log("connect :: pipe stream to writable stream"), this.stream.pipe(r), this.stream.on("error", l), this.stream.on("close", function() {
        _this46.log("(%s)stream :: on close", _this46.options.clientId), _this46._flushVolatile(), _this46.log("stream: emit close to MqttClient"), _this46.emit("close");
      }), this.log("connect: sending packet `connect`");
      var c = { cmd: "connect", protocolId: this.options.protocolId, protocolVersion: this.options.protocolVersion, clean: this.options.clean, clientId: this.options.clientId, keepalive: this.options.keepalive, username: this.options.username, password: this.options.password, properties: this.options.properties };
      if (this.options.will && (c.will = Object.assign(Object.assign({}, this.options.will), { payload: (e = this.options.will) === null || e === void 0 ? void 0 : e.payload })), this.topicAliasRecv && (c.properties || (c.properties = {}), this.topicAliasRecv && (c.properties.topicAliasMaximum = this.topicAliasRecv.max)), this._writePacket(c), i.on("error", this.emit.bind(this, "error")), this.options.properties) {
        if (!this.options.properties.authenticationMethod && this.options.properties.authenticationData)
          return this.end(function() {
            return _this46.emit("error", new Error("Packet has no Authentication Method"));
          }), this;
        if (this.options.properties.authenticationMethod && this.options.authPacket && _typeof(this.options.authPacket) == "object") {
          var _h9 = Object.assign({ cmd: "auth", reasonCode: 0 }, this.options.authPacket);
          this._writePacket(_h9);
        }
      }
      return this.stream.setMaxListeners(1e3), clearTimeout(this.connackTimer), this.connackTimer = setTimeout(function() {
        _this46.log("!!connectTimeout hit!! Calling _cleanUp with force `true`"), _this46.emit("error", new Error("connack timeout")), _this46._cleanUp(true);
      }, this.options.connectTimeout), this;
    } }, { key: "publish", value: function publish(e, r, i, n) {
      var _this47 = this;
      this.log("publish :: message `%s` to topic `%s`", r, e);
      var o = this.options;
      typeof i == "function" && (n = i, i = null), i = i || {}, i = Object.assign(Object.assign({}, { qos: 0, retain: false, dup: false }), i);
      var _i22 = i, a = _i22.qos, l = _i22.retain, c = _i22.dup, h = _i22.properties, d = _i22.cbStorePut;
      if (this._checkDisconnecting(n))
        return this;
      var g = function g2() {
        var y = 0;
        if ((a === 1 || a === 2) && (y = _this47._nextId(), y === null))
          return _this47.log("No messageId left"), false;
        var w = { cmd: "publish", topic: e, payload: r, qos: a, retain: l, messageId: y, dup: c };
        switch (o.protocolVersion === 5 && (w.properties = h), _this47.log("publish :: qos", a), a) {
          case 1:
          case 2:
            _this47.outgoing[w.messageId] = { volatile: false, cb: n || _this47.noop }, _this47.log("MqttClient:publish: packet cmd: %s", w.cmd), _this47._sendPacket(w, void 0, d);
            break;
          default:
            _this47.log("MqttClient:publish: packet cmd: %s", w.cmd), _this47._sendPacket(w, n, d);
            break;
        }
        return true;
      };
      return (this._storeProcessing || this._storeProcessingQueue.length > 0 || !g()) && this._storeProcessingQueue.push({ invoke: g, cbStorePut: i.cbStorePut, callback: n }), this;
    } }, { key: "publishAsync", value: function publishAsync(e, r, i) {
      var _this48 = this;
      return new Promise(function(n, o) {
        _this48.publish(e, r, i, function(s, a) {
          s ? o(s) : n(a);
        });
      });
    } }, { key: "subscribe", value: function subscribe(e, r, i) {
      var _this49 = this;
      var n = this.options.protocolVersion;
      typeof r == "function" && (i = r), i = i || this.noop;
      var o = false, s = [];
      typeof e == "string" ? (e = [e], s = e) : Array.isArray(e) ? s = e : _typeof(e) == "object" && (o = e.resubscribe, delete e.resubscribe, s = Object.keys(e));
      var a = Fp.validateTopics(s);
      if (a !== null)
        return Ha(i, new Error("Invalid topic ".concat(a))), this;
      if (this._checkDisconnecting(i))
        return this.log("subscribe: discconecting true"), this;
      var l = { qos: 0 };
      n === 5 && (l.nl = false, l.rap = false, l.rh = 0), r = Object.assign(Object.assign({}, l), r);
      var c = r.properties, h = [], d = function d2(y, w) {
        if (w = w || r, !Object.prototype.hasOwnProperty.call(_this49._resubscribeTopics, y) || _this49._resubscribeTopics[y].qos < w.qos || o) {
          var _S8 = { topic: y, qos: w.qos };
          n === 5 && (_S8.nl = w.nl, _S8.rap = w.rap, _S8.rh = w.rh, _S8.properties = c), _this49.log("subscribe: pushing topic `%s` and qos `%s` to subs list", _S8.topic, _S8.qos), h.push(_S8);
        }
      };
      if (Array.isArray(e) ? e.forEach(function(y) {
        _this49.log("subscribe: array topic %s", y), d(y);
      }) : Object.keys(e).forEach(function(y) {
        _this49.log("subscribe: object topic %s, %o", y, e[y]), d(y, e[y]);
      }), !h.length)
        return i(null, []), this;
      var g = function g2() {
        var y = _this49._nextId();
        if (y === null)
          return _this49.log("No messageId left"), false;
        var w = { cmd: "subscribe", subscriptions: h, messageId: y };
        if (c && (w.properties = c), _this49.options.resubscribe) {
          _this49.log("subscribe :: resubscribe true");
          var _S9 = [];
          h.forEach(function(E) {
            if (_this49.options.reconnectPeriod > 0) {
              var I = { qos: E.qos };
              n === 5 && (I.nl = E.nl || false, I.rap = E.rap || false, I.rh = E.rh || 0, I.properties = E.properties), _this49._resubscribeTopics[E.topic] = I, _S9.push(E.topic);
            }
          }), _this49.messageIdToTopic[w.messageId] = _S9;
        }
        return _this49.outgoing[w.messageId] = { volatile: true, cb: function cb(S, E) {
          if (!S) {
            var I = E.granted;
            for (var C = 0; C < I.length; C += 1)
              h[C].qos = I[C];
          }
          i(S, h, E);
        } }, _this49.log("subscribe :: call _sendPacket"), _this49._sendPacket(w), true;
      };
      return (this._storeProcessing || this._storeProcessingQueue.length > 0 || !g()) && this._storeProcessingQueue.push({ invoke: g, callback: i }), this;
    } }, { key: "subscribeAsync", value: function subscribeAsync(e, r) {
      var _this50 = this;
      return new Promise(function(i, n) {
        _this50.subscribe(e, r, function(o, s) {
          o ? n(o) : i(s);
        });
      });
    } }, { key: "unsubscribe", value: function unsubscribe(e, r, i) {
      var _this51 = this;
      typeof e == "string" && (e = [e]), typeof r == "function" && (i = r), i = i || this.noop;
      var n = Fp.validateTopics(e);
      if (n !== null)
        return Ha(i, new Error("Invalid topic ".concat(n))), this;
      if (this._checkDisconnecting(i))
        return this;
      var o = function o2() {
        var s = _this51._nextId();
        if (s === null)
          return _this51.log("No messageId left"), false;
        var a = { cmd: "unsubscribe", messageId: s, unsubscriptions: [] };
        return typeof e == "string" ? a.unsubscriptions = [e] : Array.isArray(e) && (a.unsubscriptions = e), _this51.options.resubscribe && a.unsubscriptions.forEach(function(l) {
          delete _this51._resubscribeTopics[l];
        }), _typeof(r) == "object" && r.properties && (a.properties = r.properties), _this51.outgoing[a.messageId] = { volatile: true, cb: i }, _this51.log("unsubscribe: call _sendPacket"), _this51._sendPacket(a), true;
      };
      return (this._storeProcessing || this._storeProcessingQueue.length > 0 || !o()) && this._storeProcessingQueue.push({ invoke: o, callback: i }), this;
    } }, { key: "unsubscribeAsync", value: function unsubscribeAsync(e, r) {
      var _this52 = this;
      return new Promise(function(i, n) {
        _this52.unsubscribe(e, r, function(o, s) {
          o ? n(o) : i(s);
        });
      });
    } }, { key: "end", value: function end(e, r, i) {
      var _this53 = this;
      this.log("end :: (%s)", this.options.clientId), (e == null || typeof e != "boolean") && (i = i || r, r = e, e = false), _typeof(r) != "object" && (i = i || r, r = null), this.log("end :: cb? %s", !!i), (!i || typeof i != "function") && (i = this.noop);
      var n = function n2() {
        _this53.log("end :: closeStores: closing incoming and outgoing stores"), _this53.disconnected = true, _this53.incomingStore.close(function(s) {
          _this53.outgoingStore.close(function(a) {
            if (_this53.log("end :: closeStores: emitting end"), _this53.emit("end"), i) {
              var _l25 = s || a;
              _this53.log("end :: closeStores: invoking callback with args"), i(_l25);
            }
          });
        }), _this53._deferredReconnect ? _this53._deferredReconnect() : (_this53.options.reconnectPeriod === 0 || _this53.options.manualConnect) && (_this53.disconnecting = false);
      }, o = function o2() {
        _this53.log("end :: (%s) :: finish :: calling _cleanUp with force %s", _this53.options.clientId, e), _this53._cleanUp(e, function() {
          _this53.log("end :: finish :: calling process.nextTick on closeStores"), (0, ns.nextTick)(n);
        }, r);
      };
      return this.disconnecting ? (i(), this) : (this._clearReconnect(), this.disconnecting = true, !e && Object.keys(this.outgoing).length > 0 ? (this.log("end :: (%s) :: calling finish in 10ms once outgoing is empty", this.options.clientId), this.once("outgoingEmpty", setTimeout.bind(null, o, 10))) : (this.log("end :: (%s) :: immediately calling finish", this.options.clientId), o()), this);
    } }, { key: "endAsync", value: function endAsync(e, r) {
      var _this54 = this;
      return new Promise(function(i, n) {
        _this54.end(e, r, function(o) {
          o ? n(o) : i();
        });
      });
    } }, { key: "removeOutgoingMessage", value: function removeOutgoingMessage(e) {
      if (this.outgoing[e]) {
        var _r49 = this.outgoing[e].cb;
        this._removeOutgoingAndStoreMessage(e, function() {
          _r49(new Error("Message removed"));
        });
      }
      return this;
    } }, { key: "reconnect", value: function reconnect(e) {
      var _this55 = this;
      this.log("client reconnect");
      var r = function r2() {
        e ? (_this55.options.incomingStore = e.incomingStore, _this55.options.outgoingStore = e.outgoingStore) : (_this55.options.incomingStore = null, _this55.options.outgoingStore = null), _this55.incomingStore = _this55.options.incomingStore || new ii.default(), _this55.outgoingStore = _this55.options.outgoingStore || new ii.default(), _this55.disconnecting = false, _this55.disconnected = false, _this55._deferredReconnect = null, _this55._reconnect();
      };
      return this.disconnecting && !this.disconnected ? this._deferredReconnect = r : r(), this;
    } }, { key: "_flushVolatile", value: function _flushVolatile() {
      var _this56 = this;
      this.outgoing && (this.log("_flushVolatile :: deleting volatile messages from the queue and setting their callbacks as error function"), Object.keys(this.outgoing).forEach(function(e) {
        _this56.outgoing[e].volatile && typeof _this56.outgoing[e].cb == "function" && (_this56.outgoing[e].cb(new Error("Connection closed")), delete _this56.outgoing[e]);
      }));
    } }, { key: "_flush", value: function _flush() {
      var _this57 = this;
      this.outgoing && (this.log("_flush: queue exists? %b", !!this.outgoing), Object.keys(this.outgoing).forEach(function(e) {
        typeof _this57.outgoing[e].cb == "function" && (_this57.outgoing[e].cb(new Error("Connection closed")), delete _this57.outgoing[e]);
      }));
    } }, { key: "_removeTopicAliasAndRecoverTopicName", value: function _removeTopicAliasAndRecoverTopicName(e) {
      var r;
      e.properties && (r = e.properties.topicAlias);
      var i = e.topic.toString();
      if (this.log("_removeTopicAliasAndRecoverTopicName :: alias %d, topic %o", r, i), i.length === 0) {
        if (_typeof(r) > "u")
          return new Error("Unregistered Topic Alias");
        if (i = this.topicAliasSend.getTopicByAlias(r), _typeof(i) > "u")
          return new Error("Unregistered Topic Alias");
        e.topic = i;
      }
      r && delete e.properties.topicAlias;
    } }, { key: "_checkDisconnecting", value: function _checkDisconnecting(e) {
      return this.disconnecting && (e && e !== this.noop ? e(new Error("client disconnecting")) : this.emit("error", new Error("client disconnecting"))), this.disconnecting;
    } }, { key: "_reconnect", value: function _reconnect() {
      var _this58 = this;
      this.log("_reconnect: emitting reconnect to client"), this.emit("reconnect"), this.connected ? (this.end(function() {
        _this58.connect();
      }), this.log("client already connected. disconnecting first.")) : (this.log("_reconnect: calling connect"), this.connect());
    } }, { key: "_setupReconnect", value: function _setupReconnect() {
      var _this59 = this;
      !this.disconnecting && !this.reconnectTimer && this.options.reconnectPeriod > 0 ? (this.reconnecting || (this.log("_setupReconnect :: emit `offline` state"), this.emit("offline"), this.log("_setupReconnect :: set `reconnecting` to `true`"), this.reconnecting = true), this.log("_setupReconnect :: setting reconnectTimer for %d ms", this.options.reconnectPeriod), this.reconnectTimer = setInterval(function() {
        _this59.log("reconnectTimer :: reconnect triggered!"), _this59._reconnect();
      }, this.options.reconnectPeriod)) : this.log("_setupReconnect :: doing nothing...");
    } }, { key: "_clearReconnect", value: function _clearReconnect() {
      this.log("_clearReconnect : clearing reconnect timer"), this.reconnectTimer && (clearInterval(this.reconnectTimer), this.reconnectTimer = null);
    } }, { key: "_cleanUp", value: function _cleanUp(e, r) {
      var _this60 = this;
      var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (r && (this.log("_cleanUp :: done callback provided for on stream close"), this.stream.on("close", r)), this.log("_cleanUp :: forced? %s", e), e)
        this.options.reconnectPeriod === 0 && this.options.clean && this._flush(), this.log("_cleanUp :: (%s) :: destroying stream", this.options.clientId), this.stream.destroy();
      else {
        var _n42 = Object.assign({ cmd: "disconnect" }, i);
        this.log("_cleanUp :: (%s) :: call _sendPacket with disconnect packet", this.options.clientId), this._sendPacket(_n42, function() {
          _this60.log("_cleanUp :: (%s) :: destroying stream", _this60.options.clientId), Ha(function() {
            _this60.stream.end(function() {
              _this60.log("_cleanUp :: (%s) :: stream destroyed", _this60.options.clientId);
            });
          });
        });
      }
      !this.disconnecting && !this.reconnecting && (this.log("_cleanUp :: client not disconnecting/reconnecting. Clearing and resetting reconnect."), this._clearReconnect(), this._setupReconnect()), this._destroyKeepaliveManager(), r && !this.connected && (this.log("_cleanUp :: (%s) :: removing stream `done` callback `close` listener", this.options.clientId), this.stream.removeListener("close", r), r());
    } }, { key: "_storeAndSend", value: function _storeAndSend(e, r, i) {
      var _this61 = this;
      this.log("storeAndSend :: store packet with cmd %s to outgoingStore", e.cmd);
      var n = e, o;
      if (n.cmd === "publish" && (n = (0, jp.default)(e), o = this._removeTopicAliasAndRecoverTopicName(n), o))
        return r && r(o);
      this.outgoingStore.put(n, function(s) {
        if (s)
          return r && r(s);
        i(), _this61._writePacket(e, r);
      });
    } }, { key: "_applyTopicAlias", value: function _applyTopicAlias(e) {
      if (this.options.protocolVersion === 5 && e.cmd === "publish") {
        var _r50;
        e.properties && (_r50 = e.properties.topicAlias);
        var i = e.topic.toString();
        if (this.topicAliasSend) {
          if (_r50) {
            if (i.length !== 0 && (this.log("applyTopicAlias :: register topic: %s - alias: %d", i, _r50), !this.topicAliasSend.put(i, _r50)))
              return this.log("applyTopicAlias :: error out of range. topic: %s - alias: %d", i, _r50), new Error("Sending Topic Alias out of range");
          } else
            i.length !== 0 && (this.options.autoAssignTopicAlias ? (_r50 = this.topicAliasSend.getAliasByTopic(i), _r50 ? (e.topic = "", e.properties = Object.assign(Object.assign({}, e.properties), { topicAlias: _r50 }), this.log("applyTopicAlias :: auto assign(use) topic: %s - alias: %d", i, _r50)) : (_r50 = this.topicAliasSend.getLruAlias(), this.topicAliasSend.put(i, _r50), e.properties = Object.assign(Object.assign({}, e.properties), { topicAlias: _r50 }), this.log("applyTopicAlias :: auto assign topic: %s - alias: %d", i, _r50))) : this.options.autoUseTopicAlias && (_r50 = this.topicAliasSend.getAliasByTopic(i), _r50 && (e.topic = "", e.properties = Object.assign(Object.assign({}, e.properties), { topicAlias: _r50 }), this.log("applyTopicAlias :: auto use topic: %s - alias: %d", i, _r50))));
        } else if (_r50)
          return this.log("applyTopicAlias :: error out of range. topic: %s - alias: %d", i, _r50), new Error("Sending Topic Alias out of range");
      }
    } }, { key: "_noop", value: function _noop(e) {
      this.log("noop ::", e);
    } }, { key: "_writePacket", value: function _writePacket(e, r) {
      this.log("_writePacket :: packet: %O", e), this.log("_writePacket :: emitting `packetsend`"), this.emit("packetsend", e), this.log("_writePacket :: writing to stream");
      var i = $a.default.writeToStream(e, this.stream, this.options);
      this.log("_writePacket :: writeToStream result %s", i), !i && r && r !== this.noop ? (this.log("_writePacket :: handle events on `drain` once through callback."), this.stream.once("drain", r)) : r && (this.log("_writePacket :: invoking cb"), r());
    } }, { key: "_sendPacket", value: function _sendPacket(e, r, i, n) {
      this.log("_sendPacket :: (%s) ::  start", this.options.clientId), i = i || this.noop, r = r || this.noop;
      var o = this._applyTopicAlias(e);
      if (o) {
        r(o);
        return;
      }
      if (!this.connected) {
        if (e.cmd === "auth") {
          this._writePacket(e, r);
          return;
        }
        this.log("_sendPacket :: client not connected. Storing packet offline."), this._storePacket(e, r, i);
        return;
      }
      if (n) {
        this._writePacket(e, r);
        return;
      }
      switch (e.cmd) {
        case "publish":
          break;
        case "pubrel":
          this._storeAndSend(e, r, i);
          return;
        default:
          this._writePacket(e, r);
          return;
      }
      switch (e.qos) {
        case 2:
        case 1:
          this._storeAndSend(e, r, i);
          break;
        case 0:
        default:
          this._writePacket(e, r);
          break;
      }
      this.log("_sendPacket :: (%s) ::  end", this.options.clientId);
    } }, { key: "_storePacket", value: function _storePacket(e, r, i) {
      this.log("_storePacket :: packet: %o", e), this.log("_storePacket :: cb? %s", !!r), i = i || this.noop;
      var n = e;
      if (n.cmd === "publish") {
        n = (0, jp.default)(e);
        var _s18 = this._removeTopicAliasAndRecoverTopicName(n);
        if (_s18)
          return r && r(_s18);
      }
      var o = n.qos || 0;
      o === 0 && this.queueQoSZero || n.cmd !== "publish" ? this.queue.push({ packet: n, cb: r }) : o > 0 ? (r = this.outgoing[n.messageId] ? this.outgoing[n.messageId].cb : null, this.outgoingStore.put(n, function(s) {
        if (s)
          return r && r(s);
        i();
      })) : r && r(new Error("No connection to broker"));
    } }, { key: "_setupKeepaliveManager", value: function _setupKeepaliveManager() {
      this.log("_setupKeepaliveManager :: keepalive %d (seconds)", this.options.keepalive), !this.keepaliveManager && this.options.keepalive && (this.keepaliveManager = new eE.default(this, this.options.timerVariant));
    } }, { key: "_destroyKeepaliveManager", value: function _destroyKeepaliveManager() {
      this.keepaliveManager && (this.log("_destroyKeepaliveManager :: destroying keepalive manager"), this.keepaliveManager.destroy(), this.keepaliveManager = null);
    } }, { key: "reschedulePing", value: function reschedulePing() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
      this.keepaliveManager && this.options.keepalive && (e || this.options.reschedulePings) && this._reschedulePing();
    } }, { key: "_reschedulePing", value: function _reschedulePing() {
      this.log("_reschedulePing :: rescheduling ping"), this.keepaliveManager.reschedule();
    } }, { key: "sendPing", value: function sendPing() {
      this.log("_sendPing :: sending pingreq"), this._sendPacket({ cmd: "pingreq" });
    } }, { key: "onKeepaliveTimeout", value: function onKeepaliveTimeout() {
      this.emit("error", new Error("Keepalive timeout")), this.log("onKeepaliveTimeout :: calling _cleanUp with force true"), this._cleanUp(true);
    } }, { key: "_resubscribe", value: function _resubscribe() {
      this.log("_resubscribe");
      var e = Object.keys(this._resubscribeTopics);
      if (!this._firstConnection && (this.options.clean || this.options.protocolVersion >= 4 && !this.connackPacket.sessionPresent) && e.length > 0)
        if (this.options.resubscribe) {
          if (this.options.protocolVersion === 5) {
            this.log("_resubscribe: protocolVersion 5");
            for (var _r51 = 0; _r51 < e.length; _r51++) {
              var i = {};
              i[e[_r51]] = this._resubscribeTopics[e[_r51]], i.resubscribe = true, this.subscribe(i, { properties: i[e[_r51]].properties });
            }
          } else
            this._resubscribeTopics.resubscribe = true, this.subscribe(this._resubscribeTopics);
        } else
          this._resubscribeTopics = {};
      this._firstConnection = false;
    } }, { key: "_onConnect", value: function _onConnect(e) {
      var _this62 = this;
      if (this.disconnected) {
        this.emit("connect", e);
        return;
      }
      this.connackPacket = e, this.messageIdProvider.clear(), this._setupKeepaliveManager(), this.connected = true;
      var r = function(_r52) {
        function r2() {
          return _r52.apply(this, arguments);
        }
        r2.toString = function() {
          return _r52.toString();
        };
        return r2;
      }(function() {
        var i = _this62.outgoingStore.createStream(), n = function n2() {
          i.destroy(), i = null, _this62._flushStoreProcessingQueue(), o();
        }, o = function o2() {
          _this62._storeProcessing = false, _this62._packetIdsDuringStoreProcessing = {};
        };
        _this62.once("close", n), i.on("error", function(a) {
          o(), _this62._flushStoreProcessingQueue(), _this62.removeListener("close", n), _this62.emit("error", a);
        });
        var s = function(_s19) {
          function s2() {
            return _s19.apply(this, arguments);
          }
          s2.toString = function() {
            return _s19.toString();
          };
          return s2;
        }(function() {
          if (!i)
            return;
          var a = i.read(1), l;
          if (!a) {
            i.once("readable", s);
            return;
          }
          if (_this62._storeProcessing = true, _this62._packetIdsDuringStoreProcessing[a.messageId]) {
            s();
            return;
          }
          !_this62.disconnecting && !_this62.reconnectTimer ? (l = _this62.outgoing[a.messageId] ? _this62.outgoing[a.messageId].cb : null, _this62.outgoing[a.messageId] = { volatile: false, cb: function cb(c, h) {
            l && l(c, h), s();
          } }, _this62._packetIdsDuringStoreProcessing[a.messageId] = true, _this62.messageIdProvider.register(a.messageId) ? _this62._sendPacket(a, void 0, void 0, true) : _this62.log("messageId: %d has already used.", a.messageId)) : i.destroy && i.destroy();
        });
        i.on("end", function() {
          var a = true;
          for (var _l26 in _this62._packetIdsDuringStoreProcessing)
            if (!_this62._packetIdsDuringStoreProcessing[_l26]) {
              a = false;
              break;
            }
          _this62.removeListener("close", n), a ? (o(), _this62._invokeAllStoreProcessingQueue(), _this62.emit("connect", e)) : r();
        }), s();
      });
      r();
    } }, { key: "_invokeStoreProcessingQueue", value: function _invokeStoreProcessingQueue() {
      if (!this._storeProcessing && this._storeProcessingQueue.length > 0) {
        var e = this._storeProcessingQueue[0];
        if (e && e.invoke())
          return this._storeProcessingQueue.shift(), true;
      }
      return false;
    } }, { key: "_invokeAllStoreProcessingQueue", value: function _invokeAllStoreProcessingQueue() {
      for (; this._invokeStoreProcessingQueue(); )
        ;
    } }, { key: "_flushStoreProcessingQueue", value: function _flushStoreProcessingQueue() {
      var _iterator37 = _createForOfIteratorHelper(this._storeProcessingQueue), _step37;
      try {
        for (_iterator37.s(); !(_step37 = _iterator37.n()).done; ) {
          var e = _step37.value;
          e.cbStorePut && e.cbStorePut(new Error("Connection closed")), e.callback && e.callback(new Error("Connection closed"));
        }
      } catch (err) {
        _iterator37.e(err);
      } finally {
        _iterator37.f();
      }
      this._storeProcessingQueue.splice(0);
    } }, { key: "_removeOutgoingAndStoreMessage", value: function _removeOutgoingAndStoreMessage(e, r) {
      var _this63 = this;
      delete this.outgoing[e], this.outgoingStore.del({ messageId: e }, function(i, n) {
        r(i, n), _this63.messageIdProvider.deallocate(e), _this63._invokeStoreProcessingQueue();
      });
    } }], [{ key: "defaultId", value: function defaultId() {
      return "mqttjs_".concat(Math.random().toString(16).substr(2, 8));
    } }]);
  }(Zv.TypedEventEmitter);
  ss.VERSION = ns.MQTTJS_VERSION;
  Qe.default = ss;
});
var Vp = M(function(za) {
  _();
  v();
  m();
  Object.defineProperty(za, "__esModule", { value: true });
  var tE = Ua(), Va = /* @__PURE__ */ function() {
    function Va2() {
      _classCallCheck(this, Va2);
      this.numberAllocator = new tE.NumberAllocator(1, 65535);
    }
    return _createClass(Va2, [{ key: "allocate", value: function allocate() {
      return this.lastId = this.numberAllocator.alloc(), this.lastId;
    } }, { key: "getLastAllocated", value: function getLastAllocated() {
      return this.lastId;
    } }, { key: "register", value: function register(e) {
      return this.numberAllocator.use(e);
    } }, { key: "deallocate", value: function deallocate(e) {
      this.numberAllocator.free(e);
    } }, { key: "clear", value: function clear() {
      this.numberAllocator.clear();
    } }]);
  }();
  za.default = Va;
});
function Rr(t) {
  throw new RangeError(sE[t]);
}
function zp(t, e) {
  var r = t.split("@"), i = "";
  r.length > 1 && (i = r[0] + "@", t = r[1]);
  var n = function(o, s) {
    var a = [], l = o.length;
    for (; l--; )
      a[l] = s(o[l]);
    return a;
  }((t = t.replace(nE, ".")).split("."), e).join(".");
  return i + n;
}
function Yp(t) {
  var e = [], r = 0, i = t.length;
  for (; r < i; ) {
    var _n43 = t.charCodeAt(r++);
    if (_n43 >= 55296 && _n43 <= 56319 && r < i) {
      var _o34 = t.charCodeAt(r++);
      (64512 & _o34) == 56320 ? e.push(((1023 & _n43) << 10) + (1023 & _o34) + 65536) : (e.push(_n43), r--);
    } else
      e.push(_n43);
  }
  return e;
}
var rE, iE, nE, sE, dt, Ka, Kp, Jp, Gp, Qp, Kt, Xp = _e(function() {
  _();
  v();
  m();
  rE = /^xn--/, iE = /[^\0-\x7E]/, nE = /[\x2E\u3002\uFF0E\uFF61]/g, sE = { overflow: "Overflow: input needs wider integers to process", "not-basic": "Illegal input >= 0x80 (not a basic code point)", "invalid-input": "Invalid input" }, dt = Math.floor, Ka = String.fromCharCode;
  Kp = function Kp2(t, e) {
    return t + 22 + 75 * (t < 26) - ((e != 0) << 5);
  }, Jp = function Jp2(t, e, r) {
    var i = 0;
    for (t = r ? dt(t / 700) : t >> 1, t += dt(t / e); t > 455; i += 36)
      t = dt(t / 35);
    return dt(i + 36 * t / (t + 38));
  }, Gp = function Gp2(t) {
    var e = [], r = t.length, i = 0, n = 128, o = 72, s = t.lastIndexOf("-");
    s < 0 && (s = 0);
    for (var _l27 = 0; _l27 < s; ++_l27)
      t.charCodeAt(_l27) >= 128 && Rr("not-basic"), e.push(t.charCodeAt(_l27));
    for (var _l28 = s > 0 ? s + 1 : 0; _l28 < r; ) {
      var _c17 = i;
      for (var _d11 = 1, _g15 = 36; ; _g15 += 36) {
        _l28 >= r && Rr("invalid-input");
        var _y14 = (a = t.charCodeAt(_l28++)) - 48 < 10 ? a - 22 : a - 65 < 26 ? a - 65 : a - 97 < 26 ? a - 97 : 36;
        (_y14 >= 36 || _y14 > dt((2147483647 - i) / _d11)) && Rr("overflow"), i += _y14 * _d11;
        var _w6 = _g15 <= o ? 1 : _g15 >= o + 26 ? 26 : _g15 - o;
        if (_y14 < _w6)
          break;
        var _S10 = 36 - _w6;
        _d11 > dt(2147483647 / _S10) && Rr("overflow"), _d11 *= _S10;
      }
      var _h10 = e.length + 1;
      o = Jp(i - _c17, _h10, _c17 == 0), dt(i / _h10) > 2147483647 - n && Rr("overflow"), n += dt(i / _h10), i %= _h10, e.splice(i++, 0, n);
    }
    var a;
    return String.fromCodePoint.apply(String, e);
  }, Qp = function Qp2(t) {
    var e = [], r = (t = Yp(t)).length, i = 128, n = 0, o = 72;
    var _iterator38 = _createForOfIteratorHelper(t), _step38;
    try {
      for (_iterator38.s(); !(_step38 = _iterator38.n()).done; ) {
        var _l30 = _step38.value;
        _l30 < 128 && e.push(Ka(_l30));
      }
    } catch (err) {
      _iterator38.e(err);
    } finally {
      _iterator38.f();
    }
    var s = e.length, a = s;
    for (s && e.push("-"); a < r; ) {
      var _l29 = 2147483647;
      var _iterator39 = _createForOfIteratorHelper(t), _step39;
      try {
        for (_iterator39.s(); !(_step39 = _iterator39.n()).done; ) {
          var _h11 = _step39.value;
          _h11 >= i && _h11 < _l29 && (_l29 = _h11);
        }
      } catch (err) {
        _iterator39.e(err);
      } finally {
        _iterator39.f();
      }
      var _c18 = a + 1;
      _l29 - i > dt((2147483647 - n) / _c18) && Rr("overflow"), n += (_l29 - i) * _c18, i = _l29;
      var _iterator40 = _createForOfIteratorHelper(t), _step40;
      try {
        for (_iterator40.s(); !(_step40 = _iterator40.n()).done; ) {
          var _h12 = _step40.value;
          if (_h12 < i && ++n > 2147483647 && Rr("overflow"), _h12 == i) {
            var _d12 = n;
            for (var _g16 = 36; ; _g16 += 36) {
              var _y15 = _g16 <= o ? 1 : _g16 >= o + 26 ? 26 : _g16 - o;
              if (_d12 < _y15)
                break;
              var _w7 = _d12 - _y15, _S11 = 36 - _y15;
              e.push(Ka(Kp(_y15 + _w7 % _S11, 0))), _d12 = dt(_w7 / _S11);
            }
            e.push(Ka(Kp(_d12, 0))), o = Jp(n, _c18, a == s), n = 0, ++a;
          }
        }
      } catch (err) {
        _iterator40.e(err);
      } finally {
        _iterator40.f();
      }
      ++n, ++i;
    }
    return e.join("");
  }, Kt = { version: "2.1.0", ucs2: { decode: Yp, encode: function encode2(t) {
    return String.fromCodePoint.apply(String, _toConsumableArray(t));
  } }, decode: Gp, encode: Qp, toASCII: function toASCII(t) {
    return zp(t, function(e) {
      return iE.test(e) ? "xn--" + Qp(e) : e;
    });
  }, toUnicode: function toUnicode(t) {
    return zp(t, function(e) {
      return rE.test(e) ? Gp(e.slice(4).toLowerCase()) : e;
    });
  } };
  Kt.decode;
  Kt.encode;
  Kt.toASCII;
  Kt.toUnicode;
  Kt.ucs2;
  Kt.version;
});
function oE(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
var aE, Mi, lE, pt, Zp = _e(function() {
  _();
  v();
  m();
  aE = function aE2(t, e, r, i) {
    e = e || "&", r = r || "=";
    var n = {};
    if (typeof t != "string" || t.length === 0)
      return n;
    var o = /\+/g;
    t = t.split(e);
    var s = 1e3;
    i && typeof i.maxKeys == "number" && (s = i.maxKeys);
    var a = t.length;
    s > 0 && a > s && (a = s);
    for (var l = 0; l < a; ++l) {
      var c, h, d, g, y = t[l].replace(o, "%20"), w = y.indexOf(r);
      w >= 0 ? (c = y.substr(0, w), h = y.substr(w + 1)) : (c = y, h = ""), d = decodeURIComponent(c), g = decodeURIComponent(h), oE(n, d) ? Array.isArray(n[d]) ? n[d].push(g) : n[d] = [n[d], g] : n[d] = g;
    }
    return n;
  }, Mi = function Mi2(t) {
    switch (_typeof(t)) {
      case "string":
        return t;
      case "boolean":
        return t ? "true" : "false";
      case "number":
        return isFinite(t) ? t : "";
      default:
        return "";
    }
  }, lE = function lE2(t, e, r, i) {
    return e = e || "&", r = r || "=", t === null && (t = void 0), _typeof(t) == "object" ? Object.keys(t).map(function(n) {
      var o = encodeURIComponent(Mi(n)) + r;
      return Array.isArray(t[n]) ? t[n].map(function(s) {
        return o + encodeURIComponent(Mi(s));
      }).join(e) : o + encodeURIComponent(Mi(t[n]));
    }).join(e) : i ? encodeURIComponent(Mi(i)) + r + encodeURIComponent(Mi(t)) : "";
  }, pt = {};
  pt.decode = pt.parse = aE, pt.encode = pt.stringify = lE;
  pt.decode;
  pt.encode;
  pt.parse;
  pt.stringify;
});
function Ga() {
  throw new Error("setTimeout has not been defined");
}
function Qa() {
  throw new Error("clearTimeout has not been defined");
}
function rg(t) {
  if (Pt === setTimeout)
    return setTimeout(t, 0);
  if ((Pt === Ga || !Pt) && setTimeout)
    return Pt = setTimeout, setTimeout(t, 0);
  try {
    return Pt(t, 0);
  } catch (_unused13) {
    try {
      return Pt.call(null, t, 0);
    } catch (_unused14) {
      return Pt.call(this || si, t, 0);
    }
  }
}
function uE() {
  ni && Cr && (ni = false, Cr.length ? Ot = Cr.concat(Ot) : as = -1, Ot.length && ig());
}
function ig() {
  if (!ni) {
    var t = rg(uE);
    ni = true;
    for (var e = Ot.length; e; ) {
      for (Cr = Ot, Ot = []; ++as < e; )
        Cr && Cr[as].run();
      as = -1, e = Ot.length;
    }
    Cr = null, ni = false, function(r) {
      if (kt === clearTimeout)
        return clearTimeout(r);
      if ((kt === Qa || !kt) && clearTimeout)
        return kt = clearTimeout, clearTimeout(r);
      try {
        kt(r);
      } catch (_unused15) {
        try {
          return kt.call(null, r);
        } catch (_unused16) {
          return kt.call(this || si, r);
        }
      }
    }(t);
  }
}
function eg(t, e) {
  (this || si).fun = t, (this || si).array = e;
}
function Bt() {
}
var tg, Pt, kt, si, fe, Cr, Ot, ni, as, ne, ng = _e(function() {
  _();
  v();
  m();
  si = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" ? self : global, fe = tg = {};
  (function() {
    try {
      Pt = typeof setTimeout == "function" ? setTimeout : Ga;
    } catch (_unused17) {
      Pt = Ga;
    }
    try {
      kt = typeof clearTimeout == "function" ? clearTimeout : Qa;
    } catch (_unused18) {
      kt = Qa;
    }
  })();
  Ot = [], ni = false, as = -1;
  fe.nextTick = function(t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1)
      for (var r = 1; r < arguments.length; r++)
        e[r - 1] = arguments[r];
    Ot.push(new eg(t, e)), Ot.length !== 1 || ni || rg(ig);
  }, eg.prototype.run = function() {
    (this || si).fun.apply(null, (this || si).array);
  }, fe.title = "browser", fe.browser = true, fe.env = {}, fe.argv = [], fe.version = "", fe.versions = {}, fe.on = Bt, fe.addListener = Bt, fe.once = Bt, fe.off = Bt, fe.removeListener = Bt, fe.removeAllListeners = Bt, fe.emit = Bt, fe.prependListener = Bt, fe.prependOnceListener = Bt, fe.listeners = function(t) {
    return [];
  }, fe.binding = function(t) {
    throw new Error("process.binding is not supported");
  }, fe.cwd = function() {
    return "/";
  }, fe.chdir = function(t) {
    throw new Error("process.chdir is not supported");
  }, fe.umask = function() {
    return 0;
  };
  ne = tg;
  ne.addListener;
  ne.argv;
  ne.binding;
  ne.browser;
  ne.chdir;
  ne.cwd;
  ne.emit;
  ne.env;
  ne.listeners;
  ne.nextTick;
  ne.off;
  ne.on;
  ne.once;
  ne.prependListener;
  ne.prependOnceListener;
  ne.removeAllListeners;
  ne.removeListener;
  ne.title;
  ne.umask;
  ne.version;
  ne.versions;
});
function fE() {
  if (sg)
    return Ya;
  sg = true;
  var t = Ya = {}, e, r;
  function i() {
    throw new Error("setTimeout has not been defined");
  }
  function n() {
    throw new Error("clearTimeout has not been defined");
  }
  (function() {
    try {
      typeof setTimeout == "function" ? e = setTimeout : e = i;
    } catch (_unused19) {
      e = i;
    }
    try {
      typeof clearTimeout == "function" ? r = clearTimeout : r = n;
    } catch (_unused20) {
      r = n;
    }
  })();
  function o(S) {
    if (e === setTimeout)
      return setTimeout(S, 0);
    if ((e === i || !e) && setTimeout)
      return e = setTimeout, setTimeout(S, 0);
    try {
      return e(S, 0);
    } catch (_unused21) {
      try {
        return e.call(null, S, 0);
      } catch (_unused22) {
        return e.call(this || oi, S, 0);
      }
    }
  }
  function s(S) {
    if (r === clearTimeout)
      return clearTimeout(S);
    if ((r === n || !r) && clearTimeout)
      return r = clearTimeout, clearTimeout(S);
    try {
      return r(S);
    } catch (_unused23) {
      try {
        return r.call(null, S);
      } catch (_unused24) {
        return r.call(this || oi, S);
      }
    }
  }
  var a = [], l = false, c, h = -1;
  function d() {
    !l || !c || (l = false, c.length ? a = c.concat(a) : h = -1, a.length && g());
  }
  function g() {
    if (!l) {
      var S = o(d);
      l = true;
      for (var E = a.length; E; ) {
        for (c = a, a = []; ++h < E; )
          c && c[h].run();
        h = -1, E = a.length;
      }
      c = null, l = false, s(S);
    }
  }
  t.nextTick = function(S) {
    var E = new Array(arguments.length - 1);
    if (arguments.length > 1)
      for (var I = 1; I < arguments.length; I++)
        E[I - 1] = arguments[I];
    a.push(new y(S, E)), a.length === 1 && !l && o(g);
  };
  function y(S, E) {
    (this || oi).fun = S, (this || oi).array = E;
  }
  y.prototype.run = function() {
    (this || oi).fun.apply(null, (this || oi).array);
  }, t.title = "browser", t.browser = true, t.env = {}, t.argv = [], t.version = "", t.versions = {};
  function w() {
  }
  return t.on = w, t.addListener = w, t.once = w, t.off = w, t.removeListener = w, t.removeAllListeners = w, t.emit = w, t.prependListener = w, t.prependOnceListener = w, t.listeners = function(S) {
    return [];
  }, t.binding = function(S) {
    throw new Error("process.binding is not supported");
  }, t.cwd = function() {
    return "/";
  }, t.chdir = function(S) {
    throw new Error("process.chdir is not supported");
  }, t.umask = function() {
    return 0;
  }, Ya;
}
var Ya, sg, oi, re, Ja = _e(function() {
  _();
  v();
  m();
  Ya = {}, sg = false, oi = (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) < "u" ? globalThis : (typeof self === "undefined" ? "undefined" : _typeof(self)) < "u" ? self : global;
  re = fE();
  re.platform = "browser";
  re.addListener;
  re.argv;
  re.binding;
  re.browser;
  re.chdir;
  re.cwd;
  re.emit;
  re.env;
  re.listeners;
  re.nextTick;
  re.off;
  re.on;
  re.once;
  re.prependListener;
  re.prependOnceListener;
  re.removeAllListeners;
  re.removeListener;
  re.title;
  re.umask;
  re.version;
  re.versions;
});
function cE() {
  if (og)
    return Xa;
  og = true;
  var t = re;
  function e(o) {
    if (typeof o != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(o));
  }
  function r(o, s) {
    for (var a = "", l = 0, c = -1, h = 0, d, g = 0; g <= o.length; ++g) {
      if (g < o.length)
        d = o.charCodeAt(g);
      else {
        if (d === 47)
          break;
        d = 47;
      }
      if (d === 47) {
        if (!(c === g - 1 || h === 1))
          if (c !== g - 1 && h === 2) {
            if (a.length < 2 || l !== 2 || a.charCodeAt(a.length - 1) !== 46 || a.charCodeAt(a.length - 2) !== 46) {
              if (a.length > 2) {
                var y = a.lastIndexOf("/");
                if (y !== a.length - 1) {
                  y === -1 ? (a = "", l = 0) : (a = a.slice(0, y), l = a.length - 1 - a.lastIndexOf("/")), c = g, h = 0;
                  continue;
                }
              } else if (a.length === 2 || a.length === 1) {
                a = "", l = 0, c = g, h = 0;
                continue;
              }
            }
            s && (a.length > 0 ? a += "/.." : a = "..", l = 2);
          } else
            a.length > 0 ? a += "/" + o.slice(c + 1, g) : a = o.slice(c + 1, g), l = g - c - 1;
        c = g, h = 0;
      } else
        d === 46 && h !== -1 ? ++h : h = -1;
    }
    return a;
  }
  function i(o, s) {
    var a = s.dir || s.root, l = s.base || (s.name || "") + (s.ext || "");
    return a ? a === s.root ? a + l : a + o + l : l;
  }
  var n = { resolve: function resolve2() {
    for (var s = "", a = false, l, c = arguments.length - 1; c >= -1 && !a; c--) {
      var h;
      c >= 0 ? h = arguments[c] : (l === void 0 && (l = t.cwd()), h = l), e(h), h.length !== 0 && (s = h + "/" + s, a = h.charCodeAt(0) === 47);
    }
    return s = r(s, !a), a ? s.length > 0 ? "/" + s : "/" : s.length > 0 ? s : ".";
  }, normalize: function normalize(s) {
    if (e(s), s.length === 0)
      return ".";
    var a = s.charCodeAt(0) === 47, l = s.charCodeAt(s.length - 1) === 47;
    return s = r(s, !a), s.length === 0 && !a && (s = "."), s.length > 0 && l && (s += "/"), a ? "/" + s : s;
  }, isAbsolute: function isAbsolute(s) {
    return e(s), s.length > 0 && s.charCodeAt(0) === 47;
  }, join: function join() {
    if (arguments.length === 0)
      return ".";
    for (var s, a = 0; a < arguments.length; ++a) {
      var l = arguments[a];
      e(l), l.length > 0 && (s === void 0 ? s = l : s += "/" + l);
    }
    return s === void 0 ? "." : n.normalize(s);
  }, relative: function relative(s, a) {
    if (e(s), e(a), s === a || (s = n.resolve(s), a = n.resolve(a), s === a))
      return "";
    for (var l = 1; l < s.length && s.charCodeAt(l) === 47; ++l)
      ;
    for (var c = s.length, h = c - l, d = 1; d < a.length && a.charCodeAt(d) === 47; ++d)
      ;
    for (var g = a.length, y = g - d, w = h < y ? h : y, S = -1, E = 0; E <= w; ++E) {
      if (E === w) {
        if (y > w) {
          if (a.charCodeAt(d + E) === 47)
            return a.slice(d + E + 1);
          if (E === 0)
            return a.slice(d + E);
        } else
          h > w && (s.charCodeAt(l + E) === 47 ? S = E : E === 0 && (S = 0));
        break;
      }
      var I = s.charCodeAt(l + E), C = a.charCodeAt(d + E);
      if (I !== C)
        break;
      I === 47 && (S = E);
    }
    var R = "";
    for (E = l + S + 1; E <= c; ++E)
      (E === c || s.charCodeAt(E) === 47) && (R.length === 0 ? R += ".." : R += "/..");
    return R.length > 0 ? R + a.slice(d + S) : (d += S, a.charCodeAt(d) === 47 && ++d, a.slice(d));
  }, _makeLong: function _makeLong(s) {
    return s;
  }, dirname: function dirname(s) {
    if (e(s), s.length === 0)
      return ".";
    for (var a = s.charCodeAt(0), l = a === 47, c = -1, h = true, d = s.length - 1; d >= 1; --d)
      if (a = s.charCodeAt(d), a === 47) {
        if (!h) {
          c = d;
          break;
        }
      } else
        h = false;
    return c === -1 ? l ? "/" : "." : l && c === 1 ? "//" : s.slice(0, c);
  }, basename: function basename(s, a) {
    if (a !== void 0 && typeof a != "string")
      throw new TypeError('"ext" argument must be a string');
    e(s);
    var l = 0, c = -1, h = true, d;
    if (a !== void 0 && a.length > 0 && a.length <= s.length) {
      if (a.length === s.length && a === s)
        return "";
      var g = a.length - 1, y = -1;
      for (d = s.length - 1; d >= 0; --d) {
        var w = s.charCodeAt(d);
        if (w === 47) {
          if (!h) {
            l = d + 1;
            break;
          }
        } else
          y === -1 && (h = false, y = d + 1), g >= 0 && (w === a.charCodeAt(g) ? --g === -1 && (c = d) : (g = -1, c = y));
      }
      return l === c ? c = y : c === -1 && (c = s.length), s.slice(l, c);
    } else {
      for (d = s.length - 1; d >= 0; --d)
        if (s.charCodeAt(d) === 47) {
          if (!h) {
            l = d + 1;
            break;
          }
        } else
          c === -1 && (h = false, c = d + 1);
      return c === -1 ? "" : s.slice(l, c);
    }
  }, extname: function extname(s) {
    e(s);
    for (var a = -1, l = 0, c = -1, h = true, d = 0, g = s.length - 1; g >= 0; --g) {
      var y = s.charCodeAt(g);
      if (y === 47) {
        if (!h) {
          l = g + 1;
          break;
        }
        continue;
      }
      c === -1 && (h = false, c = g + 1), y === 46 ? a === -1 ? a = g : d !== 1 && (d = 1) : a !== -1 && (d = -1);
    }
    return a === -1 || c === -1 || d === 0 || d === 1 && a === c - 1 && a === l + 1 ? "" : s.slice(a, c);
  }, format: function format2(s) {
    if (s === null || _typeof(s) != "object")
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + _typeof(s));
    return i("/", s);
  }, parse: function parse2(s) {
    e(s);
    var a = { root: "", dir: "", base: "", ext: "", name: "" };
    if (s.length === 0)
      return a;
    var l = s.charCodeAt(0), c = l === 47, h;
    c ? (a.root = "/", h = 1) : h = 0;
    for (var d = -1, g = 0, y = -1, w = true, S = s.length - 1, E = 0; S >= h; --S) {
      if (l = s.charCodeAt(S), l === 47) {
        if (!w) {
          g = S + 1;
          break;
        }
        continue;
      }
      y === -1 && (w = false, y = S + 1), l === 46 ? d === -1 ? d = S : E !== 1 && (E = 1) : d !== -1 && (E = -1);
    }
    return d === -1 || y === -1 || E === 0 || E === 1 && d === y - 1 && d === g + 1 ? y !== -1 && (g === 0 && c ? a.base = a.name = s.slice(1, y) : a.base = a.name = s.slice(g, y)) : (g === 0 && c ? (a.name = s.slice(1, d), a.base = s.slice(1, y)) : (a.name = s.slice(g, d), a.base = s.slice(g, y)), a.ext = s.slice(d, y)), g > 0 ? a.dir = s.slice(0, g - 1) : c && (a.dir = "/"), a;
  }, sep: "/", delimiter: ":", win32: null, posix: null };
  return n.posix = n, Xa = n, Xa;
}
var Xa, og, Za, ag = _e(function() {
  _();
  v();
  m();
  Ja();
  Xa = {}, og = false;
  Za = cE();
});
var gg = {};
Jt(gg, { URL: function URL2() {
  return FE;
}, Url: function Url() {
  return UE;
}, default: function _default5() {
  return Z;
}, fileURLToPath: function fileURLToPath() {
  return dg;
}, format: function format() {
  return NE;
}, parse: function parse() {
  return jE;
}, pathToFileURL: function pathToFileURL() {
  return pg;
}, resolve: function resolve() {
  return qE;
}, resolveObject: function resolveObject() {
  return DE;
} });
function Fe() {
  this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
}
function Li(t, e, r) {
  if (t && gt.isObject(t) && t instanceof Fe)
    return t;
  var i = new Fe();
  return i.parse(t, e, r), i;
}
function _E() {
  if (cg)
    return rl;
  cg = true;
  var t = ne;
  function e(o) {
    if (typeof o != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(o));
  }
  function r(o, s) {
    for (var a = "", l = 0, c = -1, h = 0, d, g = 0; g <= o.length; ++g) {
      if (g < o.length)
        d = o.charCodeAt(g);
      else {
        if (d === 47)
          break;
        d = 47;
      }
      if (d === 47) {
        if (!(c === g - 1 || h === 1))
          if (c !== g - 1 && h === 2) {
            if (a.length < 2 || l !== 2 || a.charCodeAt(a.length - 1) !== 46 || a.charCodeAt(a.length - 2) !== 46) {
              if (a.length > 2) {
                var y = a.lastIndexOf("/");
                if (y !== a.length - 1) {
                  y === -1 ? (a = "", l = 0) : (a = a.slice(0, y), l = a.length - 1 - a.lastIndexOf("/")), c = g, h = 0;
                  continue;
                }
              } else if (a.length === 2 || a.length === 1) {
                a = "", l = 0, c = g, h = 0;
                continue;
              }
            }
            s && (a.length > 0 ? a += "/.." : a = "..", l = 2);
          } else
            a.length > 0 ? a += "/" + o.slice(c + 1, g) : a = o.slice(c + 1, g), l = g - c - 1;
        c = g, h = 0;
      } else
        d === 46 && h !== -1 ? ++h : h = -1;
    }
    return a;
  }
  function i(o, s) {
    var a = s.dir || s.root, l = s.base || (s.name || "") + (s.ext || "");
    return a ? a === s.root ? a + l : a + o + l : l;
  }
  var n = { resolve: function resolve2() {
    for (var s = "", a = false, l, c = arguments.length - 1; c >= -1 && !a; c--) {
      var h;
      c >= 0 ? h = arguments[c] : (l === void 0 && (l = t.cwd()), h = l), e(h), h.length !== 0 && (s = h + "/" + s, a = h.charCodeAt(0) === 47);
    }
    return s = r(s, !a), a ? s.length > 0 ? "/" + s : "/" : s.length > 0 ? s : ".";
  }, normalize: function normalize(s) {
    if (e(s), s.length === 0)
      return ".";
    var a = s.charCodeAt(0) === 47, l = s.charCodeAt(s.length - 1) === 47;
    return s = r(s, !a), s.length === 0 && !a && (s = "."), s.length > 0 && l && (s += "/"), a ? "/" + s : s;
  }, isAbsolute: function isAbsolute(s) {
    return e(s), s.length > 0 && s.charCodeAt(0) === 47;
  }, join: function join() {
    if (arguments.length === 0)
      return ".";
    for (var s, a = 0; a < arguments.length; ++a) {
      var l = arguments[a];
      e(l), l.length > 0 && (s === void 0 ? s = l : s += "/" + l);
    }
    return s === void 0 ? "." : n.normalize(s);
  }, relative: function relative(s, a) {
    if (e(s), e(a), s === a || (s = n.resolve(s), a = n.resolve(a), s === a))
      return "";
    for (var l = 1; l < s.length && s.charCodeAt(l) === 47; ++l)
      ;
    for (var c = s.length, h = c - l, d = 1; d < a.length && a.charCodeAt(d) === 47; ++d)
      ;
    for (var g = a.length, y = g - d, w = h < y ? h : y, S = -1, E = 0; E <= w; ++E) {
      if (E === w) {
        if (y > w) {
          if (a.charCodeAt(d + E) === 47)
            return a.slice(d + E + 1);
          if (E === 0)
            return a.slice(d + E);
        } else
          h > w && (s.charCodeAt(l + E) === 47 ? S = E : E === 0 && (S = 0));
        break;
      }
      var I = s.charCodeAt(l + E), C = a.charCodeAt(d + E);
      if (I !== C)
        break;
      I === 47 && (S = E);
    }
    var R = "";
    for (E = l + S + 1; E <= c; ++E)
      (E === c || s.charCodeAt(E) === 47) && (R.length === 0 ? R += ".." : R += "/..");
    return R.length > 0 ? R + a.slice(d + S) : (d += S, a.charCodeAt(d) === 47 && ++d, a.slice(d));
  }, _makeLong: function _makeLong(s) {
    return s;
  }, dirname: function dirname(s) {
    if (e(s), s.length === 0)
      return ".";
    for (var a = s.charCodeAt(0), l = a === 47, c = -1, h = true, d = s.length - 1; d >= 1; --d)
      if (a = s.charCodeAt(d), a === 47) {
        if (!h) {
          c = d;
          break;
        }
      } else
        h = false;
    return c === -1 ? l ? "/" : "." : l && c === 1 ? "//" : s.slice(0, c);
  }, basename: function basename(s, a) {
    if (a !== void 0 && typeof a != "string")
      throw new TypeError('"ext" argument must be a string');
    e(s);
    var l = 0, c = -1, h = true, d;
    if (a !== void 0 && a.length > 0 && a.length <= s.length) {
      if (a.length === s.length && a === s)
        return "";
      var g = a.length - 1, y = -1;
      for (d = s.length - 1; d >= 0; --d) {
        var w = s.charCodeAt(d);
        if (w === 47) {
          if (!h) {
            l = d + 1;
            break;
          }
        } else
          y === -1 && (h = false, y = d + 1), g >= 0 && (w === a.charCodeAt(g) ? --g === -1 && (c = d) : (g = -1, c = y));
      }
      return l === c ? c = y : c === -1 && (c = s.length), s.slice(l, c);
    } else {
      for (d = s.length - 1; d >= 0; --d)
        if (s.charCodeAt(d) === 47) {
          if (!h) {
            l = d + 1;
            break;
          }
        } else
          c === -1 && (h = false, c = d + 1);
      return c === -1 ? "" : s.slice(l, c);
    }
  }, extname: function extname(s) {
    e(s);
    for (var a = -1, l = 0, c = -1, h = true, d = 0, g = s.length - 1; g >= 0; --g) {
      var y = s.charCodeAt(g);
      if (y === 47) {
        if (!h) {
          l = g + 1;
          break;
        }
        continue;
      }
      c === -1 && (h = false, c = g + 1), y === 46 ? a === -1 ? a = g : d !== 1 && (d = 1) : a !== -1 && (d = -1);
    }
    return a === -1 || c === -1 || d === 0 || d === 1 && a === c - 1 && a === l + 1 ? "" : s.slice(a, c);
  }, format: function format2(s) {
    if (s === null || _typeof(s) != "object")
      throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + _typeof(s));
    return i("/", s);
  }, parse: function parse2(s) {
    e(s);
    var a = { root: "", dir: "", base: "", ext: "", name: "" };
    if (s.length === 0)
      return a;
    var l = s.charCodeAt(0), c = l === 47, h;
    c ? (a.root = "/", h = 1) : h = 0;
    for (var d = -1, g = 0, y = -1, w = true, S = s.length - 1, E = 0; S >= h; --S) {
      if (l = s.charCodeAt(S), l === 47) {
        if (!w) {
          g = S + 1;
          break;
        }
        continue;
      }
      y === -1 && (w = false, y = S + 1), l === 46 ? d === -1 ? d = S : E !== 1 && (E = 1) : d !== -1 && (E = -1);
    }
    return d === -1 || y === -1 || E === 0 || E === 1 && d === y - 1 && d === g + 1 ? y !== -1 && (g === 0 && c ? a.base = a.name = s.slice(1, y) : a.base = a.name = s.slice(g, y)) : (g === 0 && c ? (a.name = s.slice(1, d), a.base = s.slice(1, y)) : (a.name = s.slice(g, d), a.base = s.slice(g, y)), a.ext = s.slice(d, y)), g > 0 ? a.dir = s.slice(0, g - 1) : c && (a.dir = "/"), a;
  }, sep: "/", delimiter: ":", win32: null, posix: null };
  return n.posix = n, rl = n, rl;
}
function kE(t) {
  if (typeof t == "string")
    t = new URL(t);
  else if (!(t instanceof URL))
    throw new Deno.errors.InvalidData("invalid argument path , must be a string or URL");
  if (t.protocol !== "file:")
    throw new Deno.errors.InvalidData("invalid url scheme");
  return nl ? OE(t) : xE(t);
}
function OE(t) {
  var e = t.hostname, r = t.pathname;
  for (var i = 0; i < r.length; i++)
    if (r[i] === "%") {
      var _n44 = r.codePointAt(i + 2) || 32;
      if (r[i + 1] === "2" && _n44 === 102 || r[i + 1] === "5" && _n44 === 99)
        throw new Deno.errors.InvalidData("must not include encoded \\ or / characters");
    }
  if (r = r.replace(IE, "\\"), r = decodeURIComponent(r), e !== "")
    return "\\\\".concat(e).concat(r);
  {
    var _i23 = r.codePointAt(1) | 32, _n45 = r[2];
    if (_i23 < SE || _i23 > AE || _n45 !== ":")
      throw new Deno.errors.InvalidData("file url path must be absolute");
    return r.slice(1);
  }
}
function xE(t) {
  if (t.hostname !== "")
    throw new Deno.errors.InvalidData("invalid file url hostname");
  var e = t.pathname;
  for (var _r53 = 0; _r53 < e.length; _r53++)
    if (e[_r53] === "%") {
      var i = e.codePointAt(_r53 + 2) || 32;
      if (e[_r53 + 1] === "2" && i === 102)
        throw new Deno.errors.InvalidData("must not include encoded / characters");
    }
  return decodeURIComponent(e);
}
function ME(t) {
  var e = hg.resolve(t), r = t.charCodeAt(t.length - 1);
  (r === EE || nl && r === vE) && e[e.length - 1] !== hg.sep && (e += "/");
  var i = new URL("file://");
  return e.includes("%") && (e = e.replace(TE, "%25")), !nl && e.includes("\\") && (e = e.replace(RE, "%5C")), e.includes("\n") && (e = e.replace(CE, "%0A")), e.includes("\r") && (e = e.replace(BE, "%0D")), e.includes("	") && (e = e.replace(PE, "%09")), i.pathname = e, i;
}
function dg(t) {
  if (typeof t == "string")
    t = new URL(t);
  else if (!(t instanceof URL))
    throw new Deno.errors.InvalidData("invalid argument path , must be a string or URL");
  if (t.protocol !== "file:")
    throw new Deno.errors.InvalidData("invalid url scheme");
  return sl ? XE(t) : ZE(t);
}
function XE(t) {
  var e = t.hostname, r = t.pathname;
  for (var i = 0; i < r.length; i++)
    if (r[i] === "%") {
      var _n46 = r.codePointAt(i + 2) || 32;
      if (r[i + 1] === "2" && _n46 === 102 || r[i + 1] === "5" && _n46 === 99)
        throw new Deno.errors.InvalidData("must not include encoded \\ or / characters");
    }
  if (r = r.replace(zE, "\\"), r = decodeURIComponent(r), e !== "")
    return "\\\\".concat(e).concat(r);
  {
    var _i24 = r.codePointAt(1) | 32, _n47 = r[2];
    if (_i24 < HE || _i24 > VE || _n47 !== ":")
      throw new Deno.errors.InvalidData("file url path must be absolute");
    return r.slice(1);
  }
}
function ZE(t) {
  if (t.hostname !== "")
    throw new Deno.errors.InvalidData("invalid file url hostname");
  var e = t.pathname;
  for (var _r54 = 0; _r54 < e.length; _r54++)
    if (e[_r54] === "%") {
      var i = e.codePointAt(_r54 + 2) || 32;
      if (e[_r54 + 1] === "2" && i === 102)
        throw new Deno.errors.InvalidData("must not include encoded / characters");
    }
  return decodeURIComponent(e);
}
function pg(t) {
  var e = Za.resolve(t), r = t.charCodeAt(t.length - 1);
  (r === $E || sl && r === WE) && e[e.length - 1] !== Za.sep && (e += "/");
  var i = new URL("file://");
  return e.includes("%") && (e = e.replace(KE, "%25")), !sl && e.includes("\\") && (e = e.replace(GE, "%5C")), e.includes("\n") && (e = e.replace(QE, "%0A")), e.includes("\r") && (e = e.replace(YE, "%0D")), e.includes("	") && (e = e.replace(JE, "%09")), i.pathname = e, i;
}
var Z, hE, gt, dE, pE, gE, yE, il, lg, ug, fg, bE, wE, el, ai, tl, rl, cg, hg, mE, vE, EE, SE, AE, nl, IE, TE, RE, CE, BE, PE, LE, UE, NE, qE, DE, jE, FE, WE, $E, HE, VE, sl, zE, KE, GE, QE, YE, JE, yg = _e(function() {
  _();
  v();
  m();
  Xp();
  Zp();
  ng();
  ag();
  Ja();
  Z = {}, hE = Kt, gt = { isString: function isString(t) {
    return typeof t == "string";
  }, isObject: function isObject(t) {
    return _typeof(t) == "object" && t !== null;
  }, isNull: function isNull(t) {
    return t === null;
  }, isNullOrUndefined: function isNullOrUndefined(t) {
    return t == null;
  } };
  Z.parse = Li, Z.resolve = function(t, e) {
    return Li(t, false, true).resolve(e);
  }, Z.resolveObject = function(t, e) {
    return t ? Li(t, false, true).resolveObject(e) : e;
  }, Z.format = function(t) {
    return gt.isString(t) && (t = Li(t)), t instanceof Fe ? t.format() : Fe.prototype.format.call(t);
  }, Z.Url = Fe;
  dE = /^([a-z0-9.+-]+:)/i, pE = /:[0-9]*$/, gE = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, yE = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "	"]), il = ["'"].concat(yE), lg = ["%", "/", "?", ";", "#"].concat(il), ug = ["/", "?", "#"], fg = /^[+a-z0-9A-Z_-]{0,63}$/, bE = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, wE = { javascript: true, "javascript:": true }, el = { javascript: true, "javascript:": true }, ai = { http: true, https: true, ftp: true, gopher: true, file: true, "http:": true, "https:": true, "ftp:": true, "gopher:": true, "file:": true }, tl = pt;
  Fe.prototype.parse = function(t, e, r) {
    if (!gt.isString(t))
      throw new TypeError("Parameter 'url' must be a string, not " + _typeof(t));
    var i = t.indexOf("?"), n = i !== -1 && i < t.indexOf("#") ? "?" : "#", o = t.split(n);
    o[0] = o[0].replace(/\\/g, "/");
    var s = t = o.join(n);
    if (s = s.trim(), !r && t.split("#").length === 1) {
      var a = gE.exec(s);
      if (a)
        return this.path = s, this.href = s, this.pathname = a[1], a[2] ? (this.search = a[2], this.query = e ? tl.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
    }
    var l = dE.exec(s);
    if (l) {
      var c = (l = l[0]).toLowerCase();
      this.protocol = c, s = s.substr(l.length);
    }
    if (r || l || s.match(/^\/\/[^@\/]+@[^@\/]+/)) {
      var h = s.substr(0, 2) === "//";
      !h || l && el[l] || (s = s.substr(2), this.slashes = true);
    }
    if (!el[l] && (h || l && !ai[l])) {
      for (var d, g, y = -1, w = 0; w < ug.length; w++)
        (S = s.indexOf(ug[w])) !== -1 && (y === -1 || S < y) && (y = S);
      for ((g = y === -1 ? s.lastIndexOf("@") : s.lastIndexOf("@", y)) !== -1 && (d = s.slice(0, g), s = s.slice(g + 1), this.auth = decodeURIComponent(d)), y = -1, w = 0; w < lg.length; w++) {
        var S;
        (S = s.indexOf(lg[w])) !== -1 && (y === -1 || S < y) && (y = S);
      }
      y === -1 && (y = s.length), this.host = s.slice(0, y), s = s.slice(y), this.parseHost(), this.hostname = this.hostname || "";
      var E = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
      if (!E)
        for (var I = this.hostname.split(/\./), C = (w = 0, I.length); w < C; w++) {
          var R = I[w];
          if (R && !R.match(fg)) {
            for (var U = "", N = 0, W = R.length; N < W; N++)
              R.charCodeAt(N) > 127 ? U += "x" : U += R[N];
            if (!U.match(fg)) {
              var K = I.slice(0, w), z = I.slice(w + 1), Q = R.match(bE);
              Q && (K.push(Q[1]), z.unshift(Q[2])), z.length && (s = "/" + z.join(".") + s), this.hostname = K.join(".");
              break;
            }
          }
        }
      this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), E || (this.hostname = hE.toASCII(this.hostname));
      var pe = this.port ? ":" + this.port : "", Yt = this.hostname || "";
      this.host = Yt + pe, this.href += this.host, E && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), s[0] !== "/" && (s = "/" + s));
    }
    if (!wE[c])
      for (w = 0, C = il.length; w < C; w++) {
        var ge = il[w];
        if (s.indexOf(ge) !== -1) {
          var Pr = encodeURIComponent(ge);
          Pr === ge && (Pr = escape(ge)), s = s.split(ge).join(Pr);
        }
      }
    var kr = s.indexOf("#");
    kr !== -1 && (this.hash = s.substr(kr), s = s.slice(0, kr));
    var Or = s.indexOf("?");
    if (Or !== -1 ? (this.search = s.substr(Or), this.query = s.substr(Or + 1), e && (this.query = tl.parse(this.query)), s = s.slice(0, Or)) : e && (this.search = "", this.query = {}), s && (this.pathname = s), ai[c] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
      pe = this.pathname || "";
      var hs = this.search || "";
      this.path = pe + hs;
    }
    return this.href = this.format(), this;
  }, Fe.prototype.format = function() {
    var t = this.auth || "";
    t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
    var e = this.protocol || "", r = this.pathname || "", i = this.hash || "", n = false, o = "";
    this.host ? n = t + this.host : this.hostname && (n = t + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]"), this.port && (n += ":" + this.port)), this.query && gt.isObject(this.query) && Object.keys(this.query).length && (o = tl.stringify(this.query));
    var s = this.search || o && "?" + o || "";
    return e && e.substr(-1) !== ":" && (e += ":"), this.slashes || (!e || ai[e]) && n !== false ? (n = "//" + (n || ""), r && r.charAt(0) !== "/" && (r = "/" + r)) : n || (n = ""), i && i.charAt(0) !== "#" && (i = "#" + i), s && s.charAt(0) !== "?" && (s = "?" + s), e + n + (r = r.replace(/[?#]/g, function(a) {
      return encodeURIComponent(a);
    })) + (s = s.replace("#", "%23")) + i;
  }, Fe.prototype.resolve = function(t) {
    return this.resolveObject(Li(t, false, true)).format();
  }, Fe.prototype.resolveObject = function(t) {
    if (gt.isString(t)) {
      var e = new Fe();
      e.parse(t, false, true), t = e;
    }
    for (var r = new Fe(), i = Object.keys(this), n = 0; n < i.length; n++) {
      var o = i[n];
      r[o] = this[o];
    }
    if (r.hash = t.hash, t.href === "")
      return r.href = r.format(), r;
    if (t.slashes && !t.protocol) {
      for (var s = Object.keys(t), a = 0; a < s.length; a++) {
        var l = s[a];
        l !== "protocol" && (r[l] = t[l]);
      }
      return ai[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
    }
    if (t.protocol && t.protocol !== r.protocol) {
      if (!ai[t.protocol]) {
        for (var c = Object.keys(t), h = 0; h < c.length; h++) {
          var d = c[h];
          r[d] = t[d];
        }
        return r.href = r.format(), r;
      }
      if (r.protocol = t.protocol, t.host || el[t.protocol])
        r.pathname = t.pathname;
      else {
        for (var g = (t.pathname || "").split("/"); g.length && !(t.host = g.shift()); )
          ;
        t.host || (t.host = ""), t.hostname || (t.hostname = ""), g[0] !== "" && g.unshift(""), g.length < 2 && g.unshift(""), r.pathname = g.join("/");
      }
      if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
        var y = r.pathname || "", w = r.search || "";
        r.path = y + w;
      }
      return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
    }
    var S = r.pathname && r.pathname.charAt(0) === "/", E = t.host || t.pathname && t.pathname.charAt(0) === "/", I = E || S || r.host && t.pathname, C = I, R = r.pathname && r.pathname.split("/") || [], U = (g = t.pathname && t.pathname.split("/") || [], r.protocol && !ai[r.protocol]);
    if (U && (r.hostname = "", r.port = null, r.host && (R[0] === "" ? R[0] = r.host : R.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && (g[0] === "" ? g[0] = t.host : g.unshift(t.host)), t.host = null), I = I && (g[0] === "" || R[0] === "")), E)
      r.host = t.host || t.host === "" ? t.host : r.host, r.hostname = t.hostname || t.hostname === "" ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, R = g;
    else if (g.length)
      R || (R = []), R.pop(), R = R.concat(g), r.search = t.search, r.query = t.query;
    else if (!gt.isNullOrUndefined(t.search))
      return U && (r.hostname = r.host = R.shift(), (Q = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = Q.shift(), r.host = r.hostname = Q.shift())), r.search = t.search, r.query = t.query, gt.isNull(r.pathname) && gt.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
    if (!R.length)
      return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;
    for (var N = R.slice(-1)[0], W = (r.host || t.host || R.length > 1) && (N === "." || N === "..") || N === "", K = 0, z = R.length; z >= 0; z--)
      (N = R[z]) === "." ? R.splice(z, 1) : N === ".." ? (R.splice(z, 1), K++) : K && (R.splice(z, 1), K--);
    if (!I && !C)
      for (; K--; K)
        R.unshift("..");
    !I || R[0] === "" || R[0] && R[0].charAt(0) === "/" || R.unshift(""), W && R.join("/").substr(-1) !== "/" && R.push("");
    var Q, pe = R[0] === "" || R[0] && R[0].charAt(0) === "/";
    return U && (r.hostname = r.host = pe ? "" : R.length ? R.shift() : "", (Q = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = Q.shift(), r.host = r.hostname = Q.shift())), (I = I || r.host && R.length) && !pe && R.unshift(""), R.length ? r.pathname = R.join("/") : (r.pathname = null, r.path = null), gt.isNull(r.pathname) && gt.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
  }, Fe.prototype.parseHost = function() {
    var t = this.host, e = pE.exec(t);
    e && ((e = e[0]) !== ":" && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
  };
  Z.Url;
  Z.format;
  Z.resolve;
  Z.resolveObject;
  rl = {}, cg = false;
  hg = _E(), mE = (typeof Deno === "undefined" ? "undefined" : _typeof(Deno)) < "u" ? Deno.build.os === "windows" ? "win32" : Deno.build.os : void 0;
  Z.URL = (typeof URL === "undefined" ? "undefined" : _typeof(URL)) < "u" ? URL : null;
  Z.pathToFileURL = ME;
  Z.fileURLToPath = kE;
  Z.Url;
  Z.format;
  Z.resolve;
  Z.resolveObject;
  Z.URL;
  vE = 92, EE = 47, SE = 97, AE = 122, nl = mE === "win32", IE = /\//g, TE = /%/g, RE = /\\/g, CE = /\n/g, BE = /\r/g, PE = /\t/g;
  LE = (typeof Deno === "undefined" ? "undefined" : _typeof(Deno)) < "u" ? Deno.build.os === "windows" ? "win32" : Deno.build.os : void 0;
  Z.URL = (typeof URL === "undefined" ? "undefined" : _typeof(URL)) < "u" ? URL : null;
  Z.pathToFileURL = pg;
  Z.fileURLToPath = dg;
  UE = Z.Url, NE = Z.format, qE = Z.resolve, DE = Z.resolveObject, jE = Z.parse, FE = Z.URL, WE = 92, $E = 47, HE = 97, VE = 122, sl = LE === "win32", zE = /\//g, KE = /%/g, GE = /\\/g, QE = /\n/g, YE = /\r/g, JE = /\t/g;
});
var wg = M(function(m8, bg) {
  _();
  v();
  m();
  bg.exports = function() {
    throw new Error("ws does not work in the browser. Browser clients must use the native WebSocket object");
  };
});
var ls = M(function(li) {
  _();
  v();
  m();
  Object.defineProperty(li, "__esModule", { value: true });
  li.BufferedDuplex = li.writev = void 0;
  var eS = jt(), _g = (be(), X(me));
  function mg(t, e) {
    var r = new Array(t.length);
    for (var i = 0; i < t.length; i++)
      typeof t[i].chunk == "string" ? r[i] = _g.Buffer.from(t[i].chunk, "utf8") : r[i] = t[i].chunk;
    this._write(_g.Buffer.concat(r), "binary", e);
  }
  li.writev = mg;
  var ol = /* @__PURE__ */ function(_eS$Duplex) {
    function ol2(e, r, i) {
      var _this64;
      _classCallCheck(this, ol2);
      _this64 = _callSuper(this, ol2, [{ objectMode: true }]), _this64.proxy = r, _this64.socket = i, _this64.writeQueue = [], e.objectMode || (_this64._writev = mg.bind(_assertThisInitialized(_this64))), _this64.isSocketOpen = false, _this64.proxy.on("data", function(n) {
        _this64.destroyed || _this64.push(n);
      });
      return _this64;
    }
    _inherits(ol2, _eS$Duplex);
    return _createClass(ol2, [{ key: "_read", value: function _read(e) {
      this.proxy.read(e);
    } }, { key: "_write", value: function _write(e, r, i) {
      this.isSocketOpen ? this.writeToProxy(e, r, i) : this.writeQueue.push({ chunk: e, encoding: r, cb: i });
    } }, { key: "_final", value: function _final(e) {
      this.writeQueue = [], this.proxy.end(e);
    } }, { key: "_destroy", value: function _destroy(e, r) {
      this.writeQueue = [], this.proxy.destroy(), r(e);
    } }, { key: "socketReady", value: function socketReady() {
      this.emit("connect"), this.isSocketOpen = true, this.processWriteQueue();
    } }, { key: "writeToProxy", value: function writeToProxy(e, r, i) {
      this.proxy.write(e, r) === false ? this.proxy.once("drain", i) : i();
    } }, { key: "processWriteQueue", value: function processWriteQueue() {
      for (; this.writeQueue.length > 0; ) {
        var _this$writeQueue$shif = this.writeQueue.shift(), e = _this$writeQueue$shif.chunk, _r55 = _this$writeQueue$shif.encoding, i = _this$writeQueue$shif.cb;
        this.writeToProxy(e, _r55, i);
      }
    } }]);
  }(eS.Duplex);
  li.BufferedDuplex = ol;
});
var Ui = M(function(Qt) {
  _();
  v();
  m();
  var ll = Qt && Qt.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(Qt, "__esModule", { value: true });
  Qt.streamBuilder = Qt.browserStreamBuilder = void 0;
  var us = (be(), X(me)), vg = ll(wg()), tS = ll(ot()), rS = jt(), iS = ll(Oi()), al = ls(), Gt = (0, tS.default)("mqttjs:ws"), nS = ["rejectUnauthorized", "ca", "cert", "key", "pfx", "passphrase"];
  function Eg(t, e) {
    var r = "".concat(t.protocol, "://").concat(t.hostname, ":").concat(t.port).concat(t.path);
    return typeof t.transformWsUrl == "function" && (r = t.transformWsUrl(r, t, e)), r;
  }
  function Sg(t) {
    var e = t;
    return t.port || (t.protocol === "wss" ? e.port = 443 : e.port = 80), t.path || (e.path = "/"), t.wsOptions || (e.wsOptions = {}), !iS.default && !t.forceNativeWebSocket && t.protocol === "wss" && nS.forEach(function(r) {
      Object.prototype.hasOwnProperty.call(t, r) && !Object.prototype.hasOwnProperty.call(t.wsOptions, r) && (e.wsOptions[r] = t[r]);
    }), e;
  }
  function sS(t) {
    var e = Sg(t);
    if (e.hostname || (e.hostname = e.host), !e.hostname) {
      if ((typeof document === "undefined" ? "undefined" : _typeof(document)) > "u")
        throw new Error("Could not determine host. Specify host manually.");
      var _r56 = new URL(document.URL);
      e.hostname = _r56.hostname, e.port || (e.port = Number(_r56.port));
    }
    return e.objectMode === void 0 && (e.objectMode = !(e.binary === true || e.binary === void 0)), e;
  }
  function oS(t, e, r) {
    Gt("createWebSocket"), Gt("protocol: ".concat(r.protocolId, " ").concat(r.protocolVersion));
    var i = r.protocolId === "MQIsdp" && r.protocolVersion === 3 ? "mqttv3.1" : "mqtt";
    Gt("creating new Websocket for url: ".concat(e, " and protocol: ").concat(i));
    var n;
    return r.createWebsocket ? n = r.createWebsocket(e, [i], r) : n = new vg.default(e, [i], r.wsOptions), n;
  }
  function aS(t, e) {
    var r = e.protocolId === "MQIsdp" && e.protocolVersion === 3 ? "mqttv3.1" : "mqtt", i = Eg(e, t), n;
    return e.createWebsocket ? n = e.createWebsocket(i, [r], e) : n = new WebSocket(i, [r]), n.binaryType = "arraybuffer", n;
  }
  var lS = function lS2(t, e) {
    Gt("streamBuilder");
    var r = Sg(e);
    r.hostname = r.hostname || r.host || "localhost";
    var i = Eg(r, t), n = oS(t, i, r), o = vg.default.createWebSocketStream(n, r.wsOptions);
    return o.url = i, n.on("close", function() {
      o.destroy();
    }), o;
  };
  Qt.streamBuilder = lS;
  var uS = function uS2(t, e) {
    Gt("browserStreamBuilder");
    var r, n = sS(e).browserBufferSize || 1024 * 512, o = e.browserBufferTimeout || 1e3, s = !e.objectMode, a = aS(t, e), l = h(e, S, E);
    e.objectMode || (l._writev = al.writev.bind(l)), l.on("close", function() {
      a.close();
    });
    var c = _typeof(a.addEventListener) < "u";
    a.readyState === a.OPEN ? (r = l, r.socket = a) : (r = new al.BufferedDuplex(e, l, a), c ? a.addEventListener("open", d) : a.onopen = d), c ? (a.addEventListener("close", g), a.addEventListener("error", y), a.addEventListener("message", w)) : (a.onclose = g, a.onerror = y, a.onmessage = w);
    function h(I, C, R) {
      var U = new rS.Transform({ objectMode: I.objectMode });
      return U._write = C, U._flush = R, U;
    }
    function d() {
      Gt("WebSocket onOpen"), r instanceof al.BufferedDuplex && r.socketReady();
    }
    function g(I) {
      Gt("WebSocket onClose", I), r.end(), r.destroy();
    }
    function y(I) {
      Gt("WebSocket onError", I);
      var C = new Error("WebSocket error");
      C.event = I, r.destroy(C);
    }
    function w(_x34) {
      return _w8.apply(this, arguments);
    }
    function _w8() {
      _w8 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee38(I) {
        var C;
        return _regeneratorRuntime().wrap(function _callee38$(_context47) {
          while (1)
            switch (_context47.prev = _context47.next) {
              case 0:
                C = I.data;
                if (!(C instanceof ArrayBuffer)) {
                  _context47.next = 5;
                  break;
                }
                C = us.Buffer.from(C);
                _context47.next = 14;
                break;
              case 5:
                if (!(C instanceof Blob)) {
                  _context47.next = 13;
                  break;
                }
                _context47.t0 = us.Buffer;
                _context47.next = 9;
                return new Response(C).arrayBuffer();
              case 9:
                _context47.t1 = _context47.sent;
                C = _context47.t0.from.call(_context47.t0, _context47.t1);
                _context47.next = 14;
                break;
              case 13:
                C = us.Buffer.from(C, "utf8");
              case 14:
                l && !l.destroyed && l.push(C);
              case 15:
              case "end":
                return _context47.stop();
            }
        }, _callee38);
      }));
      return _w8.apply(this, arguments);
    }
    function S(I, C, R) {
      if (a.bufferedAmount > n) {
        setTimeout(S, o, I, C, R);
        return;
      }
      s && typeof I == "string" && (I = us.Buffer.from(I, "utf8"));
      try {
        a.send(I);
      } catch (U) {
        return R(U);
      }
      R();
    }
    function E(I) {
      a.close(), I();
    }
    return r;
  };
  Qt.browserStreamBuilder = uS;
});
var ul = {};
Jt(ul, { Server: function Server() {
  return Me;
}, Socket: function Socket() {
  return Me;
}, Stream: function Stream() {
  return Me;
}, _createServerHandle: function _createServerHandle() {
  return Me;
}, _normalizeArgs: function _normalizeArgs() {
  return Me;
}, _setSimultaneousAccepts: function _setSimultaneousAccepts() {
  return Me;
}, connect: function connect() {
  return Me;
}, createConnection: function createConnection() {
  return Me;
}, createServer: function createServer() {
  return Me;
}, default: function _default6() {
  return fS;
}, isIP: function isIP() {
  return Me;
}, isIPv4: function isIPv4() {
  return Me;
}, isIPv6: function isIPv6() {
  return Me;
} });
function Me() {
  throw new Error("Node.js net module is not supported by JSPM core outside of Node.js");
}
var fS, fl = _e(function() {
  _();
  v();
  m();
  fS = { _createServerHandle: Me, _normalizeArgs: Me, _setSimultaneousAccepts: Me, connect: Me, createConnection: Me, createServer: Me, isIP: Me, isIPv4: Me, isIPv6: Me, Server: Me, Socket: Me, Stream: Me };
});
var cl = M(function(Ni) {
  _();
  v();
  m();
  var Ag = Ni && Ni.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(Ni, "__esModule", { value: true });
  var cS = Ag((fl(), X(ul))), hS = Ag(ot()), dS = (0, hS.default)("mqttjs:tcp"), pS = function pS2(t, e) {
    e.port = e.port || 1883, e.hostname = e.hostname || e.host || "localhost";
    var r = e.port, i = e.path, n = e.hostname;
    return dS("port %d and host %s", r, n), cS.default.createConnection({ port: r, host: n, path: i });
  };
  Ni.default = pS;
});
var Ig = {};
Jt(Ig, { default: function _default7() {
  return gS;
} });
var gS, Tg = _e(function() {
  _();
  v();
  m();
  gS = {};
});
var dl = M(function(qi) {
  _();
  v();
  m();
  var hl = qi && qi.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(qi, "__esModule", { value: true });
  var yS = hl((Tg(), X(Ig))), bS = hl((fl(), X(ul))), wS = hl(ot()), _S = (0, wS.default)("mqttjs:tls"), mS = function mS2(t, e) {
    e.port = e.port || 8883, e.host = e.hostname || e.host || "localhost", bS.default.isIP(e.host) === 0 && (e.servername = e.host), e.rejectUnauthorized = e.rejectUnauthorized !== false, delete e.path, _S("port %d host %s rejectUnauthorized %b", e.port, e.host, e.rejectUnauthorized);
    var r = yS.default.connect(e);
    r.on("secureConnect", function() {
      e.rejectUnauthorized && !r.authorized ? r.emit("error", new Error("TLS not authorized")) : r.removeListener("error", i);
    });
    function i(n) {
      e.rejectUnauthorized && t.emit("error", n), r.end();
    }
    return r.on("error", i), r;
  };
  qi.default = mS;
});
var yl = M(function(gl) {
  _();
  v();
  m();
  Object.defineProperty(gl, "__esModule", { value: true });
  var Rg = (be(), X(me)), vS = jt(), ES = ls(), yt, pl, Le;
  function SS() {
    var t = new vS.Transform();
    return t._write = function(e, r, i) {
      yt.send({ data: e.buffer, success: function success() {
        i();
      }, fail: function fail(n) {
        i(new Error(n));
      } });
    }, t._flush = function(e) {
      yt.close({ success: function success() {
        e();
      } });
    }, t;
  }
  function AS(t) {
    t.hostname || (t.hostname = "localhost"), t.path || (t.path = "/"), t.wsOptions || (t.wsOptions = {});
  }
  function IS(t, e) {
    var r = t.protocol === "wxs" ? "wss" : "ws", i = "".concat(r, "://").concat(t.hostname).concat(t.path);
    return t.port && t.port !== 80 && t.port !== 443 && (i = "".concat(r, "://").concat(t.hostname, ":").concat(t.port).concat(t.path)), typeof t.transformWsUrl == "function" && (i = t.transformWsUrl(i, t, e)), i;
  }
  function TS() {
    yt.onOpen(function() {
      Le.socketReady();
    }), yt.onMessage(function(t) {
      var e = t.data;
      e instanceof ArrayBuffer ? e = Rg.Buffer.from(e) : e = Rg.Buffer.from(e, "utf8"), pl.push(e);
    }), yt.onClose(function() {
      Le.emit("close"), Le.end(), Le.destroy();
    }), yt.onError(function(t) {
      var e = new Error(t.errMsg);
      Le.destroy(e);
    });
  }
  var RS = function RS2(t, e) {
    if (e.hostname = e.hostname || e.host, !e.hostname)
      throw new Error("Could not determine host. Specify host manually.");
    var r = e.protocolId === "MQIsdp" && e.protocolVersion === 3 ? "mqttv3.1" : "mqtt";
    AS(e);
    var i = IS(e, t);
    yt = wx.connectSocket({ url: i, protocols: [r] }), pl = SS(), Le = new ES.BufferedDuplex(e, pl, yt), Le._destroy = function(o, s) {
      yt.close({ success: function success() {
        s && s(o);
      } });
    };
    var n = Le.destroy;
    return Le.destroy = function(o, s) {
      return Le.destroy = n, setTimeout(function() {
        yt.close({ fail: function fail() {
          Le._destroy(o, s);
        } });
      }, 0), Le;
    }, TS(), Le;
  };
  gl.default = RS;
});
var _l = M(function(wl) {
  _();
  v();
  m();
  Object.defineProperty(wl, "__esModule", { value: true });
  var bl = (be(), X(me)), CS = jt(), BS = ls(), xt, fs, ui, Cg = false;
  function PS() {
    var t = new CS.Transform();
    return t._write = function(e, r, i) {
      xt.sendSocketMessage({ data: e.buffer, success: function success() {
        i();
      }, fail: function fail() {
        i(new Error());
      } });
    }, t._flush = function(e) {
      xt.closeSocket({ success: function success() {
        e();
      } });
    }, t;
  }
  function kS(t) {
    t.hostname || (t.hostname = "localhost"), t.path || (t.path = "/"), t.wsOptions || (t.wsOptions = {});
  }
  function OS(t, e) {
    var r = t.protocol === "alis" ? "wss" : "ws", i = "".concat(r, "://").concat(t.hostname).concat(t.path);
    return t.port && t.port !== 80 && t.port !== 443 && (i = "".concat(r, "://").concat(t.hostname, ":").concat(t.port).concat(t.path)), typeof t.transformWsUrl == "function" && (i = t.transformWsUrl(i, t, e)), i;
  }
  function xS() {
    Cg || (Cg = true, xt.onSocketOpen(function() {
      ui.socketReady();
    }), xt.onSocketMessage(function(t) {
      if (typeof t.data == "string") {
        var e = bl.Buffer.from(t.data, "base64");
        fs.push(e);
      } else {
        var _e10 = new FileReader();
        _e10.addEventListener("load", function() {
          var r = _e10.result;
          r instanceof ArrayBuffer ? r = bl.Buffer.from(r) : r = bl.Buffer.from(r, "utf8"), fs.push(r);
        }), _e10.readAsArrayBuffer(t.data);
      }
    }), xt.onSocketClose(function() {
      ui.end(), ui.destroy();
    }), xt.onSocketError(function(t) {
      ui.destroy(t);
    }));
  }
  var MS = function MS2(t, e) {
    if (e.hostname = e.hostname || e.host, !e.hostname)
      throw new Error("Could not determine host. Specify host manually.");
    var r = e.protocolId === "MQIsdp" && e.protocolVersion === 3 ? "mqttv3.1" : "mqtt";
    kS(e);
    var i = OS(e, t);
    return xt = e.my, xt.connectSocket({ url: i, protocols: r }), fs = PS(), ui = new BS.BufferedDuplex(e, fs, xt), xS(), ui;
  };
  wl.default = MS;
});
var kg = M(function(Br) {
  _();
  v();
  m();
  var cs = Br && Br.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(Br, "__esModule", { value: true });
  Br.connectAsync = void 0;
  var LS = cs(ot()), US = cs((yg(), X(gg))), NS = cs(os()), qS = cs(Oi());
  typeof (B === null || B === void 0 ? void 0 : B.nextTick) != "function" && (B.nextTick = setImmediate);
  var Bg = (0, LS.default)("mqttjs"), de = null;
  function DS(t) {
    var e;
    t.auth && (e = t.auth.match(/^(.+):(.+)$/), e ? (t.username = e[1], t.password = e[2]) : t.username = t.auth);
  }
  function Pg(t, e) {
    var r, i, n, o;
    if (Bg("connecting to an MQTT broker..."), _typeof(t) == "object" && !e && (e = t, t = ""), e = e || {}, t && typeof t == "string") {
      var _l31 = US.default.parse(t, true), _c19 = {};
      if (_l31.port != null && (_c19.port = Number(_l31.port)), _c19.host = _l31.hostname, _c19.query = _l31.query, _c19.auth = _l31.auth, _c19.protocol = _l31.protocol, _c19.path = _l31.path, _c19.protocol = (r = _c19.protocol) === null || r === void 0 ? void 0 : r.replace(/:$/, ""), e = Object.assign(Object.assign({}, _c19), e), !e.protocol)
        throw new Error("Missing protocol");
    }
    if (e.unixSocket = e.unixSocket || ((i = e.protocol) === null || i === void 0 ? void 0 : i.includes("+unix")), e.unixSocket ? e.protocol = e.protocol.replace("+unix", "") : !(!((n = e.protocol) === null || n === void 0) && n.startsWith("ws")) && !(!((o = e.protocol) === null || o === void 0) && o.startsWith("wx")) && delete e.path, DS(e), e.query && typeof e.query.clientId == "string" && (e.clientId = e.query.clientId), e.cert && e.key)
      if (e.protocol) {
        if (["mqtts", "wss", "wxs", "alis"].indexOf(e.protocol) === -1)
          switch (e.protocol) {
            case "mqtt":
              e.protocol = "mqtts";
              break;
            case "ws":
              e.protocol = "wss";
              break;
            case "wx":
              e.protocol = "wxs";
              break;
            case "ali":
              e.protocol = "alis";
              break;
            default:
              throw new Error('Unknown protocol for secure connection: "'.concat(e.protocol, '"!'));
          }
      } else
        throw new Error("Missing secure protocol key");
    if (de || (de = {}, !qS.default && !e.forceNativeWebSocket ? (de.ws = Ui().streamBuilder, de.wss = Ui().streamBuilder, de.mqtt = cl().default, de.tcp = cl().default, de.ssl = dl().default, de.tls = de.ssl, de.mqtts = dl().default) : (de.ws = Ui().browserStreamBuilder, de.wss = Ui().browserStreamBuilder, de.wx = yl().default, de.wxs = yl().default, de.ali = _l().default, de.alis = _l().default)), !de[e.protocol]) {
      var _l32 = ["mqtts", "wss"].indexOf(e.protocol) !== -1;
      e.protocol = ["mqtt", "mqtts", "ws", "wss", "wx", "wxs", "ali", "alis"].filter(function(c, h) {
        return _l32 && h % 2 === 0 ? false : typeof de[c] == "function";
      })[0];
    }
    if (e.clean === false && !e.clientId)
      throw new Error("Missing clientId for unclean clients");
    e.protocol && (e.defaultProtocol = e.protocol);
    function s(l) {
      return e.servers && ((!l._reconnectCount || l._reconnectCount === e.servers.length) && (l._reconnectCount = 0), e.host = e.servers[l._reconnectCount].host, e.port = e.servers[l._reconnectCount].port, e.protocol = e.servers[l._reconnectCount].protocol ? e.servers[l._reconnectCount].protocol : e.defaultProtocol, e.hostname = e.host, l._reconnectCount++), Bg("calling streambuilder for", e.protocol), de[e.protocol](l, e);
    }
    var a = new NS.default(s, e);
    return a.on("error", function() {
    }), a;
  }
  function jS(t, e) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return new Promise(function(i, n) {
      var o = Pg(t, e), s = { connect: function connect2(l) {
        a(), i(o);
      }, end: function end() {
        a(), i(o);
      }, error: function error(l) {
        a(), o.end(), n(l);
      } };
      r === false && (s.close = function() {
        s.error(new Error("Couldn't connect to server"));
      });
      function a() {
        Object.keys(s).forEach(function(l) {
          o.off(l, s[l]);
        });
      }
      Object.keys(s).forEach(function(l) {
        o.on(l, s[l]);
      });
    });
  }
  Br.connectAsync = jS;
  Br.default = Pg;
});
var ml = M(function(G) {
  _();
  v();
  m();
  var Og = G && G.__createBinding || (Object.create ? function(t, e, r, i) {
    i === void 0 && (i = r);
    var n = Object.getOwnPropertyDescriptor(e, r);
    (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = { enumerable: true, get: function get2() {
      return e[r];
    } }), Object.defineProperty(t, i, n);
  } : function(t, e, r, i) {
    i === void 0 && (i = r), t[i] = e[r];
  }), FS = G && G.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", { enumerable: true, value: e });
  } : function(t, e) {
    t.default = e;
  }), WS = G && G.__importStar || function(t) {
    if (t && t.__esModule)
      return t;
    var e = {};
    if (t != null)
      for (var r in t)
        r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && Og(e, t, r);
    return FS(e, t), e;
  }, xg = G && G.__exportStar || function(t, e) {
    for (var r in t)
      r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && Og(e, t, r);
  }, Di = G && G.__importDefault || function(t) {
    return t && t.__esModule ? t : { default: t };
  };
  Object.defineProperty(G, "__esModule", { value: true });
  G.ReasonCodes = G.KeepaliveManager = G.UniqueMessageIdProvider = G.DefaultMessageIdProvider = G.Store = G.MqttClient = G.connectAsync = G.connect = G.Client = void 0;
  var Mg = Di(os());
  G.MqttClient = Mg.default;
  var $S = Di(Zo());
  G.DefaultMessageIdProvider = $S.default;
  var HS = Di(Vp());
  G.UniqueMessageIdProvider = HS.default;
  var VS = Di(ra());
  G.Store = VS.default;
  var Lg = WS(kg());
  G.connect = Lg.default;
  Object.defineProperty(G, "connectAsync", { enumerable: true, get: function get2() {
    return Lg.connectAsync;
  } });
  var zS = Di(Wa());
  G.KeepaliveManager = zS.default;
  G.Client = Mg.default;
  xg(os(), G);
  xg(_r(), G);
  var KS = Ti();
  Object.defineProperty(G, "ReasonCodes", { enumerable: true, get: function get2() {
    return KS.ReasonCodes;
  } });
});
var XS = M(function(We) {
  _();
  v();
  m();
  var Ug = We && We.__createBinding || (Object.create ? function(t, e, r, i) {
    i === void 0 && (i = r);
    var n = Object.getOwnPropertyDescriptor(e, r);
    (!n || ("get" in n ? !e.__esModule : n.writable || n.configurable)) && (n = { enumerable: true, get: function get2() {
      return e[r];
    } }), Object.defineProperty(t, i, n);
  } : function(t, e, r, i) {
    i === void 0 && (i = r), t[i] = e[r];
  }), GS = We && We.__setModuleDefault || (Object.create ? function(t, e) {
    Object.defineProperty(t, "default", { enumerable: true, value: e });
  } : function(t, e) {
    t.default = e;
  }), QS = We && We.__importStar || function(t) {
    if (t && t.__esModule)
      return t;
    var e = {};
    if (t != null)
      for (var r in t)
        r !== "default" && Object.prototype.hasOwnProperty.call(t, r) && Ug(e, t, r);
    return GS(e, t), e;
  }, YS = We && We.__exportStar || function(t, e) {
    for (var r in t)
      r !== "default" && !Object.prototype.hasOwnProperty.call(e, r) && Ug(e, t, r);
  };
  Object.defineProperty(We, "__esModule", { value: true });
  var JS = QS(ml());
  We.default = JS;
  YS(ml(), We);
});
var mqtt = XS();
/*! Bundled license information:

@jspm/core/nodelibs/browser/buffer.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)
*/
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 256).toString(16).slice(1));
}
function unsafeStringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + "-" + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + "-" + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + "-" + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + "-" + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues) {
    if (typeof crypto === "undefined" || !crypto.getRandomValues) {
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    getRandomValues = crypto.getRandomValues.bind(crypto);
  }
  return getRandomValues(rnds8);
}
var randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var native = { randomUUID };
function v4(options, buf, offset) {
  var _ref40, _options$random, _options$rng, _options;
  if (native.randomUUID && !buf && !options) {
    return native.randomUUID();
  }
  options = options || {};
  var rnds = (_ref40 = (_options$random = options.random) !== null && _options$random !== void 0 ? _options$random : (_options$rng = (_options = options).rng) === null || _options$rng === void 0 ? void 0 : _options$rng.call(_options)) !== null && _ref40 !== void 0 ? _ref40 : rng();
  if (rnds.length < 16) {
    throw new Error("Random bytes length must be >= 16");
  }
  rnds[6] = rnds[6] & 15 | 64;
  rnds[8] = rnds[8] & 63 | 128;
  if (buf) {
    offset = offset || 0;
    if (offset < 0 || offset + 16 > buf.length) {
      throw new RangeError("UUID byte range ".concat(offset, ":").concat(offset + 15, " is out of buffer bounds"));
    }
    for (var _i25 = 0; _i25 < 16; ++_i25) {
      buf[offset + _i25] = rnds[_i25];
    }
    return buf;
  }
  return unsafeStringify(rnds);
}
var browser = {};
var canPromise$1 = function canPromise$12() {
  return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};
var qrcode = {};
var utils$1 = {};
var toSJISFunction;
var CODEWORDS_COUNT = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
utils$1.getSymbolSize = function getSymbolSize(version3) {
  if (!version3)
    throw new Error('"version" cannot be null or undefined');
  if (version3 < 1 || version3 > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return version3 * 4 + 17;
};
utils$1.getSymbolTotalCodewords = function getSymbolTotalCodewords(version3) {
  return CODEWORDS_COUNT[version3];
};
utils$1.getBCHDigit = function(data) {
  var digit = 0;
  while (data !== 0) {
    digit++;
    data >>>= 1;
  }
  return digit;
};
utils$1.setToSJISFunction = function setToSJISFunction(f) {
  if (typeof f !== "function") {
    throw new Error('"toSJISFunc" is not a valid function.');
  }
  toSJISFunction = f;
};
utils$1.isKanjiModeEnabled = function() {
  return typeof toSJISFunction !== "undefined";
};
utils$1.toSJIS = function toSJIS(kanji2) {
  return toSJISFunction(kanji2);
};
var errorCorrectionLevel = {};
(function(exports) {
  exports.L = { bit: 1 };
  exports.M = { bit: 0 };
  exports.Q = { bit: 3 };
  exports.H = { bit: 2 };
  function fromString(string) {
    if (typeof string !== "string") {
      throw new Error("Param is not a string");
    }
    var lcStr = string.toLowerCase();
    switch (lcStr) {
      case "l":
      case "low":
        return exports.L;
      case "m":
      case "medium":
        return exports.M;
      case "q":
      case "quartile":
        return exports.Q;
      case "h":
      case "high":
        return exports.H;
      default:
        throw new Error("Unknown EC Level: " + string);
    }
  }
  exports.isValid = function isValid2(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
  };
  exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) {
      return value;
    }
    try {
      return fromString(value);
    } catch (e) {
      return defaultValue;
    }
  };
})(errorCorrectionLevel);
function BitBuffer$1() {
  this.buffer = [];
  this.length = 0;
}
BitBuffer$1.prototype = { get: function get(index2) {
  var bufIndex = Math.floor(index2 / 8);
  return (this.buffer[bufIndex] >>> 7 - index2 % 8 & 1) === 1;
}, put: function put(num, length) {
  for (var _i26 = 0; _i26 < length; _i26++) {
    this.putBit((num >>> length - _i26 - 1 & 1) === 1);
  }
}, getLengthInBits: function getLengthInBits() {
  return this.length;
}, putBit: function putBit(bit) {
  var bufIndex = Math.floor(this.length / 8);
  if (this.buffer.length <= bufIndex) {
    this.buffer.push(0);
  }
  if (bit) {
    this.buffer[bufIndex] |= 128 >>> this.length % 8;
  }
  this.length++;
} };
var bitBuffer = BitBuffer$1;
function BitMatrix$1(size) {
  if (!size || size < 1) {
    throw new Error("BitMatrix size must be defined and greater than 0");
  }
  this.size = size;
  this.data = new Uint8Array(size * size);
  this.reservedBit = new Uint8Array(size * size);
}
BitMatrix$1.prototype.set = function(row, col, value, reserved) {
  var index2 = row * this.size + col;
  this.data[index2] = value;
  if (reserved)
    this.reservedBit[index2] = true;
};
BitMatrix$1.prototype.get = function(row, col) {
  return this.data[row * this.size + col];
};
BitMatrix$1.prototype.xor = function(row, col, value) {
  this.data[row * this.size + col] ^= value;
};
BitMatrix$1.prototype.isReserved = function(row, col) {
  return this.reservedBit[row * this.size + col];
};
var bitMatrix = BitMatrix$1;
var alignmentPattern = {};
(function(exports) {
  var getSymbolSize3 = utils$1.getSymbolSize;
  exports.getRowColCoords = function getRowColCoords(version3) {
    if (version3 === 1)
      return [];
    var posCount = Math.floor(version3 / 7) + 2;
    var size = getSymbolSize3(version3);
    var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    var positions = [size - 7];
    for (var _i27 = 1; _i27 < posCount - 1; _i27++) {
      positions[_i27] = positions[_i27 - 1] - intervals;
    }
    positions.push(6);
    return positions.reverse();
  };
  exports.getPositions = function getPositions2(version3) {
    var coords = [];
    var pos = exports.getRowColCoords(version3);
    var posLength = pos.length;
    for (var _i28 = 0; _i28 < posLength; _i28++) {
      for (var j = 0; j < posLength; j++) {
        if (_i28 === 0 && j === 0 || // top-left
        _i28 === 0 && j === posLength - 1 || // bottom-left
        _i28 === posLength - 1 && j === 0) {
          continue;
        }
        coords.push([pos[_i28], pos[j]]);
      }
    }
    return coords;
  };
})(alignmentPattern);
var finderPattern = {};
var getSymbolSize2 = utils$1.getSymbolSize;
var FINDER_PATTERN_SIZE = 7;
finderPattern.getPositions = function getPositions(version3) {
  var size = getSymbolSize2(version3);
  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ];
};
var maskPattern = {};
(function(exports) {
  exports.Patterns = { PATTERN000: 0, PATTERN001: 1, PATTERN010: 2, PATTERN011: 3, PATTERN100: 4, PATTERN101: 5, PATTERN110: 6, PATTERN111: 7 };
  var PenaltyScores = { N1: 3, N2: 3, N3: 40, N4: 10 };
  exports.isValid = function isValid2(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
  };
  exports.from = function from(value) {
    return exports.isValid(value) ? parseInt(value, 10) : void 0;
  };
  exports.getPenaltyN1 = function getPenaltyN1(data) {
    var size = data.size;
    var points = 0;
    var sameCountCol = 0;
    var sameCountRow = 0;
    var lastCol = null;
    var lastRow = null;
    for (var row = 0; row < size; row++) {
      sameCountCol = sameCountRow = 0;
      lastCol = lastRow = null;
      for (var col = 0; col < size; col++) {
        var module = data.get(row, col);
        if (module === lastCol) {
          sameCountCol++;
        } else {
          if (sameCountCol >= 5)
            points += PenaltyScores.N1 + (sameCountCol - 5);
          lastCol = module;
          sameCountCol = 1;
        }
        module = data.get(col, row);
        if (module === lastRow) {
          sameCountRow++;
        } else {
          if (sameCountRow >= 5)
            points += PenaltyScores.N1 + (sameCountRow - 5);
          lastRow = module;
          sameCountRow = 1;
        }
      }
      if (sameCountCol >= 5)
        points += PenaltyScores.N1 + (sameCountCol - 5);
      if (sameCountRow >= 5)
        points += PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
  };
  exports.getPenaltyN2 = function getPenaltyN2(data) {
    var size = data.size;
    var points = 0;
    for (var row = 0; row < size - 1; row++) {
      for (var col = 0; col < size - 1; col++) {
        var last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0)
          points++;
      }
    }
    return points * PenaltyScores.N2;
  };
  exports.getPenaltyN3 = function getPenaltyN3(data) {
    var size = data.size;
    var points = 0;
    var bitsCol = 0;
    var bitsRow = 0;
    for (var row = 0; row < size; row++) {
      bitsCol = bitsRow = 0;
      for (var col = 0; col < size; col++) {
        bitsCol = bitsCol << 1 & 2047 | data.get(row, col);
        if (col >= 10 && (bitsCol === 1488 || bitsCol === 93))
          points++;
        bitsRow = bitsRow << 1 & 2047 | data.get(col, row);
        if (col >= 10 && (bitsRow === 1488 || bitsRow === 93))
          points++;
      }
    }
    return points * PenaltyScores.N3;
  };
  exports.getPenaltyN4 = function getPenaltyN4(data) {
    var darkCount = 0;
    var modulesCount = data.data.length;
    for (var _i29 = 0; _i29 < modulesCount; _i29++)
      darkCount += data.data[_i29];
    var k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * PenaltyScores.N4;
  };
  function getMaskAt(maskPattern2, i, j) {
    switch (maskPattern2) {
      case exports.Patterns.PATTERN000:
        return (i + j) % 2 === 0;
      case exports.Patterns.PATTERN001:
        return i % 2 === 0;
      case exports.Patterns.PATTERN010:
        return j % 3 === 0;
      case exports.Patterns.PATTERN011:
        return (i + j) % 3 === 0;
      case exports.Patterns.PATTERN100:
        return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
      case exports.Patterns.PATTERN101:
        return i * j % 2 + i * j % 3 === 0;
      case exports.Patterns.PATTERN110:
        return (i * j % 2 + i * j % 3) % 2 === 0;
      case exports.Patterns.PATTERN111:
        return (i * j % 3 + (i + j) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + maskPattern2);
    }
  }
  exports.applyMask = function applyMask(pattern, data) {
    var size = data.size;
    for (var col = 0; col < size; col++) {
      for (var row = 0; row < size; row++) {
        if (data.isReserved(row, col))
          continue;
        data.xor(row, col, getMaskAt(pattern, row, col));
      }
    }
  };
  exports.getBestMask = function getBestMask(data, setupFormatFunc) {
    var numPatterns = Object.keys(exports.Patterns).length;
    var bestPattern = 0;
    var lowerPenalty = Infinity;
    for (var p = 0; p < numPatterns; p++) {
      setupFormatFunc(p);
      exports.applyMask(p, data);
      var penalty = exports.getPenaltyN1(data) + exports.getPenaltyN2(data) + exports.getPenaltyN3(data) + exports.getPenaltyN4(data);
      exports.applyMask(p, data);
      if (penalty < lowerPenalty) {
        lowerPenalty = penalty;
        bestPattern = p;
      }
    }
    return bestPattern;
  };
})(maskPattern);
var errorCorrectionCode = {};
var ECLevel$1 = errorCorrectionLevel;
var EC_BLOCKS_TABLE = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
];
var EC_CODEWORDS_TABLE = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
errorCorrectionCode.getBlocksCount = function getBlocksCount(version3, errorCorrectionLevel2) {
  switch (errorCorrectionLevel2) {
    case ECLevel$1.L:
      return EC_BLOCKS_TABLE[(version3 - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_BLOCKS_TABLE[(version3 - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_BLOCKS_TABLE[(version3 - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_BLOCKS_TABLE[(version3 - 1) * 4 + 3];
    default:
      return void 0;
  }
};
errorCorrectionCode.getTotalCodewordsCount = function getTotalCodewordsCount(version3, errorCorrectionLevel2) {
  switch (errorCorrectionLevel2) {
    case ECLevel$1.L:
      return EC_CODEWORDS_TABLE[(version3 - 1) * 4 + 0];
    case ECLevel$1.M:
      return EC_CODEWORDS_TABLE[(version3 - 1) * 4 + 1];
    case ECLevel$1.Q:
      return EC_CODEWORDS_TABLE[(version3 - 1) * 4 + 2];
    case ECLevel$1.H:
      return EC_CODEWORDS_TABLE[(version3 - 1) * 4 + 3];
    default:
      return void 0;
  }
};
var polynomial = {};
var galoisField = {};
var EXP_TABLE = new Uint8Array(512);
var LOG_TABLE = new Uint8Array(256);
(function initTables() {
  var x2 = 1;
  for (var _i30 = 0; _i30 < 255; _i30++) {
    EXP_TABLE[_i30] = x2;
    LOG_TABLE[x2] = _i30;
    x2 <<= 1;
    if (x2 & 256) {
      x2 ^= 285;
    }
  }
  for (var _i31 = 255; _i31 < 512; _i31++) {
    EXP_TABLE[_i31] = EXP_TABLE[_i31 - 255];
  }
})();
galoisField.log = function log(n) {
  if (n < 1)
    throw new Error("log(" + n + ")");
  return LOG_TABLE[n];
};
galoisField.exp = function exp(n) {
  return EXP_TABLE[n];
};
galoisField.mul = function mul(x2, y) {
  if (x2 === 0 || y === 0)
    return 0;
  return EXP_TABLE[LOG_TABLE[x2] + LOG_TABLE[y]];
};
(function(exports) {
  var GF = galoisField;
  exports.mul = function mul2(p1, p2) {
    var coeff = new Uint8Array(p1.length + p2.length - 1);
    for (var _i32 = 0; _i32 < p1.length; _i32++) {
      for (var j = 0; j < p2.length; j++) {
        coeff[_i32 + j] ^= GF.mul(p1[_i32], p2[j]);
      }
    }
    return coeff;
  };
  exports.mod = function mod(divident, divisor) {
    var result = new Uint8Array(divident);
    while (result.length - divisor.length >= 0) {
      var coeff = result[0];
      for (var _i33 = 0; _i33 < divisor.length; _i33++) {
        result[_i33] ^= GF.mul(divisor[_i33], coeff);
      }
      var offset = 0;
      while (offset < result.length && result[offset] === 0)
        offset++;
      result = result.slice(offset);
    }
    return result;
  };
  exports.generateECPolynomial = function generateECPolynomial(degree) {
    var poly = new Uint8Array([1]);
    for (var _i34 = 0; _i34 < degree; _i34++) {
      poly = exports.mul(poly, new Uint8Array([1, GF.exp(_i34)]));
    }
    return poly;
  };
})(polynomial);
var Polynomial = polynomial;
function ReedSolomonEncoder$1(degree) {
  this.genPoly = void 0;
  this.degree = degree;
  if (this.degree)
    this.initialize(this.degree);
}
ReedSolomonEncoder$1.prototype.initialize = function initialize(degree) {
  this.degree = degree;
  this.genPoly = Polynomial.generateECPolynomial(this.degree);
};
ReedSolomonEncoder$1.prototype.encode = function encode(data) {
  if (!this.genPoly) {
    throw new Error("Encoder not initialized");
  }
  var paddedData = new Uint8Array(data.length + this.degree);
  paddedData.set(data);
  var remainder = Polynomial.mod(paddedData, this.genPoly);
  var start = this.degree - remainder.length;
  if (start > 0) {
    var buff = new Uint8Array(this.degree);
    buff.set(remainder, start);
    return buff;
  }
  return remainder;
};
var reedSolomonEncoder = ReedSolomonEncoder$1;
var version2 = {};
var mode = {};
var versionCheck = {};
versionCheck.isValid = function isValid(version3) {
  return !isNaN(version3) && version3 >= 1 && version3 <= 40;
};
var regex = {};
var numeric = "[0-9]+";
var alphanumeric = "[A-Z $%*+\\-./:]+";
var kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
kanji = kanji.replace(/u/g, "\\u");
var byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + kanji + ")(?:.|[\r\n]))+";
regex.KANJI = new RegExp(kanji, "g");
regex.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
regex.BYTE = new RegExp(byte, "g");
regex.NUMERIC = new RegExp(numeric, "g");
regex.ALPHANUMERIC = new RegExp(alphanumeric, "g");
var TEST_KANJI = new RegExp("^" + kanji + "$");
var TEST_NUMERIC = new RegExp("^" + numeric + "$");
var TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
regex.testKanji = function testKanji(str) {
  return TEST_KANJI.test(str);
};
regex.testNumeric = function testNumeric(str) {
  return TEST_NUMERIC.test(str);
};
regex.testAlphanumeric = function testAlphanumeric(str) {
  return TEST_ALPHANUMERIC.test(str);
};
(function(exports) {
  var VersionCheck = versionCheck;
  var Regex = regex;
  exports.NUMERIC = { id: "Numeric", bit: 1 << 0, ccBits: [10, 12, 14] };
  exports.ALPHANUMERIC = { id: "Alphanumeric", bit: 1 << 1, ccBits: [9, 11, 13] };
  exports.BYTE = { id: "Byte", bit: 1 << 2, ccBits: [8, 16, 16] };
  exports.KANJI = { id: "Kanji", bit: 1 << 3, ccBits: [8, 10, 12] };
  exports.MIXED = { bit: -1 };
  exports.getCharCountIndicator = function getCharCountIndicator(mode2, version3) {
    if (!mode2.ccBits)
      throw new Error("Invalid mode: " + mode2);
    if (!VersionCheck.isValid(version3)) {
      throw new Error("Invalid version: " + version3);
    }
    if (version3 >= 1 && version3 < 10)
      return mode2.ccBits[0];
    else if (version3 < 27)
      return mode2.ccBits[1];
    return mode2.ccBits[2];
  };
  exports.getBestModeForData = function getBestModeForData(dataStr) {
    if (Regex.testNumeric(dataStr))
      return exports.NUMERIC;
    else if (Regex.testAlphanumeric(dataStr))
      return exports.ALPHANUMERIC;
    else if (Regex.testKanji(dataStr))
      return exports.KANJI;
    else
      return exports.BYTE;
  };
  exports.toString = function toString(mode2) {
    if (mode2 && mode2.id)
      return mode2.id;
    throw new Error("Invalid mode");
  };
  exports.isValid = function isValid2(mode2) {
    return mode2 && mode2.bit && mode2.ccBits;
  };
  function fromString(string) {
    if (typeof string !== "string") {
      throw new Error("Param is not a string");
    }
    var lcStr = string.toLowerCase();
    switch (lcStr) {
      case "numeric":
        return exports.NUMERIC;
      case "alphanumeric":
        return exports.ALPHANUMERIC;
      case "kanji":
        return exports.KANJI;
      case "byte":
        return exports.BYTE;
      default:
        throw new Error("Unknown mode: " + string);
    }
  }
  exports.from = function from(value, defaultValue) {
    if (exports.isValid(value)) {
      return value;
    }
    try {
      return fromString(value);
    } catch (e) {
      return defaultValue;
    }
  };
})(mode);
(function(exports) {
  var Utils2 = utils$1;
  var ECCode2 = errorCorrectionCode;
  var ECLevel2 = errorCorrectionLevel;
  var Mode2 = mode;
  var VersionCheck = versionCheck;
  var G18 = 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0;
  var G18_BCH = Utils2.getBCHDigit(G18);
  function getBestVersionForDataLength(mode2, length, errorCorrectionLevel2) {
    for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
      if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel2, mode2)) {
        return currentVersion;
      }
    }
    return void 0;
  }
  function getReservedBitsCount(mode2, version3) {
    return Mode2.getCharCountIndicator(mode2, version3) + 4;
  }
  function getTotalBitsFromDataArray(segments2, version3) {
    var totalBits = 0;
    segments2.forEach(function(data) {
      var reservedBits = getReservedBitsCount(data.mode, version3);
      totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
  }
  function getBestVersionForMixedData(segments2, errorCorrectionLevel2) {
    for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
      var length = getTotalBitsFromDataArray(segments2, currentVersion);
      if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel2, Mode2.MIXED)) {
        return currentVersion;
      }
    }
    return void 0;
  }
  exports.from = function from(value, defaultValue) {
    if (VersionCheck.isValid(value)) {
      return parseInt(value, 10);
    }
    return defaultValue;
  };
  exports.getCapacity = function getCapacity(version3, errorCorrectionLevel2, mode2) {
    if (!VersionCheck.isValid(version3)) {
      throw new Error("Invalid QR Code version");
    }
    if (typeof mode2 === "undefined")
      mode2 = Mode2.BYTE;
    var totalCodewords = Utils2.getSymbolTotalCodewords(version3);
    var ecTotalCodewords = ECCode2.getTotalCodewordsCount(version3, errorCorrectionLevel2);
    var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode2 === Mode2.MIXED)
      return dataTotalCodewordsBits;
    var usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode2, version3);
    switch (mode2) {
      case Mode2.NUMERIC:
        return Math.floor(usableBits / 10 * 3);
      case Mode2.ALPHANUMERIC:
        return Math.floor(usableBits / 11 * 2);
      case Mode2.KANJI:
        return Math.floor(usableBits / 13);
      case Mode2.BYTE:
      default:
        return Math.floor(usableBits / 8);
    }
  };
  exports.getBestVersionForData = function getBestVersionForData(data, errorCorrectionLevel2) {
    var seg;
    var ecl = ECLevel2.from(errorCorrectionLevel2, ECLevel2.M);
    if (Array.isArray(data)) {
      if (data.length > 1) {
        return getBestVersionForMixedData(data, ecl);
      }
      if (data.length === 0) {
        return 1;
      }
      seg = data[0];
    } else {
      seg = data;
    }
    return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
  };
  exports.getEncodedBits = function getEncodedBits2(version3) {
    if (!VersionCheck.isValid(version3) || version3 < 7) {
      throw new Error("Invalid QR Code version");
    }
    var d = version3 << 12;
    while (Utils2.getBCHDigit(d) - G18_BCH >= 0) {
      d ^= G18 << Utils2.getBCHDigit(d) - G18_BCH;
    }
    return version3 << 12 | d;
  };
})(version2);
var formatInfo = {};
var Utils$3 = utils$1;
var G15 = 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0;
var G15_MASK = 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1;
var G15_BCH = Utils$3.getBCHDigit(G15);
formatInfo.getEncodedBits = function getEncodedBits(errorCorrectionLevel2, mask) {
  var data = errorCorrectionLevel2.bit << 3 | mask;
  var d = data << 10;
  while (Utils$3.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= G15 << Utils$3.getBCHDigit(d) - G15_BCH;
  }
  return (data << 10 | d) ^ G15_MASK;
};
var segments = {};
var Mode$4 = mode;
function NumericData(data) {
  this.mode = Mode$4.NUMERIC;
  this.data = data.toString();
}
NumericData.getBitsLength = function getBitsLength(length) {
  return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
NumericData.prototype.getLength = function getLength() {
  return this.data.length;
};
NumericData.prototype.getBitsLength = function getBitsLength2() {
  return NumericData.getBitsLength(this.data.length);
};
NumericData.prototype.write = function write(bitBuffer2) {
  var i, group, value;
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3);
    value = parseInt(group, 10);
    bitBuffer2.put(value, 10);
  }
  var remainingNum = this.data.length - i;
  if (remainingNum > 0) {
    group = this.data.substr(i);
    value = parseInt(group, 10);
    bitBuffer2.put(value, remainingNum * 3 + 1);
  }
};
var numericData = NumericData;
var Mode$3 = mode;
var ALPHA_NUM_CHARS = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", " ", "$", "%", "*", "+", "-", ".", "/", ":"];
function AlphanumericData(data) {
  this.mode = Mode$3.ALPHANUMERIC;
  this.data = data;
}
AlphanumericData.getBitsLength = function getBitsLength3(length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
AlphanumericData.prototype.getLength = function getLength2() {
  return this.data.length;
};
AlphanumericData.prototype.getBitsLength = function getBitsLength4() {
  return AlphanumericData.getBitsLength(this.data.length);
};
AlphanumericData.prototype.write = function write2(bitBuffer2) {
  var i;
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    var value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
    bitBuffer2.put(value, 11);
  }
  if (this.data.length % 2) {
    bitBuffer2.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
  }
};
var alphanumericData = AlphanumericData;
var Mode$2 = mode;
function ByteData(data) {
  this.mode = Mode$2.BYTE;
  if (typeof data === "string") {
    this.data = new TextEncoder().encode(data);
  } else {
    this.data = new Uint8Array(data);
  }
}
ByteData.getBitsLength = function getBitsLength5(length) {
  return length * 8;
};
ByteData.prototype.getLength = function getLength3() {
  return this.data.length;
};
ByteData.prototype.getBitsLength = function getBitsLength6() {
  return ByteData.getBitsLength(this.data.length);
};
ByteData.prototype.write = function(bitBuffer2) {
  for (var _i35 = 0, _l33 = this.data.length; _i35 < _l33; _i35++) {
    bitBuffer2.put(this.data[_i35], 8);
  }
};
var byteData = ByteData;
var Mode$1 = mode;
var Utils$2 = utils$1;
function KanjiData(data) {
  this.mode = Mode$1.KANJI;
  this.data = data;
}
KanjiData.getBitsLength = function getBitsLength7(length) {
  return length * 13;
};
KanjiData.prototype.getLength = function getLength4() {
  return this.data.length;
};
KanjiData.prototype.getBitsLength = function getBitsLength8() {
  return KanjiData.getBitsLength(this.data.length);
};
KanjiData.prototype.write = function(bitBuffer2) {
  var i;
  for (i = 0; i < this.data.length; i++) {
    var value = Utils$2.toSJIS(this.data[i]);
    if (value >= 33088 && value <= 40956) {
      value -= 33088;
    } else if (value >= 57408 && value <= 60351) {
      value -= 49472;
    } else {
      throw new Error("Invalid SJIS character: " + this.data[i] + "\nMake sure your charset is UTF-8");
    }
    value = (value >>> 8 & 255) * 192 + (value & 255);
    bitBuffer2.put(value, 13);
  }
};
var kanjiData = KanjiData;
var dijkstra = { exports: {} };
(function(module) {
  var dijkstra2 = {
    single_source_shortest_paths: function single_source_shortest_paths(graph, s, d) {
      var predecessors = {};
      var costs = {};
      costs[s] = 0;
      var open = dijkstra2.PriorityQueue.make();
      open.push(s, 0);
      var closest, u, v2, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
      while (!open.empty()) {
        closest = open.pop();
        u = closest.value;
        cost_of_s_to_u = closest.cost;
        adjacent_nodes = graph[u] || {};
        for (v2 in adjacent_nodes) {
          if (adjacent_nodes.hasOwnProperty(v2)) {
            cost_of_e = adjacent_nodes[v2];
            cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
            cost_of_s_to_v = costs[v2];
            first_visit = typeof costs[v2] === "undefined";
            if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
              costs[v2] = cost_of_s_to_u_plus_cost_of_e;
              open.push(v2, cost_of_s_to_u_plus_cost_of_e);
              predecessors[v2] = u;
            }
          }
        }
      }
      if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
        var msg = ["Could not find a path from ", s, " to ", d, "."].join("");
        throw new Error(msg);
      }
      return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function extract_shortest_path_from_predecessor_list(predecessors, d) {
      var nodes = [];
      var u = d;
      while (u) {
        nodes.push(u);
        predecessors[u];
        u = predecessors[u];
      }
      nodes.reverse();
      return nodes;
    },
    find_path: function find_path(graph, s, d) {
      var predecessors = dijkstra2.single_source_shortest_paths(graph, s, d);
      return dijkstra2.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
    * A very naive priority queue implementation.
    */
    PriorityQueue: {
      make: function make(opts) {
        var T = dijkstra2.PriorityQueue, t = {}, key;
        opts = opts || {};
        for (key in T) {
          if (T.hasOwnProperty(key)) {
            t[key] = T[key];
          }
        }
        t.queue = [];
        t.sorter = opts.sorter || T.default_sorter;
        return t;
      },
      default_sorter: function default_sorter(a, b) {
        return a.cost - b.cost;
      },
      /**
      * Add a new item to the queue and ensure the highest priority element
      * is at the front of the queue.
      */
      push: function push(value, cost) {
        var item = { value, cost };
        this.queue.push(item);
        this.queue.sort(this.sorter);
      },
      /**
      * Return the highest priority element in the queue.
      */
      pop: function pop() {
        return this.queue.shift();
      },
      empty: function empty() {
        return this.queue.length === 0;
      }
    }
  };
  {
    module.exports = dijkstra2;
  }
})(dijkstra);
var dijkstraExports = dijkstra.exports;
(function(exports) {
  var Mode2 = mode;
  var NumericData2 = numericData;
  var AlphanumericData2 = alphanumericData;
  var ByteData2 = byteData;
  var KanjiData2 = kanjiData;
  var Regex = regex;
  var Utils2 = utils$1;
  var dijkstra2 = dijkstraExports;
  function getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
  }
  function getSegments(regex2, mode2, str) {
    var segments2 = [];
    var result;
    while ((result = regex2.exec(str)) !== null) {
      segments2.push({ data: result[0], index: result.index, mode: mode2, length: result[0].length });
    }
    return segments2;
  }
  function getSegmentsFromString(dataStr) {
    var numSegs = getSegments(Regex.NUMERIC, Mode2.NUMERIC, dataStr);
    var alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode2.ALPHANUMERIC, dataStr);
    var byteSegs;
    var kanjiSegs;
    if (Utils2.isKanjiModeEnabled()) {
      byteSegs = getSegments(Regex.BYTE, Mode2.BYTE, dataStr);
      kanjiSegs = getSegments(Regex.KANJI, Mode2.KANJI, dataStr);
    } else {
      byteSegs = getSegments(Regex.BYTE_KANJI, Mode2.BYTE, dataStr);
      kanjiSegs = [];
    }
    var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
      return s1.index - s2.index;
    }).map(function(obj) {
      return { data: obj.data, mode: obj.mode, length: obj.length };
    });
  }
  function getSegmentBitsLength(length, mode2) {
    switch (mode2) {
      case Mode2.NUMERIC:
        return NumericData2.getBitsLength(length);
      case Mode2.ALPHANUMERIC:
        return AlphanumericData2.getBitsLength(length);
      case Mode2.KANJI:
        return KanjiData2.getBitsLength(length);
      case Mode2.BYTE:
        return ByteData2.getBitsLength(length);
    }
  }
  function mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
      var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
      if (prevSeg && prevSeg.mode === curr.mode) {
        acc[acc.length - 1].data += curr.data;
        return acc;
      }
      acc.push(curr);
      return acc;
    }, []);
  }
  function buildNodes(segs) {
    var nodes = [];
    for (var _i36 = 0; _i36 < segs.length; _i36++) {
      var seg = segs[_i36];
      switch (seg.mode) {
        case Mode2.NUMERIC:
          nodes.push([seg, { data: seg.data, mode: Mode2.ALPHANUMERIC, length: seg.length }, { data: seg.data, mode: Mode2.BYTE, length: seg.length }]);
          break;
        case Mode2.ALPHANUMERIC:
          nodes.push([seg, { data: seg.data, mode: Mode2.BYTE, length: seg.length }]);
          break;
        case Mode2.KANJI:
          nodes.push([seg, { data: seg.data, mode: Mode2.BYTE, length: getStringByteLength(seg.data) }]);
          break;
        case Mode2.BYTE:
          nodes.push([{ data: seg.data, mode: Mode2.BYTE, length: getStringByteLength(seg.data) }]);
      }
    }
    return nodes;
  }
  function buildGraph(nodes, version3) {
    var table = {};
    var graph = { start: {} };
    var prevNodeIds = ["start"];
    for (var _i37 = 0; _i37 < nodes.length; _i37++) {
      var nodeGroup = nodes[_i37];
      var currentNodeIds = [];
      for (var j = 0; j < nodeGroup.length; j++) {
        var node = nodeGroup[j];
        var key = "" + _i37 + j;
        currentNodeIds.push(key);
        table[key] = { node, lastCount: 0 };
        graph[key] = {};
        for (var _n48 = 0; _n48 < prevNodeIds.length; _n48++) {
          var prevNodeId = prevNodeIds[_n48];
          if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
            graph[prevNodeId][key] = getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
            table[prevNodeId].lastCount += node.length;
          } else {
            if (table[prevNodeId])
              table[prevNodeId].lastCount = node.length;
            graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) + 4 + Mode2.getCharCountIndicator(node.mode, version3);
          }
        }
      }
      prevNodeIds = currentNodeIds;
    }
    for (var _n49 = 0; _n49 < prevNodeIds.length; _n49++) {
      graph[prevNodeIds[_n49]].end = 0;
    }
    return { map: graph, table };
  }
  function buildSingleSegment(data, modesHint) {
    var mode2;
    var bestMode = Mode2.getBestModeForData(data);
    mode2 = Mode2.from(modesHint, bestMode);
    if (mode2 !== Mode2.BYTE && mode2.bit < bestMode.bit) {
      throw new Error('"' + data + '" cannot be encoded with mode ' + Mode2.toString(mode2) + ".\n Suggested mode is: " + Mode2.toString(bestMode));
    }
    if (mode2 === Mode2.KANJI && !Utils2.isKanjiModeEnabled()) {
      mode2 = Mode2.BYTE;
    }
    switch (mode2) {
      case Mode2.NUMERIC:
        return new NumericData2(data);
      case Mode2.ALPHANUMERIC:
        return new AlphanumericData2(data);
      case Mode2.KANJI:
        return new KanjiData2(data);
      case Mode2.BYTE:
        return new ByteData2(data);
    }
  }
  exports.fromArray = function fromArray(array) {
    return array.reduce(function(acc, seg) {
      if (typeof seg === "string") {
        acc.push(buildSingleSegment(seg, null));
      } else if (seg.data) {
        acc.push(buildSingleSegment(seg.data, seg.mode));
      }
      return acc;
    }, []);
  };
  exports.fromString = function fromString(data, version3) {
    var segs = getSegmentsFromString(data, Utils2.isKanjiModeEnabled());
    var nodes = buildNodes(segs);
    var graph = buildGraph(nodes, version3);
    var path = dijkstra2.find_path(graph.map, "start", "end");
    var optimizedSegs = [];
    for (var _i38 = 1; _i38 < path.length - 1; _i38++) {
      optimizedSegs.push(graph.table[path[_i38]].node);
    }
    return exports.fromArray(mergeSegments(optimizedSegs));
  };
  exports.rawSplit = function rawSplit(data) {
    return exports.fromArray(getSegmentsFromString(data, Utils2.isKanjiModeEnabled()));
  };
})(segments);
var Utils$1 = utils$1;
var ECLevel = errorCorrectionLevel;
var BitBuffer = bitBuffer;
var BitMatrix = bitMatrix;
var AlignmentPattern = alignmentPattern;
var FinderPattern = finderPattern;
var MaskPattern = maskPattern;
var ECCode = errorCorrectionCode;
var ReedSolomonEncoder = reedSolomonEncoder;
var Version = version2;
var FormatInfo = formatInfo;
var Mode = mode;
var Segments = segments;
function setupFinderPattern(matrix, version3) {
  var size = matrix.size;
  var pos = FinderPattern.getPositions(version3);
  for (var _i39 = 0; _i39 < pos.length; _i39++) {
    var row = pos[_i39][0];
    var col = pos[_i39][1];
    for (var _r57 = -1; _r57 <= 7; _r57++) {
      if (row + _r57 <= -1 || size <= row + _r57)
        continue;
      for (var _c20 = -1; _c20 <= 7; _c20++) {
        if (col + _c20 <= -1 || size <= col + _c20)
          continue;
        if (_r57 >= 0 && _r57 <= 6 && (_c20 === 0 || _c20 === 6) || _c20 >= 0 && _c20 <= 6 && (_r57 === 0 || _r57 === 6) || _r57 >= 2 && _r57 <= 4 && _c20 >= 2 && _c20 <= 4) {
          matrix.set(row + _r57, col + _c20, true, true);
        } else {
          matrix.set(row + _r57, col + _c20, false, true);
        }
      }
    }
  }
}
function setupTimingPattern(matrix) {
  var size = matrix.size;
  for (var _r58 = 8; _r58 < size - 8; _r58++) {
    var value = _r58 % 2 === 0;
    matrix.set(_r58, 6, value, true);
    matrix.set(6, _r58, value, true);
  }
}
function setupAlignmentPattern(matrix, version3) {
  var pos = AlignmentPattern.getPositions(version3);
  for (var _i40 = 0; _i40 < pos.length; _i40++) {
    var row = pos[_i40][0];
    var col = pos[_i40][1];
    for (var _r59 = -2; _r59 <= 2; _r59++) {
      for (var _c21 = -2; _c21 <= 2; _c21++) {
        if (_r59 === -2 || _r59 === 2 || _c21 === -2 || _c21 === 2 || _r59 === 0 && _c21 === 0) {
          matrix.set(row + _r59, col + _c21, true, true);
        } else {
          matrix.set(row + _r59, col + _c21, false, true);
        }
      }
    }
  }
}
function setupVersionInfo(matrix, version3) {
  var size = matrix.size;
  var bits = Version.getEncodedBits(version3);
  var row, col, mod;
  for (var _i41 = 0; _i41 < 18; _i41++) {
    row = Math.floor(_i41 / 3);
    col = _i41 % 3 + size - 8 - 3;
    mod = (bits >> _i41 & 1) === 1;
    matrix.set(row, col, mod, true);
    matrix.set(col, row, mod, true);
  }
}
function setupFormatInfo(matrix, errorCorrectionLevel2, maskPattern2) {
  var size = matrix.size;
  var bits = FormatInfo.getEncodedBits(errorCorrectionLevel2, maskPattern2);
  var i, mod;
  for (i = 0; i < 15; i++) {
    mod = (bits >> i & 1) === 1;
    if (i < 6) {
      matrix.set(i, 8, mod, true);
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true);
    } else {
      matrix.set(size - 15 + i, 8, mod, true);
    }
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true);
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true);
    } else {
      matrix.set(8, 15 - i - 1, mod, true);
    }
  }
  matrix.set(size - 8, 8, 1, true);
}
function setupData(matrix, data) {
  var size = matrix.size;
  var inc = -1;
  var row = size - 1;
  var bitIndex = 7;
  var byteIndex = 0;
  for (var col = size - 1; col > 0; col -= 2) {
    if (col === 6)
      col--;
    while (true) {
      for (var _c22 = 0; _c22 < 2; _c22++) {
        if (!matrix.isReserved(row, col - _c22)) {
          var dark = false;
          if (byteIndex < data.length) {
            dark = (data[byteIndex] >>> bitIndex & 1) === 1;
          }
          matrix.set(row, col - _c22, dark);
          bitIndex--;
          if (bitIndex === -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }
      row += inc;
      if (row < 0 || size <= row) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
}
function createData(version3, errorCorrectionLevel2, segments2) {
  var buffer2 = new BitBuffer();
  segments2.forEach(function(data) {
    buffer2.put(data.mode.bit, 4);
    buffer2.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version3));
    data.write(buffer2);
  });
  var totalCodewords = Utils$1.getSymbolTotalCodewords(version3);
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version3, errorCorrectionLevel2);
  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
  if (buffer2.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer2.put(0, 4);
  }
  while (buffer2.getLengthInBits() % 8 !== 0) {
    buffer2.putBit(0);
  }
  var remainingByte = (dataTotalCodewordsBits - buffer2.getLengthInBits()) / 8;
  for (var _i42 = 0; _i42 < remainingByte; _i42++) {
    buffer2.put(_i42 % 2 ? 17 : 236, 8);
  }
  return createCodewords(buffer2, version3, errorCorrectionLevel2);
}
function createCodewords(bitBuffer2, version3, errorCorrectionLevel2) {
  var totalCodewords = Utils$1.getSymbolTotalCodewords(version3);
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version3, errorCorrectionLevel2);
  var dataTotalCodewords = totalCodewords - ecTotalCodewords;
  var ecTotalBlocks = ECCode.getBlocksCount(version3, errorCorrectionLevel2);
  var blocksInGroup2 = totalCodewords % ecTotalBlocks;
  var blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
  var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
  var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
  var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
  var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
  var rs = new ReedSolomonEncoder(ecCount);
  var offset = 0;
  var dcData = new Array(ecTotalBlocks);
  var ecData = new Array(ecTotalBlocks);
  var maxDataSize = 0;
  var buffer2 = new Uint8Array(bitBuffer2.buffer);
  for (var b = 0; b < ecTotalBlocks; b++) {
    var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
    dcData[b] = buffer2.slice(offset, offset + dataSize);
    ecData[b] = rs.encode(dcData[b]);
    offset += dataSize;
    maxDataSize = Math.max(maxDataSize, dataSize);
  }
  var data = new Uint8Array(totalCodewords);
  var index2 = 0;
  var i, r;
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index2++] = dcData[r][i];
      }
    }
  }
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index2++] = ecData[r][i];
    }
  }
  return data;
}
function createSymbol(data, version3, errorCorrectionLevel2, maskPattern2) {
  var segments2;
  if (Array.isArray(data)) {
    segments2 = Segments.fromArray(data);
  } else if (typeof data === "string") {
    var estimatedVersion = version3;
    if (!estimatedVersion) {
      var rawSegments = Segments.rawSplit(data);
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel2);
    }
    segments2 = Segments.fromString(data, estimatedVersion || 40);
  } else {
    throw new Error("Invalid data");
  }
  var bestVersion = Version.getBestVersionForData(segments2, errorCorrectionLevel2);
  if (!bestVersion) {
    throw new Error("The amount of data is too big to be stored in a QR Code");
  }
  if (!version3) {
    version3 = bestVersion;
  } else if (version3 < bestVersion) {
    throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
  }
  var dataBits = createData(version3, errorCorrectionLevel2, segments2);
  var moduleCount = Utils$1.getSymbolSize(version3);
  var modules = new BitMatrix(moduleCount);
  setupFinderPattern(modules, version3);
  setupTimingPattern(modules);
  setupAlignmentPattern(modules, version3);
  setupFormatInfo(modules, errorCorrectionLevel2, 0);
  if (version3 >= 7) {
    setupVersionInfo(modules, version3);
  }
  setupData(modules, dataBits);
  if (isNaN(maskPattern2)) {
    maskPattern2 = MaskPattern.getBestMask(modules, setupFormatInfo.bind(null, modules, errorCorrectionLevel2));
  }
  MaskPattern.applyMask(maskPattern2, modules);
  setupFormatInfo(modules, errorCorrectionLevel2, maskPattern2);
  return { modules, version: version3, errorCorrectionLevel: errorCorrectionLevel2, maskPattern: maskPattern2, segments: segments2 };
}
qrcode.create = function create(data, options) {
  if (typeof data === "undefined" || data === "") {
    throw new Error("No input text");
  }
  var errorCorrectionLevel2 = ECLevel.M;
  var version3;
  var mask;
  if (typeof options !== "undefined") {
    errorCorrectionLevel2 = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
    version3 = Version.from(options.version);
    mask = MaskPattern.from(options.maskPattern);
    if (options.toSJISFunc) {
      Utils$1.setToSJISFunction(options.toSJISFunc);
    }
  }
  return createSymbol(data, version3, errorCorrectionLevel2, mask);
};
var canvas = {};
var utils = {};
(function(exports) {
  function hex2rgba(hex) {
    if (typeof hex === "number") {
      hex = hex.toString();
    }
    if (typeof hex !== "string") {
      throw new Error("Color should be defined as hex string");
    }
    var hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
      throw new Error("Invalid hex color: " + hex);
    }
    if (hexCode.length === 3 || hexCode.length === 4) {
      hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [c, c];
      }));
    }
    if (hexCode.length === 6)
      hexCode.push("F", "F");
    var hexValue = parseInt(hexCode.join(""), 16);
    return { r: hexValue >> 24 & 255, g: hexValue >> 16 & 255, b: hexValue >> 8 & 255, a: hexValue & 255, hex: "#" + hexCode.slice(0, 6).join("") };
  }
  exports.getOptions = function getOptions(options) {
    if (!options)
      options = {};
    if (!options.color)
      options.color = {};
    var margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    var width = options.width && options.width >= 21 ? options.width : void 0;
    var scale = options.scale || 4;
    return { width, scale: width ? 4 : scale, margin, color: { dark: hex2rgba(options.color.dark || "#000000ff"), light: hex2rgba(options.color.light || "#ffffffff") }, type: options.type, rendererOpts: options.rendererOpts || {} };
  };
  exports.getScale = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
  };
  exports.getImageWidth = function getImageWidth(qrSize, opts) {
    var scale = exports.getScale(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
  };
  exports.qrToImageData = function qrToImageData(imgData, qr2, opts) {
    var size = qr2.modules.size;
    var data = qr2.modules.data;
    var scale = exports.getScale(size, opts);
    var symbolSize = Math.floor((size + opts.margin * 2) * scale);
    var scaledMargin = opts.margin * scale;
    var palette = [opts.color.light, opts.color.dark];
    for (var _i43 = 0; _i43 < symbolSize; _i43++) {
      for (var j = 0; j < symbolSize; j++) {
        var posDst = (_i43 * symbolSize + j) * 4;
        var pxColor = opts.color.light;
        if (_i43 >= scaledMargin && j >= scaledMargin && _i43 < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
          var iSrc = Math.floor((_i43 - scaledMargin) / scale);
          var jSrc = Math.floor((j - scaledMargin) / scale);
          pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
      }
    }
  };
})(utils);
(function(exports) {
  var Utils2 = utils;
  function clearCanvas(ctx, canvas2, size) {
    ctx.clearRect(0, 0, canvas2.width, canvas2.height);
    if (!canvas2.style)
      canvas2.style = {};
    canvas2.height = size;
    canvas2.width = size;
    canvas2.style.height = size + "px";
    canvas2.style.width = size + "px";
  }
  function getCanvasElement() {
    try {
      return document.createElement("canvas");
    } catch (e) {
      throw new Error("You need to specify a canvas element");
    }
  }
  exports.render = function render2(qrData, canvas2, options) {
    var opts = options;
    var canvasEl = canvas2;
    if (typeof opts === "undefined" && (!canvas2 || !canvas2.getContext)) {
      opts = canvas2;
      canvas2 = void 0;
    }
    if (!canvas2) {
      canvasEl = getCanvasElement();
    }
    opts = Utils2.getOptions(opts);
    var size = Utils2.getImageWidth(qrData.modules.size, opts);
    var ctx = canvasEl.getContext("2d");
    var image = ctx.createImageData(size, size);
    Utils2.qrToImageData(image.data, qrData, opts);
    clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
  };
  exports.renderToDataURL = function renderToDataURL(qrData, canvas2, options) {
    var opts = options;
    if (typeof opts === "undefined" && (!canvas2 || !canvas2.getContext)) {
      opts = canvas2;
      canvas2 = void 0;
    }
    if (!opts)
      opts = {};
    var canvasEl = exports.render(qrData, canvas2, opts);
    var type = opts.type || "image/png";
    var rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
  };
})(canvas);
var svgTag = {};
var Utils = utils;
function getColorAttrib(color, attrib) {
  var alpha = color.a / 255;
  var str = attrib + '="' + color.hex + '"';
  return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function svgCmd(cmd, x2, y) {
  var str = cmd + x2;
  if (typeof y !== "undefined")
    str += " " + y;
  return str;
}
function qrToPath(data, size, margin) {
  var path = "";
  var moveBy = 0;
  var newRow = false;
  var lineLength = 0;
  for (var _i44 = 0; _i44 < data.length; _i44++) {
    var col = Math.floor(_i44 % size);
    var row = Math.floor(_i44 / size);
    if (!col && !newRow)
      newRow = true;
    if (data[_i44]) {
      lineLength++;
      if (!(_i44 > 0 && col > 0 && data[_i44 - 1])) {
        path += newRow ? svgCmd("M", col + margin, 0.5 + row + margin) : svgCmd("m", moveBy, 0);
        moveBy = 0;
        newRow = false;
      }
      if (!(col + 1 < size && data[_i44 + 1])) {
        path += svgCmd("h", lineLength);
        lineLength = 0;
      }
    } else {
      moveBy++;
    }
  }
  return path;
}
svgTag.render = function render(qrData, options, cb) {
  var opts = Utils.getOptions(options);
  var size = qrData.modules.size;
  var data = qrData.modules.data;
  var qrcodesize = size + opts.margin * 2;
  var bg = !opts.color.light.a ? "" : "<path " + getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
  var path = "<path " + getColorAttrib(opts.color.dark, "stroke") + ' d="' + qrToPath(data, size, opts.margin) + '"/>';
  var viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
  var width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
  var svgTag2 = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
  if (typeof cb === "function") {
    cb(null, svgTag2);
  }
  return svgTag2;
};
var canPromise = canPromise$1;
var QRCode = qrcode;
var CanvasRenderer = canvas;
var SvgRenderer = svgTag;
function renderCanvas(renderFunc, canvas2, text, opts, cb) {
  var args = [].slice.call(arguments, 1);
  var argsNum = args.length;
  var isLastArgCb = typeof args[argsNum - 1] === "function";
  if (!isLastArgCb && !canPromise()) {
    throw new Error("Callback required as last argument");
  }
  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error("Too few arguments provided");
    }
    if (argsNum === 2) {
      cb = text;
      text = canvas2;
      canvas2 = opts = void 0;
    } else if (argsNum === 3) {
      if (canvas2.getContext && typeof cb === "undefined") {
        cb = opts;
        opts = void 0;
      } else {
        cb = opts;
        opts = text;
        text = canvas2;
        canvas2 = void 0;
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error("Too few arguments provided");
    }
    if (argsNum === 1) {
      text = canvas2;
      canvas2 = opts = void 0;
    } else if (argsNum === 2 && !canvas2.getContext) {
      opts = text;
      text = canvas2;
      canvas2 = void 0;
    }
    return new Promise(function(resolve2, reject) {
      try {
        var data2 = QRCode.create(text, opts);
        resolve2(renderFunc(data2, canvas2, opts));
      } catch (e) {
        reject(e);
      }
    });
  }
  try {
    var data = QRCode.create(text, opts);
    cb(null, renderFunc(data, canvas2, opts));
  } catch (e) {
    cb(e);
  }
}
browser.create = QRCode.create;
browser.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
browser.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);
browser.toString = renderCanvas.bind(null, function(data, _2, opts) {
  return SvgRenderer.render(data, opts);
});
var buffer = {};
var base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error("Invalid string. Length must be a multiple of 4");
  }
  var validLen = b64.indexOf("=");
  if (validLen === -1)
    validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 255;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 16711680) + (uint8[i + 1] << 8 & 65280) + (uint8[i + 2] & 255);
    output.push(tripletToBase64(tmp));
  }
  return output.join("");
}
function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3;
  var parts = [];
  var maxChunkLength = 16383;
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
  }
  return parts.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(buffer2, offset, isLE, mLen, nBytes) {
  var e, m2;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer2[offset + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer2[offset + i], i += d, nBits -= 8) {
  }
  m2 = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m2 = m2 * 256 + buffer2[offset + i], i += d, nBits -= 8) {
  }
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m2 ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m2 = m2 + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m2 * Math.pow(2, e - mLen);
};
ieee754.write = function(buffer2, value, offset, isLE, mLen, nBytes) {
  var e, m2, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m2 = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m2 = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m2 = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m2 = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer2[offset + i] = m2 & 255, i += d, m2 /= 256, mLen -= 8) {
  }
  e = e << mLen | m2;
  eLen += mLen;
  for (; eLen > 0; buffer2[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
  }
  buffer2[offset + i - d] |= s * 128;
};
/*!
* The buffer module from node.js, for the browser.
*
* @author   Feross Aboukhadijeh <https://feross.org>
* @license  MIT
*/
(function(exports) {
  var base64 = base64Js;
  var ieee754$1 = ieee754;
  var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
  exports.Buffer = Buffer2;
  exports.SlowBuffer = SlowBuffer;
  exports.INSPECT_MAX_BYTES = 50;
  var K_MAX_LENGTH = 2147483647;
  exports.kMaxLength = K_MAX_LENGTH;
  Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
  if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
    console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
  }
  function typedArraySupport() {
    try {
      var arr = new Uint8Array(1);
      var proto = { foo: function foo() {
        return 42;
      } };
      Object.setPrototypeOf(proto, Uint8Array.prototype);
      Object.setPrototypeOf(arr, proto);
      return arr.foo() === 42;
    } catch (e) {
      return false;
    }
  }
  Object.defineProperty(Buffer2.prototype, "parent", { enumerable: true, get: function get2() {
    if (!Buffer2.isBuffer(this))
      return void 0;
    return this.buffer;
  } });
  Object.defineProperty(Buffer2.prototype, "offset", { enumerable: true, get: function get2() {
    if (!Buffer2.isBuffer(this))
      return void 0;
    return this.byteOffset;
  } });
  function createBuffer(length) {
    if (length > K_MAX_LENGTH) {
      throw new RangeError('The value "' + length + '" is invalid for option "size"');
    }
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function Buffer2(arg, encodingOrOffset, length) {
    if (typeof arg === "number") {
      if (typeof encodingOrOffset === "string") {
        throw new TypeError('The "string" argument must be of type string. Received type number');
      }
      return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
  }
  Buffer2.poolSize = 8192;
  function from(value, encodingOrOffset, length) {
    if (typeof value === "string") {
      return fromString(value, encodingOrOffset);
    }
    if (ArrayBuffer.isView(value)) {
      return fromArrayView(value);
    }
    if (value == null) {
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(value));
    }
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
      return fromArrayBuffer(value, encodingOrOffset, length);
    }
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
      return fromArrayBuffer(value, encodingOrOffset, length);
    }
    if (typeof value === "number") {
      throw new TypeError('The "value" argument must not be of type number. Received type number');
    }
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) {
      return Buffer2.from(valueOf, encodingOrOffset, length);
    }
    var b = fromObject(value);
    if (b)
      return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
      return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    }
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + _typeof(value));
  }
  Buffer2.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
  };
  Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
  Object.setPrototypeOf(Buffer2, Uint8Array);
  function assertSize(size) {
    if (typeof size !== "number") {
      throw new TypeError('"size" argument must be of type number');
    } else if (size < 0) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
  }
  function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(size);
    }
    if (fill !== void 0) {
      return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    }
    return createBuffer(size);
  }
  Buffer2.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
  };
  function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
  }
  Buffer2.allocUnsafe = function(size) {
    return allocUnsafe(size);
  };
  Buffer2.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
  };
  function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") {
      encoding = "utf8";
    }
    if (!Buffer2.isEncoding(encoding)) {
      throw new TypeError("Unknown encoding: " + encoding);
    }
    var length = byteLength2(string, encoding) | 0;
    var buf = createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) {
      buf = buf.slice(0, actual);
    }
    return buf;
  }
  function fromArrayLike(array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0;
    var buf = createBuffer(length);
    for (var _i45 = 0; _i45 < length; _i45 += 1) {
      buf[_i45] = array[_i45] & 255;
    }
    return buf;
  }
  function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
      var copy = new Uint8Array(arrayView);
      return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
  }
  function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('"offset" is outside of buffer bounds');
    }
    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('"length" is outside of buffer bounds');
    }
    var buf;
    if (byteOffset === void 0 && length === void 0) {
      buf = new Uint8Array(array);
    } else if (length === void 0) {
      buf = new Uint8Array(array, byteOffset);
    } else {
      buf = new Uint8Array(array, byteOffset, length);
    }
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function fromObject(obj) {
    if (Buffer2.isBuffer(obj)) {
      var _len21 = checked(obj.length) | 0;
      var buf = createBuffer(_len21);
      if (buf.length === 0) {
        return buf;
      }
      obj.copy(buf, 0, 0, _len21);
      return buf;
    }
    if (obj.length !== void 0) {
      if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
        return createBuffer(0);
      }
      return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) {
      return fromArrayLike(obj.data);
    }
  }
  function checked(length) {
    if (length >= K_MAX_LENGTH) {
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    }
    return length | 0;
  }
  function SlowBuffer(length) {
    if (+length != length) {
      length = 0;
    }
    return Buffer2.alloc(+length);
  }
  Buffer2.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer2.prototype;
  };
  Buffer2.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array))
      a = Buffer2.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array))
      b = Buffer2.from(b, b.offset, b.byteLength);
    if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
      throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    }
    if (a === b)
      return 0;
    var x2 = a.length;
    var y = b.length;
    for (var _i46 = 0, _len22 = Math.min(x2, y); _i46 < _len22; ++_i46) {
      if (a[_i46] !== b[_i46]) {
        x2 = a[_i46];
        y = b[_i46];
        break;
      }
    }
    if (x2 < y)
      return -1;
    if (y < x2)
      return 1;
    return 0;
  };
  Buffer2.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return true;
      default:
        return false;
    }
  };
  Buffer2.concat = function concat(list, length) {
    if (!Array.isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    if (list.length === 0) {
      return Buffer2.alloc(0);
    }
    var i;
    if (length === void 0) {
      length = 0;
      for (i = 0; i < list.length; ++i) {
        length += list[i].length;
      }
    }
    var buffer2 = Buffer2.allocUnsafe(length);
    var pos = 0;
    for (i = 0; i < list.length; ++i) {
      var buf = list[i];
      if (isInstance(buf, Uint8Array)) {
        if (pos + buf.length > buffer2.length) {
          if (!Buffer2.isBuffer(buf))
            buf = Buffer2.from(buf);
          buf.copy(buffer2, pos);
        } else {
          Uint8Array.prototype.set.call(buffer2, buf, pos);
        }
      } else if (!Buffer2.isBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      } else {
        buf.copy(buffer2, pos);
      }
      pos += buf.length;
    }
    return buffer2;
  };
  function byteLength2(string, encoding) {
    if (Buffer2.isBuffer(string)) {
      return string.length;
    }
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
      return string.byteLength;
    }
    if (typeof string !== "string") {
      throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + _typeof(string));
    }
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0)
      return 0;
    var loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "ascii":
        case "latin1":
        case "binary":
          return len;
        case "utf8":
        case "utf-8":
          return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return len * 2;
        case "hex":
          return len >>> 1;
        case "base64":
          return base64ToBytes(string).length;
        default:
          if (loweredCase) {
            return mustMatch ? -1 : utf8ToBytes(string).length;
          }
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.byteLength = byteLength2;
  function slowToString(encoding, start, end) {
    var loweredCase = false;
    if (start === void 0 || start < 0) {
      start = 0;
    }
    if (start > this.length) {
      return "";
    }
    if (end === void 0 || end > this.length) {
      end = this.length;
    }
    if (end <= 0) {
      return "";
    }
    end >>>= 0;
    start >>>= 0;
    if (end <= start) {
      return "";
    }
    if (!encoding)
      encoding = "utf8";
    while (true) {
      switch (encoding) {
        case "hex":
          return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
          return utf8Slice(this, start, end);
        case "ascii":
          return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
          return latin1Slice(this, start, end);
        case "base64":
          return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return utf16leSlice(this, start, end);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = (encoding + "").toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.prototype._isBuffer = true;
  function swap(b, n, m2) {
    var i = b[n];
    b[n] = b[m2];
    b[m2] = i;
  }
  Buffer2.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    }
    for (var _i47 = 0; _i47 < len; _i47 += 2) {
      swap(this, _i47, _i47 + 1);
    }
    return this;
  };
  Buffer2.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    }
    for (var _i48 = 0; _i48 < len; _i48 += 4) {
      swap(this, _i48, _i48 + 3);
      swap(this, _i48 + 1, _i48 + 2);
    }
    return this;
  };
  Buffer2.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    }
    for (var _i49 = 0; _i49 < len; _i49 += 8) {
      swap(this, _i49, _i49 + 7);
      swap(this, _i49 + 1, _i49 + 6);
      swap(this, _i49 + 2, _i49 + 5);
      swap(this, _i49 + 3, _i49 + 4);
    }
    return this;
  };
  Buffer2.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0)
      return "";
    if (arguments.length === 0)
      return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
  };
  Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
  Buffer2.prototype.equals = function equals(b) {
    if (!Buffer2.isBuffer(b))
      throw new TypeError("Argument must be a Buffer");
    if (this === b)
      return true;
    return Buffer2.compare(this, b) === 0;
  };
  Buffer2.prototype.inspect = function inspect() {
    var str = "";
    var max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max)
      str += " ... ";
    return "<Buffer " + str + ">";
  };
  if (customInspectSymbol) {
    Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
  }
  Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) {
      target = Buffer2.from(target, target.offset, target.byteLength);
    }
    if (!Buffer2.isBuffer(target)) {
      throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + _typeof(target));
    }
    if (start === void 0) {
      start = 0;
    }
    if (end === void 0) {
      end = target ? target.length : 0;
    }
    if (thisStart === void 0) {
      thisStart = 0;
    }
    if (thisEnd === void 0) {
      thisEnd = this.length;
    }
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError("out of range index");
    }
    if (thisStart >= thisEnd && start >= end) {
      return 0;
    }
    if (thisStart >= thisEnd) {
      return -1;
    }
    if (start >= end) {
      return 1;
    }
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target)
      return 0;
    var x2 = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x2, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for (var _i50 = 0; _i50 < len; ++_i50) {
      if (thisCopy[_i50] !== targetCopy[_i50]) {
        x2 = thisCopy[_i50];
        y = targetCopy[_i50];
        break;
      }
    }
    if (x2 < y)
      return -1;
    if (y < x2)
      return 1;
    return 0;
  };
  function bidirectionalIndexOf(buffer2, val, byteOffset, encoding, dir) {
    if (buffer2.length === 0)
      return -1;
    if (typeof byteOffset === "string") {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 2147483647) {
      byteOffset = 2147483647;
    } else if (byteOffset < -2147483648) {
      byteOffset = -2147483648;
    }
    byteOffset = +byteOffset;
    if (numberIsNaN(byteOffset)) {
      byteOffset = dir ? 0 : buffer2.length - 1;
    }
    if (byteOffset < 0)
      byteOffset = buffer2.length + byteOffset;
    if (byteOffset >= buffer2.length) {
      if (dir)
        return -1;
      else
        byteOffset = buffer2.length - 1;
    } else if (byteOffset < 0) {
      if (dir)
        byteOffset = 0;
      else
        return -1;
    }
    if (typeof val === "string") {
      val = Buffer2.from(val, encoding);
    }
    if (Buffer2.isBuffer(val)) {
      if (val.length === 0) {
        return -1;
      }
      return arrayIndexOf(buffer2, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
      val = val & 255;
      if (typeof Uint8Array.prototype.indexOf === "function") {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer2, val, byteOffset);
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer2, val, byteOffset);
        }
      }
      return arrayIndexOf(buffer2, [val], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
  }
  function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== void 0) {
      encoding = String(encoding).toLowerCase();
      if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
        if (arr.length < 2 || val.length < 2) {
          return -1;
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }
    function read(buf, i2) {
      if (indexSize === 1) {
        return buf[i2];
      } else {
        return buf.readUInt16BE(i2 * indexSize);
      }
    }
    var i;
    if (dir) {
      var foundIndex = -1;
      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1)
            foundIndex = i;
          if (i - foundIndex + 1 === valLength)
            return foundIndex * indexSize;
        } else {
          if (foundIndex !== -1)
            i -= i - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength)
        byteOffset = arrLength - valLength;
      for (i = byteOffset; i >= 0; i--) {
        var found = true;
        for (var j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val, j)) {
            found = false;
            break;
          }
        }
        if (found)
          return i;
      }
    }
    return -1;
  }
  Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
  };
  Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
  };
  Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
  };
  function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) {
      length = remaining;
    } else {
      length = Number(length);
      if (length > remaining) {
        length = remaining;
      }
    }
    var strLen = string.length;
    if (length > strLen / 2) {
      length = strLen / 2;
    }
    var i;
    for (i = 0; i < length; ++i) {
      var parsed = parseInt(string.substr(i * 2, 2), 16);
      if (numberIsNaN(parsed))
        return i;
      buf[offset + i] = parsed;
    }
    return i;
  }
  function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
  }
  function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
  }
  function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
  }
  function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
  }
  Buffer2.prototype.write = function write3(string, offset, length, encoding) {
    if (offset === void 0) {
      encoding = "utf8";
      length = this.length;
      offset = 0;
    } else if (length === void 0 && typeof offset === "string") {
      encoding = offset;
      length = this.length;
      offset = 0;
    } else if (isFinite(offset)) {
      offset = offset >>> 0;
      if (isFinite(length)) {
        length = length >>> 0;
        if (encoding === void 0)
          encoding = "utf8";
      } else {
        encoding = length;
        length = void 0;
      }
    } else {
      throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    }
    var remaining = this.length - offset;
    if (length === void 0 || length > remaining)
      length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
      throw new RangeError("Attempt to write outside buffer bounds");
    }
    if (!encoding)
      encoding = "utf8";
    var loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "hex":
          return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
          return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
          return asciiWrite(this, string, offset, length);
        case "base64":
          return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ucs2Write(this, string, offset, length);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };
  Buffer2.prototype.toJSON = function toJSON() {
    return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
  };
  function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
      return base64.fromByteArray(buf);
    } else {
      return base64.fromByteArray(buf.slice(start, end));
    }
  }
  function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while (i < end) {
      var firstByte = buf[i];
      var codePoint = null;
      var bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
      if (i + bytesPerSequence <= end) {
        var secondByte = void 0, thirdByte = void 0, fourthByte = void 0, tempCodePoint = void 0;
        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 128) {
              codePoint = firstByte;
            }
            break;
          case 2:
            secondByte = buf[i + 1];
            if ((secondByte & 192) === 128) {
              tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
              if (tempCodePoint > 127) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 3:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
              if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 4:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            fourthByte = buf[i + 3];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
              if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                codePoint = tempCodePoint;
              }
            }
        }
      }
      if (codePoint === null) {
        codePoint = 65533;
        bytesPerSequence = 1;
      } else if (codePoint > 65535) {
        codePoint -= 65536;
        res.push(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
      }
      res.push(codePoint);
      i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
  }
  var MAX_ARGUMENTS_LENGTH = 4096;
  function decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints);
    }
    var res = "";
    var i = 0;
    while (i < len) {
      res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }
    return res;
  }
  function asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for (var _i51 = start; _i51 < end; ++_i51) {
      ret += String.fromCharCode(buf[_i51] & 127);
    }
    return ret;
  }
  function latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for (var _i52 = start; _i52 < end; ++_i52) {
      ret += String.fromCharCode(buf[_i52]);
    }
    return ret;
  }
  function hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0)
      start = 0;
    if (!end || end < 0 || end > len)
      end = len;
    var out = "";
    for (var _i53 = start; _i53 < end; ++_i53) {
      out += hexSliceLookupTable[buf[_i53]];
    }
    return out;
  }
  function utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    for (var _i54 = 0; _i54 < bytes.length - 1; _i54 += 2) {
      res += String.fromCharCode(bytes[_i54] + bytes[_i54 + 1] * 256);
    }
    return res;
  }
  Buffer2.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === void 0 ? len : ~~end;
    if (start < 0) {
      start += len;
      if (start < 0)
        start = 0;
    } else if (start > len) {
      start = len;
    }
    if (end < 0) {
      end += len;
      if (end < 0)
        end = 0;
    } else if (end > len) {
      end = len;
    }
    if (end < start)
      end = start;
    var newBuf = this.subarray(start, end);
    Object.setPrototypeOf(newBuf, Buffer2.prototype);
    return newBuf;
  };
  function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0)
      throw new RangeError("offset is not uint");
    if (offset + ext > length)
      throw new RangeError("Trying to access beyond buffer length");
  }
  Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    var val = this[offset];
    var mul2 = 1;
    var i = 0;
    while (++i < byteLength3 && (mul2 *= 256)) {
      val += this[offset + i] * mul2;
    }
    return val;
  };
  Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      checkOffset(offset, byteLength3, this.length);
    }
    var val = this[offset + --byteLength3];
    var mul2 = 1;
    while (byteLength3 > 0 && (mul2 *= 256)) {
      val += this[offset + --byteLength3] * mul2;
    }
    return val;
  };
  Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 1, this.length);
    return this[offset];
  };
  Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
  };
  Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
  };
  Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
  };
  Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
  };
  Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    var lo = first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    var hi2 = this[++offset] + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi2) << BigInt(32));
  });
  Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    var hi2 = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
    var lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last;
    return (BigInt(hi2) << BigInt(32)) + BigInt(lo);
  });
  Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    var val = this[offset];
    var mul2 = 1;
    var i = 0;
    while (++i < byteLength3 && (mul2 *= 256)) {
      val += this[offset + i] * mul2;
    }
    mul2 *= 128;
    if (val >= mul2)
      val -= Math.pow(2, 8 * byteLength3);
    return val;
  };
  Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    var i = byteLength3;
    var mul2 = 1;
    var val = this[offset + --i];
    while (i > 0 && (mul2 *= 256)) {
      val += this[offset + --i] * mul2;
    }
    mul2 *= 128;
    if (val >= mul2)
      val -= Math.pow(2, 8 * byteLength3);
    return val;
  };
  Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 1, this.length);
    if (!(this[offset] & 128))
      return this[offset];
    return (255 - this[offset] + 1) * -1;
  };
  Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 32768 ? val | 4294901760 : val;
  };
  Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 32768 ? val | 4294901760 : val;
  };
  Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
  };
  Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
  };
  Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    var val = this[offset + 4] + this[offset + 5] * Math.pow(2, 8) + this[offset + 6] * Math.pow(2, 16) + (last << 24);
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * Math.pow(2, 8) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
  });
  Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    var first = this[offset];
    var last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    var val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 8) + last);
  });
  Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return ieee754$1.read(this, offset, true, 23, 4);
  };
  Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return ieee754$1.read(this, offset, false, 23, 4);
  };
  Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 8, this.length);
    return ieee754$1.read(this, offset, true, 52, 8);
  };
  Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 8, this.length);
    return ieee754$1.read(this, offset, false, 52, 8);
  };
  function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer2.isBuffer(buf))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min)
      throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length)
      throw new RangeError("Index out of range");
  }
  Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value, offset, byteLength3, maxBytes, 0);
    }
    var mul2 = 1;
    var i = 0;
    this[offset] = value & 255;
    while (++i < byteLength3 && (mul2 *= 256)) {
      this[offset + i] = value / mul2 & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value, offset, byteLength3, maxBytes, 0);
    }
    var i = byteLength3 - 1;
    var mul2 = 1;
    this[offset + i] = value & 255;
    while (--i >= 0 && (mul2 *= 256)) {
      this[offset + i] = value / mul2 & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 1, 255, 0);
    this[offset] = value & 255;
    return offset + 1;
  };
  Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };
  Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
  };
  Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 255;
    return offset + 4;
  };
  Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
  };
  function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(4294967295));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    var hi2 = Number(value >> BigInt(32) & BigInt(4294967295));
    buf[offset++] = hi2;
    hi2 = hi2 >> 8;
    buf[offset++] = hi2;
    hi2 = hi2 >> 8;
    buf[offset++] = hi2;
    hi2 = hi2 >> 8;
    buf[offset++] = hi2;
    return offset;
  }
  function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    var lo = Number(value & BigInt(4294967295));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    var hi2 = Number(value >> BigInt(32) & BigInt(4294967295));
    buf[offset + 3] = hi2;
    hi2 = hi2 >> 8;
    buf[offset + 2] = hi2;
    hi2 = hi2 >> 8;
    buf[offset + 1] = hi2;
    hi2 = hi2 >> 8;
    buf[offset] = hi2;
    return offset + 8;
  }
  Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value, offset, byteLength3, limit - 1, -limit);
    }
    var i = 0;
    var mul2 = 1;
    var sub = 0;
    this[offset] = value & 255;
    while (++i < byteLength3 && (mul2 *= 256)) {
      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = (value / mul2 >> 0) - sub & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      var limit = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value, offset, byteLength3, limit - 1, -limit);
    }
    var i = byteLength3 - 1;
    var mul2 = 1;
    var sub = 0;
    this[offset + i] = value & 255;
    while (--i >= 0 && (mul2 *= 256)) {
      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = (value / mul2 >> 0) - sub & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 1, 127, -128);
    if (value < 0)
      value = 255 + value + 1;
    this[offset] = value & 255;
    return offset + 1;
  };
  Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };
  Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
  };
  Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 2147483647, -2147483648);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
  };
  Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 2147483647, -2147483648);
    if (value < 0)
      value = 4294967295 + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
  };
  Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length)
      throw new RangeError("Index out of range");
    if (offset < 0)
      throw new RangeError("Index out of range");
  }
  function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4);
    }
    ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
  }
  Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
  };
  Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
  };
  function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8);
    }
    ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
  }
  Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
  };
  Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
  };
  Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer2.isBuffer(target))
      throw new TypeError("argument should be a Buffer");
    if (!start)
      start = 0;
    if (!end && end !== 0)
      end = this.length;
    if (targetStart >= target.length)
      targetStart = target.length;
    if (!targetStart)
      targetStart = 0;
    if (end > 0 && end < start)
      end = start;
    if (end === start)
      return 0;
    if (target.length === 0 || this.length === 0)
      return 0;
    if (targetStart < 0) {
      throw new RangeError("targetStart out of bounds");
    }
    if (start < 0 || start >= this.length)
      throw new RangeError("Index out of range");
    if (end < 0)
      throw new RangeError("sourceEnd out of bounds");
    if (end > this.length)
      end = this.length;
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
      this.copyWithin(targetStart, start, end);
    } else {
      Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    }
    return len;
  };
  Buffer2.prototype.fill = function fill(val, start, end, encoding) {
    if (typeof val === "string") {
      if (typeof start === "string") {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === "string") {
        encoding = end;
        end = this.length;
      }
      if (encoding !== void 0 && typeof encoding !== "string") {
        throw new TypeError("encoding must be a string");
      }
      if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      if (val.length === 1) {
        var _code = val.charCodeAt(0);
        if (encoding === "utf8" && _code < 128 || encoding === "latin1") {
          val = _code;
        }
      }
    } else if (typeof val === "number") {
      val = val & 255;
    } else if (typeof val === "boolean") {
      val = Number(val);
    }
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError("Out of range index");
    }
    if (end <= start) {
      return this;
    }
    start = start >>> 0;
    end = end === void 0 ? this.length : end >>> 0;
    if (!val)
      val = 0;
    var i;
    if (typeof val === "number") {
      for (i = start; i < end; ++i) {
        this[i] = val;
      }
    } else {
      var bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
      var _len23 = bytes.length;
      if (_len23 === 0) {
        throw new TypeError('The value "' + val + '" is invalid for argument "value"');
      }
      for (i = 0; i < end - start; ++i) {
        this[i + start] = bytes[i % _len23];
      }
    }
    return this;
  };
  var errors = {};
  function E(sym, getMessage, Base) {
    errors[sym] = /* @__PURE__ */ function(_Base) {
      function NodeError() {
        var _this65;
        _classCallCheck(this, NodeError);
        _this65 = _callSuper(this, NodeError);
        Object.defineProperty(_this65, "message", { value: getMessage.apply(_this65, arguments), writable: true, configurable: true });
        _this65.name = "".concat(_this65.name, " [").concat(sym, "]");
        _this65.stack;
        delete _this65.name;
        return _this65;
      }
      _inherits(NodeError, _Base);
      return _createClass(NodeError, [{ key: "code", get: function get2() {
        return sym;
      }, set: function set(value) {
        Object.defineProperty(this, "code", { configurable: true, enumerable: true, value, writable: true });
      } }, { key: "toString", value: function toString() {
        return "".concat(this.name, " [").concat(sym, "]: ").concat(this.message);
      } }]);
    }(Base);
  }
  E("ERR_BUFFER_OUT_OF_BOUNDS", function(name2) {
    if (name2) {
      return "".concat(name2, " is outside of buffer bounds");
    }
    return "Attempt to access memory outside buffer bounds";
  }, RangeError);
  E("ERR_INVALID_ARG_TYPE", function(name2, actual) {
    return 'The "'.concat(name2, '" argument must be of type number. Received type ').concat(_typeof(actual));
  }, TypeError);
  E("ERR_OUT_OF_RANGE", function(str, range, input) {
    var msg = 'The value of "'.concat(str, '" is out of range.');
    var received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) {
      received = addNumericalSeparator(String(input));
    } else if (typeof input === "bigint") {
      received = String(input);
      if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) {
        received = addNumericalSeparator(received);
      }
      received += "n";
    }
    msg += " It must be ".concat(range, ". Received ").concat(received);
    return msg;
  }, RangeError);
  function addNumericalSeparator(val) {
    var res = "";
    var i = val.length;
    var start = val[0] === "-" ? 1 : 0;
    for (; i >= start + 4; i -= 3) {
      res = "_".concat(val.slice(i - 3, i)).concat(res);
    }
    return "".concat(val.slice(0, i)).concat(res);
  }
  function checkBounds(buf, offset, byteLength3) {
    validateNumber(offset, "offset");
    if (buf[offset] === void 0 || buf[offset + byteLength3] === void 0) {
      boundsError(offset, buf.length - (byteLength3 + 1));
    }
  }
  function checkIntBI(value, min, max, buf, offset, byteLength3) {
    if (value > max || value < min) {
      var _n50 = typeof min === "bigint" ? "n" : "";
      var range;
      if (byteLength3 > 3) {
        if (min === 0 || min === BigInt(0)) {
          range = ">= 0".concat(_n50, " and < 2").concat(_n50, " ** ").concat((byteLength3 + 1) * 8).concat(_n50);
        } else {
          range = ">= -(2".concat(_n50, " ** ").concat((byteLength3 + 1) * 8 - 1).concat(_n50, ") and < 2 ** ") + "".concat((byteLength3 + 1) * 8 - 1).concat(_n50);
        }
      } else {
        range = ">= ".concat(min).concat(_n50, " and <= ").concat(max).concat(_n50);
      }
      throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength3);
  }
  function validateNumber(value, name2) {
    if (typeof value !== "number") {
      throw new errors.ERR_INVALID_ARG_TYPE(name2, "number", value);
    }
  }
  function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
      validateNumber(value, type);
      throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) {
      throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    }
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", ">= ".concat(type ? 1 : 0, " and <= ").concat(length), value);
  }
  var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
  function base64clean(str) {
    str = str.split("=")[0];
    str = str.trim().replace(INVALID_BASE64_RE, "");
    if (str.length < 2)
      return "";
    while (str.length % 4 !== 0) {
      str = str + "=";
    }
    return str;
  }
  function utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for (var _i55 = 0; _i55 < length; ++_i55) {
      codePoint = string.charCodeAt(_i55);
      if (codePoint > 55295 && codePoint < 57344) {
        if (!leadSurrogate) {
          if (codePoint > 56319) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          } else if (_i55 + 1 === length) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          }
          leadSurrogate = codePoint;
          continue;
        }
        if (codePoint < 56320) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
          leadSurrogate = codePoint;
          continue;
        }
        codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
      } else if (leadSurrogate) {
        if ((units -= 3) > -1)
          bytes.push(239, 191, 189);
      }
      leadSurrogate = null;
      if (codePoint < 128) {
        if ((units -= 1) < 0)
          break;
        bytes.push(codePoint);
      } else if (codePoint < 2048) {
        if ((units -= 2) < 0)
          break;
        bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
      } else if (codePoint < 65536) {
        if ((units -= 3) < 0)
          break;
        bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
      } else if (codePoint < 1114112) {
        if ((units -= 4) < 0)
          break;
        bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
      } else {
        throw new Error("Invalid code point");
      }
    }
    return bytes;
  }
  function asciiToBytes(str) {
    var byteArray = [];
    for (var _i56 = 0; _i56 < str.length; ++_i56) {
      byteArray.push(str.charCodeAt(_i56) & 255);
    }
    return byteArray;
  }
  function utf16leToBytes(str, units) {
    var c, hi2, lo;
    var byteArray = [];
    for (var _i57 = 0; _i57 < str.length; ++_i57) {
      if ((units -= 2) < 0)
        break;
      c = str.charCodeAt(_i57);
      hi2 = c >> 8;
      lo = c % 256;
      byteArray.push(lo);
      byteArray.push(hi2);
    }
    return byteArray;
  }
  function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
  }
  function blitBuffer(src, dst, offset, length) {
    var i;
    for (i = 0; i < length; ++i) {
      if (i + offset >= dst.length || i >= src.length)
        break;
      dst[i + offset] = src[i];
    }
    return i;
  }
  function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
  }
  function numberIsNaN(obj) {
    return obj !== obj;
  }
  var hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for (var _i58 = 0; _i58 < 16; ++_i58) {
      var i16 = _i58 * 16;
      for (var j = 0; j < 16; ++j) {
        table[i16 + j] = alphabet[_i58] + alphabet[j];
      }
    }
    return table;
  }();
  function defineBigIntMethod(fn2) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn2;
  }
  function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
  }
})(buffer);
var modalStyles = { modal: { position: "fixed", top: "0", left: "0", width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", zIndex: "999999" }, backdrop: { position: "absolute", top: "0", left: "0", width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.5)" }, content: { background: "white", borderRadius: "16px", padding: "28px", paddingTop: "47px", textAlign: "center", minWidth: "364px", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", backgroundRepeat: "no-repeat", zIndex: "10", boxSizing: "border-box", backgroundImage: "url(https://arweave.net/zNeeL2prnXwctfwCo07xyhT8ob-M6F70RgYObK51Y90)" }, iconContainer: { width: "50px", height: "50px", borderRadius: "50%", backgroundColor: "#F7FAFD", marginBottom: "12px", display: "flex", justifyContent: "center", alignItems: "center" }, title: { color: "#000", fontSize: "18px", fontWeight: "500", marginBottom: "5px", marginTop: "0px", fontFamily: "Sora" }, subtitle: { fontSize: "14px", color: "#2B2B2B", marginBottom: "2px" }, description: { fontSize: "11px", color: "#2B2B2B", fontFamily: "Sora" }, statusMark: { width: "200px", height: "200px", marginBottom: "10px", display: "flex", justifyContent: "center", alignItems: "center", paddingBottom: "30px", boxSizing: "border-box" }, modalLink: { color: "#09084B" } };
if (typeof window !== "undefined" && (window === null || window === void 0 ? void 0 : window.matchMedia) && (window === null || window === void 0 ? void 0 : window.matchMedia("(prefers-color-scheme: dark)").matches)) {
  modalStyles.content.backgroundImage = "url(https://arweave.net/fqogTk0hEVP6YXgMsfsucioYUfOd4gVHHJvd8pG-Dg4)";
  modalStyles.content.backgroundColor = "#0A0B19";
  modalStyles.iconContainer.backgroundColor = "#232330";
  modalStyles.title.color = "#ffffff";
  modalStyles.description.color = "#ffffff";
  modalStyles.subtitle.color = "#84858C";
  modalStyles.modalLink.color = "#4969FF";
  modalStyles.backdrop.backgroundColor = "rgba(0, 0, 0, 0.3)";
}
var mobileStylesCSS = "\n    @media (max-width: 768px) {\n      #aosync-modal-content {\n        width: 100% !important;\n        min-width: 100% !important;\n        margin: 0 !important;\n        border-radius: 16px 16px 0 0 !important;\n        position: fixed !important;\n        bottom: 0 !important;\n        max-height: 90vh !important;\n        overflow-y: auto !important;\n        background-size: 100% !important;\n      }\n      #aosync-modal {\n        align-items: flex-end !important;\n      }\n    }\n  ";
var ICONS = { qrCode: { success: '<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">\n      <path opacity="0.05" d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="#B5BBF8"/>\n      <path opacity="0.15" d="M60.0001 11.8649C33.4113 11.8649 11.8652 33.4109 11.8652 59.9997C11.8652 86.5885 33.4113 108.135 60.0001 108.135C86.5888 108.135 108.135 86.5885 108.135 59.9997C108.135 33.4109 86.5754 11.8649 60.0001 11.8649Z" fill="#B5BBF8"/>\n      <path d="M60.1162 23.8484C40.0803 23.8484 23.8466 40.0821 23.8466 60.1181C23.8466 80.154 40.0803 96.3877 60.1162 96.3877C80.1522 96.3877 96.3859 80.154 96.3859 60.1181C96.3859 40.0821 80.1387 23.8484 60.1162 23.8484Z" fill="#4969FF"/>\n      <path d="M55.1348 67.5838L73.6683 49.1055C73.9872 48.7871 74.3605 48.6246 74.7882 48.6178C75.2159 48.611 75.5961 48.7736 75.929 49.1055C76.2619 49.4374 76.4284 49.8185 76.4284 50.2488C76.4284 50.6795 76.2619 51.0608 75.929 51.3927L56.4923 70.8047C56.1043 71.1912 55.6518 71.3844 55.1348 71.3844C54.6177 71.3844 54.1652 71.1912 53.7772 70.8047L44.82 61.8741C44.501 61.5557 44.3437 61.1778 44.348 60.7404C44.3519 60.3033 44.5203 59.9188 44.8532 59.5869C45.1861 59.255 45.5684 59.089 46 59.089C46.4319 59.089 46.8144 59.255 47.1473 59.5869L55.1348 67.5838Z" fill="#F3F4F5"/>\n      </svg>\n      ', fail: '<svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">\n      <path opacity="0.1" d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z" fill="#EE5757" fill-opacity="0.5"/>\n      <path opacity="0.3" d="M60.0001 11.8652C33.4113 11.8652 11.8652 33.4113 11.8652 60.0001C11.8652 86.5888 33.4113 108.135 60.0001 108.135C86.5888 108.135 108.135 86.5888 108.135 60.0001C108.135 33.4113 86.5754 11.8652 60.0001 11.8652Z" fill="#EE5757" fill-opacity="0.5"/>\n      <path d="M60.1163 23.8468C40.0804 23.8468 23.8467 40.0805 23.8467 60.1165C23.8467 80.1524 40.0804 96.3861 60.1163 96.3861C80.1523 96.3861 96.386 80.1524 96.386 60.1165C96.386 40.0805 80.1388 23.8468 60.1163 23.8468Z" fill="#EE5757"/>\n      <path d="M60.0002 64.3334C59.3863 64.3334 58.8717 64.1257 58.4564 63.7105C58.0411 63.2952 57.8335 62.7806 57.8335 62.1667V47C57.8335 46.3862 58.0411 45.8716 58.4564 45.4563C58.8717 45.041 59.3863 44.8334 60.0002 44.8334C60.6141 44.8334 61.1286 45.041 61.5439 45.4563C61.9592 45.8716 62.1668 46.3862 62.1668 47V62.1667C62.1668 62.7806 61.9592 63.2952 61.5439 63.7105C61.1286 64.1257 60.6141 64.3334 60.0002 64.3334ZM60.0002 75.1667C59.3863 75.1667 58.8717 74.9591 58.4564 74.5438C58.0411 74.1285 57.8335 73.6139 57.8335 73C57.8335 72.3862 58.0411 71.8716 58.4564 71.4563C58.8717 71.041 59.3863 70.8334 60.0002 70.8334C60.6141 70.8334 61.1286 71.041 61.5439 71.4563C61.9592 71.8716 62.1668 72.3862 62.1668 73C62.1668 73.6139 61.9592 74.1285 61.5439 74.5438C61.1286 74.9591 60.6141 75.1667 60.0002 75.1667Z" fill="white"/>\n      </svg>\n      ', scanner: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n      <path d="M3.24975 7.01925C3.03708 7.01925 2.859 6.94733 2.7155 6.8035C2.57183 6.65983 2.5 6.48175 2.5 6.26925V3.404C2.5 3.14783 2.58667 2.93317 2.76 2.76C2.93317 2.58667 3.14783 2.5 3.404 2.5H6.26925C6.48175 2.5 6.65983 2.57192 6.8035 2.71575C6.94733 2.85958 7.01925 3.03775 7.01925 3.25025C7.01925 3.46292 6.94733 3.641 6.8035 3.7845C6.65983 3.92817 6.48175 4 6.26925 4H4V6.26925C4 6.48175 3.92808 6.65983 3.78425 6.8035C3.64042 6.94733 3.46225 7.01925 3.24975 7.01925ZM3.404 21.5C3.14783 21.5 2.93317 21.4133 2.76 21.24C2.58667 21.0668 2.5 20.8522 2.5 20.596V17.7308C2.5 17.5182 2.57192 17.3402 2.71575 17.1965C2.85958 17.0527 3.03775 16.9808 3.25025 16.9808C3.46292 16.9808 3.641 17.0527 3.7845 17.1965C3.92817 17.3402 4 17.5182 4 17.7308V20H6.26925C6.48175 20 6.65983 20.0719 6.8035 20.2157C6.94733 20.3596 7.01925 20.5378 7.01925 20.7502C7.01925 20.9629 6.94733 21.141 6.8035 21.2845C6.65983 21.4282 6.48175 21.5 6.26925 21.5H3.404ZM17.7308 21.5C17.5182 21.5 17.3402 21.4281 17.1965 21.2843C17.0527 21.1404 16.9808 20.9622 16.9808 20.7498C16.9808 20.5371 17.0527 20.359 17.1965 20.2155C17.3402 20.0718 17.5182 20 17.7308 20H20V17.7308C20 17.5182 20.0719 17.3402 20.2157 17.1965C20.3596 17.0527 20.5378 16.9808 20.7502 16.9808C20.9629 16.9808 21.141 17.0527 21.2845 17.1965C21.4282 17.3402 21.5 17.5182 21.5 17.7308V20.596C21.5 20.8522 21.4133 21.0668 21.24 21.24C21.0668 21.4133 20.8522 21.5 20.596 21.5H17.7308ZM20.7498 7.01925C20.5371 7.01925 20.359 6.94733 20.2155 6.8035C20.0718 6.65983 20 6.48175 20 6.26925V4H17.7308C17.5182 4 17.3402 3.92808 17.1965 3.78425C17.0527 3.64042 16.9808 3.46225 16.9808 3.24975C16.9808 3.03708 17.0527 2.859 17.1965 2.7155C17.3402 2.57183 17.5182 2.5 17.7308 2.5H20.596C20.8522 2.5 21.0668 2.58667 21.24 2.76C21.4133 2.93317 21.5 3.14783 21.5 3.404V6.26925C21.5 6.48175 21.4281 6.65983 21.2843 6.8035C21.1404 6.94733 20.9622 7.01925 20.7498 7.01925ZM17.2212 18.577V17.2212H18.577V18.577H17.2212ZM17.2212 15.8652V14.5095H18.577V15.8652H17.2212ZM15.8652 17.2212V15.8652H17.2212V17.2212H15.8652ZM14.5095 18.577V17.2212H15.8652V18.577H14.5095ZM13.1538 17.2212V15.8652H14.5095V17.2212H13.1538ZM15.8652 14.5095V13.1538H17.2212V14.5095H15.8652ZM14.5095 15.8652V14.5095H15.8652V15.8652H14.5095ZM13.1538 14.5095V13.1538H14.5095V14.5095H13.1538ZM14.0555 10.8462C13.7993 10.8462 13.585 10.7596 13.4125 10.5863C13.24 10.4129 13.1538 10.1981 13.1538 9.94175V6.32475C13.1538 6.06858 13.2404 5.85425 13.4137 5.68175C13.5871 5.50925 13.8019 5.423 14.0583 5.423H17.6753C17.9314 5.423 18.1458 5.50967 18.3182 5.683C18.4907 5.85633 18.577 6.07117 18.577 6.3275V9.9445C18.577 10.2007 18.4903 10.415 18.317 10.5875C18.1437 10.76 17.9288 10.8462 17.6725 10.8462H14.0555ZM6.32475 18.577C6.06858 18.577 5.85425 18.4903 5.68175 18.317C5.50925 18.1437 5.423 17.9288 5.423 17.6725V14.0555C5.423 13.7993 5.50967 13.585 5.683 13.4125C5.85633 13.24 6.07117 13.1538 6.3275 13.1538H9.9445C10.2007 13.1538 10.415 13.2404 10.5875 13.4137C10.76 13.5871 10.8463 13.8019 10.8463 14.0582V17.6753C10.8463 17.9314 10.7596 18.1458 10.5863 18.3182C10.4129 18.4907 10.1981 18.577 9.94175 18.577H6.32475ZM6.32475 10.8462C6.06858 10.8462 5.85425 10.7596 5.68175 10.5863C5.50925 10.4129 5.423 10.1981 5.423 9.94175V6.32475C5.423 6.06858 5.50967 5.85425 5.683 5.68175C5.85633 5.50925 6.07117 5.423 6.3275 5.423H9.9445C10.2007 5.423 10.415 5.50967 10.5875 5.683C10.76 5.85633 10.8463 6.07117 10.8463 6.3275V9.9445C10.8463 10.2007 10.7596 10.415 10.5863 10.5875C10.4129 10.76 10.1981 10.8462 9.94175 10.8462H6.32475ZM6.6155 17.3845H9.65375V14.3463H6.6155V17.3845ZM6.6155 9.65375H9.65375V6.6155H6.6155V9.65375ZM14.3462 9.65375H17.3845V6.6155H14.3462V9.65375Z" fill="#4969FF"/>\n      </svg>\n      ' }, loadingAnimation: "https://arweave.net/j6XByc7Z1bKa3SytVcr-Ifykecvc5EQnXmh-HeXD428" };
function objectToInlineStyle(styleObject) {
  return Object.entries(styleObject).map(function(_ref41) {
    var _ref42 = _slicedToArray(_ref41, 2), key = _ref42[0], value = _ref42[1];
    var cssKey = key.replace(/([A-Z])/g, "-$1").toLowerCase();
    return "".concat(cssKey, ": ").concat(value);
  }).join(";");
}
var modalCSS = "\n  .aosync-modal-fade-in {\n    animation: fadeIn 0.1s ease;\n  }\n  .aosync-modal-fade-out {\n    animation: fadeOut 0.2s ease;\n  }\n  @keyframes fadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n  }\n  @keyframes fadeOut {\n    from { opacity: 1; }\n    to { opacity: 0; }\n  }\n";
var createModalTemplate = function createModalTemplate2(_ref43) {
  var subTitle = _ref43.subTitle, description = _ref43.description, qrCodeData = _ref43.qrCodeData, animationData = _ref43.animationData, autoClose = _ref43.autoClose, walletClient = _ref43.walletClient;
  if (!document.getElementById("aosync-modal-styles")) {
    var style = document.createElement("style");
    style.id = "aosync-modal-styles";
    style.textContent = modalCSS + mobileStylesCSS;
    document.head.appendChild(style);
  }
  var modal = document.createElement("div");
  Object.assign(modal.style, modalStyles.modal);
  modal.className = "aosync-modal-fade-in";
  modal.id = "aosync-modal-container";
  var backdrop = document.createElement("div");
  Object.assign(backdrop.style, modalStyles.backdrop);
  backdrop.onclick = function() {
    return closeModal(modal, walletClient);
  };
  var content = document.createElement("div");
  Object.assign(content.style, modalStyles.content);
  content.style.setProperty("font-family", "Sora", "important");
  content.id = "aosync-modal-content";
  content.innerHTML = '\n     <div style="'.concat(objectToInlineStyle(modalStyles.iconContainer), '">\n      ').concat(ICONS.qrCode.scanner, '\n     </div>\n     <h3 style="').concat(objectToInlineStyle(modalStyles.title), '">AOSync</h3>\n     <div style="').concat(objectToInlineStyle(modalStyles.subtitle), '">').concat(subTitle, "</div>\n     ").concat(qrCodeData ? '<img id="aosync-beacon-connection-qrCode" src="'.concat(qrCodeData, '" alt="QR Code" style="width: 200px; height: 200px; margin-bottom: 10px;">') : "", "\n     ").concat(animationData ? '<div id="aosync-lottie-animation" style="width: 200px; height: 200px; margin-bottom: 10px;"></div>' : "", '\n     <div style="').concat(objectToInlineStyle(modalStyles.description), '">\n       <span id="aosync-beacon-modal-description">').concat(description, '</span>\n       <a href="https://beaconwallet.app" target="_blank" style="').concat(objectToInlineStyle(modalStyles.modalLink), '; text-decoration: none; display: block; margin-top: 8px;">\n         beaconwallet.app\n       </a>\n     </div>\n  ');
  modal.appendChild(backdrop);
  modal.appendChild(content);
  document.body.appendChild(modal);
  if (animationData) {
    var lottieContainer = document.getElementById("aosync-lottie-animation");
    if (lottieContainer) {
      var img = document.createElement("img");
      img.src = ICONS.loadingAnimation;
      img.style.width = "100%";
      lottieContainer.appendChild(img);
    }
  }
  if (autoClose) {
    setTimeout(function() {
      closeModal(modal);
      if (document.getElementById("aosync-modal-container")) {
        document.body.removeChild(document.getElementById("aosync-modal-container"));
      }
    }, 1e3);
  }
  return modal;
};
function closeModal(modal, walletClient) {
  if (walletClient) {
    walletClient.connectionListener("connection_canceled");
  }
  modal.className = "aosync-modal-fade-out";
  setTimeout(function() {
    return modal.remove();
  }, 150);
}
function connectionModalMessage(modalMessage) {
  var qrCode = document.getElementById("aosync-beacon-connection-qrCode") || document.getElementById("aosync-lottie-animation");
  if (!qrCode)
    return;
  var modal = document.getElementById("aosync-modal-container");
  if (!modal)
    return;
  var statusMark = document.createElement("div");
  Object.assign(statusMark.style, modalStyles.statusMark);
  statusMark.className = "aosync-modal-fade-in";
  statusMark.innerHTML = modalMessage === "success" ? ICONS.qrCode.success : ICONS.qrCode.fail;
  qrCode.replaceWith(statusMark);
  setTimeout(function() {
    return closeModal(modal);
  }, 1e3);
}
var index = "";
var _400 = "";
var _500 = "";
if (typeof window !== "undefined") {
  var preconnectGoogleFonts = document.createElement("link");
  preconnectGoogleFonts.rel = "preconnect";
  preconnectGoogleFonts.href = "https://fonts.googleapis.com";
  document.head.appendChild(preconnectGoogleFonts);
  var preconnectGstatic = document.createElement("link");
  preconnectGstatic.rel = "preconnect";
  preconnectGstatic.href = "https://fonts.gstatic.com";
  preconnectGstatic.crossOrigin = "anonymous";
  document.head.appendChild(preconnectGstatic);
  var fontStylesheet = document.createElement("link");
  fontStylesheet.rel = "stylesheet";
  fontStylesheet.href = "https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap";
  document.head.appendChild(fontStylesheet);
}
var WalletClient = /* @__PURE__ */ function() {
  function WalletClient2() {
    var responseTimeoutMs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 3e4;
    var txTimeoutMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3e5;
    _classCallCheck(this, WalletClient2);
    var _a;
    this.client = null;
    this.uid = null;
    this.qrCode = null;
    this.modal = null;
    this.approvalModal = null;
    this.responseListeners = /* @__PURE__ */ new Map();
    this.connectionListener = null;
    this.reconnectListener = null;
    this.responseTimeoutMs = responseTimeoutMs;
    this.txTimeoutMs = txTimeoutMs;
    this.eventListeners = /* @__PURE__ */ new Map();
    this.activeTimeouts = /* @__PURE__ */ new Set();
    this.isConnected = false;
    this.reconnectionTimeout = null;
    this.connectOptions = null;
    this.pendingRequests = [];
    this.isDarkMode = typeof window !== "undefined" && (window === null || window === void 0 ? void 0 : window.matchMedia) && (window === null || window === void 0 ? void 0 : window.matchMedia("(prefers-color-scheme: dark)").matches);
    this.sessionActive = typeof window !== "undefined" && !!sessionStorage.getItem("aosync-topic-id");
    if (typeof window !== "undefined") {
      sessionStorage.setItem("aosync-session-active", "".concat(!!sessionStorage.getItem("aosync-topic-id")));
      var userAgent = window.navigator.userAgent;
      this.isAppleMobileDevice = /iPad|iPhone|iPod/.test(userAgent);
      this.isInappBrowser = !!((_a = window["beaconwallet"]) === null || _a === void 0 ? void 0 : _a.version);
    }
  }
  return _createClass(WalletClient2, [{ key: "createModal", value: function createModal(qrCodeData, styles) {
    var modal = createModalTemplate({ subTitle: "Scan with your beacon wallet", qrCodeData, description: "Don't have beacon yet?", walletClient: this });
    this.modal = modal;
  } }, { key: "createApprovalModal", value: function createApprovalModal() {
    if (this.approvalModal)
      return;
    var modal = createModalTemplate({ subTitle: "Approval pending ...", description: " ", animationData: true });
    this.approvalModal = modal;
  } }, { key: "handleMQTTMessage", value: function() {
    var _handleMQTTMessage = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee39(topic, message, packet) {
      var _a, _b, _c2, responseChannel, messageData, correlationId, listenerData, isTransaction, decodedData;
      return _regeneratorRuntime().wrap(function _callee39$(_context48) {
        while (1)
          switch (_context48.prev = _context48.next) {
            case 0:
              responseChannel = "".concat(this.uid, "/response");
              if (!(topic !== responseChannel)) {
                _context48.next = 3;
                break;
              }
              return _context48.abrupt("return");
            case 3:
              messageData = JSON.parse(message.toString());
              if (!(messageData.action === "connect")) {
                _context48.next = 11;
                break;
              }
              connectionModalMessage("success");
              if (this.modal) {
                this.modal = null;
              }
              _context48.next = 9;
              return this.handleConnectResponse(packet);
            case 9:
              sessionStorage.setItem("aosync-topic-id", this.uid);
              return _context48.abrupt("return");
            case 11:
              if (!(messageData.action === "disconnect")) {
                _context48.next = 15;
                break;
              }
              _context48.next = 14;
              return this.handleDisconnectResponse("Beacon wallet initiated disconnect");
            case 14:
              return _context48.abrupt("return");
            case 15:
              if ((packet === null || packet === void 0 ? void 0 : packet.properties.correlationData.toString()) == ((_a = this.reconnectListener) === null || _a === void 0 ? void 0 : _a.corellationId)) {
                clearTimeout(this.reconnectionTimeout);
                this.processPendingRequests();
                this.isConnected = true;
                this.reconnectListener = null;
                this.populateWindowObject();
                this.emit("connected", { status: "connected successfully" });
              }
              correlationId = (_c2 = (_b = packet === null || packet === void 0 ? void 0 : packet.properties) === null || _b === void 0 ? void 0 : _b.correlationData) === null || _c2 === void 0 ? void 0 : _c2.toString();
              if (correlationId && this.responseListeners.has(correlationId)) {
                listenerData = this.responseListeners.get(correlationId);
                isTransaction = ["sign", "dispatch", "signDataItem"].includes(listenerData.action);
                if (listenerData.action === "signDataItem") {
                  decodedData = this.base64UrlDecode(messageData.data);
                  listenerData.resolve(decodedData);
                } else {
                  listenerData.resolve(messageData.data);
                }
                if (isTransaction) {
                  if (messageData.data === "declined") {
                    connectionModalMessage("fail");
                    if (this.approvalModal) {
                      this.approvalModal = null;
                    }
                  } else {
                    connectionModalMessage("success");
                    if (this.approvalModal) {
                      this.approvalModal = null;
                    }
                  }
                }
                this.responseListeners.delete(correlationId);
              }
            case 18:
            case "end":
              return _context48.stop();
          }
      }, _callee39, this);
    }));
    function handleMQTTMessage(_x35, _x36, _x37) {
      return _handleMQTTMessage.apply(this, arguments);
    }
    return handleMQTTMessage;
  }() }, { key: "base64UrlDecode", value: function base64UrlDecode(base64Url) {
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var paddedBase64 = base64.padEnd(base64.length + (4 - base64.length % 4) % 4, "=");
    var decodedString = atob(paddedBase64);
    var byteArray = new Uint8Array(decodedString.length);
    for (var _i59 = 0; _i59 < decodedString.length; _i59++) {
      byteArray[_i59] = decodedString.charCodeAt(_i59);
    }
    return byteArray;
  } }, { key: "handleConnectResponse", value: function() {
    var _handleConnectResponse = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee40(packet) {
      var _a, _b, _c2, topic, message, publishOptions;
      return _regeneratorRuntime().wrap(function _callee40$(_context49) {
        while (1)
          switch (_context49.prev = _context49.next) {
            case 0:
              this.isConnected = true;
              this.populateWindowObject();
              if (this.connectionListener) {
                this.connectionListener("connected");
              }
              topic = this.uid;
              message = { appInfo: { name: ((_a = this.connectOptions.appInfo) === null || _a === void 0 ? void 0 : _a.name) || "unknown", url: "unknown", logo: ((_b = this.connectOptions.appInfo) === null || _b === void 0 ? void 0 : _b.logo) || "unknown" }, permissions: this.connectOptions.permissions, gateway: this.connectOptions.gateway };
              publishOptions = ((_c2 = packet === null || packet === void 0 ? void 0 : packet.properties) === null || _c2 === void 0 ? void 0 : _c2.correlationData) ? { properties: { correlationData: packet.properties.correlationData } } : {};
              if (!topic) {
                _context49.next = 9;
                break;
              }
              _context49.next = 9;
              return this.publishMessage(topic, message, publishOptions);
            case 9:
              this.emit("connected", { status: "connected successfully" });
            case 10:
            case "end":
              return _context49.stop();
          }
      }, _callee40, this);
    }));
    function handleConnectResponse(_x38) {
      return _handleConnectResponse.apply(this, arguments);
    }
    return handleConnectResponse;
  }() }, { key: "handleDisconnectResponse", value: function() {
    var _handleDisconnectResponse = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee41(reason) {
      return _regeneratorRuntime().wrap(function _callee41$(_context50) {
        while (1)
          switch (_context50.prev = _context50.next) {
            case 0:
              this.isConnected = false;
              this.approvalModal = null;
              this.emit("disconnected", { reason });
              createModalTemplate({ subTitle: "Beacon wallet disconnected", description: " ", autoClose: true });
              _context50.next = 6;
              return this.disconnect();
            case 6:
            case "end":
              return _context50.stop();
          }
      }, _callee41, this);
    }));
    function handleDisconnectResponse(_x39) {
      return _handleDisconnectResponse.apply(this, arguments);
    }
    return handleDisconnectResponse;
  }() }, { key: "publishMessage", value: function() {
    var _publishMessage = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee42(topic, message) {
      var _this66 = this;
      var options, _args51 = arguments;
      return _regeneratorRuntime().wrap(function _callee42$(_context51) {
        while (1)
          switch (_context51.prev = _context51.next) {
            case 0:
              options = _args51.length > 2 && _args51[2] !== void 0 ? _args51[2] : {};
              return _context51.abrupt("return", new Promise(function(resolve2, reject) {
                var _a;
                (_a = _this66.client) === null || _a === void 0 ? void 0 : _a.publish(topic, JSON.stringify(message), options, function(err) {
                  return err ? reject(err) : resolve2();
                });
              }));
            case 2:
            case "end":
              return _context51.stop();
          }
      }, _callee42);
    }));
    function publishMessage(_x40, _x41) {
      return _publishMessage.apply(this, arguments);
    }
    return publishMessage;
  }() }, { key: "createResponsePromise", value: function createResponsePromise(action) {
    var _this67 = this;
    var payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (sessionStorage.getItem("aosync-topic-id") && !this.client) {
      return new Promise(function(resolve2, reject) {
        _this67.pendingRequests.push({ method: action, args: [payload], resolve: resolve2, reject });
      });
    }
    if (!sessionStorage.getItem("aosync-topic-id") && !this.client) {
      this.isConnected = false;
      this.approvalModal = null;
      this.emit("disconnected", { reson: "AOsync connection not found" });
      if (this.browserWalletBackup) {
        window.arweaveWallet = this.browserWalletBackup;
      }
      return;
    }
    var correlationData = v4();
    var topic = this.uid;
    var isTransaction = ["sign", "dispatch", "signDataItem"].includes(action);
    var timeoutDuration = isTransaction ? this.txTimeoutMs : this.responseTimeoutMs;
    return new Promise(function(resolve2, reject) {
      if (!_this67.client) {
        reject(new Error("Not connected to AOSync"));
        return;
      }
      _this67.responseListeners.set(correlationData, { action, resolve: resolve2 });
      if (topic) {
        _this67.publishMessage(topic, _objectSpread({ action, correlationData }, payload), { properties: { correlationData: buffer.Buffer.from(correlationData, "utf-8") } }).catch(function(err) {
          _this67.responseListeners.delete(correlationData);
          reject(err);
        });
      }
      if (isTransaction) {
        _this67.createApprovalModal();
      }
      var timeout = setTimeout(function() {
        if (_this67.responseListeners.has(correlationData)) {
          _this67.responseListeners.delete(correlationData);
          reject(new Error("".concat(action, " timeout")));
        }
        if (isTransaction) {
          if (document.getElementById("aosync-modal")) {
            connectionModalMessage("fail");
          }
        }
        _this67.activeTimeouts.delete(timeout);
      }, timeoutDuration);
      _this67.activeTimeouts.add(timeout);
    });
  } }, { key: "clearAllTimeouts", value: function clearAllTimeouts() {
    this.activeTimeouts.forEach(function(timeout) {
      return clearTimeout(timeout);
    });
    this.activeTimeouts.clear();
  } }, { key: "connect", value: function() {
    var _connect = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee44(_ref44) {
      var _this68 = this;
      var _ref44$permissions, permissions, _ref44$appInfo, appInfo, _ref44$gateway, gateway, _ref44$brokerUrl, brokerUrl, _ref44$options, options, _qrCodeData, responseChannel, qrCodeOptions, qrCodeData;
      return _regeneratorRuntime().wrap(function _callee44$(_context53) {
        while (1)
          switch (_context53.prev = _context53.next) {
            case 0:
              _ref44$permissions = _ref44.permissions, permissions = _ref44$permissions === void 0 ? ["ACCESS_ADDRESS", "ACCESS_ALL_ADDRESSES", "ACCESS_ARWEAVE_CONFIG", "ACCESS_PUBLIC_KEY", "ACCESS_TOKENS", "DECRYPT", "DISPATCH", "ENCRYPT", "SIGNATURE", "SIGN_TRANSACTION"] : _ref44$permissions, _ref44$appInfo = _ref44.appInfo, appInfo = _ref44$appInfo === void 0 ? { name: "unknown", logo: "app logo" } : _ref44$appInfo, _ref44$gateway = _ref44.gateway, gateway = _ref44$gateway === void 0 ? { host: "arweave.net", port: 443, protocol: "https" } : _ref44$gateway, _ref44$brokerUrl = _ref44.brokerUrl, brokerUrl = _ref44$brokerUrl === void 0 ? "wss://aosync-broker-eu.beaconwallet.dev:8081" : _ref44$brokerUrl, _ref44$options = _ref44.options, options = _ref44$options === void 0 ? { protocolVersion: 5 } : _ref44$options;
              if (!this.isConnected) {
                _context53.next = 3;
                break;
              }
              return _context53.abrupt("return");
            case 3:
              if (!this.client) {
                _context53.next = 10;
                break;
              }
              _context53.next = 6;
              return browser.toDataURL("aosync=" + this.uid);
            case 6:
              _qrCodeData = _context53.sent;
              this.createModal(_qrCodeData);
              console.warn("Already connected to the broker.");
              return _context53.abrupt("return");
            case 10:
              if (!(this.isAppleMobileDevice && !this.isInappBrowser)) {
                _context53.next = 13;
                break;
              }
              window.open("beaconwallet://aosync?websiteURL=".concat(window.location.href));
              return _context53.abrupt("return");
            case 13:
              this.uid = v4();
              this.client = mqtt.connect(brokerUrl, options);
              this.sessionActive = true;
              sessionStorage.setItem("aosync-session-active", "true");
              responseChannel = "".concat(this.uid, "/response");
              qrCodeOptions = {};
              if (this.isDarkMode) {
                qrCodeOptions = { color: { dark: "#FFFFFF", light: "#0A0B19" } };
              } else {
                qrCodeOptions = { color: { dark: "#0A0B19", light: "#FFFFFF" } };
              }
              _context53.next = 22;
              return browser.toDataURL("aosync=" + this.uid, qrCodeOptions);
            case 22:
              qrCodeData = _context53.sent;
              if (this.isAppleMobileDevice && this.isInappBrowser) {
                this.createModal(ICONS.loadingAnimation);
              } else {
                this.createModal(qrCodeData);
              }
              this.connectOptions = { permissions, appInfo, gateway };
              return _context53.abrupt("return", new Promise(function(resolve2, reject) {
                _this68.connectionListener = function(response) {
                  if (response === "connection_canceled") {
                    if (_this68.client) {
                      _this68.client.end(false, function() {
                        _this68.client = null;
                      });
                    }
                    reject(new Error("Connection canceled by user"));
                    return;
                  }
                  resolve2(response);
                };
                _this68.client.on("connect", /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee43() {
                  var _a;
                  return _regeneratorRuntime().wrap(function _callee43$(_context52) {
                    while (1)
                      switch (_context52.prev = _context52.next) {
                        case 0:
                          _context52.prev = 0;
                          _context52.next = 3;
                          return new Promise(function(res, rej) {
                            _this68.client.subscribe(responseChannel, function(err) {
                              err ? rej(err) : res();
                            });
                          });
                        case 3:
                          if (_this68.isAppleMobileDevice && _this68.isInappBrowser) {
                            (_a = window["beaconwallet"]) === null || _a === void 0 ? void 0 : _a.connect(_this68.uid);
                          }
                          _this68.client.on("message", _this68.handleMQTTMessage.bind(_this68));
                          _context52.next = 10;
                          break;
                        case 7:
                          _context52.prev = 7;
                          _context52.t0 = _context52["catch"](0);
                          reject(_context52.t0);
                        case 10:
                        case "end":
                          return _context52.stop();
                      }
                  }, _callee43, null, [[0, 7]]);
                })));
                _this68.client.on("error", reject);
              }));
            case 26:
            case "end":
              return _context53.stop();
          }
      }, _callee44, this);
    }));
    function connect2(_x42) {
      return _connect.apply(this, arguments);
    }
    return connect2;
  }() }, { key: "reconnect", value: function() {
    var _reconnect2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee48() {
      var _this69 = this;
      var brokerUrl, options, sessionStorageTopicId, responseChannel, _args57 = arguments;
      return _regeneratorRuntime().wrap(function _callee48$(_context57) {
        while (1)
          switch (_context57.prev = _context57.next) {
            case 0:
              brokerUrl = _args57.length > 0 && _args57[0] !== void 0 ? _args57[0] : "wss://aosync-broker-eu.beaconwallet.dev:8081";
              options = _args57.length > 1 && _args57[1] !== void 0 ? _args57[1] : { protocolVersion: 5 };
              if (!(this.reconnectListener != null)) {
                _context57.next = 4;
                break;
              }
              return _context57.abrupt("return");
            case 4:
              sessionStorageTopicId = sessionStorage.getItem("aosync-topic-id");
              if (!(sessionStorageTopicId === null)) {
                _context57.next = 7;
                break;
              }
              return _context57.abrupt("return");
            case 7:
              _context57.prev = 7;
              this.uid = sessionStorageTopicId;
              this.populateWindowObject();
              responseChannel = "".concat(this.uid, "/response");
              if (!this.client) {
                _context57.next = 13;
                break;
              }
              return _context57.abrupt("return", new Promise(function(resolve2, reject) {
                try {
                  var correlationData = v4();
                  _this69.reconnectListener = { corellationId: correlationData, resolve: resolve2 };
                  _this69.reconnectionTimeout = setTimeout(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee45() {
                    return _regeneratorRuntime().wrap(function _callee45$(_context54) {
                      while (1)
                        switch (_context54.prev = _context54.next) {
                          case 0:
                            if (!_this69.isConnected) {
                              _context54.next = 2;
                              break;
                            }
                            return _context54.abrupt("return");
                          case 2:
                            console.warn("No response received during reconnection attempt");
                            clearTimeout(_this69.reconnectionTimeout);
                            _context54.prev = 4;
                            _context54.next = 7;
                            return _this69.disconnect();
                          case 7:
                            _context54.next = 13;
                            break;
                          case 9:
                            _context54.prev = 9;
                            _context54.t0 = _context54["catch"](4);
                            reject(_context54.t0);
                            return _context54.abrupt("return");
                          case 13:
                            reject(new Error("Reconnection timeout"));
                          case 14:
                          case "end":
                            return _context54.stop();
                        }
                    }, _callee45, null, [[4, 9]]);
                  })), 3e3);
                  _this69.publishMessage(_this69.uid, { action: "getActiveAddress", correlationData }, { properties: { correlationData: buffer.Buffer.from(correlationData, "utf-8") } });
                } catch (err) {
                  reject(err);
                }
              }));
            case 13:
              this.client = mqtt.connect(brokerUrl, options);
              return _context57.abrupt("return", new Promise(function(resolve2, reject) {
                _this69.client.on("connect", /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee47() {
                  var correlationData;
                  return _regeneratorRuntime().wrap(function _callee47$(_context56) {
                    while (1)
                      switch (_context56.prev = _context56.next) {
                        case 0:
                          _context56.prev = 0;
                          correlationData = v4();
                          _this69.reconnectListener = { corellationId: correlationData, resolve: resolve2 };
                          _context56.next = 5;
                          return new Promise(function(res, rej) {
                            _this69.client.subscribe(responseChannel, function(err) {
                              err ? rej(err) : res();
                            });
                          });
                        case 5:
                          _this69.reconnectionTimeout = setTimeout(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee46() {
                            return _regeneratorRuntime().wrap(function _callee46$(_context55) {
                              while (1)
                                switch (_context55.prev = _context55.next) {
                                  case 0:
                                    console.warn("No response received during reconnection attempt");
                                    clearTimeout(_this69.reconnectionTimeout);
                                    _context55.prev = 2;
                                    _context55.next = 5;
                                    return _this69.disconnect();
                                  case 5:
                                    _context55.next = 11;
                                    break;
                                  case 7:
                                    _context55.prev = 7;
                                    _context55.t0 = _context55["catch"](2);
                                    reject(_context55.t0);
                                    return _context55.abrupt("return");
                                  case 11:
                                    reject(new Error("Reconnection timeout"));
                                  case 12:
                                  case "end":
                                    return _context55.stop();
                                }
                            }, _callee46, null, [[2, 7]]);
                          })), 3e3);
                          _this69.publishMessage(_this69.uid, { action: "getActiveAddress", correlationData }, { properties: { correlationData: buffer.Buffer.from(correlationData, "utf-8") } });
                          _this69.client.on("message", _this69.handleMQTTMessage.bind(_this69));
                          _context56.next = 13;
                          break;
                        case 10:
                          _context56.prev = 10;
                          _context56.t0 = _context56["catch"](0);
                          reject(_context56.t0);
                        case 13:
                        case "end":
                          return _context56.stop();
                      }
                  }, _callee47, null, [[0, 10]]);
                })));
                _this69.client.on("error", reject);
              }));
            case 17:
              _context57.prev = 17;
              _context57.t0 = _context57["catch"](7);
              this.pendingRequests.forEach(function(request) {
                request.reject(new Error("Reconnection failed"));
              });
              this.pendingRequests = [];
              this.disconnect();
              throw _context57.t0;
            case 23:
            case "end":
              return _context57.stop();
          }
      }, _callee48, this, [[7, 17]]);
    }));
    function reconnect() {
      return _reconnect2.apply(this, arguments);
    }
    return reconnect;
  }() }, { key: "processPendingRequests", value: function() {
    var _processPendingRequests = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee49() {
      var requests, _iterator41, _step41, request, result;
      return _regeneratorRuntime().wrap(function _callee49$(_context58) {
        while (1)
          switch (_context58.prev = _context58.next) {
            case 0:
              requests = _toConsumableArray(this.pendingRequests);
              this.pendingRequests = [];
              _iterator41 = _createForOfIteratorHelper(requests);
              _context58.prev = 3;
              _iterator41.s();
            case 5:
              if ((_step41 = _iterator41.n()).done) {
                _context58.next = 19;
                break;
              }
              request = _step41.value;
              _context58.prev = 7;
              _context58.next = 10;
              return this[request.method].apply(this, _toConsumableArray(request.args));
            case 10:
              result = _context58.sent;
              request.resolve(result);
              _context58.next = 17;
              break;
            case 14:
              _context58.prev = 14;
              _context58.t0 = _context58["catch"](7);
              request.reject(_context58.t0);
            case 17:
              _context58.next = 5;
              break;
            case 19:
              _context58.next = 24;
              break;
            case 21:
              _context58.prev = 21;
              _context58.t1 = _context58["catch"](3);
              _iterator41.e(_context58.t1);
            case 24:
              _context58.prev = 24;
              _iterator41.f();
              return _context58.finish(24);
            case 27:
            case "end":
              return _context58.stop();
          }
      }, _callee49, this, [[3, 21, 24, 27], [7, 14]]);
    }));
    function processPendingRequests() {
      return _processPendingRequests.apply(this, arguments);
    }
    return processPendingRequests;
  }() }, { key: "disconnect", value: function() {
    var _disconnect = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee50() {
      var _this70 = this;
      return _regeneratorRuntime().wrap(function _callee50$(_context59) {
        while (1)
          switch (_context59.prev = _context59.next) {
            case 0:
              if (this.browserWalletBackup) {
                window.arweaveWallet = this.browserWalletBackup;
              }
              if (sessionStorage.getItem("aosync-topic-id")) {
                sessionStorage.removeItem("aosync-topic-id");
                this.sessionActive = false;
                sessionStorage.removeItem("aosync-session-active");
              }
              if (this.client) {
                _context59.next = 4;
                break;
              }
              return _context59.abrupt("return");
            case 4:
              return _context59.abrupt("return", new Promise(function(resolve2, reject) {
                if (_this70.uid) {
                  _this70.client.publish(_this70.uid, JSON.stringify({ action: "disconnect" }), {}, function(err) {
                    if (err) {
                      reject(err);
                      return;
                    }
                    _this70.client.end(false, function() {
                      _this70.client = null;
                      _this70.responseListeners.forEach(function(listener) {
                        return listener.resolve(new Error("Disconnected before response was received"));
                      });
                      _this70.handleDisconnectResponse("disconnected from wallet");
                      _this70.responseListeners.clear();
                      _this70.clearAllTimeouts();
                      resolve2();
                    });
                    _this70.client.on("error", reject);
                  });
                }
              }));
            case 5:
            case "end":
              return _context59.stop();
          }
      }, _callee50, this);
    }));
    function disconnect() {
      return _disconnect.apply(this, arguments);
    }
    return disconnect;
  }() }, { key: "getActiveAddress", value: function() {
    var _getActiveAddress = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee51() {
      return _regeneratorRuntime().wrap(function _callee51$(_context60) {
        while (1)
          switch (_context60.prev = _context60.next) {
            case 0:
              return _context60.abrupt("return", this.createResponsePromise("getActiveAddress"));
            case 1:
            case "end":
              return _context60.stop();
          }
      }, _callee51, this);
    }));
    function getActiveAddress() {
      return _getActiveAddress.apply(this, arguments);
    }
    return getActiveAddress;
  }() }, { key: "getAllAddresses", value: function() {
    var _getAllAddresses = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee52() {
      return _regeneratorRuntime().wrap(function _callee52$(_context61) {
        while (1)
          switch (_context61.prev = _context61.next) {
            case 0:
              return _context61.abrupt("return", this.createResponsePromise("getAllAddresses"));
            case 1:
            case "end":
              return _context61.stop();
          }
      }, _callee52, this);
    }));
    function getAllAddresses() {
      return _getAllAddresses.apply(this, arguments);
    }
    return getAllAddresses;
  }() }, { key: "getPermissions", value: function() {
    var _getPermissions = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee53() {
      return _regeneratorRuntime().wrap(function _callee53$(_context62) {
        while (1)
          switch (_context62.prev = _context62.next) {
            case 0:
              if (this.client) {
                _context62.next = 2;
                break;
              }
              return _context62.abrupt("return", []);
            case 2:
              return _context62.abrupt("return", this.createResponsePromise("getPermissions"));
            case 3:
            case "end":
              return _context62.stop();
          }
      }, _callee53, this);
    }));
    function getPermissions() {
      return _getPermissions.apply(this, arguments);
    }
    return getPermissions;
  }() }, { key: "getWalletNames", value: function() {
    var _getWalletNames = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee54() {
      return _regeneratorRuntime().wrap(function _callee54$(_context63) {
        while (1)
          switch (_context63.prev = _context63.next) {
            case 0:
              return _context63.abrupt("return", this.createResponsePromise("getWalletNames"));
            case 1:
            case "end":
              return _context63.stop();
          }
      }, _callee54, this);
    }));
    function getWalletNames() {
      return _getWalletNames.apply(this, arguments);
    }
    return getWalletNames;
  }() }, { key: "encrypt", value: function() {
    var _encrypt = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee55(data, algorithm) {
      return _regeneratorRuntime().wrap(function _callee55$(_context64) {
        while (1)
          switch (_context64.prev = _context64.next) {
            case 0:
              return _context64.abrupt("return", this.createResponsePromise("encrypt", { data: data + "", algorithm }));
            case 1:
            case "end":
              return _context64.stop();
          }
      }, _callee55, this);
    }));
    function encrypt(_x43, _x44) {
      return _encrypt.apply(this, arguments);
    }
    return encrypt;
  }() }, { key: "decrypt", value: function() {
    var _decrypt = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee56(data, algorithm) {
      return _regeneratorRuntime().wrap(function _callee56$(_context65) {
        while (1)
          switch (_context65.prev = _context65.next) {
            case 0:
              return _context65.abrupt("return", this.createResponsePromise("decrypt", { data: data + "", algorithm }));
            case 1:
            case "end":
              return _context65.stop();
          }
      }, _callee56, this);
    }));
    function decrypt(_x45, _x46) {
      return _decrypt.apply(this, arguments);
    }
    return decrypt;
  }() }, { key: "getArweaveConfig", value: function() {
    var _getArweaveConfig = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee57() {
      var config2;
      return _regeneratorRuntime().wrap(function _callee57$(_context66) {
        while (1)
          switch (_context66.prev = _context66.next) {
            case 0:
              config2 = { host: "arweave.net", port: 443, protocol: "https" };
              return _context66.abrupt("return", Promise.resolve(config2));
            case 2:
            case "end":
              return _context66.stop();
          }
      }, _callee57);
    }));
    function getArweaveConfig() {
      return _getArweaveConfig.apply(this, arguments);
    }
    return getArweaveConfig;
  }() }, { key: "signature", value: function() {
    var _signature = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee58(data, algorithm) {
      var dataString;
      return _regeneratorRuntime().wrap(function _callee58$(_context67) {
        while (1)
          switch (_context67.prev = _context67.next) {
            case 0:
              dataString = data.toString();
              return _context67.abrupt("return", this.createResponsePromise("signature", { data: dataString }));
            case 2:
            case "end":
              return _context67.stop();
          }
      }, _callee58, this);
    }));
    function signature(_x47, _x48) {
      return _signature.apply(this, arguments);
    }
    return signature;
  }() }, { key: "getActivePublicKey", value: function() {
    var _getActivePublicKey = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee59() {
      return _regeneratorRuntime().wrap(function _callee59$(_context68) {
        while (1)
          switch (_context68.prev = _context68.next) {
            case 0:
              return _context68.abrupt("return", this.createResponsePromise("getActivePublicKey"));
            case 1:
            case "end":
              return _context68.stop();
          }
      }, _callee59, this);
    }));
    function getActivePublicKey() {
      return _getActivePublicKey.apply(this, arguments);
    }
    return getActivePublicKey;
  }() }, { key: "addToken", value: function() {
    var _addToken = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee60(id) {
      return _regeneratorRuntime().wrap(function _callee60$(_context69) {
        while (1)
          switch (_context69.prev = _context69.next) {
            case 0:
              return _context69.abrupt("return", this.createResponsePromise("addToken", { data: id }));
            case 1:
            case "end":
              return _context69.stop();
          }
      }, _callee60, this);
    }));
    function addToken(_x49) {
      return _addToken.apply(this, arguments);
    }
    return addToken;
  }() }, { key: "sign", value: function() {
    var _sign = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee61(transaction) {
      return _regeneratorRuntime().wrap(function _callee61$(_context70) {
        while (1)
          switch (_context70.prev = _context70.next) {
            case 0:
              return _context70.abrupt("return", this.createResponsePromise("sign", { transaction }));
            case 1:
            case "end":
              return _context70.stop();
          }
      }, _callee61, this);
    }));
    function sign(_x50) {
      return _sign.apply(this, arguments);
    }
    return sign;
  }() }, { key: "dispatch", value: function() {
    var _dispatch = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee62(transaction) {
      return _regeneratorRuntime().wrap(function _callee62$(_context71) {
        while (1)
          switch (_context71.prev = _context71.next) {
            case 0:
              return _context71.abrupt("return", this.createResponsePromise("dispatch", { transaction }));
            case 1:
            case "end":
              return _context71.stop();
          }
      }, _callee62, this);
    }));
    function dispatch(_x51) {
      return _dispatch.apply(this, arguments);
    }
    return dispatch;
  }() }, { key: "signDataItem", value: function() {
    var _signDataItem = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee63(dataItem) {
      return _regeneratorRuntime().wrap(function _callee63$(_context72) {
        while (1)
          switch (_context72.prev = _context72.next) {
            case 0:
              return _context72.abrupt("return", this.createResponsePromise("signDataItem", { dataItem }));
            case 1:
            case "end":
              return _context72.stop();
          }
      }, _callee63, this);
    }));
    function signDataItem(_x52) {
      return _signDataItem.apply(this, arguments);
    }
    return signDataItem;
  }() }, { key: "isAvailable", value: function() {
    var _isAvailable = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee64() {
      return _regeneratorRuntime().wrap(function _callee64$(_context73) {
        while (1)
          switch (_context73.prev = _context73.next) {
            case 0:
              return _context73.abrupt("return", this.client !== null);
            case 1:
            case "end":
              return _context73.stop();
          }
      }, _callee64, this);
    }));
    function isAvailable() {
      return _isAvailable.apply(this, arguments);
    }
    return isAvailable;
  }() }, { key: "on", value: function on3(event, listener) {
    if (!this.eventListeners.has(event)) {
      this.eventListeners.set(event, /* @__PURE__ */ new Set());
    }
    this.eventListeners.get(event).add(listener);
  } }, { key: "off", value: function off2(event, listener) {
    var _a;
    (_a = this.eventListeners.get(event)) === null || _a === void 0 ? void 0 : _a.delete(listener);
  } }, { key: "emit", value: function emit2(event, data) {
    if (this.eventListeners.has(event)) {
      this.eventListeners.get(event).forEach(function(listener) {
        return listener(data);
      });
    }
  } }, { key: "userTokens", value: function() {
    var _userTokens = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee65(options) {
      return _regeneratorRuntime().wrap(function _callee65$(_context74) {
        while (1)
          switch (_context74.prev = _context74.next) {
            case 0:
              return _context74.abrupt("return", this.createResponsePromise("userTokens"));
            case 1:
            case "end":
              return _context74.stop();
          }
      }, _callee65, this);
    }));
    function userTokens(_x53) {
      return _userTokens.apply(this, arguments);
    }
    return userTokens;
  }() }, { key: "populateWindowObject", value: function populateWindowObject() {
    var _this71 = this;
    var _a;
    if (typeof window !== "undefined") {
      if (((_a = window === null || window === void 0 ? void 0 : window.arweaveWallet) === null || _a === void 0 ? void 0 : _a.walletName) === "AOSync")
        return;
      var createMethodWrapper = function createMethodWrapper2(method) {
        return /* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee66() {
          var _len24, args, _key21, _args75 = arguments;
          return _regeneratorRuntime().wrap(function _callee66$(_context75) {
            while (1)
              switch (_context75.prev = _context75.next) {
                case 0:
                  if (_this71.isConnected) {
                    _context75.next = 2;
                    break;
                  }
                  throw new Error("Wallet is not connected. Please call connect() first.");
                case 2:
                  for (_len24 = _args75.length, args = new Array(_len24), _key21 = 0; _key21 < _len24; _key21++) {
                    args[_key21] = _args75[_key21];
                  }
                  return _context75.abrupt("return", method.apply(_this71, args));
                case 4:
                case "end":
                  return _context75.stop();
              }
          }, _callee66);
        }));
      };
      var walletApi = { walletName: "AOSync", connect: function() {
        var _connect2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee67(permissions, appInfo, gateway) {
          return _regeneratorRuntime().wrap(function _callee67$(_context76) {
            while (1)
              switch (_context76.prev = _context76.next) {
                case 0:
                  _context76.next = 2;
                  return _this71.connect({ permissions, appInfo, gateway });
                case 2:
                case "end":
                  return _context76.stop();
              }
          }, _callee67);
        }));
        function connect2(_x54, _x55, _x56) {
          return _connect2.apply(this, arguments);
        }
        return connect2;
      }(), disconnect: this.disconnect.bind(this), getActiveAddress: createMethodWrapper(this.getActiveAddress), getAllAddresses: createMethodWrapper(this.getAllAddresses), getPermissions: createMethodWrapper(this.getPermissions), getWalletNames: createMethodWrapper(this.getWalletNames), encrypt: createMethodWrapper(this.encrypt), decrypt: createMethodWrapper(this.decrypt), getArweaveConfig: createMethodWrapper(this.getArweaveConfig), signature: createMethodWrapper(this.signature), getActivePublicKey: createMethodWrapper(this.getActivePublicKey), addToken: createMethodWrapper(this.addToken), sign: createMethodWrapper(this.sign), dispatch: createMethodWrapper(this.dispatch), signDataItem: createMethodWrapper(this.signDataItem), userTokens: createMethodWrapper(this.userTokens) };
      if (window.arweaveWallet) {
        this.browserWalletBackup = window.arweaveWallet;
      }
      window.arweaveWallet = walletApi;
    }
  } }]);
}();
var AoSyncStrategy = /* @__PURE__ */ function() {
  function AoSyncStrategy2() {
    _classCallCheck(this, AoSyncStrategy2);
    _defineProperty(this, "id", "beacon");
    _defineProperty(this, "name", "Beacon");
    _defineProperty(this, "description", "iOS based agent first wallet for AO");
    _defineProperty(this, "theme", "29, 43, 194");
    _defineProperty(this, "logo", "iXL24MHFs5MRS0uwAHLQgxEluwolVc9VKYVou7ngM6o");
    _defineProperty(this, "url", "https://beaconwallet.app");
    _defineProperty(this, "walletRef", void 0);
    _defineProperty(this, "addressListeners", []);
    this.walletRef = new WalletClient();
    this.walletRef.reconnect();
  }
  return _createClass(AoSyncStrategy2, [{ key: "connect", value: function() {
    var _connect3 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee68(permissions, appInfo, gateway) {
      return _regeneratorRuntime().wrap(function _callee68$(_context77) {
        while (1)
          switch (_context77.prev = _context77.next) {
            case 0:
              if (permissions) {
                console.warn("[Arweave Wallet Kit] Beacon implicitly requires all permissions. Your `permissions` parameter will be ignored.");
              }
              _context77.next = 3;
              return this.walletRef.connect({ permissions, appInfo, gateway });
            case 3:
              return _context77.abrupt("return", _context77.sent);
            case 4:
            case "end":
              return _context77.stop();
          }
      }, _callee68, this);
    }));
    function connect2(_x57, _x58, _x59) {
      return _connect3.apply(this, arguments);
    }
    return connect2;
  }() }, { key: "disconnect", value: function() {
    var _disconnect2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee69() {
      return _regeneratorRuntime().wrap(function _callee69$(_context78) {
        while (1)
          switch (_context78.prev = _context78.next) {
            case 0:
              return _context78.abrupt("return", this.walletRef.disconnect());
            case 1:
            case "end":
              return _context78.stop();
          }
      }, _callee69, this);
    }));
    function disconnect() {
      return _disconnect2.apply(this, arguments);
    }
    return disconnect;
  }() }, { key: "getActiveAddress", value: function() {
    var _getActiveAddress2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee70() {
      return _regeneratorRuntime().wrap(function _callee70$(_context79) {
        while (1)
          switch (_context79.prev = _context79.next) {
            case 0:
              _context79.next = 2;
              return this.walletRef.getActiveAddress();
            case 2:
              return _context79.abrupt("return", _context79.sent);
            case 3:
            case "end":
              return _context79.stop();
          }
      }, _callee70, this);
    }));
    function getActiveAddress() {
      return _getActiveAddress2.apply(this, arguments);
    }
    return getActiveAddress;
  }() }, { key: "getAllAddresses", value: function() {
    var _getAllAddresses2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee71() {
      return _regeneratorRuntime().wrap(function _callee71$(_context80) {
        while (1)
          switch (_context80.prev = _context80.next) {
            case 0:
              return _context80.abrupt("return", this.walletRef.getAllAddresses());
            case 1:
            case "end":
              return _context80.stop();
          }
      }, _callee71, this);
    }));
    function getAllAddresses() {
      return _getAllAddresses2.apply(this, arguments);
    }
    return getAllAddresses;
  }() }, { key: "sign", value: function() {
    var _sign2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee72(transaction, options) {
      return _regeneratorRuntime().wrap(function _callee72$(_context81) {
        while (1)
          switch (_context81.prev = _context81.next) {
            case 0:
              if (options) {
                console.warn("[Arweave Wallet Kit] Beacon does not support `sign()` options");
              }
              return _context81.abrupt("return", this.walletRef.sign(transaction));
            case 2:
            case "end":
              return _context81.stop();
          }
      }, _callee72, this);
    }));
    function sign(_x60, _x61) {
      return _sign2.apply(this, arguments);
    }
    return sign;
  }() }, { key: "getPermissions", value: function() {
    var _getPermissions2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee73() {
      return _regeneratorRuntime().wrap(function _callee73$(_context82) {
        while (1)
          switch (_context82.prev = _context82.next) {
            case 0:
              return _context82.abrupt("return", this.walletRef.getPermissions());
            case 1:
            case "end":
              return _context82.stop();
          }
      }, _callee73, this);
    }));
    function getPermissions() {
      return _getPermissions2.apply(this, arguments);
    }
    return getPermissions;
  }() }, { key: "getWalletNames", value: function() {
    var _getWalletNames2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee74() {
      return _regeneratorRuntime().wrap(function _callee74$(_context83) {
        while (1)
          switch (_context83.prev = _context83.next) {
            case 0:
              return _context83.abrupt("return", this.walletRef.getWalletNames());
            case 1:
            case "end":
              return _context83.stop();
          }
      }, _callee74, this);
    }));
    function getWalletNames() {
      return _getWalletNames2.apply(this, arguments);
    }
    return getWalletNames;
  }() }, { key: "encrypt", value: function encrypt(data, options) {
    throw new Error("Encrypt is not implemented in Beacon wallet");
  } }, { key: "decrypt", value: function decrypt(data, options) {
    throw new Error("Decrypt is not implemented in Beacon wallet");
  } }, { key: "getArweaveConfig", value: function getArweaveConfig() {
    return this.walletRef.getArweaveConfig();
  } }, { key: "signature", value: function signature(data, options) {
    if (options) {
      console.warn("[Arweave Wallet Kit] Beacon does not support `signature()` options");
    }
    return this.walletRef.signature(data);
  } }, { key: "getActivePublicKey", value: function() {
    var _getActivePublicKey2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee75() {
      return _regeneratorRuntime().wrap(function _callee75$(_context84) {
        while (1)
          switch (_context84.prev = _context84.next) {
            case 0:
              return _context84.abrupt("return", this.walletRef.getActivePublicKey());
            case 1:
            case "end":
              return _context84.stop();
          }
      }, _callee75, this);
    }));
    function getActivePublicKey() {
      return _getActivePublicKey2.apply(this, arguments);
    }
    return getActivePublicKey;
  }() }, { key: "addToken", value: function() {
    var _addToken2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee76(id) {
      return _regeneratorRuntime().wrap(function _callee76$(_context85) {
        while (1)
          switch (_context85.prev = _context85.next) {
            case 0:
              return _context85.abrupt("return", this.walletRef.addToken(id));
            case 1:
            case "end":
              return _context85.stop();
          }
      }, _callee76, this);
    }));
    function addToken(_x62) {
      return _addToken2.apply(this, arguments);
    }
    return addToken;
  }() }, { key: "dispatch", value: function() {
    var _dispatch2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee77(transaction) {
      return _regeneratorRuntime().wrap(function _callee77$(_context86) {
        while (1)
          switch (_context86.prev = _context86.next) {
            case 0:
              return _context86.abrupt("return", this.walletRef.dispatch(transaction));
            case 1:
            case "end":
              return _context86.stop();
          }
      }, _callee77, this);
    }));
    function dispatch(_x63) {
      return _dispatch2.apply(this, arguments);
    }
    return dispatch;
  }() }, { key: "isAvailable", value: function() {
    var _isAvailable2 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee78() {
      return _regeneratorRuntime().wrap(function _callee78$(_context87) {
        while (1)
          switch (_context87.prev = _context87.next) {
            case 0:
              return _context87.abrupt("return", true);
            case 1:
            case "end":
              return _context87.stop();
          }
      }, _callee78);
    }));
    function isAvailable() {
      return _isAvailable2.apply(this, arguments);
    }
    return isAvailable;
  }() }, { key: "signDataItem", value: function signDataItem(p) {
    return this.walletRef.signDataItem(p);
  } }, { key: "addAddressEvent", value: function addAddressEvent(listener) {
    this.addressListeners.push(listener);
    return listener;
  } }, { key: "removeAddressEvent", value: function removeAddressEvent(listener) {
    this.addressListeners.splice(this.addressListeners.indexOf(listener), 1);
  } }]);
}();
export {
  AoSyncStrategy as default
};
